//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAccountServiceProxy {
    /**
     * @param body (optional)
     * @return Success
     */
    isTenantAvailable(body?: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput>;
    /**
     * @param body (optional)
     * @return Success
     */
    register(body?: RegisterInput | undefined): Observable<RegisterOutput>;
}

@Injectable()
export class AccountServiceProxy implements IAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    isTenantAvailable(body?: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body?: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAnalysisStatusServiceProxy {
    /**
     * Gets all analysis statuses.
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<AnalysisStatusDtoPagedResultDto>;
}

@Injectable()
export class AnalysisStatusServiceProxy implements IAnalysisStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all analysis statuses.
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<AnalysisStatusDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AnalysisStatus/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnalysisStatusDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnalysisStatusDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AnalysisStatusDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisStatusDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IArtificialIntelligenceServiceProxy {
    /**
     * Kicks off the process to run a batch set of images through AI batch processing for a given inspection and model
     * @param tenantId (optional) Id of the tenant
     * @param inspectionId (optional) Id of the inspection
     * @param modelId (optional) Id of the model to run
     * @return Success
     */
    processBatchImages(tenantId?: number | undefined, inspectionId?: number | undefined, modelId?: number | undefined): Observable<void>;
    /**
     * Get the most recent bulk model runs for an inspection and tenant
     * @param tenant (optional) Tenant to filter by
     * @param inspectionId (optional) Inspection to filter by
     * @return Success
     */
    getBulkProcessRuns(tenant?: number | undefined, inspectionId?: number | undefined): Observable<BulkProcessingRunDto[]>;
}

@Injectable()
export class ArtificialIntelligenceServiceProxy implements IArtificialIntelligenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Kicks off the process to run a batch set of images through AI batch processing for a given inspection and model
     * @param tenantId (optional) Id of the tenant
     * @param inspectionId (optional) Id of the inspection
     * @param modelId (optional) Id of the model to run
     * @return Success
     */
    processBatchImages(tenantId?: number | undefined, inspectionId?: number | undefined, modelId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArtificialIntelligence/processBatchImages?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessBatchImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessBatchImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessBatchImages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the most recent bulk model runs for an inspection and tenant
     * @param tenant (optional) Tenant to filter by
     * @param inspectionId (optional) Inspection to filter by
     * @return Success
     */
    getBulkProcessRuns(tenant?: number | undefined, inspectionId?: number | undefined): Observable<BulkProcessingRunDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArtificialIntelligence/getBulkProcessRuns?";
        if (tenant === null)
            throw new Error("The parameter 'tenant' cannot be null.");
        else if (tenant !== undefined)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkProcessRuns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkProcessRuns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkProcessingRunDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkProcessingRunDto[]>;
        }));
    }

    protected processGetBulkProcessRuns(response: HttpResponseBase): Observable<BulkProcessingRunDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BulkProcessingRunDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAssetAssignmentAreaServiceProxy {
    /**
     * Returns the asset assignment areas for an inspection.
     * @param inspectionId (optional)
     * @return Success
     */
    assetAssignmentAreasAll(inspectionId?: number | undefined): Observable<AssetAssignmentAreaDto[]>;
    /**
     * Creates an AssetAssignmentArea.
     * @param body (optional) The data to use to create the AssetAssignmentArea.
     * @return Created
     */
    assetAssignmentAreasPOST(body?: CreateAssetAssignmentAreaDto | undefined): Observable<AssetAssignmentAreaDto>;
    /**
     * Returns the users with an assigned area.
     * @param inspectionId (optional)
     * @return Success
     */
    getAllUsersWithAssignedAreas(inspectionId?: number | undefined): Observable<AssetAssignmentAreaUserDto[]>;
    /**
     * Gets the number of assets and uninspected assets assigned to the given users, grouped by inspection.
     * @param userIds (optional)
     * @return Success
     */
    getAssignedAssetsPendingInspectionNotifications(userIds?: number[] | undefined): Observable<AssignedAssetsPendingInspectionNotificationDto[]>;
    /**
     * Gets an AssetAssignmentArea.
     * @param esriId EsriId of the AssetAssignmentArea to get
     * @return Success
     */
    assetAssignmentAreasGET(esriId: string): Observable<AssetAssignmentAreaDto>;
    /**
     * Updates a given AssetAssignmentArea.
     * @param esriId EsriId of the AssetAssignmentArea to update
     * @param body (optional) The data to use to update the AssetAssignmentArea.
     * @return Updated
     */
    assetAssignmentAreasPUT(esriId: string, body?: UpdateAssetAssignmentAreaDto | undefined): Observable<AssetAssignmentAreaDto>;
    /**
     * Soft deletes an AssetAssignmentArea
     * @param esriId EsriId of the AssetAssignmentArea to delete
     * @return Deleted
     */
    assetAssignmentAreasDELETE(esriId: string): Observable<void>;
}

@Injectable()
export class AssetAssignmentAreaServiceProxy implements IAssetAssignmentAreaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns the asset assignment areas for an inspection.
     * @param inspectionId (optional)
     * @return Success
     */
    assetAssignmentAreasAll(inspectionId?: number | undefined): Observable<AssetAssignmentAreaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetAssignmentAreasAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetAssignmentAreasAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetAssignmentAreaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetAssignmentAreaDto[]>;
        }));
    }

    protected processAssetAssignmentAreasAll(response: HttpResponseBase): Observable<AssetAssignmentAreaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetAssignmentAreaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates an AssetAssignmentArea.
     * @param body (optional) The data to use to create the AssetAssignmentArea.
     * @return Created
     */
    assetAssignmentAreasPOST(body?: CreateAssetAssignmentAreaDto | undefined): Observable<AssetAssignmentAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetAssignmentAreasPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetAssignmentAreasPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetAssignmentAreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetAssignmentAreaDto>;
        }));
    }

    protected processAssetAssignmentAreasPOST(response: HttpResponseBase): Observable<AssetAssignmentAreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AssetAssignmentAreaDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the users with an assigned area.
     * @param inspectionId (optional)
     * @return Success
     */
    getAllUsersWithAssignedAreas(inspectionId?: number | undefined): Observable<AssetAssignmentAreaUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas/Users?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersWithAssignedAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersWithAssignedAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetAssignmentAreaUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetAssignmentAreaUserDto[]>;
        }));
    }

    protected processGetAllUsersWithAssignedAreas(response: HttpResponseBase): Observable<AssetAssignmentAreaUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetAssignmentAreaUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number of assets and uninspected assets assigned to the given users, grouped by inspection.
     * @param userIds (optional)
     * @return Success
     */
    getAssignedAssetsPendingInspectionNotifications(userIds?: number[] | undefined): Observable<AssignedAssetsPendingInspectionNotificationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas/PendingInspectionNotifications?";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedAssetsPendingInspectionNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedAssetsPendingInspectionNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedAssetsPendingInspectionNotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedAssetsPendingInspectionNotificationDto[]>;
        }));
    }

    protected processGetAssignedAssetsPendingInspectionNotifications(response: HttpResponseBase): Observable<AssignedAssetsPendingInspectionNotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignedAssetsPendingInspectionNotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets an AssetAssignmentArea.
     * @param esriId EsriId of the AssetAssignmentArea to get
     * @return Success
     */
    assetAssignmentAreasGET(esriId: string): Observable<AssetAssignmentAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas/{esriId}";
        if (esriId === undefined || esriId === null)
            throw new Error("The parameter 'esriId' must be defined.");
        url_ = url_.replace("{esriId}", encodeURIComponent("" + esriId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetAssignmentAreasGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetAssignmentAreasGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetAssignmentAreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetAssignmentAreaDto>;
        }));
    }

    protected processAssetAssignmentAreasGET(response: HttpResponseBase): Observable<AssetAssignmentAreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetAssignmentAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a given AssetAssignmentArea.
     * @param esriId EsriId of the AssetAssignmentArea to update
     * @param body (optional) The data to use to update the AssetAssignmentArea.
     * @return Updated
     */
    assetAssignmentAreasPUT(esriId: string, body?: UpdateAssetAssignmentAreaDto | undefined): Observable<AssetAssignmentAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas/{esriId}";
        if (esriId === undefined || esriId === null)
            throw new Error("The parameter 'esriId' must be defined.");
        url_ = url_.replace("{esriId}", encodeURIComponent("" + esriId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetAssignmentAreasPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetAssignmentAreasPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetAssignmentAreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetAssignmentAreaDto>;
        }));
    }

    protected processAssetAssignmentAreasPUT(response: HttpResponseBase): Observable<AssetAssignmentAreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetAssignmentAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Soft deletes an AssetAssignmentArea
     * @param esriId EsriId of the AssetAssignmentArea to delete
     * @return Deleted
     */
    assetAssignmentAreasDELETE(esriId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssignmentAreas/{esriId}";
        if (esriId === undefined || esriId === null)
            throw new Error("The parameter 'esriId' must be defined.");
        url_ = url_.replace("{esriId}", encodeURIComponent("" + esriId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetAssignmentAreasDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetAssignmentAreasDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssetAssignmentAreasDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuditReasonTypeServiceProxy {
    /**
     * Gets all audit reason types.
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllAuditReasonTypes(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<AuditReasonTypeDtoPagedResultDto>;
}

@Injectable()
export class AuditReasonTypeServiceProxy implements IAuditReasonTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all audit reason types.
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllAuditReasonTypes(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<AuditReasonTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditReasonType/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAuditReasonTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAuditReasonTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditReasonTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditReasonTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAllAuditReasonTypes(response: HttpResponseBase): Observable<AuditReasonTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditReasonTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICircuitServiceProxy {
    /**
     * @param tenantName (optional) Name of tenant that circuit belongs to
     * @param name (optional) Name of the Circuit
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll2(tenantName?: string | undefined, name?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<CircuitDtoPagedResultDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    get(id?: number | undefined): Observable<CircuitDto>;
    /**
     * Creates a Circuit.
     * @param body (optional) The data to use to create the circuit.
     * @return Success
     */
    create(body?: CreateCircuitDto | undefined): Observable<CircuitDto>;
    /**
     * Updates a given Circuit.
     * @param body (optional) The data to use to update the circuit.
     * @return Success
     */
    update(body?: UpdateCircuitDto | undefined): Observable<CircuitDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    delete(id?: number | undefined): Observable<void>;
}

@Injectable()
export class CircuitServiceProxy implements ICircuitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantName (optional) Name of tenant that circuit belongs to
     * @param name (optional) Name of the Circuit
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll2(tenantName?: string | undefined, name?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<CircuitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Circuit/GetAll?";
        if (tenantName === null)
            throw new Error("The parameter 'tenantName' cannot be null.");
        else if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDtoPagedResultDto>;
        }));
    }

    protected processGetAll2(response: HttpResponseBase): Observable<CircuitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CircuitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id?: number | undefined): Observable<CircuitDto> {
        let url_ = this.baseUrl + "/api/services/app/Circuit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CircuitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CircuitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a Circuit.
     * @param body (optional) The data to use to create the circuit.
     * @return Success
     */
    create(body?: CreateCircuitDto | undefined): Observable<CircuitDto> {
        let url_ = this.baseUrl + "/api/services/app/Circuit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CircuitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CircuitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a given Circuit.
     * @param body (optional) The data to use to update the circuit.
     * @return Success
     */
    update(body?: UpdateCircuitDto | undefined): Observable<CircuitDto> {
        let url_ = this.baseUrl + "/api/services/app/Circuit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CircuitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CircuitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Circuit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IComputerVisionModelServiceProxy {
    /**
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllComputerVisionModels(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<ComputerVisionModelDtoPagedResultDto>;
    /**
     * Creates a ComputerVisionModel.
     * @param body (optional) The data to use to create the ComputerVisionModel.
     * @return Created
     */
    create(body?: CreateComputerVisionModelDto | undefined): Observable<ComputerVisionModelDto>;
    /**
     * @return Success
     */
    getComputerVisionModelTypes(): Observable<ComputerVisionModelTypeDto[]>;
    /**
     * Updates a given ComputerVisionModel.
     * @param computerVisionModelId ID of the ComputerVisionModel to update.
     * @param body (optional) The data to use to update the ComputerVisionModel.
     * @return Updated
     */
    update(computerVisionModelId: number, body?: UpdateComputerVisionModelDto | undefined): Observable<ComputerVisionModelDto>;
    /**
     * Soft deletes a ComputerVisionModel
     * @param computerVisionModelId Id of the ComputerVisionModel to delete
     * @return Deleted
     */
    delete(computerVisionModelId: number): Observable<void>;
    /**
     * Triggers the computer vision model runs on inspections associated with models that have not yet been run.
     * @return Success
     */
    runComputerVisionModels(): Observable<void>;
    /**
     * Creates a ComputerVisionModelLabel
     * @param computerVisionModelId Id of the ComputerVisionModel to assign this ComputerVisionModelLabel to
     * @param body (optional) Data for the new ComputerVisionModelLabel
     * @return Created
     */
    createComputerVisionModelLabel(computerVisionModelId: number, body?: ComputerVisionModelLabelDto | undefined): Observable<void>;
    /**
     * Updates a ComputerVisionModelLabel
     * @param computerVisionModelId Id of the ComputerVisionModel the label is associated to
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to update
     * @param body (optional) Data to use to update the ComputerVisionModelLabel
     * @return Updated
     */
    updateComputerVisionModelLabel(computerVisionModelId: number, computerVisionModelLabelId: number, body?: ComputerVisionModelLabelDto | undefined): Observable<ComputerVisionModelLabelDto>;
    /**
     * Soft deletes a ComputerVisionModelLabel from the specified ComputerVisionModel
     * @param computerVisionModelId Id of the ComputerVisionModel the label belongs to
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to delete
     * @return Deleted
     */
    deleteComputerVisionModelLabel(computerVisionModelId: number, computerVisionModelLabelId: number): Observable<void>;
    /**
     * Creates a ComputerVisionModelSubLabel
     * @param computerVisionModelId Id of the parent ComputerVisionModel for the ComputerVisionModelLabel.
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to be the parent of this ComputerVisionModelSubLabel to.
     * @param body (optional) Data for the new ComputerVisionModelSubLabel
     * @return Created
     */
    createComputerVisionModelLabelSubLabel(computerVisionModelId: number, computerVisionModelLabelId: number, body?: ComputerVisionModelSubLabelDto | undefined): Observable<void>;
    /**
     * Updates a ComputerVisionModelSubLabel
     * @param computerVisionModelId Id of the parent ComputerVisionModel for the ComputerVisionModelLabel.
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to be the parent of this ComputerVisionModelSubLabel.
     * @param id Id of the sublabel to update.
     * @param body (optional) Data for the new ComputerVisionModelLabel
     * @return Updated
     */
    updateComputerVisionModelLabelSubLabel(computerVisionModelId: number, computerVisionModelLabelId: number, id: number, body?: ComputerVisionModelSubLabelDto | undefined): Observable<ComputerVisionModelSubLabelDto>;
    /**
     * Deletes a ComputerVisionModelSubLabel.
     * @param computerVisionModelId The identifier of the ComputerVisionModel this ComputerVisionModelSubLabel is under.
     * @param computerVisionModelLabelId The identifier of the ComputerVisionModelLabel for this ComputerVisionModelSubLabel.
     * @param id The identifier of the ComputerVisionModelSubLabel.
     * @return Deleted
     */
    deleteComputerVisionModelSubLabel(computerVisionModelId: number, computerVisionModelLabelId: number, id: number): Observable<void>;
}

@Injectable()
export class ComputerVisionModelServiceProxy implements IComputerVisionModelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllComputerVisionModels(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<ComputerVisionModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComputerVisionModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComputerVisionModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelDtoPagedResultDto>;
        }));
    }

    protected processGetAllComputerVisionModels(response: HttpResponseBase): Observable<ComputerVisionModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComputerVisionModelDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a ComputerVisionModel.
     * @param body (optional) The data to use to create the ComputerVisionModel.
     * @return Created
     */
    create(body?: CreateComputerVisionModelDto | undefined): Observable<ComputerVisionModelDto> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ComputerVisionModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ComputerVisionModelDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getComputerVisionModelTypes(): Observable<ComputerVisionModelTypeDto[]> {
        let url_ = this.baseUrl + "/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComputerVisionModelTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComputerVisionModelTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelTypeDto[]>;
        }));
    }

    protected processGetComputerVisionModelTypes(response: HttpResponseBase): Observable<ComputerVisionModelTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComputerVisionModelTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a given ComputerVisionModel.
     * @param computerVisionModelId ID of the ComputerVisionModel to update.
     * @param body (optional) The data to use to update the ComputerVisionModel.
     * @return Updated
     */
    update(computerVisionModelId: number, body?: UpdateComputerVisionModelDto | undefined): Observable<ComputerVisionModelDto> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ComputerVisionModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComputerVisionModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Soft deletes a ComputerVisionModel
     * @param computerVisionModelId Id of the ComputerVisionModel to delete
     * @return Deleted
     */
    delete(computerVisionModelId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Triggers the computer vision model runs on inspections associated with models that have not yet been run.
     * @return Success
     */
    runComputerVisionModels(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/RunModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunComputerVisionModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunComputerVisionModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunComputerVisionModels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a ComputerVisionModelLabel
     * @param computerVisionModelId Id of the ComputerVisionModel to assign this ComputerVisionModelLabel to
     * @param body (optional) Data for the new ComputerVisionModelLabel
     * @return Created
     */
    createComputerVisionModelLabel(computerVisionModelId: number, body?: ComputerVisionModelLabelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}/ComputerVisionModelLabel";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComputerVisionModelLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComputerVisionModelLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateComputerVisionModelLabel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a ComputerVisionModelLabel
     * @param computerVisionModelId Id of the ComputerVisionModel the label is associated to
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to update
     * @param body (optional) Data to use to update the ComputerVisionModelLabel
     * @return Updated
     */
    updateComputerVisionModelLabel(computerVisionModelId: number, computerVisionModelLabelId: number, body?: ComputerVisionModelLabelDto | undefined): Observable<ComputerVisionModelLabelDto> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}/ComputerVisionModelLabel/{computerVisionModelLabelId}";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        if (computerVisionModelLabelId === undefined || computerVisionModelLabelId === null)
            throw new Error("The parameter 'computerVisionModelLabelId' must be defined.");
        url_ = url_.replace("{computerVisionModelLabelId}", encodeURIComponent("" + computerVisionModelLabelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComputerVisionModelLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComputerVisionModelLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelLabelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelLabelDto>;
        }));
    }

    protected processUpdateComputerVisionModelLabel(response: HttpResponseBase): Observable<ComputerVisionModelLabelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComputerVisionModelLabelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Soft deletes a ComputerVisionModelLabel from the specified ComputerVisionModel
     * @param computerVisionModelId Id of the ComputerVisionModel the label belongs to
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to delete
     * @return Deleted
     */
    deleteComputerVisionModelLabel(computerVisionModelId: number, computerVisionModelLabelId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}/ComputerVisionModelLabel/{computerVisionModelLabelId}";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        if (computerVisionModelLabelId === undefined || computerVisionModelLabelId === null)
            throw new Error("The parameter 'computerVisionModelLabelId' must be defined.");
        url_ = url_.replace("{computerVisionModelLabelId}", encodeURIComponent("" + computerVisionModelLabelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComputerVisionModelLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComputerVisionModelLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteComputerVisionModelLabel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a ComputerVisionModelSubLabel
     * @param computerVisionModelId Id of the parent ComputerVisionModel for the ComputerVisionModelLabel.
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to be the parent of this ComputerVisionModelSubLabel to.
     * @param body (optional) Data for the new ComputerVisionModelSubLabel
     * @return Created
     */
    createComputerVisionModelLabelSubLabel(computerVisionModelId: number, computerVisionModelLabelId: number, body?: ComputerVisionModelSubLabelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}/ComputerVisionModelLabel/{computerVisionModelLabelId}/SubLabel";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        if (computerVisionModelLabelId === undefined || computerVisionModelLabelId === null)
            throw new Error("The parameter 'computerVisionModelLabelId' must be defined.");
        url_ = url_.replace("{computerVisionModelLabelId}", encodeURIComponent("" + computerVisionModelLabelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComputerVisionModelLabelSubLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComputerVisionModelLabelSubLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateComputerVisionModelLabelSubLabel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a ComputerVisionModelSubLabel
     * @param computerVisionModelId Id of the parent ComputerVisionModel for the ComputerVisionModelLabel.
     * @param computerVisionModelLabelId Id of the ComputerVisionModelLabel to be the parent of this ComputerVisionModelSubLabel.
     * @param id Id of the sublabel to update.
     * @param body (optional) Data for the new ComputerVisionModelLabel
     * @return Updated
     */
    updateComputerVisionModelLabelSubLabel(computerVisionModelId: number, computerVisionModelLabelId: number, id: number, body?: ComputerVisionModelSubLabelDto | undefined): Observable<ComputerVisionModelSubLabelDto> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}/ComputerVisionModelLabel/{computerVisionModelLabelId}/SubLabel/{id}";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        if (computerVisionModelLabelId === undefined || computerVisionModelLabelId === null)
            throw new Error("The parameter 'computerVisionModelLabelId' must be defined.");
        url_ = url_.replace("{computerVisionModelLabelId}", encodeURIComponent("" + computerVisionModelLabelId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComputerVisionModelLabelSubLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComputerVisionModelLabelSubLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelSubLabelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelSubLabelDto>;
        }));
    }

    protected processUpdateComputerVisionModelLabelSubLabel(response: HttpResponseBase): Observable<ComputerVisionModelSubLabelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComputerVisionModelSubLabelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a ComputerVisionModelSubLabel.
     * @param computerVisionModelId The identifier of the ComputerVisionModel this ComputerVisionModelSubLabel is under.
     * @param computerVisionModelLabelId The identifier of the ComputerVisionModelLabel for this ComputerVisionModelSubLabel.
     * @param id The identifier of the ComputerVisionModelSubLabel.
     * @return Deleted
     */
    deleteComputerVisionModelSubLabel(computerVisionModelId: number, computerVisionModelLabelId: number, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComputerVisionModels/{computerVisionModelId}/ComputerVisionModelLabel/{computerVisionModelLabelId}/SubLabel/{id}";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined.");
        url_ = url_.replace("{computerVisionModelId}", encodeURIComponent("" + computerVisionModelId));
        if (computerVisionModelLabelId === undefined || computerVisionModelLabelId === null)
            throw new Error("The parameter 'computerVisionModelLabelId' must be defined.");
        url_ = url_.replace("{computerVisionModelLabelId}", encodeURIComponent("" + computerVisionModelLabelId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComputerVisionModelSubLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComputerVisionModelSubLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteComputerVisionModelSubLabel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IComputerVisionModelLabelServiceProxy {
    /**
     * @return Success
     */
    getComputerVisionModelLabels(): Observable<ComputerVisionModelLabelDto[]>;
}

@Injectable()
export class ComputerVisionModelLabelServiceProxy implements IComputerVisionModelLabelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getComputerVisionModelLabels(): Observable<ComputerVisionModelLabelDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/ComputerVisionModelLabels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComputerVisionModelLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComputerVisionModelLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelLabelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelLabelDto[]>;
        }));
    }

    protected processGetComputerVisionModelLabels(response: HttpResponseBase): Observable<ComputerVisionModelLabelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComputerVisionModelLabelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConditionsServiceProxy {
    /**
     * Export a spreadsheet containing Condition grid information fitting the given filters
     * @param inspectionId (optional)
     * @param assetId (optional)
     * @param clientTimeZone (optional)
     * @return Success
     */
    exportConditions(inspectionId?: number | undefined, assetId?: number | undefined, clientTimeZone?: string | undefined): Observable<FileResponse>;
    /**
     * Endpoint to create a condition from workbench
     * @param loggedInUserEmail (optional)
     * @param body (optional)
     * @return Success
     */
    createCondition(loggedInUserEmail?: string | undefined, body?: CreateWBConditionDto | undefined): Observable<number>;
    /**
     * Endpoint to update a condition from workbench
     * @param body (optional)
     * @return Success
     */
    updateCondition(conditionId: number, body?: UpdateWBConditionDto | undefined): Observable<void>;
    /**
     * Endpoint to mark this condition as deleted or not deleted
     * @param shouldDelete (optional)
     * @return Success
     */
    deleteCondition(conditionId: number, shouldDelete?: boolean | undefined): Observable<void>;
    /**
     * Endpoint to get a single condition
     * @return Success
     */
    getCondition(conditionId: number): Observable<ConditionDto>;
    /**
     * Endpoint to get conditions for an inspection-asset pair
     * @param includeDeleted (optional)
     * @param orderByNote (optional)
     * @return Success
     */
    getConditionsByInspectionAndAsset(inspectionId: number, assetId: number, includeDeleted?: boolean | undefined, orderByNote?: boolean | undefined): Observable<ConditionDto[]>;
    /**
     * Endpoint to get all conditions on an asset outside of a specific inspection
     * @return Success
     */
    historicalConditions(tenantId: number, assetId: number, inspectionIdToExclude: number): Observable<ConditionDto[]>;
    /**
     * Endpoint to get condition item types
     * @return Success
     */
    itemTypes(inspectionId: number): Observable<ConditionItemTypeDto[]>;
    /**
     * Endpoint to get condition types
     * @param conditionItemType (optional)
     * @return Success
     */
    types(inspectionId: number, conditionItemType?: string | undefined): Observable<ConditionTypeDto[]>;
    /**
     * Endpoint to get condition names
     * @param conditionItemType (optional)
     * @param conditionType (optional)
     * @return Success
     */
    names(inspectionId: number, conditionItemType?: string | undefined, conditionType?: string | undefined): Observable<WBConditionSuggestionDto[]>;
    /**
     * Get condition suggestions
     * @return Success
     */
    conditionSuggestions(inspectionId: number, computerVisionModelId: number): Observable<ConditionDto[]>;
}

@Injectable()
export class ConditionsServiceProxy implements IConditionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Export a spreadsheet containing Condition grid information fitting the given filters
     * @param inspectionId (optional)
     * @param assetId (optional)
     * @param clientTimeZone (optional)
     * @return Success
     */
    exportConditions(inspectionId?: number | undefined, assetId?: number | undefined, clientTimeZone?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/Export?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (clientTimeZone === null)
            throw new Error("The parameter 'clientTimeZone' cannot be null.");
        else if (clientTimeZone !== undefined)
            url_ += "clientTimeZone=" + encodeURIComponent("" + clientTimeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportConditions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to create a condition from workbench
     * @param loggedInUserEmail (optional)
     * @param body (optional)
     * @return Success
     */
    createCondition(loggedInUserEmail?: string | undefined, body?: CreateWBConditionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/Create?";
        if (loggedInUserEmail === null)
            throw new Error("The parameter 'loggedInUserEmail' cannot be null.");
        else if (loggedInUserEmail !== undefined)
            url_ += "loggedInUserEmail=" + encodeURIComponent("" + loggedInUserEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCondition(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to update a condition from workbench
     * @param body (optional)
     * @return Success
     */
    updateCondition(conditionId: number, body?: UpdateWBConditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/{conditionId}";
        if (conditionId === undefined || conditionId === null)
            throw new Error("The parameter 'conditionId' must be defined.");
        url_ = url_.replace("{conditionId}", encodeURIComponent("" + conditionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to mark this condition as deleted or not deleted
     * @param shouldDelete (optional)
     * @return Success
     */
    deleteCondition(conditionId: number, shouldDelete?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/{conditionId}?";
        if (conditionId === undefined || conditionId === null)
            throw new Error("The parameter 'conditionId' must be defined.");
        url_ = url_.replace("{conditionId}", encodeURIComponent("" + conditionId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get a single condition
     * @return Success
     */
    getCondition(conditionId: number): Observable<ConditionDto> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/{conditionId}";
        if (conditionId === undefined || conditionId === null)
            throw new Error("The parameter 'conditionId' must be defined.");
        url_ = url_.replace("{conditionId}", encodeURIComponent("" + conditionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionDto>;
        }));
    }

    protected processGetCondition(response: HttpResponseBase): Observable<ConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get conditions for an inspection-asset pair
     * @param includeDeleted (optional)
     * @param orderByNote (optional)
     * @return Success
     */
    getConditionsByInspectionAndAsset(inspectionId: number, assetId: number, includeDeleted?: boolean | undefined, orderByNote?: boolean | undefined): Observable<ConditionDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/ByInspectionAndAsset?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined and cannot be null.");
        else
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (orderByNote === null)
            throw new Error("The parameter 'orderByNote' cannot be null.");
        else if (orderByNote !== undefined)
            url_ += "orderByNote=" + encodeURIComponent("" + orderByNote) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionsByInspectionAndAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionsByInspectionAndAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionDto[]>;
        }));
    }

    protected processGetConditionsByInspectionAndAsset(response: HttpResponseBase): Observable<ConditionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get all conditions on an asset outside of a specific inspection
     * @return Success
     */
    historicalConditions(tenantId: number, assetId: number, inspectionIdToExclude: number): Observable<ConditionDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/HistoricalConditions?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined and cannot be null.");
        else
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (inspectionIdToExclude === undefined || inspectionIdToExclude === null)
            throw new Error("The parameter 'inspectionIdToExclude' must be defined and cannot be null.");
        else
            url_ += "inspectionIdToExclude=" + encodeURIComponent("" + inspectionIdToExclude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistoricalConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistoricalConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionDto[]>;
        }));
    }

    protected processHistoricalConditions(response: HttpResponseBase): Observable<ConditionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get condition item types
     * @return Success
     */
    itemTypes(inspectionId: number): Observable<ConditionItemTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/ItemTypes?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionItemTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionItemTypeDto[]>;
        }));
    }

    protected processItemTypes(response: HttpResponseBase): Observable<ConditionItemTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionItemTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get condition types
     * @param conditionItemType (optional)
     * @return Success
     */
    types(inspectionId: number, conditionItemType?: string | undefined): Observable<ConditionTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/Types?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (conditionItemType === null)
            throw new Error("The parameter 'conditionItemType' cannot be null.");
        else if (conditionItemType !== undefined)
            url_ += "conditionItemType=" + encodeURIComponent("" + conditionItemType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionTypeDto[]>;
        }));
    }

    protected processTypes(response: HttpResponseBase): Observable<ConditionTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get condition names
     * @param conditionItemType (optional)
     * @param conditionType (optional)
     * @return Success
     */
    names(inspectionId: number, conditionItemType?: string | undefined, conditionType?: string | undefined): Observable<WBConditionSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/Names?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (conditionItemType === null)
            throw new Error("The parameter 'conditionItemType' cannot be null.");
        else if (conditionItemType !== undefined)
            url_ += "conditionItemType=" + encodeURIComponent("" + conditionItemType) + "&";
        if (conditionType === null)
            throw new Error("The parameter 'conditionType' cannot be null.");
        else if (conditionType !== undefined)
            url_ += "conditionType=" + encodeURIComponent("" + conditionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WBConditionSuggestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WBConditionSuggestionDto[]>;
        }));
    }

    protected processNames(response: HttpResponseBase): Observable<WBConditionSuggestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WBConditionSuggestionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get condition suggestions
     * @return Success
     */
    conditionSuggestions(inspectionId: number, computerVisionModelId: number): Observable<ConditionDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Conditions/ConditionSuggestions?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (computerVisionModelId === undefined || computerVisionModelId === null)
            throw new Error("The parameter 'computerVisionModelId' must be defined and cannot be null.");
        else
            url_ += "computerVisionModelId=" + encodeURIComponent("" + computerVisionModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConditionSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConditionSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionDto[]>;
        }));
    }

    protected processConditionSuggestions(response: HttpResponseBase): Observable<ConditionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomAssetPropertyServiceProxy {
    /**
     * Retrieve all custom asset properties
     * @param tenantName (optional) Name of tenant that custom asset property belongs to
     * @param name (optional) Name of the Custom Asset Property
     * @param customPropertyTypeId (optional) Id of the custom asset property data type
     * @param displayName (optional) Display name of the custom asset property
     * @param customAssetPropertyOptions (optional) List of custom asset property options (if applicable) associated with this custom asset property
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll3(tenantName?: string | undefined, name?: string | undefined, customPropertyTypeId?: number | undefined, displayName?: string | undefined, customAssetPropertyOptions?: CustomAssetPropertyOptionDto[] | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<CustomAssetPropertyDtoPagedResultDto>;
    /**
     * Creates a Custom Asset Property.
     * @param body (optional) The data to use to create the custom asset property.
     * @return Success
     */
    create2(body?: CreateCustomAssetPropertyDto | undefined): Observable<CustomAssetPropertyDto>;
    /**
     * Updates a given Custom Asset Property.
     * @param body (optional) The data to use to update the custom asset property.
     * @return Success
     */
    update2(body?: UpdateCustomAssetPropertyDto | undefined): Observable<CustomAssetPropertyDto>;
    /**
     * Deletes the given custom asset property.
     * @param id (optional)
     * @return Success
     */
    delete2(id?: number | undefined): Observable<void>;
    /**
     * Gets a list of available data types for the custom asset property
     * @return Success
     */
    getTypes(): Observable<CustomPropertyTypeDto[]>;
    /**
     * @param id (optional)
     * @return Success
     */
    get2(id?: number | undefined): Observable<CustomAssetPropertyDto>;
}

@Injectable()
export class CustomAssetPropertyServiceProxy implements ICustomAssetPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve all custom asset properties
     * @param tenantName (optional) Name of tenant that custom asset property belongs to
     * @param name (optional) Name of the Custom Asset Property
     * @param customPropertyTypeId (optional) Id of the custom asset property data type
     * @param displayName (optional) Display name of the custom asset property
     * @param customAssetPropertyOptions (optional) List of custom asset property options (if applicable) associated with this custom asset property
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll3(tenantName?: string | undefined, name?: string | undefined, customPropertyTypeId?: number | undefined, displayName?: string | undefined, customAssetPropertyOptions?: CustomAssetPropertyOptionDto[] | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<CustomAssetPropertyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomAssetProperty/GetAll?";
        if (tenantName === null)
            throw new Error("The parameter 'tenantName' cannot be null.");
        else if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (customPropertyTypeId === null)
            throw new Error("The parameter 'customPropertyTypeId' cannot be null.");
        else if (customPropertyTypeId !== undefined)
            url_ += "CustomPropertyTypeId=" + encodeURIComponent("" + customPropertyTypeId) + "&";
        if (displayName === null)
            throw new Error("The parameter 'displayName' cannot be null.");
        else if (displayName !== undefined)
            url_ += "DisplayName=" + encodeURIComponent("" + displayName) + "&";
        if (customAssetPropertyOptions === null)
            throw new Error("The parameter 'customAssetPropertyOptions' cannot be null.");
        else if (customAssetPropertyOptions !== undefined)
            customAssetPropertyOptions && customAssetPropertyOptions.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "CustomAssetPropertyOptions[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAssetPropertyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAssetPropertyDtoPagedResultDto>;
        }));
    }

    protected processGetAll3(response: HttpResponseBase): Observable<CustomAssetPropertyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomAssetPropertyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a Custom Asset Property.
     * @param body (optional) The data to use to create the custom asset property.
     * @return Success
     */
    create2(body?: CreateCustomAssetPropertyDto | undefined): Observable<CustomAssetPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomAssetProperty/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAssetPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAssetPropertyDto>;
        }));
    }

    protected processCreate2(response: HttpResponseBase): Observable<CustomAssetPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomAssetPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a given Custom Asset Property.
     * @param body (optional) The data to use to update the custom asset property.
     * @return Success
     */
    update2(body?: UpdateCustomAssetPropertyDto | undefined): Observable<CustomAssetPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomAssetProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAssetPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAssetPropertyDto>;
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<CustomAssetPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomAssetPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the given custom asset property.
     * @param id (optional)
     * @return Success
     */
    delete2(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomAssetProperty/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a list of available data types for the custom asset property
     * @return Success
     */
    getTypes(): Observable<CustomPropertyTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomAssetProperties/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPropertyTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPropertyTypeDto[]>;
        }));
    }

    protected processGetTypes(response: HttpResponseBase): Observable<CustomPropertyTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomPropertyTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get2(id?: number | undefined): Observable<CustomAssetPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomAssetProperty/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAssetPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAssetPropertyDto>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<CustomAssetPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomAssetPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDurableFunctionServiceProxy {
    /**
     * @param id (optional)
     * @return Success
     */
    durableFunctionsDELETE(id?: number | undefined): Observable<void>;
    /**
     * Create a durable function based on provided input
     * @param body (optional) The durable function creation DTO containing values to fill the new durable function
     * @return Success
     */
    durableFunctionsPOST(body?: CreateDurableFunctionDto | undefined): Observable<DurableFunctionDto>;
    /**
     * Update the durable function's message based on the provided input
     * @param body (optional) The durable function update DTO containing values for updating the durable function
     * @return Success
     */
    durableFunctionsPATCH(body?: UpdateDurableFunctionDto | undefined): Observable<DurableFunctionDto>;
}

@Injectable()
export class DurableFunctionServiceProxy implements IDurableFunctionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    durableFunctionsDELETE(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DurableFunctions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDurableFunctionsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDurableFunctionsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDurableFunctionsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a durable function based on provided input
     * @param body (optional) The durable function creation DTO containing values to fill the new durable function
     * @return Success
     */
    durableFunctionsPOST(body?: CreateDurableFunctionDto | undefined): Observable<DurableFunctionDto> {
        let url_ = this.baseUrl + "/api/services/app/DurableFunctions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDurableFunctionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDurableFunctionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto>;
        }));
    }

    protected processDurableFunctionsPOST(response: HttpResponseBase): Observable<DurableFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DurableFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the durable function's message based on the provided input
     * @param body (optional) The durable function update DTO containing values for updating the durable function
     * @return Success
     */
    durableFunctionsPATCH(body?: UpdateDurableFunctionDto | undefined): Observable<DurableFunctionDto> {
        let url_ = this.baseUrl + "/api/services/app/DurableFunctions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDurableFunctionsPATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDurableFunctionsPATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto>;
        }));
    }

    protected processDurableFunctionsPATCH(response: HttpResponseBase): Observable<DurableFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DurableFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImageServiceProxy {
    /**
     * @param body (optional)
     * @return Success
     */
    create3(body?: CreateImageDto | undefined): Observable<ImageDto>;
    /**
     * @param body (optional)
     * @return Success
     */
    update3(body?: UpdateImageDto | undefined): Observable<ImageDto>;
    /**
     * Move images to a new asset
     * @param body (optional)
     * @return Success
     */
    moveImagesToAsset(body?: UpdateImageDto[] | undefined): Observable<void>;
    /**
     * Saves compressed image sizes for images with a specific md5 hash.
     * @param body (optional) Data to use to lookup and update the found images.
     * @return Success
     */
    compressed(body?: CompressedImageDataDto | undefined): Observable<void>;
    /**
     * @param id (optional)
     * @return Success
     */
    delete3(id?: number | undefined): Observable<void>;
    /**
     * Unlinks an image from its current asset.
     * @param imageId Identifier of the Image to unlink.
     * @return Success
     */
    unlink(imageId: number): Observable<void>;
    /**
     * Retrieve a given image.
     * @param id (optional)
     * @return Success
     */
    get3(id?: number | undefined): Observable<ImageDto>;
    /**
     * Gets the types of Images.
     * @return Success
     */
    getImageTypes(): Observable<ImageType[]>;
    /**
     * Updates the relevance of an image by performing a soft delete if the image is irrelevant.
     * @param body (optional)
     * @return Successful
     */
    setImageRelevance(imageId: number, body?: boolean | undefined): Observable<ImageRelevanceDto>;
    /**
     * Update the audit status of an image.
     * @param body (optional)
     * @return Success
     */
    audit(imageId: number, body?: UpdateImageAuditDto | undefined): Observable<ImageAuditDto>;
    /**
     * Update the profile of an image
     * @param body (optional)
     * @return Success
     */
    assetProfile(imageId: number, body?: UpdateImageAssetProfileDto | undefined): Observable<ImageAssetProfileDto>;
    /**
     * Endpoint to add a condition to an image
     * @param conditionId (optional)
     * @return Created
     */
    addConditionToImage(imageId: number, conditionId?: number | undefined): Observable<ImageToConditionDto>;
    /**
     * Endpoint to remove a condition from an image
     * @return Success
     */
    removeConditionFromImage(imageId: number, conditionId: number): Observable<void>;
    /**
     * Adds an inventory item to an image
     * @param inventoryItemId (optional)
     * @return Created
     */
    addInventoryItemToImage(imageId: number, inventoryItemId?: number | undefined): Observable<ImageToInventoryItemDto>;
    /**
     * Removes an inventory item from an image
     * @return Success
     */
    removeInventoryItemFromImage(imageId: number, inventoryItemId: number): Observable<void>;
    /**
     * Endpoint to get ConditionBoundingBoxes
     * @return Success
     */
    conditionBoundingBoxes(imageId: number): Observable<ConditionBoundingBoxDto[]>;
    /**
     * Endpoint to get InventoryItemBoundingBoxes
     * @return Success
     */
    inventoryItemBoundingBoxes(imageId: number): Observable<InventoryItemBoundingBoxDto[]>;
    /**
     * Endpoint to get an image with conditions and inventory items
     * @return Successful
     */
    getImage(imageId: number): Observable<ImageDto>;
    /**
     * Endpoint to get all images attached to an inspection and asset
     * @param inspectionId Identifier for the Inspection to find images for.
     * @param assetId Identifier for the Asset to find images for.
     * @param showIrrelevantImages (optional) Flag indicating whether images marked as irrelevant should be included.
     * @param showNoFieldImages (optional) Flag indicating whether No Field (missing Iamge URL) images should be included.
     * @return Success
     */
    getImages(inspectionId: number, assetId: number, showIrrelevantImages?: boolean | undefined, showNoFieldImages?: boolean | undefined): Observable<ImageDto[]>;
    /**
     * Get irrelevant images for inspection
     * @return Success
     */
    irrelevant(inspectionId: number): Observable<IrrelevantImageDto[]>;
    /**
     * Endpoint to save bounding boxes
     * @param body (optional)
     * @return Success
     */
    saveBoundingBoxes(imageId: number, body?: BoundingBoxSaveDto | undefined): Observable<CreatedBoundingBoxDto[]>;
    /**
     * Retrieve the predicted condition bounding boxes for an image.
     * @return Success
     */
    getPredictedConditionBoundingBoxes(imageId: number): Observable<PredictedConditionBoundingBoxDto[]>;
    /**
     * Retrieve the predicted inventory bounding boxes for an image.
     * @param imageId Identifier of the image for which to get predicted inventory bounding boxes.
     * @param minimumScore (optional) The minumum score to consider for including predicted bounding boxes.
     * @return Success
     */
    getPredictedInventoryBoundingBoxes(imageId: number, minimumScore?: number | undefined): Observable<PredictedInventoryBoundingBoxDto[]>;
}

@Injectable()
export class ImageServiceProxy implements IImageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create3(body?: CreateImageDto | undefined): Observable<ImageDto> {
        let url_ = this.baseUrl + "/api/services/app/Image/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto>;
        }));
    }

    protected processCreate3(response: HttpResponseBase): Observable<ImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update3(body?: UpdateImageDto | undefined): Observable<ImageDto> {
        let url_ = this.baseUrl + "/api/services/app/Image/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto>;
        }));
    }

    protected processUpdate3(response: HttpResponseBase): Observable<ImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Move images to a new asset
     * @param body (optional)
     * @return Success
     */
    moveImagesToAsset(body?: UpdateImageDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Images/Move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveImagesToAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveImagesToAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveImagesToAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves compressed image sizes for images with a specific md5 hash.
     * @param body (optional) Data to use to lookup and update the found images.
     * @return Success
     */
    compressed(body?: CompressedImageDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Images/Compressed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompressed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompressed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompressed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete3(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Image/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unlinks an image from its current asset.
     * @param imageId Identifier of the Image to unlink.
     * @return Success
     */
    unlink(imageId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Image/{imageId}/Unlink";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a given image.
     * @param id (optional)
     * @return Success
     */
    get3(id?: number | undefined): Observable<ImageDto> {
        let url_ = this.baseUrl + "/api/services/app/Image/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto>;
        }));
    }

    protected processGet3(response: HttpResponseBase): Observable<ImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the types of Images.
     * @return Success
     */
    getImageTypes(): Observable<ImageType[]> {
        let url_ = this.baseUrl + "/api/services/app/Images/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageType[]>;
        }));
    }

    protected processGetImageTypes(response: HttpResponseBase): Observable<ImageType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the relevance of an image by performing a soft delete if the image is irrelevant.
     * @param body (optional)
     * @return Successful
     */
    setImageRelevance(imageId: number, body?: boolean | undefined): Observable<ImageRelevanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Images/{imageId}/Relevance";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetImageRelevance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetImageRelevance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageRelevanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageRelevanceDto>;
        }));
    }

    protected processSetImageRelevance(response: HttpResponseBase): Observable<ImageRelevanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageRelevanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the audit status of an image.
     * @param body (optional)
     * @return Success
     */
    audit(imageId: number, body?: UpdateImageAuditDto | undefined): Observable<ImageAuditDto> {
        let url_ = this.baseUrl + "/api/services/app/Image/{imageId}/Audit";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageAuditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageAuditDto>;
        }));
    }

    protected processAudit(response: HttpResponseBase): Observable<ImageAuditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageAuditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the profile of an image
     * @param body (optional)
     * @return Success
     */
    assetProfile(imageId: number, body?: UpdateImageAssetProfileDto | undefined): Observable<ImageAssetProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Image/{imageId}/AssetProfile";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageAssetProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageAssetProfileDto>;
        }));
    }

    protected processAssetProfile(response: HttpResponseBase): Observable<ImageAssetProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageAssetProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to add a condition to an image
     * @param conditionId (optional)
     * @return Created
     */
    addConditionToImage(imageId: number, conditionId?: number | undefined): Observable<ImageToConditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Images/{imageId}/Condition?";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (conditionId === null)
            throw new Error("The parameter 'conditionId' cannot be null.");
        else if (conditionId !== undefined)
            url_ += "conditionId=" + encodeURIComponent("" + conditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConditionToImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConditionToImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageToConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageToConditionDto>;
        }));
    }

    protected processAddConditionToImage(response: HttpResponseBase): Observable<ImageToConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageToConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to remove a condition from an image
     * @return Success
     */
    removeConditionFromImage(imageId: number, conditionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Images/{imageId}/Condition/{conditionId}";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (conditionId === undefined || conditionId === null)
            throw new Error("The parameter 'conditionId' must be defined.");
        url_ = url_.replace("{conditionId}", encodeURIComponent("" + conditionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveConditionFromImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveConditionFromImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveConditionFromImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds an inventory item to an image
     * @param inventoryItemId (optional)
     * @return Created
     */
    addInventoryItemToImage(imageId: number, inventoryItemId?: number | undefined): Observable<ImageToInventoryItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Images/{imageId}/InventoryItem?";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' cannot be null.");
        else if (inventoryItemId !== undefined)
            url_ += "inventoryItemId=" + encodeURIComponent("" + inventoryItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInventoryItemToImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInventoryItemToImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageToInventoryItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageToInventoryItemDto>;
        }));
    }

    protected processAddInventoryItemToImage(response: HttpResponseBase): Observable<ImageToInventoryItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageToInventoryItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an inventory item from an image
     * @return Success
     */
    removeInventoryItemFromImage(imageId: number, inventoryItemId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Images/{imageId}/InventoryItem/{inventoryItemId}";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveInventoryItemFromImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveInventoryItemFromImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveInventoryItemFromImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get ConditionBoundingBoxes
     * @return Success
     */
    conditionBoundingBoxes(imageId: number): Observable<ConditionBoundingBoxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Image/{imageId}/ConditionBoundingBoxes";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConditionBoundingBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConditionBoundingBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionBoundingBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionBoundingBoxDto[]>;
        }));
    }

    protected processConditionBoundingBoxes(response: HttpResponseBase): Observable<ConditionBoundingBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionBoundingBoxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get InventoryItemBoundingBoxes
     * @return Success
     */
    inventoryItemBoundingBoxes(imageId: number): Observable<InventoryItemBoundingBoxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Image/{imageId}/InventoryItemBoundingBoxes";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryItemBoundingBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryItemBoundingBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryItemBoundingBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryItemBoundingBoxDto[]>;
        }));
    }

    protected processInventoryItemBoundingBoxes(response: HttpResponseBase): Observable<InventoryItemBoundingBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryItemBoundingBoxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get an image with conditions and inventory items
     * @return Successful
     */
    getImage(imageId: number): Observable<ImageDto> {
        let url_ = this.baseUrl + "/api/services/workbench/Images/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto>;
        }));
    }

    protected processGetImage(response: HttpResponseBase): Observable<ImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get all images attached to an inspection and asset
     * @param inspectionId Identifier for the Inspection to find images for.
     * @param assetId Identifier for the Asset to find images for.
     * @param showIrrelevantImages (optional) Flag indicating whether images marked as irrelevant should be included.
     * @param showNoFieldImages (optional) Flag indicating whether No Field (missing Iamge URL) images should be included.
     * @return Success
     */
    getImages(inspectionId: number, assetId: number, showIrrelevantImages?: boolean | undefined, showNoFieldImages?: boolean | undefined): Observable<ImageDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Images?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined and cannot be null.");
        else
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (showIrrelevantImages === null)
            throw new Error("The parameter 'showIrrelevantImages' cannot be null.");
        else if (showIrrelevantImages !== undefined)
            url_ += "showIrrelevantImages=" + encodeURIComponent("" + showIrrelevantImages) + "&";
        if (showNoFieldImages === null)
            throw new Error("The parameter 'showNoFieldImages' cannot be null.");
        else if (showNoFieldImages !== undefined)
            url_ += "showNoFieldImages=" + encodeURIComponent("" + showNoFieldImages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto[]>;
        }));
    }

    protected processGetImages(response: HttpResponseBase): Observable<ImageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get irrelevant images for inspection
     * @return Success
     */
    irrelevant(inspectionId: number): Observable<IrrelevantImageDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Images/Irrelevant?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIrrelevant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIrrelevant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IrrelevantImageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IrrelevantImageDto[]>;
        }));
    }

    protected processIrrelevant(response: HttpResponseBase): Observable<IrrelevantImageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IrrelevantImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to save bounding boxes
     * @param body (optional)
     * @return Success
     */
    saveBoundingBoxes(imageId: number, body?: BoundingBoxSaveDto | undefined): Observable<CreatedBoundingBoxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Image/{imageId}/BoundingBoxes";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBoundingBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBoundingBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedBoundingBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedBoundingBoxDto[]>;
        }));
    }

    protected processSaveBoundingBoxes(response: HttpResponseBase): Observable<CreatedBoundingBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreatedBoundingBoxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the predicted condition bounding boxes for an image.
     * @return Success
     */
    getPredictedConditionBoundingBoxes(imageId: number): Observable<PredictedConditionBoundingBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/Images/{imageId}/PredictedConditionBoundingBoxes";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredictedConditionBoundingBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredictedConditionBoundingBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictedConditionBoundingBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictedConditionBoundingBoxDto[]>;
        }));
    }

    protected processGetPredictedConditionBoundingBoxes(response: HttpResponseBase): Observable<PredictedConditionBoundingBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PredictedConditionBoundingBoxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the predicted inventory bounding boxes for an image.
     * @param imageId Identifier of the image for which to get predicted inventory bounding boxes.
     * @param minimumScore (optional) The minumum score to consider for including predicted bounding boxes.
     * @return Success
     */
    getPredictedInventoryBoundingBoxes(imageId: number, minimumScore?: number | undefined): Observable<PredictedInventoryBoundingBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/Images/{imageId}/PredictedInventoryBoundingBoxes?";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (minimumScore === null)
            throw new Error("The parameter 'minimumScore' cannot be null.");
        else if (minimumScore !== undefined)
            url_ += "minimumScore=" + encodeURIComponent("" + minimumScore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredictedInventoryBoundingBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredictedInventoryBoundingBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictedInventoryBoundingBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictedInventoryBoundingBoxDto[]>;
        }));
    }

    protected processGetPredictedInventoryBoundingBoxes(response: HttpResponseBase): Observable<PredictedInventoryBoundingBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PredictedInventoryBoundingBoxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImagesServiceProxy {
    /**
     * Retrieves an Image by url.
     * @param url (optional) The url of the Image.
     * @return Success
     */
    images(url?: string | undefined): Observable<FileResponse>;
}

@Injectable()
export class ImagesServiceProxy implements IImagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves an Image by url.
     * @param url (optional) The url of the Image.
     * @return Success
     */
    images(url?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Images?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processImages(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInspectionServiceProxy {
    /**
     * Exports filtered assets to an xlsx file.
     * @param inspectionId The ID of the inspection.
     * @param facilityId (optional) The facility ID to filter on
     * @param collectorId (optional) The Collector ID to filter on
     * @param includeAssetGPS (optional) Whether assets should be shown.
     * @param includeCustomerGPS (optional) Flag determining whether Customer GPS should be included in the results
     * @param customerGPSMissing (optional) Determines whether to only get assets where customer GPS data is missing
     * @param inspectedAssetGPSMissing (optional) Determines whether to only get assets where the inspected asset GPS data is missing.
     * @param imagesMissing (optional) Fkag determining whether the results should be refined to assets with no images
     * @param minExcessiveAssetInternalDistance (optional) Filter for Assets that have internal Asset GPS and Customer GPS distance that exceeds the number of meters provided
     * @param maxDistanceBetweenAssets (optional) Filter for Assets that are within the the given number of meters from other assets
     * @param minDistanceToImage (optional) Filter for Images that exceeds the number of meters from their parent Asset
     * @param assetId (optional) The Asset ID to filter on
     * @return Success
     */
    exportAssets(inspectionId: number, facilityId?: string | undefined, collectorId?: string | undefined, includeAssetGPS?: boolean | undefined, includeCustomerGPS?: boolean | undefined, customerGPSMissing?: boolean | undefined, inspectedAssetGPSMissing?: boolean | undefined, imagesMissing?: boolean | undefined, minExcessiveAssetInternalDistance?: number | undefined, maxDistanceBetweenAssets?: number | undefined, minDistanceToImage?: number | undefined, assetId?: number | undefined): Observable<FileResponse>;
    /**
     * Exports all Condition Suggestions to an xlsx file.
     * @param inspectionId The ID of the inspection.
     * @return Success
     */
    exportSkittleChart(inspectionId: number): Observable<FileResponse>;
    /**
     * Exports all image information to an xlsx file.
     * @param inspectionId The ID of the inspection.
     * @param facilityId (optional) The facility ID to filter on
     * @param collectorId (optional) The Collector ID to filter on
     * @param includeAssetGPS (optional) Whether assets should be shown.
     * @param includeCustomerGPS (optional) Flag determining whether Customer GPS should be included in the results
     * @param customerGPSMissing (optional) Determines whether to only get assets where customer GPS data is missing
     * @param inspectedAssetGPSMissing (optional) Determines whether to only get assets where the inspected asset GPS data is missing.
     * @param imagesMissing (optional) Fkag determining whether the results should be refined to assets with no images
     * @param minExcessiveAssetInternalDistance (optional) Filter for Assets that have internal Asset GPS and Customer GPS distance that exceeds the number of meters provided
     * @param maxDistanceBetweenAssets (optional) Filter for Assets that are within the the given number of meters from other assets
     * @param minDistanceToImage (optional) Filter for Images that exceeds the number of meters from their parent Asset
     * @param imageTypes (optional) Filter for Image Types of a specific "type".
     * @param assetId (optional) The Asset ID to filter on
     * @return Success
     */
    exportImages(inspectionId: number, facilityId?: string | undefined, collectorId?: string | undefined, includeAssetGPS?: boolean | undefined, includeCustomerGPS?: boolean | undefined, customerGPSMissing?: boolean | undefined, inspectedAssetGPSMissing?: boolean | undefined, imagesMissing?: boolean | undefined, minExcessiveAssetInternalDistance?: number | undefined, maxDistanceBetweenAssets?: number | undefined, minDistanceToImage?: number | undefined, imageTypes?: number[] | undefined, assetId?: number | undefined): Observable<FileResponse>;
    /**
     * Gets a given Inspection File on a specified inspection for download.
     * @param inspectionId The ID of the Inspection from which to get the Inspection File.
     * @param fileId The ID of the Associated Inspection File to retrieve.
     * @return Success
     */
    downloadInspectionFile(inspectionId: number, fileId: number): Observable<FileResponse>;
    /**
     * Gets a given uploaded file on a specified inspection for download
     * @param inspectionId The ID of the Inspection from which to get the uploaded file
     * @param durableFunctionId The ID of the Durable Function run instance for which the file was uploaded
     * @return Success
     */
    downloadDurableFunctionFile(inspectionId: number, durableFunctionId: number): Observable<FileResponse>;
    /**
     * Create an inspection based on provided input as well as its Azure Blob directory structure
     * @param body (optional) The inspection creation DTO containing values to fill the new inspection with
     * @return Success
     */
    create4(body?: CreateInspectionDto | undefined): Observable<InspectionDto>;
    /**
     * Get all inspections based on provided input request
    If the input's IncludeDeleted property is true, return deleted inspections as well
     * @param tenantId (optional) Tenant Inspection belongs to
     * @param inspectionName (optional) Name of the Inspection
     * @param statuses (optional) List of the Statuses to return results for
     * @param includeDeleted (optional) Flag to determine whether or not to include soft deleted inspections
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllInspections(tenantId?: number | undefined, inspectionName?: string | undefined, statuses?: number[] | undefined, includeDeleted?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<InspectionDtoPagedResultDto>;
    /**
     * Gets basic information about the specified inspection.
    Disables the soft deleted filter to allow retrieval of deleted inspection's properties.
     * @param inspectionId The specified inspection's Id
     * @return Success
     */
    getBasicInspection(inspectionId: number): Observable<BasicInspectionDto>;
    /**
     * Gets asset stats about the specified inspection.
    Disables the soft deleted filter to allow retrieval of deleted inspection's properties.
     * @param inspectionId The specified inspection's Id
     * @return Success
     */
    getInspectionStats(inspectionId: number): Observable<InspectionStatsDto>;
    /**
     * Get the specified inspection's properties.
    Disables the soft deleted filter to allow retrieval of deleted inspection's properties.
     * @param id (optional)
     * @return Success
     */
    getInspection(id?: number | undefined): Observable<InspectionDto>;
    /**
     * Updates the inspection's SME notes.
     * @param inspectionId The identifier of the inspection.
     * @param body (optional) The notes pertaining to this specific inspection for SMEs.
     * @return Success
     */
    updateNotes(inspectionId: number, body?: string | undefined): Observable<void>;
    /**
     * Updates the inspection's properties.
     * @param body (optional) The properties to update
     * @return Success
     */
    update4(body?: UpdateInspectionDto | undefined): Observable<InspectionDto>;
    /**
     * Soft deletes the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @return Deleted
     */
    deleteInspection(inspectionId: number): Observable<void>;
    /**
     * Undeletes the previously soft deleted specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param newInspectionName (optional) The name to which to rename the inspection, which is sometimes necessary
                to avoid conflict with an existing inspection.
     * @return Undeleted
     */
    undeleteInspection(inspectionId: number, newInspectionName?: string | undefined): Observable<void>;
    /**
     * Gets the most recent inspection for the specified user, if the user has restricted inspection permissions. Otherwise, the most recent of all inspections is returned.
     * @return Success
     */
    getMostRecentInspection(): Observable<InspectionDto>;
    /**
     * Check for the status of the most latest durable function to be run on an inspection of any type
     * @param inspectionId Identifier of the inspection for which to check durable functions
     * @return Success
     */
    checkExcelUploadDurableFunctionStatus(inspectionId: number): Observable<ExcelUploadStatusResponse>;
    /**
     * Terminates the current running excel upload durable function associated with the specified inspection.
     * @param inspectionId The ID of the inspection.
     * @return Terminated
     */
    terminateExcelProcessingForInspection(inspectionId: number): Observable<void>;
    /**
     * Retrieve a list of Poletop Excel Upload Durable Functions that have been executed for the current Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getPoletopDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]>;
    /**
     * Retrieve a list of Customer Asset Excel Upload Durable Functions that have been executed for the current
    Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getCustomerAssetDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]>;
    /**
     * Retrieve a list of Image Location Excel Upload Durable Functions that have been executed for the current
    Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getImageLocationDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]>;
    /**
     * Retrieve a list of Span Excel Upload Durable Functions that have been executed for the current Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getSpanDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]>;
    /**
     * Retrieve a list of Condition Excel Upload Durable Functions that have been executed for the current Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getConditionDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]>;
    /**
     * Take in customer data and determine whether to create a new Asset with the customer information or to set the
    information into an existing asset based on calculations of nearest possible poletop location
     * @param inspectionId Identifier of the Inspection to add the asset to
     * @param distRange (optional) The distance range maximum to check for nearby poletops with
     * @param duplicateRange (optional) The distance range maximum to check for duplicates with
     * @param body (optional) Object containing the customer information to set
     * @return Success
     */
    uploadCustomerAsset(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, body?: CustomerAssetData | undefined): Observable<number>;
    /**
     * Upload Customer Assets to the given Inspection by uploading the file to blob storage and kicking off the durable
    function to process the file
     * @param inspectionId ID of the Inspection to add Assets to
     * @param distRange (optional) Positive meter range to check between an Asset's Inspected GPS values and the uploaded Customer Asset
    GPS coordinates
     * @param duplicateRange (optional) Positive meter range to check between the uploaded Customer Asset GPS coordinates and possible duplicate
    Customer GPS coordinates
     * @param customerAssetSheet (optional)
     * @return Success
     */
    uploadCustomerAssets(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, customerAssetSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Take in poletop/inspected asset data and determine whether to create a new Asset with the information or to set
    it into an existing asset based on calculations of nearest possible customer asset location
     * @param inspectionId Identifier of the Inspection to add the asset to
     * @param distRange (optional) The distance range maximum to check for nearby customer assets with
     * @param duplicateRange (optional) The distance range maximum to check for duplicate assets
     * @param body (optional) Object containing the poletop information to set
     * @return Success
     */
    uploadInspectedAsset(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, body?: InspectedAssetData | undefined): Observable<number>;
    /**
     * Creates a new asset under the specified inspection.
     * @param inspectionId The identifier of the inspection.
     * @param body (optional) The location data for the new asset.
     * @return Success
     */
    addNewAsset(inspectionId: number, body?: CreatePoleDto | undefined): Observable<MappedInspectionToAssetDto>;
    /**
     * Creates a new span under the specified inspection.
     * @param inspectionId The identifier of the inspection.
     * @param body (optional) The endpoint data of the new span
     * @return Success
     */
    addNewSpan(inspectionId: number, body?: CreateSpanDto | undefined): Observable<SpanDto>;
    /**
     * Upload Inspected (Poletop) Assets to the given Inspection by uploading the file to blob storage and kicking off
    the durable function to process the file
     * @param inspectionId ID of the Inspection to add the coordinates to
     * @param distRange (optional) Positive meter range to check between an Asset Customer GPS values and the uploaded Inspected Asset GPS
    coordinates
     * @param duplicateRange (optional) Positive meter range to check between the uploaded Inspected Asset GPS coordinates and possible duplicate
    Customer GPS coordinates
     * @param inspectedAssetSheet (optional)
     * @return Success
     */
    uploadInspectedAssets(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, inspectedAssetSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Upload span excel sheet to blob storage and begin processing rows via durable function
     * @param inspectionId ID of the Inspection to add the spans to
     * @param spansSheet (optional)
     * @return Success
     */
    uploadSpans(inspectionId: number, spansSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Take in span data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the span information to set
     * @return Success
     */
    uploadSpan(inspectionId: number, body?: SpanData | undefined): Observable<void>;
    /**
     * Take in span condition data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the span condition information to set
     * @return Success
     */
    uploadSpanCondition(inspectionId: number, body?: SpanConditionData | undefined): Observable<void>;
    /**
     * Create a proper directory for the Blob File Container of the given Inspection.
     * @param inspectionId Identifier of the Inspection to create an Image Directory
     * @return Success
     */
    createImageDirectory(inspectionId: number): Observable<string>;
    /**
     * Check whether or not a proper directory path for the Blob File Container exists for the given Inspection If the
    container exists, return storage information regarding it -- if it does not, create it and return the
    information
     * @param inspectionId Identifier of the Inspection to check for the existence of an Image Directory
     * @return Success
     */
    checkImageDirectory(inspectionId: number): Observable<ImageStorageInfoDto>;
    /**
     * Create a proper directory for the Blob File Container of the given Inspection.
     * @param inspectionId Identifier of the Inspection to create a Pole Drill File Directory
     * @return Success
     */
    createPoleDrillFileDirectory(inspectionId: number): Observable<string>;
    /**
     * Check whether or not a proper directory path for the Blob File Container exists for the given Inspection If the
    container exists, return storage information regarding it -- if it does not, return a null object;
     * @return Success
     */
    checkPoleDrillFileDirectory(inspectionId: number): Observable<PoleDrillFileStorageInfoDto>;
    /**
     * Retrieve a list of Pole Drill File Upload Durable Functions that have been executed for the current
    Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getPoleDrillFileDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]>;
    /**
     * Uploads the skittle chart sheet to the inspection
     * @param skittleChartSheet (optional)
     * @return Success
     */
    uploadSkittleChart(inspectionId: number, skittleChartSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Imports the tenant skittle chart to the given inspection.
     * @param inspectionId The given inspection's id.
     * @param tenantSkittleChartId (optional) The id of the tenant skittle chart.
     * @return Success
     */
    importTenantSkittleChart(inspectionId: number, tenantSkittleChartId?: number | undefined): Observable<void>;
    /**
     * Deletes the skittle chart on the given inspection.
     * @param inspectionId The inspection on which to delete the skittle chart.
     * @return Deleted
     */
    deleteSkittleChart(inspectionId: number): Observable<void>;
    /**
     * Fetches the Condition List as a Tree for use in a Tree List
     * @return Success
     */
    getSkittleChartTreeList(inspectionId: number): Observable<ConditionNodeDto[]>;
    /**
     * Adds a given Item Type/Type/Condition Suggestion to the Skittle Chart
     * @param inspectionId Inspection under which to create a skittle chart row
     * @param body (optional) Input data for skittle chart row to be created
     * @return Success
     */
    addSkittleChartRow(inspectionId: number, body?: ConditionNodeDto | undefined): Observable<void>;
    /**
     * Update a given skittle chart with new property data
     * @param inspectionId Identifier of the inspection under which the skittle chart row is to be updated
     * @param skittleChartId Skittle chart compound identifier (ObjectType_Id#) to delete
     * @param body (optional) Data values to update the skittle chart row with
     * @return Success
     */
    updateSkittleChartRow(inspectionId: number, skittleChartId: string, body?: ConditionNodeDto | undefined): Observable<void>;
    /**
     * Delete a given Skittle Chart row
     * @param inspectionId Identifier of the inspection under which the skittle chart row is to be deleted
     * @param skittleChartId Skittle chart compound identifier (ObjectType_Id#) to delete
     * @return Deleted
     */
    deleteSkittleChartRow(inspectionId: number, skittleChartId: string): Observable<void>;
    /**
     * Uploads the conditions sheet to the inspection
     * @param conditionsSheet (optional)
     * @return Success
     */
    uploadConditions(inspectionId: number, conditionsSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Take in condition data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the condition information to set
     * @return Success
     */
    uploadCondition(inspectionId: number, body?: ConditionData | undefined): Observable<void>;
    /**
     * Gets the Poles that satisfy the filters.
     * @param inspectionId The Id of the inspection
     * @param body (optional) The filters by which to restrict the poles of the inspection
     * @return Success
     */
    getInspectionPoles(inspectionId: number, body?: MapPoleFilterDto | undefined): Observable<MapPoleFilterResultDto>;
    /**
     * Gets the Pole related on a given inspection.
     * @param inspectionId The ID of the inspection
     * @param poleId The ID of the pole to retrieve
     * @return Success
     */
    getInspectionPole(inspectionId: number, poleId: number): Observable<AssetDto>;
    /**
     * Gets the Spans that satisfy the filters.
     * @param inspectionId The ID of the inspection
     * @param body (optional) The filters by which to restrict the poles of the inspection
     * @return Success
     */
    getInspectionSpans(inspectionId: number, body?: MapSpanFilterDto | undefined): Observable<MapSpanFilterResultDto>;
    /**
     * Gets the Spans related on a given inspection within the same gap as a given span.
     * @param inspectionId The ID of the inspection
     * @param startAssetId (optional) The ID of the starting asset to retrieve related spans in the same gap
     * @param endAssetId (optional) The ID of the ending asset to retrieve related spans in the same gap
     * @return Success
     */
    getInspectionConnectingSpans(inspectionId: number, startAssetId?: number | undefined, endAssetId?: number | undefined): Observable<SpanInfoDto[]>;
    /**
     * Creates assets for this inspection.
     * @param inspectionId The ID of the inspection.
     * @param assetId (optional) The ID of the asset.
     * @return Asset Added
     */
    addAsset(inspectionId: number, assetId?: number | undefined): Observable<void>;
    /**
     * Removes the given set of Assets from an Inspection.
     * @param inspectionId Identifier of the Inspection
     * @param body (optional) The IDs of the assets to remove from the specified inspection.
     * @return Deleted
     */
    removeAssets(inspectionId: number, body?: number[] | undefined): Observable<void>;
    /**
     * Does a bulk update of the Analysis Statuses of a group of assets, setting the statuses to Analyzed
     * @param inspectionId Identifier of the Inspection containing the assets.
     * @param body (optional) The IDs of the assets to update the AnalysisStatus to Analyzed.
     * @return Success
     */
    bulkUpdateAnalysisStatuses(inspectionId: number, body?: number[] | undefined): Observable<void>;
    /**
     * Deletes the given Asset from an Inspection (by removing its association)
     * @param inspectionId Identifier of the Inspection
     * @param assetId Identifier of the Asset to remove
     * @return Deleted
     */
    removeAsset(inspectionId: number, assetId: number): Observable<void>;
    /**
     * Link two separate Assets (Pole) -- one Inspected Asset and another Customer Assets into one Asset (Pole) on the Inspection
     * @param inspectionId Identifier of the Inspection
     * @param inspectedAssetId Identifier of the Inspected Asset to join
     * @param customerAssetId Identifier of the Customer Asset to join
     * @return Linked
     */
    linkAssets(inspectionId: number, inspectedAssetId: number, customerAssetId: number): Observable<void>;
    /**
     * Link an asset to its nearest unassociated customer asset and also pull in the given list of images
     * @param inspectionId Identifier of the Inspection
     * @param assetId Identifier of the Asset to join
     * @param body (optional) DTO retaining pull distance range and image information to pull to the Inspected Asset
     * @return Success
     */
    linkNearestUnassociatedCustomerAssetAndImages(inspectionId: number, assetId: number, body?: MapAssetPullDto | undefined): Observable<void>;
    /**
     * Unlink the Asset object to two separate Inspected Asset and Customer Asset objects on the Inspection
     * @param inspectionId Identifier of the Inspection
     * @param assetId Identifier of the Asset to split
     * @return Unlinked
     */
    unlinkAsset(inspectionId: number, assetId: number): Observable<void>;
    /**
     * Retrieves images on the inspection
     * @param inspectionId The id of the inspection on which to retrieve images
     * @param getDistanceToAsset (optional) Whether or not to populate the field DistanceTakenFromAsset.
               This is avoided when possible because it is computationally expensive.
     * @return Success
     */
    getImages(inspectionId: number, getDistanceToAsset?: boolean | undefined): Observable<MapImageDto[]>;
    /**
     * Removes the given set of Images from an Inspection.
     * @param inspectionId Identifier of the Inspection
     * @param body (optional) The IDs of the images to remove from the specified inspection.
     * @return Deleted
     */
    removeImages(inspectionId: number, body?: number[] | undefined): Observable<void>;
    /**
     * Retrieves a list of Inspection Files on a given Inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Inspection Files.
     * @return Success
     */
    getInspectionFiles(inspectionId: number): Observable<InspectionFileDto[]>;
    /**
     * Creates a new Inspection File for this Inspection.
     * @param inspectionId The ID of the inspection.
     * @param name (optional) Name for the Inspection File
     * @param description (optional) Description for the Inspection File
     * @param inspectionFile (optional)
     * @return Created
     */
    addInspectionFile(inspectionId: number, name?: string | undefined, description?: string | undefined, inspectionFile?: FileParameter | undefined): Observable<void>;
    /**
     * Retrieve links on a given Inspection.
     * @param inspectionId Identifier of the Inspection from which to pull links.
     * @return Success
     */
    getInspectionLinks(inspectionId: number): Observable<LinkDto[]>;
    /**
     * Creates a new Link for this Inspection.
     * @param inspectionId The ID of the inspection.
     * @param name (optional) Name for the Link
     * @param description (optional) Description for the Link
     * @param url (optional) Url for the Link
     * @param isUrlEmbeddable (optional) Embeddable flag for the Link
     * @return Created
     */
    addLink(inspectionId: number, name?: string | undefined, description?: string | undefined, url?: string | undefined, isUrlEmbeddable?: boolean | undefined): Observable<void>;
    /**
     * Update values for a given Inspection File.
     * @param inspectionId Identifier of the Inspection that the Inspection File is under
     * @param fileId Identifier of the Inspection File to update
     * @param body (optional) Data with which to update the Inspection File's stored properties
     * @return Success
     */
    updateInspectionFile(inspectionId: number, fileId: number, body?: InspectionFileDto | undefined): Observable<void>;
    /**
     * Delete the given Inspection File from the given Inspection
     * @param inspectionId Identifier of the Inspection
     * @param fileId Identifier of the Inspection File to delete
     * @return Deleted
     */
    deleteInspectionFile(inspectionId: number, fileId: number): Observable<void>;
    /**
     * Updates the specified link on the specified inspection.
     * @param inspectionId The ID of the inspection the Link belongs to.
     * @param linkId The ID of the Link.
     * @param body (optional) The data to use to update the Link.
     * @return Success
     */
    updateLink(inspectionId: number, linkId: number, body?: LinkDto | undefined): Observable<void>;
    /**
     * Removes the specified Link from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param linkId The ID of the Link.
     * @return Deleted
     */
    deleteLink(inspectionId: number, linkId: number): Observable<void>;
    /**
     * Upload Coordinates and match them to Assets if possible at the given Inspection based on spreadsheet upload
     * @param inspectionId ID of the Inspection to add the coordinates to
     * @param imageLocationsSheet (optional)
     * @return Success
     */
    uploadImageLocations(inspectionId: number, imageLocationsSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Take in image data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the image information to set
     * @return Success
     */
    uploadImageLocation(inspectionId: number, body?: ImageData | undefined): Observable<void>;
    /**
     * Check whether or not a proper directory path for the Blob File Container exists for the given Inspection
    If the container exists, return storage information regarding it -- if it does not, create it and return the information
     * @param inspectionId Identifier of the Inspection to check for the existence of an Orthomosaic Directory
     * @return Success
     */
    getOrthomosaicDirectoryInfo(inspectionId: number): Observable<OrthomosaicStorageInfoDto>;
    /**
     * Retrieves a list of Orthomosaics on a given Inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Orthomosaics.
     * @param onlyDisplayable (optional) Whether to only obtain orthomosaics that can be displayed. Defaults to false.
     * @return Success
     */
    getOrthomosaics(inspectionId: number, onlyDisplayable?: boolean | undefined): Observable<OrthomosaicDto[]>;
    /**
     * Creates a new Orthomosaic for this Inspection.
     * @param inspectionId The ID of the inspection.
     * @param body (optional) The data for the Orthomosaic to be created
     * @return Created
     */
    addOrthomosaic(inspectionId: number, body?: CreateOrthomosaicDto | undefined): Observable<OrthomosaicDto>;
    /**
     * Updates the specified Orthomosaic on the specified inspection.
     * @param inspectionId The ID of the inspection the Orthomosaic belongs to.
     * @param orthomosaicId The ID of the Orthomosaic.
     * @param body (optional) The data for the Orthomosaic to be update
     * @return Success
     */
    updateOrthomosaic(inspectionId: number, orthomosaicId: number, body?: UpdateOrthomosaicDto | undefined): Observable<void>;
    /**
     * Removes the specified Orthomosaic from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param orthomosaicId The ID of the Orthomosaic.
     * @return Deleted
     */
    deleteOrthomosaic(inspectionId: number, orthomosaicId: number): Observable<void>;
    /**
     * Get the Orthomosaic image of the provided path.
     * @param orthomosaicImagePath (optional) The path of the Orthomosaic image in azure blob storage.
     * @return Success
     */
    getOrthomosaicImage(orthomosaicImagePath?: string | undefined): Observable<FileResponse>;
    /**
     * Retrieves a list of circuits on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Circuits.
     * @return Success
     */
    getCircuits(inspectionId: number): Observable<CircuitReportDto[]>;
    /**
     * Adds a Circuit to an Inspection.
     * @param inspectionId The ID of the inspection.
     * @param circuitId The ID of the circuit to add to the inspection
     * @return Added
     */
    addCircuit(inspectionId: number, circuitId: number): Observable<CircuitDto>;
    /**
     * Removes the specified Circuit from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param circuitId The ID of the Circuit to remove.
     * @return Removed
     */
    removeCircuit(inspectionId: number, circuitId: number): Observable<void>;
    /**
     * Retrieves a list of custom asset properties on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Custom Asset Properties.
     * @return Success
     */
    getCustomAssetProperties(inspectionId: number): Observable<CustomAssetPropertyDto[]>;
    /**
     * Adds a Custom Asset Property to an Inspection.
     * @param inspectionId The ID of the inspection.
     * @param customAssetPropertyId The ID of the Custom Asset Property to add to the inspection
     * @return Added
     */
    addCustomAssetProperty(inspectionId: number, customAssetPropertyId: number): Observable<void>;
    /**
     * Removes the specified Custom Asset Property from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param customAssetPropertyId The ID of the Custom Asset Property to remove.
     * @return Removed
     */
    removeCustomAssetProperty(inspectionId: number, customAssetPropertyId: number): Observable<void>;
    /**
     * Retrieves a list of custom asset properties on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Custom Asset Properties.
     * @return Success
     */
    getComputerVisionModels(inspectionId: number): Observable<ComputerVisionModelDto[]>;
    /**
     * Retrieves the InspectionToComputerVisionModels for a given inspection
     * @return Success
     */
    getInspectionToComputerVisionModels(inspectionId: number): Observable<InspectionToComputerVisionModelDto[]>;
    /**
     * Retrieves a list of Contractors assigned for Data Collection on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull data collection contractor assignments.
     * @return Success
     */
    getInspectionContractors(inspectionId: number): Observable<UserInspectionDataCollectionAssignmentDto[]>;
    /**
     * Adds a user as a Data Collection Contractor to an Inspection.
     * @param inspectionId The identifier of the Inspection under which User should be added as a Data Collection Contractor
     * @param userId (optional) The identifier of the User to be added as a Data Collection Contractor/
     * @return Added
     */
    addContractor(inspectionId: number, userId?: number | undefined): Observable<UserInspectionDataCollectionAssignmentDto>;
    /**
     * Removes the specified Contractor from the specified Inspection.
     * @param inspectionId The identifier of the Inspection.
     * @param userId The identifier of the Contractor to remove from the Inspection.
     * @return Removed
     */
    removeContractor(inspectionId: number, userId: number): Observable<void>;
    /**
     * Retrieves a list of Limited Inspectors on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull inspection permission assignments.
     * @return Success
     */
    getInspectionLimitedInspectors(inspectionId: number): Observable<InspectionPermissionDto[]>;
    /**
     * Adds a user as a Limited Inspector to an Inspection.
     * @param inspectionId The identifier of the Inspection under which User should be added as a Limited Inspector
     * @param body (optional) The data representative the User to be added as a Limited Inspector/
     * @return Added
     */
    addLimitedInspector(inspectionId: number, body?: CreateInspectionPermissionDto | undefined): Observable<InspectionPermissionDto>;
    /**
     * Update Limited Inspector properties
     * @param inspectionId The identifier of the Inspection under which User should be added as a Limited Inspector
     * @param body (optional) The data representative the User to be added as a Limited Inspector/
     * @return Updated
     */
    updateLimitedInspector(inspectionId: number, userId: number, body?: UpdateInspectionPermissionDto | undefined): Observable<InspectionPermissionDto>;
    /**
     * Removes the specified Limited Inspector from the specified Inspection.
     * @param inspectionId The identifier of the Inspection.
     * @param userId The identifier of the Limited Inspector to remove from the Inspection.
     * @return Removed
     */
    removeLimitedInspector(inspectionId: number, userId: number): Observable<void>;
    /**
     * Retrieves a list of Inspection Quality Assurance Levels on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Inspection Quality Assurance Levels.
     * @return Success
     */
    getQualityAssuranceLevels(inspectionId: number): Observable<InspectionQualityAssuranceLevelDto[]>;
    /**
     * Adds an Inspection Quality Assurance Level to an Inspection.
     * @param inspectionId The identifier of the inspection under which the Inspection Quality Assurance Level should be found
     * @param body (optional) Contains data related to the Inspection Quality Assurance Level
     * @return Added
     */
    addQualityAssuranceLevel(inspectionId: number, body?: CreateInspectionQualityAssuranceLevelDto | undefined): Observable<InspectionQualityAssuranceLevelDto>;
    /**
     * Creates an Inspection Quality Assurance Level under an Inspection.
     * @param inspectionId The identifier of the inspection under which the Inspection Quality Assurance Level should be found
     * @param levelId The identifier of the level under the inspection to update.
     * @param body (optional) The QC percentage to assign to the level.
     * @return Updated
     */
    updateQualityAssuranceLevel(inspectionId: number, levelId: number, body?: number | undefined): Observable<InspectionQualityAssuranceLevelDto>;
    /**
     * Removes the specified Quality Assurance Level from the specified Inspection.
     * @param inspectionId The identifier of the Inspection.
     * @param levelId The identifier of the Inspection Quality Assurance Level to delete.
     * @return Removed
     */
    removeQualityAssuranceLevel(inspectionId: number, levelId: number): Observable<void>;
    /**
     * Updates the given Asset's analysis status from the specified Inspection.
     * @param inspectionId The indentifier of the Inspection
     * @param assetId The identifier of the Asset
     * @return Updated
     */
    setInspectionPoleAsAnalyzed(inspectionId: number, assetId: number): Observable<void>;
    /**
     * Gets the number of QC fail and error assets that are review pending for the logged in user.
     * @return Success
     */
    getQCFeedbackAssetsForUser(): Observable<QCFeedbackDto[]>;
    /**
     * Gets the high priority QC Pending assets. High priority is P10/P20.
     * @return Success
     */
    getHighPriorityQCPendingNotificationsForUser(): Observable<HighPriorityQCPendingNotificationDto[]>;
    /**
     * Endpoint to query InspectionToAssets
     * @param assetIds (optional)
     * @param circuitIds (optional)
     * @param inspected (optional)
     * @param includeImages (optional)
     * @return Success
     */
    getInspectionToAssets(inspectionId: number, assetIds?: number[] | undefined, circuitIds?: number[] | undefined, inspected?: boolean | undefined, includeImages?: boolean | undefined): Observable<WBInspectionToAssetDto[]>;
    /**
     * Endpoint to query historical InspectionToAssets
     * @return Success
     */
    getHistoricalInspectionToAssets(assetId: number, inspectionId: number): Observable<WBInspectionToAssetDto[]>;
    /**
     * Endpoint to grab the number of assets
     * @param circuitIds (optional)
     * @return Success
     */
    assetCount(inspectionId: number, circuitIds?: number[] | undefined): Observable<number>;
    /**
     * Update QC for InspectionToAsset
     * @param body (optional)
     * @return Updated
     */
    qualityCheckReviewInspectionToAsset(inspectionId: number, assetId: number, body?: UpdateQCInspectionToAssetDto | undefined): Observable<QCInspectionToAssetDto>;
    /**
     * Quick Pass InspectionToAsset
     * @param body (optional)
     * @return Updated
     */
    quickPassInspectionToAsset(inspectionId: number, assetId: number, body?: UpdateQCInspectionToAssetDto | undefined): Observable<QCInspectionToAssetDto>;
    /**
     * Returns the ids of the assets on the inspection that have at least one image on them that is audit required.
     * @return Success
     */
    assetsWithAuditRequiredImages(inspectionId: number): Observable<number[]>;
    /**
     * Update/Create/Delete ConditionQualityAssuranceNote of the conditions in the provided list.
     * @param body (optional)
     * @return Created
     */
    upsertConditionQCNotes(inspectionId: number, assetId: number, body?: UpsertConditionQualityAssuranceNoteDto[] | undefined): Observable<void>;
    /**
     * Update/Create/Delete InventoryItemQualityAssuranceNote of the inventory itesm in the provided list.
     * @param body (optional)
     * @return Created
     */
    upsertInventoryItemQCNotes(inspectionId: number, assetId: number, body?: UpsertInventoryItemQualityAssuranceNoteDto[] | undefined): Observable<void>;
    /**
     * Determine if a user has historical condition access for a given inspection
     * @return Success
     */
    getHistoricalConditionAccess(inspectionId: number): Observable<HistoricalConditionAccessDto>;
}

@Injectable()
export class InspectionServiceProxy implements IInspectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Exports filtered assets to an xlsx file.
     * @param inspectionId The ID of the inspection.
     * @param facilityId (optional) The facility ID to filter on
     * @param collectorId (optional) The Collector ID to filter on
     * @param includeAssetGPS (optional) Whether assets should be shown.
     * @param includeCustomerGPS (optional) Flag determining whether Customer GPS should be included in the results
     * @param customerGPSMissing (optional) Determines whether to only get assets where customer GPS data is missing
     * @param inspectedAssetGPSMissing (optional) Determines whether to only get assets where the inspected asset GPS data is missing.
     * @param imagesMissing (optional) Fkag determining whether the results should be refined to assets with no images
     * @param minExcessiveAssetInternalDistance (optional) Filter for Assets that have internal Asset GPS and Customer GPS distance that exceeds the number of meters provided
     * @param maxDistanceBetweenAssets (optional) Filter for Assets that are within the the given number of meters from other assets
     * @param minDistanceToImage (optional) Filter for Images that exceeds the number of meters from their parent Asset
     * @param assetId (optional) The Asset ID to filter on
     * @return Success
     */
    exportAssets(inspectionId: number, facilityId?: string | undefined, collectorId?: string | undefined, includeAssetGPS?: boolean | undefined, includeCustomerGPS?: boolean | undefined, customerGPSMissing?: boolean | undefined, inspectedAssetGPSMissing?: boolean | undefined, imagesMissing?: boolean | undefined, minExcessiveAssetInternalDistance?: number | undefined, maxDistanceBetweenAssets?: number | undefined, minDistanceToImage?: number | undefined, assetId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/AssetData?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (facilityId === null)
            throw new Error("The parameter 'facilityId' cannot be null.");
        else if (facilityId !== undefined)
            url_ += "facilityId=" + encodeURIComponent("" + facilityId) + "&";
        if (collectorId === null)
            throw new Error("The parameter 'collectorId' cannot be null.");
        else if (collectorId !== undefined)
            url_ += "collectorId=" + encodeURIComponent("" + collectorId) + "&";
        if (includeAssetGPS === null)
            throw new Error("The parameter 'includeAssetGPS' cannot be null.");
        else if (includeAssetGPS !== undefined)
            url_ += "includeAssetGPS=" + encodeURIComponent("" + includeAssetGPS) + "&";
        if (includeCustomerGPS === null)
            throw new Error("The parameter 'includeCustomerGPS' cannot be null.");
        else if (includeCustomerGPS !== undefined)
            url_ += "includeCustomerGPS=" + encodeURIComponent("" + includeCustomerGPS) + "&";
        if (customerGPSMissing === null)
            throw new Error("The parameter 'customerGPSMissing' cannot be null.");
        else if (customerGPSMissing !== undefined)
            url_ += "customerGPSMissing=" + encodeURIComponent("" + customerGPSMissing) + "&";
        if (inspectedAssetGPSMissing === null)
            throw new Error("The parameter 'inspectedAssetGPSMissing' cannot be null.");
        else if (inspectedAssetGPSMissing !== undefined)
            url_ += "inspectedAssetGPSMissing=" + encodeURIComponent("" + inspectedAssetGPSMissing) + "&";
        if (imagesMissing === null)
            throw new Error("The parameter 'imagesMissing' cannot be null.");
        else if (imagesMissing !== undefined)
            url_ += "imagesMissing=" + encodeURIComponent("" + imagesMissing) + "&";
        if (minExcessiveAssetInternalDistance === null)
            throw new Error("The parameter 'minExcessiveAssetInternalDistance' cannot be null.");
        else if (minExcessiveAssetInternalDistance !== undefined)
            url_ += "minExcessiveAssetInternalDistance=" + encodeURIComponent("" + minExcessiveAssetInternalDistance) + "&";
        if (maxDistanceBetweenAssets === null)
            throw new Error("The parameter 'maxDistanceBetweenAssets' cannot be null.");
        else if (maxDistanceBetweenAssets !== undefined)
            url_ += "maxDistanceBetweenAssets=" + encodeURIComponent("" + maxDistanceBetweenAssets) + "&";
        if (minDistanceToImage === null)
            throw new Error("The parameter 'minDistanceToImage' cannot be null.");
        else if (minDistanceToImage !== undefined)
            url_ += "minDistanceToImage=" + encodeURIComponent("" + minDistanceToImage) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportAssets(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports all Condition Suggestions to an xlsx file.
     * @param inspectionId The ID of the inspection.
     * @return Success
     */
    exportSkittleChart(inspectionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/SkittleChart";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSkittleChart(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports all image information to an xlsx file.
     * @param inspectionId The ID of the inspection.
     * @param facilityId (optional) The facility ID to filter on
     * @param collectorId (optional) The Collector ID to filter on
     * @param includeAssetGPS (optional) Whether assets should be shown.
     * @param includeCustomerGPS (optional) Flag determining whether Customer GPS should be included in the results
     * @param customerGPSMissing (optional) Determines whether to only get assets where customer GPS data is missing
     * @param inspectedAssetGPSMissing (optional) Determines whether to only get assets where the inspected asset GPS data is missing.
     * @param imagesMissing (optional) Fkag determining whether the results should be refined to assets with no images
     * @param minExcessiveAssetInternalDistance (optional) Filter for Assets that have internal Asset GPS and Customer GPS distance that exceeds the number of meters provided
     * @param maxDistanceBetweenAssets (optional) Filter for Assets that are within the the given number of meters from other assets
     * @param minDistanceToImage (optional) Filter for Images that exceeds the number of meters from their parent Asset
     * @param imageTypes (optional) Filter for Image Types of a specific "type".
     * @param assetId (optional) The Asset ID to filter on
     * @return Success
     */
    exportImages(inspectionId: number, facilityId?: string | undefined, collectorId?: string | undefined, includeAssetGPS?: boolean | undefined, includeCustomerGPS?: boolean | undefined, customerGPSMissing?: boolean | undefined, inspectedAssetGPSMissing?: boolean | undefined, imagesMissing?: boolean | undefined, minExcessiveAssetInternalDistance?: number | undefined, maxDistanceBetweenAssets?: number | undefined, minDistanceToImage?: number | undefined, imageTypes?: number[] | undefined, assetId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/ImageData?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (facilityId === null)
            throw new Error("The parameter 'facilityId' cannot be null.");
        else if (facilityId !== undefined)
            url_ += "facilityId=" + encodeURIComponent("" + facilityId) + "&";
        if (collectorId === null)
            throw new Error("The parameter 'collectorId' cannot be null.");
        else if (collectorId !== undefined)
            url_ += "collectorId=" + encodeURIComponent("" + collectorId) + "&";
        if (includeAssetGPS === null)
            throw new Error("The parameter 'includeAssetGPS' cannot be null.");
        else if (includeAssetGPS !== undefined)
            url_ += "includeAssetGPS=" + encodeURIComponent("" + includeAssetGPS) + "&";
        if (includeCustomerGPS === null)
            throw new Error("The parameter 'includeCustomerGPS' cannot be null.");
        else if (includeCustomerGPS !== undefined)
            url_ += "includeCustomerGPS=" + encodeURIComponent("" + includeCustomerGPS) + "&";
        if (customerGPSMissing === null)
            throw new Error("The parameter 'customerGPSMissing' cannot be null.");
        else if (customerGPSMissing !== undefined)
            url_ += "customerGPSMissing=" + encodeURIComponent("" + customerGPSMissing) + "&";
        if (inspectedAssetGPSMissing === null)
            throw new Error("The parameter 'inspectedAssetGPSMissing' cannot be null.");
        else if (inspectedAssetGPSMissing !== undefined)
            url_ += "inspectedAssetGPSMissing=" + encodeURIComponent("" + inspectedAssetGPSMissing) + "&";
        if (imagesMissing === null)
            throw new Error("The parameter 'imagesMissing' cannot be null.");
        else if (imagesMissing !== undefined)
            url_ += "imagesMissing=" + encodeURIComponent("" + imagesMissing) + "&";
        if (minExcessiveAssetInternalDistance === null)
            throw new Error("The parameter 'minExcessiveAssetInternalDistance' cannot be null.");
        else if (minExcessiveAssetInternalDistance !== undefined)
            url_ += "minExcessiveAssetInternalDistance=" + encodeURIComponent("" + minExcessiveAssetInternalDistance) + "&";
        if (maxDistanceBetweenAssets === null)
            throw new Error("The parameter 'maxDistanceBetweenAssets' cannot be null.");
        else if (maxDistanceBetweenAssets !== undefined)
            url_ += "maxDistanceBetweenAssets=" + encodeURIComponent("" + maxDistanceBetweenAssets) + "&";
        if (minDistanceToImage === null)
            throw new Error("The parameter 'minDistanceToImage' cannot be null.");
        else if (minDistanceToImage !== undefined)
            url_ += "minDistanceToImage=" + encodeURIComponent("" + minDistanceToImage) + "&";
        if (imageTypes === null)
            throw new Error("The parameter 'imageTypes' cannot be null.");
        else if (imageTypes !== undefined)
            imageTypes && imageTypes.forEach(item => { url_ += "imageTypes=" + encodeURIComponent("" + item) + "&"; });
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportImages(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a given Inspection File on a specified inspection for download.
     * @param inspectionId The ID of the Inspection from which to get the Inspection File.
     * @param fileId The ID of the Associated Inspection File to retrieve.
     * @return Success
     */
    downloadInspectionFile(inspectionId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/InspectionFiles/{fileId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInspectionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInspectionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInspectionFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a given uploaded file on a specified inspection for download
     * @param inspectionId The ID of the Inspection from which to get the uploaded file
     * @param durableFunctionId The ID of the Durable Function run instance for which the file was uploaded
     * @return Success
     */
    downloadDurableFunctionFile(inspectionId: number, durableFunctionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/DurableFunctions/{durableFunctionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (durableFunctionId === undefined || durableFunctionId === null)
            throw new Error("The parameter 'durableFunctionId' must be defined.");
        url_ = url_.replace("{durableFunctionId}", encodeURIComponent("" + durableFunctionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDurableFunctionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDurableFunctionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDurableFunctionFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create an inspection based on provided input as well as its Azure Blob directory structure
     * @param body (optional) The inspection creation DTO containing values to fill the new inspection with
     * @return Success
     */
    create4(body?: CreateInspectionDto | undefined): Observable<InspectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDto>;
        }));
    }

    protected processCreate4(response: HttpResponseBase): Observable<InspectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all inspections based on provided input request
    If the input's IncludeDeleted property is true, return deleted inspections as well
     * @param tenantId (optional) Tenant Inspection belongs to
     * @param inspectionName (optional) Name of the Inspection
     * @param statuses (optional) List of the Statuses to return results for
     * @param includeDeleted (optional) Flag to determine whether or not to include soft deleted inspections
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllInspections(tenantId?: number | undefined, inspectionName?: string | undefined, statuses?: number[] | undefined, includeDeleted?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<InspectionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/GetAll?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (inspectionName === null)
            throw new Error("The parameter 'inspectionName' cannot be null.");
        else if (inspectionName !== undefined)
            url_ += "InspectionName=" + encodeURIComponent("" + inspectionName) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInspections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInspections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDtoPagedResultDto>;
        }));
    }

    protected processGetAllInspections(response: HttpResponseBase): Observable<InspectionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets basic information about the specified inspection.
    Disables the soft deleted filter to allow retrieval of deleted inspection's properties.
     * @param inspectionId The specified inspection's Id
     * @return Success
     */
    getBasicInspection(inspectionId: number): Observable<BasicInspectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Basic";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicInspectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicInspectionDto>;
        }));
    }

    protected processGetBasicInspection(response: HttpResponseBase): Observable<BasicInspectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicInspectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets asset stats about the specified inspection.
    Disables the soft deleted filter to allow retrieval of deleted inspection's properties.
     * @param inspectionId The specified inspection's Id
     * @return Success
     */
    getInspectionStats(inspectionId: number): Observable<InspectionStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Stats";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionStatsDto>;
        }));
    }

    protected processGetInspectionStats(response: HttpResponseBase): Observable<InspectionStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the specified inspection's properties.
    Disables the soft deleted filter to allow retrieval of deleted inspection's properties.
     * @param id (optional)
     * @return Success
     */
    getInspection(id?: number | undefined): Observable<InspectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDto>;
        }));
    }

    protected processGetInspection(response: HttpResponseBase): Observable<InspectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the inspection's SME notes.
     * @param inspectionId The identifier of the inspection.
     * @param body (optional) The notes pertaining to this specific inspection for SMEs.
     * @return Success
     */
    updateNotes(inspectionId: number, body?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SMENotes";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the inspection's properties.
     * @param body (optional) The properties to update
     * @return Success
     */
    update4(body?: UpdateInspectionDto | undefined): Observable<InspectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDto>;
        }));
    }

    protected processUpdate4(response: HttpResponseBase): Observable<InspectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Soft deletes the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @return Deleted
     */
    deleteInspection(inspectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Undeletes the previously soft deleted specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param newInspectionName (optional) The name to which to rename the inspection, which is sometimes necessary
                to avoid conflict with an existing inspection.
     * @return Undeleted
     */
    undeleteInspection(inspectionId: number, newInspectionName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Undelete?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (newInspectionName === null)
            throw new Error("The parameter 'newInspectionName' cannot be null.");
        else if (newInspectionName !== undefined)
            url_ += "newInspectionName=" + encodeURIComponent("" + newInspectionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndeleteInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndeleteInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUndeleteInspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the most recent inspection for the specified user, if the user has restricted inspection permissions. Otherwise, the most recent of all inspections is returned.
     * @return Success
     */
    getMostRecentInspection(): Observable<InspectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/MostRecent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMostRecentInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMostRecentInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDto>;
        }));
    }

    protected processGetMostRecentInspection(response: HttpResponseBase): Observable<InspectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check for the status of the most latest durable function to be run on an inspection of any type
     * @param inspectionId Identifier of the inspection for which to check durable functions
     * @return Success
     */
    checkExcelUploadDurableFunctionStatus(inspectionId: number): Observable<ExcelUploadStatusResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ExcelUploadDurableFunctionStatus";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExcelUploadDurableFunctionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExcelUploadDurableFunctionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelUploadStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelUploadStatusResponse>;
        }));
    }

    protected processCheckExcelUploadDurableFunctionStatus(response: HttpResponseBase): Observable<ExcelUploadStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelUploadStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Terminates the current running excel upload durable function associated with the specified inspection.
     * @param inspectionId The ID of the inspection.
     * @return Terminated
     */
    terminateExcelProcessingForInspection(inspectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ExcelUploadDurableFunction";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateExcelProcessingForInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateExcelProcessingForInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateExcelProcessingForInspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of Poletop Excel Upload Durable Functions that have been executed for the current Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getPoletopDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/PoletopDurableFunctions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoletopDurableFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoletopDurableFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto[]>;
        }));
    }

    protected processGetPoletopDurableFunctions(response: HttpResponseBase): Observable<DurableFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurableFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of Customer Asset Excel Upload Durable Functions that have been executed for the current
    Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getCustomerAssetDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/CustomerAssetDurableFunctions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerAssetDurableFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerAssetDurableFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto[]>;
        }));
    }

    protected processGetCustomerAssetDurableFunctions(response: HttpResponseBase): Observable<DurableFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurableFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of Image Location Excel Upload Durable Functions that have been executed for the current
    Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getImageLocationDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ImageLocationDurableFunctions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageLocationDurableFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageLocationDurableFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto[]>;
        }));
    }

    protected processGetImageLocationDurableFunctions(response: HttpResponseBase): Observable<DurableFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurableFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of Span Excel Upload Durable Functions that have been executed for the current Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getSpanDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SpanDurableFunctions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpanDurableFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpanDurableFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto[]>;
        }));
    }

    protected processGetSpanDurableFunctions(response: HttpResponseBase): Observable<DurableFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurableFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of Condition Excel Upload Durable Functions that have been executed for the current Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getConditionDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ConditionDurableFunctions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionDurableFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionDurableFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto[]>;
        }));
    }

    protected processGetConditionDurableFunctions(response: HttpResponseBase): Observable<DurableFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurableFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Take in customer data and determine whether to create a new Asset with the customer information or to set the
    information into an existing asset based on calculations of nearest possible poletop location
     * @param inspectionId Identifier of the Inspection to add the asset to
     * @param distRange (optional) The distance range maximum to check for nearby poletops with
     * @param duplicateRange (optional) The distance range maximum to check for duplicates with
     * @param body (optional) Object containing the customer information to set
     * @return Success
     */
    uploadCustomerAsset(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, body?: CustomerAssetData | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/CustomerAsset?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (distRange === null)
            throw new Error("The parameter 'distRange' cannot be null.");
        else if (distRange !== undefined)
            url_ += "distRange=" + encodeURIComponent("" + distRange) + "&";
        if (duplicateRange === null)
            throw new Error("The parameter 'duplicateRange' cannot be null.");
        else if (duplicateRange !== undefined)
            url_ += "duplicateRange=" + encodeURIComponent("" + duplicateRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCustomerAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCustomerAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadCustomerAsset(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;

            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Customer Assets to the given Inspection by uploading the file to blob storage and kicking off the durable
    function to process the file
     * @param inspectionId ID of the Inspection to add Assets to
     * @param distRange (optional) Positive meter range to check between an Asset's Inspected GPS values and the uploaded Customer Asset
    GPS coordinates
     * @param duplicateRange (optional) Positive meter range to check between the uploaded Customer Asset GPS coordinates and possible duplicate
    Customer GPS coordinates
     * @param customerAssetSheet (optional)
     * @return Success
     */
    uploadCustomerAssets(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, customerAssetSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/CustomerAssets?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (distRange === null)
            throw new Error("The parameter 'distRange' cannot be null.");
        else if (distRange !== undefined)
            url_ += "distRange=" + encodeURIComponent("" + distRange) + "&";
        if (duplicateRange === null)
            throw new Error("The parameter 'duplicateRange' cannot be null.");
        else if (duplicateRange !== undefined)
            url_ += "duplicateRange=" + encodeURIComponent("" + duplicateRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customerAssetSheet === null || customerAssetSheet === undefined)
            throw new Error("The parameter 'customerAssetSheet' cannot be null.");
        else
            content_.append("customerAssetSheet", customerAssetSheet.data, customerAssetSheet.fileName ? customerAssetSheet.fileName : "customerAssetSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCustomerAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCustomerAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadCustomerAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Take in poletop/inspected asset data and determine whether to create a new Asset with the information or to set
    it into an existing asset based on calculations of nearest possible customer asset location
     * @param inspectionId Identifier of the Inspection to add the asset to
     * @param distRange (optional) The distance range maximum to check for nearby customer assets with
     * @param duplicateRange (optional) The distance range maximum to check for duplicate assets
     * @param body (optional) Object containing the poletop information to set
     * @return Success
     */
    uploadInspectedAsset(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, body?: InspectedAssetData | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectedAsset?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (distRange === null)
            throw new Error("The parameter 'distRange' cannot be null.");
        else if (distRange !== undefined)
            url_ += "distRange=" + encodeURIComponent("" + distRange) + "&";
        if (duplicateRange === null)
            throw new Error("The parameter 'duplicateRange' cannot be null.");
        else if (duplicateRange !== undefined)
            url_ += "duplicateRange=" + encodeURIComponent("" + duplicateRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInspectedAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInspectedAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadInspectedAsset(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;

            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new asset under the specified inspection.
     * @param inspectionId The identifier of the inspection.
     * @param body (optional) The location data for the new asset.
     * @return Success
     */
    addNewAsset(inspectionId: number, body?: CreatePoleDto | undefined): Observable<MappedInspectionToAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Asset";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MappedInspectionToAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MappedInspectionToAssetDto>;
        }));
    }

    protected processAddNewAsset(response: HttpResponseBase): Observable<MappedInspectionToAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MappedInspectionToAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new span under the specified inspection.
     * @param inspectionId The identifier of the inspection.
     * @param body (optional) The endpoint data of the new span
     * @return Success
     */
    addNewSpan(inspectionId: number, body?: CreateSpanDto | undefined): Observable<SpanDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/AddSpan";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewSpan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewSpan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanDto>;
        }));
    }

    protected processAddNewSpan(response: HttpResponseBase): Observable<SpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Inspected (Poletop) Assets to the given Inspection by uploading the file to blob storage and kicking off
    the durable function to process the file
     * @param inspectionId ID of the Inspection to add the coordinates to
     * @param distRange (optional) Positive meter range to check between an Asset Customer GPS values and the uploaded Inspected Asset GPS
    coordinates
     * @param duplicateRange (optional) Positive meter range to check between the uploaded Inspected Asset GPS coordinates and possible duplicate
    Customer GPS coordinates
     * @param inspectedAssetSheet (optional)
     * @return Success
     */
    uploadInspectedAssets(inspectionId: number, distRange?: number | undefined, duplicateRange?: number | undefined, inspectedAssetSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectedAssets?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (distRange === null)
            throw new Error("The parameter 'distRange' cannot be null.");
        else if (distRange !== undefined)
            url_ += "distRange=" + encodeURIComponent("" + distRange) + "&";
        if (duplicateRange === null)
            throw new Error("The parameter 'duplicateRange' cannot be null.");
        else if (duplicateRange !== undefined)
            url_ += "duplicateRange=" + encodeURIComponent("" + duplicateRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (inspectedAssetSheet === null || inspectedAssetSheet === undefined)
            throw new Error("The parameter 'inspectedAssetSheet' cannot be null.");
        else
            content_.append("inspectedAssetSheet", inspectedAssetSheet.data, inspectedAssetSheet.fileName ? inspectedAssetSheet.fileName : "inspectedAssetSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInspectedAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInspectedAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadInspectedAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload span excel sheet to blob storage and begin processing rows via durable function
     * @param inspectionId ID of the Inspection to add the spans to
     * @param spansSheet (optional)
     * @return Success
     */
    uploadSpans(inspectionId: number, spansSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Spans";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (spansSheet === null || spansSheet === undefined)
            throw new Error("The parameter 'spansSheet' cannot be null.");
        else
            content_.append("spansSheet", spansSheet.data, spansSheet.fileName ? spansSheet.fileName : "spansSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadSpans(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Take in span data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the span information to set
     * @return Success
     */
    uploadSpan(inspectionId: number, body?: SpanData | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Span";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSpan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSpan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadSpan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Take in span condition data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the span condition information to set
     * @return Success
     */
    uploadSpanCondition(inspectionId: number, body?: SpanConditionData | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SpanCondition";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSpanCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSpanCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadSpanCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a proper directory for the Blob File Container of the given Inspection.
     * @param inspectionId Identifier of the Inspection to create an Image Directory
     * @return Success
     */
    createImageDirectory(inspectionId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ImageDirectory";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateImageDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateImageDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateImageDirectory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check whether or not a proper directory path for the Blob File Container exists for the given Inspection If the
    container exists, return storage information regarding it -- if it does not, create it and return the
    information
     * @param inspectionId Identifier of the Inspection to check for the existence of an Image Directory
     * @return Success
     */
    checkImageDirectory(inspectionId: number): Observable<ImageStorageInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ImageDirectory";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckImageDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckImageDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageStorageInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageStorageInfoDto>;
        }));
    }

    protected processCheckImageDirectory(response: HttpResponseBase): Observable<ImageStorageInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageStorageInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a proper directory for the Blob File Container of the given Inspection.
     * @param inspectionId Identifier of the Inspection to create a Pole Drill File Directory
     * @return Success
     */
    createPoleDrillFileDirectory(inspectionId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/PoleDrillFileDirectory";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePoleDrillFileDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePoleDrillFileDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePoleDrillFileDirectory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check whether or not a proper directory path for the Blob File Container exists for the given Inspection If the
    container exists, return storage information regarding it -- if it does not, return a null object;
     * @return Success
     */
    checkPoleDrillFileDirectory(inspectionId: number): Observable<PoleDrillFileStorageInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/PoleDrillFileDirectory";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPoleDrillFileDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPoleDrillFileDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PoleDrillFileStorageInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PoleDrillFileStorageInfoDto>;
        }));
    }

    protected processCheckPoleDrillFileDirectory(response: HttpResponseBase): Observable<PoleDrillFileStorageInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoleDrillFileStorageInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of Pole Drill File Upload Durable Functions that have been executed for the current
    Inspection
     * @param inspectionId The inspection for which to retrieve durable functions for
     * @return Success
     */
    getPoleDrillFileDurableFunctions(inspectionId: number): Observable<DurableFunctionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/PoleDrillFileDurableFunctions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoleDrillFileDurableFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoleDrillFileDurableFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurableFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurableFunctionDto[]>;
        }));
    }

    protected processGetPoleDrillFileDurableFunctions(response: HttpResponseBase): Observable<DurableFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurableFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the skittle chart sheet to the inspection
     * @param skittleChartSheet (optional)
     * @return Success
     */
    uploadSkittleChart(inspectionId: number, skittleChartSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChart";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (skittleChartSheet === null || skittleChartSheet === undefined)
            throw new Error("The parameter 'skittleChartSheet' cannot be null.");
        else
            content_.append("skittleChartSheet", skittleChartSheet.data, skittleChartSheet.fileName ? skittleChartSheet.fileName : "skittleChartSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadSkittleChart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Imports the tenant skittle chart to the given inspection.
     * @param inspectionId The given inspection's id.
     * @param tenantSkittleChartId (optional) The id of the tenant skittle chart.
     * @return Success
     */
    importTenantSkittleChart(inspectionId: number, tenantSkittleChartId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChart?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (tenantSkittleChartId === null)
            throw new Error("The parameter 'tenantSkittleChartId' cannot be null.");
        else if (tenantSkittleChartId !== undefined)
            url_ += "tenantSkittleChartId=" + encodeURIComponent("" + tenantSkittleChartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTenantSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTenantSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportTenantSkittleChart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the skittle chart on the given inspection.
     * @param inspectionId The inspection on which to delete the skittle chart.
     * @return Deleted
     */
    deleteSkittleChart(inspectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChart";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSkittleChart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fetches the Condition List as a Tree for use in a Tree List
     * @return Success
     */
    getSkittleChartTreeList(inspectionId: number): Observable<ConditionNodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChartTreeList";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSkittleChartTreeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSkittleChartTreeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionNodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionNodeDto[]>;
        }));
    }

    protected processGetSkittleChartTreeList(response: HttpResponseBase): Observable<ConditionNodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionNodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a given Item Type/Type/Condition Suggestion to the Skittle Chart
     * @param inspectionId Inspection under which to create a skittle chart row
     * @param body (optional) Input data for skittle chart row to be created
     * @return Success
     */
    addSkittleChartRow(inspectionId: number, body?: ConditionNodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChartTreeList";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSkittleChartRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSkittleChartRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSkittleChartRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a given skittle chart with new property data
     * @param inspectionId Identifier of the inspection under which the skittle chart row is to be updated
     * @param skittleChartId Skittle chart compound identifier (ObjectType_Id#) to delete
     * @param body (optional) Data values to update the skittle chart row with
     * @return Success
     */
    updateSkittleChartRow(inspectionId: number, skittleChartId: string, body?: ConditionNodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChartTreeList/{skittleChartId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSkittleChartRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSkittleChartRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSkittleChartRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a given Skittle Chart row
     * @param inspectionId Identifier of the inspection under which the skittle chart row is to be deleted
     * @param skittleChartId Skittle chart compound identifier (ObjectType_Id#) to delete
     * @return Deleted
     */
    deleteSkittleChartRow(inspectionId: number, skittleChartId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/SkittleChartTreeList/{skittleChartId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSkittleChartRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSkittleChartRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSkittleChartRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the conditions sheet to the inspection
     * @param conditionsSheet (optional)
     * @return Success
     */
    uploadConditions(inspectionId: number, conditionsSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Conditions";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (conditionsSheet === null || conditionsSheet === undefined)
            throw new Error("The parameter 'conditionsSheet' cannot be null.");
        else
            content_.append("conditionsSheet", conditionsSheet.data, conditionsSheet.fileName ? conditionsSheet.fileName : "conditionsSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadConditions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Take in condition data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the condition information to set
     * @return Success
     */
    uploadCondition(inspectionId: number, body?: ConditionData | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Condition";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Poles that satisfy the filters.
     * @param inspectionId The Id of the inspection
     * @param body (optional) The filters by which to restrict the poles of the inspection
     * @return Success
     */
    getInspectionPoles(inspectionId: number, body?: MapPoleFilterDto | undefined): Observable<MapPoleFilterResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Poles";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionPoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionPoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapPoleFilterResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapPoleFilterResultDto>;
        }));
    }

    protected processGetInspectionPoles(response: HttpResponseBase): Observable<MapPoleFilterResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapPoleFilterResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Pole related on a given inspection.
     * @param inspectionId The ID of the inspection
     * @param poleId The ID of the pole to retrieve
     * @return Success
     */
    getInspectionPole(inspectionId: number, poleId: number): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Pole/{poleId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (poleId === undefined || poleId === null)
            throw new Error("The parameter 'poleId' must be defined.");
        url_ = url_.replace("{poleId}", encodeURIComponent("" + poleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionPole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionPole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processGetInspectionPole(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Spans that satisfy the filters.
     * @param inspectionId The ID of the inspection
     * @param body (optional) The filters by which to restrict the poles of the inspection
     * @return Success
     */
    getInspectionSpans(inspectionId: number, body?: MapSpanFilterDto | undefined): Observable<MapSpanFilterResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Spans2";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapSpanFilterResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapSpanFilterResultDto>;
        }));
    }

    protected processGetInspectionSpans(response: HttpResponseBase): Observable<MapSpanFilterResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapSpanFilterResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Spans related on a given inspection within the same gap as a given span.
     * @param inspectionId The ID of the inspection
     * @param startAssetId (optional) The ID of the starting asset to retrieve related spans in the same gap
     * @param endAssetId (optional) The ID of the ending asset to retrieve related spans in the same gap
     * @return Success
     */
    getInspectionConnectingSpans(inspectionId: number, startAssetId?: number | undefined, endAssetId?: number | undefined): Observable<SpanInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ConnectingSpans?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (startAssetId === null)
            throw new Error("The parameter 'startAssetId' cannot be null.");
        else if (startAssetId !== undefined)
            url_ += "startAssetId=" + encodeURIComponent("" + startAssetId) + "&";
        if (endAssetId === null)
            throw new Error("The parameter 'endAssetId' cannot be null.");
        else if (endAssetId !== undefined)
            url_ += "endAssetId=" + encodeURIComponent("" + endAssetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionConnectingSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionConnectingSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanInfoDto[]>;
        }));
    }

    protected processGetInspectionConnectingSpans(response: HttpResponseBase): Observable<SpanInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpanInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates assets for this inspection.
     * @param inspectionId The ID of the inspection.
     * @param assetId (optional) The ID of the asset.
     * @return Asset Added
     */
    addAsset(inspectionId: number, assetId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the given set of Assets from an Inspection.
     * @param inspectionId Identifier of the Inspection
     * @param body (optional) The IDs of the assets to remove from the specified inspection.
     * @return Deleted
     */
    removeAssets(inspectionId: number, body?: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Does a bulk update of the Analysis Statuses of a group of assets, setting the statuses to Analyzed
     * @param inspectionId Identifier of the Inspection containing the assets.
     * @param body (optional) The IDs of the assets to update the AnalysisStatus to Analyzed.
     * @return Success
     */
    bulkUpdateAnalysisStatuses(inspectionId: number, body?: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets/AnalysisStatuses";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateAnalysisStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateAnalysisStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateAnalysisStatuses(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the given Asset from an Inspection (by removing its association)
     * @param inspectionId Identifier of the Inspection
     * @param assetId Identifier of the Asset to remove
     * @return Deleted
     */
    removeAsset(inspectionId: number, assetId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets/{assetId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Link two separate Assets (Pole) -- one Inspected Asset and another Customer Assets into one Asset (Pole) on the Inspection
     * @param inspectionId Identifier of the Inspection
     * @param inspectedAssetId Identifier of the Inspected Asset to join
     * @param customerAssetId Identifier of the Customer Asset to join
     * @return Linked
     */
    linkAssets(inspectionId: number, inspectedAssetId: number, customerAssetId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets/{inspectedAssetId}/{customerAssetId}/LinkAssets";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectedAssetId === undefined || inspectedAssetId === null)
            throw new Error("The parameter 'inspectedAssetId' must be defined.");
        url_ = url_.replace("{inspectedAssetId}", encodeURIComponent("" + inspectedAssetId));
        if (customerAssetId === undefined || customerAssetId === null)
            throw new Error("The parameter 'customerAssetId' must be defined.");
        url_ = url_.replace("{customerAssetId}", encodeURIComponent("" + customerAssetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Link an asset to its nearest unassociated customer asset and also pull in the given list of images
     * @param inspectionId Identifier of the Inspection
     * @param assetId Identifier of the Asset to join
     * @param body (optional) DTO retaining pull distance range and image information to pull to the Inspected Asset
     * @return Success
     */
    linkNearestUnassociatedCustomerAssetAndImages(inspectionId: number, assetId: number, body?: MapAssetPullDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets/{assetId}/LinkNearestUnassociatedCustomerAssetAndImages";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkNearestUnassociatedCustomerAssetAndImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkNearestUnassociatedCustomerAssetAndImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkNearestUnassociatedCustomerAssetAndImages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unlink the Asset object to two separate Inspected Asset and Customer Asset objects on the Inspection
     * @param inspectionId Identifier of the Inspection
     * @param assetId Identifier of the Asset to split
     * @return Unlinked
     */
    unlinkAsset(inspectionId: number, assetId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets/{assetId}/UnlinkAsset";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves images on the inspection
     * @param inspectionId The id of the inspection on which to retrieve images
     * @param getDistanceToAsset (optional) Whether or not to populate the field DistanceTakenFromAsset.
               This is avoided when possible because it is computationally expensive.
     * @return Success
     */
    getImages(inspectionId: number, getDistanceToAsset?: boolean | undefined): Observable<MapImageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/Images?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (getDistanceToAsset === null)
            throw new Error("The parameter 'getDistanceToAsset' cannot be null.");
        else if (getDistanceToAsset !== undefined)
            url_ += "getDistanceToAsset=" + encodeURIComponent("" + getDistanceToAsset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapImageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapImageDto[]>;
        }));
    }

    protected processGetImages(response: HttpResponseBase): Observable<MapImageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MapImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the given set of Images from an Inspection.
     * @param inspectionId Identifier of the Inspection
     * @param body (optional) The IDs of the images to remove from the specified inspection.
     * @return Deleted
     */
    removeImages(inspectionId: number, body?: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Images";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveImages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of Inspection Files on a given Inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Inspection Files.
     * @return Success
     */
    getInspectionFiles(inspectionId: number): Observable<InspectionFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectionFiles";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionFileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionFileDto[]>;
        }));
    }

    protected processGetInspectionFiles(response: HttpResponseBase): Observable<InspectionFileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Inspection File for this Inspection.
     * @param inspectionId The ID of the inspection.
     * @param name (optional) Name for the Inspection File
     * @param description (optional) Description for the Inspection File
     * @param inspectionFile (optional)
     * @return Created
     */
    addInspectionFile(inspectionId: number, name?: string | undefined, description?: string | undefined, inspectionFile?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectionFiles?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (inspectionFile === null || inspectionFile === undefined)
            throw new Error("The parameter 'inspectionFile' cannot be null.");
        else
            content_.append("inspectionFile", inspectionFile.data, inspectionFile.fileName ? inspectionFile.fileName : "inspectionFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInspectionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInspectionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddInspectionFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve links on a given Inspection.
     * @param inspectionId Identifier of the Inspection from which to pull links.
     * @return Success
     */
    getInspectionLinks(inspectionId: number): Observable<LinkDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Links";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkDto[]>;
        }));
    }

    protected processGetInspectionLinks(response: HttpResponseBase): Observable<LinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Link for this Inspection.
     * @param inspectionId The ID of the inspection.
     * @param name (optional) Name for the Link
     * @param description (optional) Description for the Link
     * @param url (optional) Url for the Link
     * @param isUrlEmbeddable (optional) Embeddable flag for the Link
     * @return Created
     */
    addLink(inspectionId: number, name?: string | undefined, description?: string | undefined, url?: string | undefined, isUrlEmbeddable?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Links?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (isUrlEmbeddable === null)
            throw new Error("The parameter 'isUrlEmbeddable' cannot be null.");
        else if (isUrlEmbeddable !== undefined)
            url_ += "isUrlEmbeddable=" + encodeURIComponent("" + isUrlEmbeddable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update values for a given Inspection File.
     * @param inspectionId Identifier of the Inspection that the Inspection File is under
     * @param fileId Identifier of the Inspection File to update
     * @param body (optional) Data with which to update the Inspection File's stored properties
     * @return Success
     */
    updateInspectionFile(inspectionId: number, fileId: number, body?: InspectionFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectionFiles/{fileId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInspectionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInspectionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInspectionFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the given Inspection File from the given Inspection
     * @param inspectionId Identifier of the Inspection
     * @param fileId Identifier of the Inspection File to delete
     * @return Deleted
     */
    deleteInspectionFile(inspectionId: number, fileId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectionFiles/{fileId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInspectionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInspectionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInspectionFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified link on the specified inspection.
     * @param inspectionId The ID of the inspection the Link belongs to.
     * @param linkId The ID of the Link.
     * @param body (optional) The data to use to update the Link.
     * @return Success
     */
    updateLink(inspectionId: number, linkId: number, body?: LinkDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Links/{linkId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Link from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param linkId The ID of the Link.
     * @return Deleted
     */
    deleteLink(inspectionId: number, linkId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Links/{linkId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Coordinates and match them to Assets if possible at the given Inspection based on spreadsheet upload
     * @param inspectionId ID of the Inspection to add the coordinates to
     * @param imageLocationsSheet (optional)
     * @return Success
     */
    uploadImageLocations(inspectionId: number, imageLocationsSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ImageLocations";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageLocationsSheet === null || imageLocationsSheet === undefined)
            throw new Error("The parameter 'imageLocationsSheet' cannot be null.");
        else
            content_.append("imageLocationsSheet", imageLocationsSheet.data, imageLocationsSheet.fileName ? imageLocationsSheet.fileName : "imageLocationsSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadImageLocations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Take in image data to add to a given inspection
     * @param inspectionId Identifier of the inspection to add the asset to
     * @param body (optional) Object containing the image information to set
     * @return Success
     */
    uploadImageLocation(inspectionId: number, body?: ImageData | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ImageLocation";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadImageLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check whether or not a proper directory path for the Blob File Container exists for the given Inspection
    If the container exists, return storage information regarding it -- if it does not, create it and return the information
     * @param inspectionId Identifier of the Inspection to check for the existence of an Orthomosaic Directory
     * @return Success
     */
    getOrthomosaicDirectoryInfo(inspectionId: number): Observable<OrthomosaicStorageInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/OrthomosaicDirectoryInfo";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrthomosaicDirectoryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrthomosaicDirectoryInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrthomosaicStorageInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrthomosaicStorageInfoDto>;
        }));
    }

    protected processGetOrthomosaicDirectoryInfo(response: HttpResponseBase): Observable<OrthomosaicStorageInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrthomosaicStorageInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of Orthomosaics on a given Inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Orthomosaics.
     * @param onlyDisplayable (optional) Whether to only obtain orthomosaics that can be displayed. Defaults to false.
     * @return Success
     */
    getOrthomosaics(inspectionId: number, onlyDisplayable?: boolean | undefined): Observable<OrthomosaicDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Orthomosaics?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (onlyDisplayable === null)
            throw new Error("The parameter 'onlyDisplayable' cannot be null.");
        else if (onlyDisplayable !== undefined)
            url_ += "onlyDisplayable=" + encodeURIComponent("" + onlyDisplayable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrthomosaics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrthomosaics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrthomosaicDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrthomosaicDto[]>;
        }));
    }

    protected processGetOrthomosaics(response: HttpResponseBase): Observable<OrthomosaicDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrthomosaicDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Orthomosaic for this Inspection.
     * @param inspectionId The ID of the inspection.
     * @param body (optional) The data for the Orthomosaic to be created
     * @return Created
     */
    addOrthomosaic(inspectionId: number, body?: CreateOrthomosaicDto | undefined): Observable<OrthomosaicDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Orthomosaics";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrthomosaic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrthomosaic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrthomosaicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrthomosaicDto>;
        }));
    }

    protected processAddOrthomosaic(response: HttpResponseBase): Observable<OrthomosaicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrthomosaicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified Orthomosaic on the specified inspection.
     * @param inspectionId The ID of the inspection the Orthomosaic belongs to.
     * @param orthomosaicId The ID of the Orthomosaic.
     * @param body (optional) The data for the Orthomosaic to be update
     * @return Success
     */
    updateOrthomosaic(inspectionId: number, orthomosaicId: number, body?: UpdateOrthomosaicDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Orthomosaics/{orthomosaicId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (orthomosaicId === undefined || orthomosaicId === null)
            throw new Error("The parameter 'orthomosaicId' must be defined.");
        url_ = url_.replace("{orthomosaicId}", encodeURIComponent("" + orthomosaicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrthomosaic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrthomosaic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrthomosaic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Orthomosaic from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param orthomosaicId The ID of the Orthomosaic.
     * @return Deleted
     */
    deleteOrthomosaic(inspectionId: number, orthomosaicId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Orthomosaics/{orthomosaicId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (orthomosaicId === undefined || orthomosaicId === null)
            throw new Error("The parameter 'orthomosaicId' must be defined.");
        url_ = url_.replace("{orthomosaicId}", encodeURIComponent("" + orthomosaicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrthomosaic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrthomosaic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrthomosaic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Orthomosaic image of the provided path.
     * @param orthomosaicImagePath (optional) The path of the Orthomosaic image in azure blob storage.
     * @return Success
     */
    getOrthomosaicImage(orthomosaicImagePath?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/OrthomosaicImage?";
        if (orthomosaicImagePath === null)
            throw new Error("The parameter 'orthomosaicImagePath' cannot be null.");
        else if (orthomosaicImagePath !== undefined)
            url_ += "orthomosaicImagePath=" + encodeURIComponent("" + orthomosaicImagePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrthomosaicImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrthomosaicImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetOrthomosaicImage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of circuits on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Circuits.
     * @return Success
     */
    getCircuits(inspectionId: number): Observable<CircuitReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Circuits";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCircuits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCircuits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitReportDto[]>;
        }));
    }

    protected processGetCircuits(response: HttpResponseBase): Observable<CircuitReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CircuitReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a Circuit to an Inspection.
     * @param inspectionId The ID of the inspection.
     * @param circuitId The ID of the circuit to add to the inspection
     * @return Added
     */
    addCircuit(inspectionId: number, circuitId: number): Observable<CircuitDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Circuits/{circuitId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (circuitId === undefined || circuitId === null)
            throw new Error("The parameter 'circuitId' must be defined.");
        url_ = url_.replace("{circuitId}", encodeURIComponent("" + circuitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCircuit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCircuit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDto>;
        }));
    }

    protected processAddCircuit(response: HttpResponseBase): Observable<CircuitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CircuitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Circuit from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param circuitId The ID of the Circuit to remove.
     * @return Removed
     */
    removeCircuit(inspectionId: number, circuitId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Circuits/{circuitId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (circuitId === undefined || circuitId === null)
            throw new Error("The parameter 'circuitId' must be defined.");
        url_ = url_.replace("{circuitId}", encodeURIComponent("" + circuitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCircuit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCircuit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCircuit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of custom asset properties on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Custom Asset Properties.
     * @return Success
     */
    getCustomAssetProperties(inspectionId: number): Observable<CustomAssetPropertyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/CustomAssetProperties";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomAssetProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomAssetProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAssetPropertyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAssetPropertyDto[]>;
        }));
    }

    protected processGetCustomAssetProperties(response: HttpResponseBase): Observable<CustomAssetPropertyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomAssetPropertyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a Custom Asset Property to an Inspection.
     * @param inspectionId The ID of the inspection.
     * @param customAssetPropertyId The ID of the Custom Asset Property to add to the inspection
     * @return Added
     */
    addCustomAssetProperty(inspectionId: number, customAssetPropertyId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/CustomAssetProperties/{customAssetPropertyId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (customAssetPropertyId === undefined || customAssetPropertyId === null)
            throw new Error("The parameter 'customAssetPropertyId' must be defined.");
        url_ = url_.replace("{customAssetPropertyId}", encodeURIComponent("" + customAssetPropertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomAssetProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomAssetProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCustomAssetProperty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Custom Asset Property from the specified Inspection.
     * @param inspectionId The ID of the Inspection.
     * @param customAssetPropertyId The ID of the Custom Asset Property to remove.
     * @return Removed
     */
    removeCustomAssetProperty(inspectionId: number, customAssetPropertyId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/CustomAssetProperties/{customAssetPropertyId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (customAssetPropertyId === undefined || customAssetPropertyId === null)
            throw new Error("The parameter 'customAssetPropertyId' must be defined.");
        url_ = url_.replace("{customAssetPropertyId}", encodeURIComponent("" + customAssetPropertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCustomAssetProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCustomAssetProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCustomAssetProperty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of custom asset properties on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Custom Asset Properties.
     * @return Success
     */
    getComputerVisionModels(inspectionId: number): Observable<ComputerVisionModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/ComputerVisionModels";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComputerVisionModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComputerVisionModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComputerVisionModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComputerVisionModelDto[]>;
        }));
    }

    protected processGetComputerVisionModels(response: HttpResponseBase): Observable<ComputerVisionModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComputerVisionModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the InspectionToComputerVisionModels for a given inspection
     * @return Success
     */
    getInspectionToComputerVisionModels(inspectionId: number): Observable<InspectionToComputerVisionModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/InspectionToComputerVisionModels";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionToComputerVisionModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionToComputerVisionModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionToComputerVisionModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionToComputerVisionModelDto[]>;
        }));
    }

    protected processGetInspectionToComputerVisionModels(response: HttpResponseBase): Observable<InspectionToComputerVisionModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionToComputerVisionModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of Contractors assigned for Data Collection on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull data collection contractor assignments.
     * @return Success
     */
    getInspectionContractors(inspectionId: number): Observable<UserInspectionDataCollectionAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Contractors";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionContractors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionContractors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInspectionDataCollectionAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInspectionDataCollectionAssignmentDto[]>;
        }));
    }

    protected processGetInspectionContractors(response: HttpResponseBase): Observable<UserInspectionDataCollectionAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInspectionDataCollectionAssignmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a user as a Data Collection Contractor to an Inspection.
     * @param inspectionId The identifier of the Inspection under which User should be added as a Data Collection Contractor
     * @param userId (optional) The identifier of the User to be added as a Data Collection Contractor/
     * @return Added
     */
    addContractor(inspectionId: number, userId?: number | undefined): Observable<UserInspectionDataCollectionAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Contractors?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddContractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddContractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInspectionDataCollectionAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInspectionDataCollectionAssignmentDto>;
        }));
    }

    protected processAddContractor(response: HttpResponseBase): Observable<UserInspectionDataCollectionAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInspectionDataCollectionAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Contractor from the specified Inspection.
     * @param inspectionId The identifier of the Inspection.
     * @param userId The identifier of the Contractor to remove from the Inspection.
     * @return Removed
     */
    removeContractor(inspectionId: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Contractors/{userId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveContractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveContractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveContractor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of Limited Inspectors on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull inspection permission assignments.
     * @return Success
     */
    getInspectionLimitedInspectors(inspectionId: number): Observable<InspectionPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/LimitedInspectors";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionLimitedInspectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionLimitedInspectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionPermissionDto[]>;
        }));
    }

    protected processGetInspectionLimitedInspectors(response: HttpResponseBase): Observable<InspectionPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a user as a Limited Inspector to an Inspection.
     * @param inspectionId The identifier of the Inspection under which User should be added as a Limited Inspector
     * @param body (optional) The data representative the User to be added as a Limited Inspector/
     * @return Added
     */
    addLimitedInspector(inspectionId: number, body?: CreateInspectionPermissionDto | undefined): Observable<InspectionPermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/LimitedInspectors";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLimitedInspector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLimitedInspector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionPermissionDto>;
        }));
    }

    protected processAddLimitedInspector(response: HttpResponseBase): Observable<InspectionPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Limited Inspector properties
     * @param inspectionId The identifier of the Inspection under which User should be added as a Limited Inspector
     * @param body (optional) The data representative the User to be added as a Limited Inspector/
     * @return Updated
     */
    updateLimitedInspector(inspectionId: number, userId: number, body?: UpdateInspectionPermissionDto | undefined): Observable<InspectionPermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/LimitedInspectors/{userId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLimitedInspector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLimitedInspector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionPermissionDto>;
        }));
    }

    protected processUpdateLimitedInspector(response: HttpResponseBase): Observable<InspectionPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Limited Inspector from the specified Inspection.
     * @param inspectionId The identifier of the Inspection.
     * @param userId The identifier of the Limited Inspector to remove from the Inspection.
     * @return Removed
     */
    removeLimitedInspector(inspectionId: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/LimitedInspectors/{userId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLimitedInspector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLimitedInspector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveLimitedInspector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of Inspection Quality Assurance Levels on a given inspection.
     * @param inspectionId Identifier of the Inspection from which to pull Inspection Quality Assurance Levels.
     * @return Success
     */
    getQualityAssuranceLevels(inspectionId: number): Observable<InspectionQualityAssuranceLevelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/QualityAssuranceLevels";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityAssuranceLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityAssuranceLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionQualityAssuranceLevelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionQualityAssuranceLevelDto[]>;
        }));
    }

    protected processGetQualityAssuranceLevels(response: HttpResponseBase): Observable<InspectionQualityAssuranceLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionQualityAssuranceLevelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds an Inspection Quality Assurance Level to an Inspection.
     * @param inspectionId The identifier of the inspection under which the Inspection Quality Assurance Level should be found
     * @param body (optional) Contains data related to the Inspection Quality Assurance Level
     * @return Added
     */
    addQualityAssuranceLevel(inspectionId: number, body?: CreateInspectionQualityAssuranceLevelDto | undefined): Observable<InspectionQualityAssuranceLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/QualityAssuranceLevels";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQualityAssuranceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQualityAssuranceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionQualityAssuranceLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionQualityAssuranceLevelDto>;
        }));
    }

    protected processAddQualityAssuranceLevel(response: HttpResponseBase): Observable<InspectionQualityAssuranceLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionQualityAssuranceLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates an Inspection Quality Assurance Level under an Inspection.
     * @param inspectionId The identifier of the inspection under which the Inspection Quality Assurance Level should be found
     * @param levelId The identifier of the level under the inspection to update.
     * @param body (optional) The QC percentage to assign to the level.
     * @return Updated
     */
    updateQualityAssuranceLevel(inspectionId: number, levelId: number, body?: number | undefined): Observable<InspectionQualityAssuranceLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/QualityAssuranceLevels/{levelId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (levelId === undefined || levelId === null)
            throw new Error("The parameter 'levelId' must be defined.");
        url_ = url_.replace("{levelId}", encodeURIComponent("" + levelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQualityAssuranceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQualityAssuranceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionQualityAssuranceLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionQualityAssuranceLevelDto>;
        }));
    }

    protected processUpdateQualityAssuranceLevel(response: HttpResponseBase): Observable<InspectionQualityAssuranceLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionQualityAssuranceLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the specified Quality Assurance Level from the specified Inspection.
     * @param inspectionId The identifier of the Inspection.
     * @param levelId The identifier of the Inspection Quality Assurance Level to delete.
     * @return Removed
     */
    removeQualityAssuranceLevel(inspectionId: number, levelId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/QualityAssuranceLevels/{levelId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (levelId === undefined || levelId === null)
            throw new Error("The parameter 'levelId' must be defined.");
        url_ = url_.replace("{levelId}", encodeURIComponent("" + levelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveQualityAssuranceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveQualityAssuranceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveQualityAssuranceLevel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the given Asset's analysis status from the specified Inspection.
     * @param inspectionId The indentifier of the Inspection
     * @param assetId The identifier of the Asset
     * @return Updated
     */
    setInspectionPoleAsAnalyzed(inspectionId: number, assetId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Pole/{assetId}/Analyzed";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetInspectionPoleAsAnalyzed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetInspectionPoleAsAnalyzed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetInspectionPoleAsAnalyzed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number of QC fail and error assets that are review pending for the logged in user.
     * @return Success
     */
    getQCFeedbackAssetsForUser(): Observable<QCFeedbackDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Inspections/GetQCFeedbackAssetsForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQCFeedbackAssetsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQCFeedbackAssetsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QCFeedbackDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QCFeedbackDto[]>;
        }));
    }

    protected processGetQCFeedbackAssetsForUser(response: HttpResponseBase): Observable<QCFeedbackDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QCFeedbackDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the high priority QC Pending assets. High priority is P10/P20.
     * @return Success
     */
    getHighPriorityQCPendingNotificationsForUser(): Observable<HighPriorityQCPendingNotificationDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Inspections/GetHighPriorityQCPendingNotificationsForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHighPriorityQCPendingNotificationsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHighPriorityQCPendingNotificationsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HighPriorityQCPendingNotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HighPriorityQCPendingNotificationDto[]>;
        }));
    }

    protected processGetHighPriorityQCPendingNotificationsForUser(response: HttpResponseBase): Observable<HighPriorityQCPendingNotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HighPriorityQCPendingNotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to query InspectionToAssets
     * @param assetIds (optional)
     * @param circuitIds (optional)
     * @param inspected (optional)
     * @param includeImages (optional)
     * @return Success
     */
    getInspectionToAssets(inspectionId: number, assetIds?: number[] | undefined, circuitIds?: number[] | undefined, inspected?: boolean | undefined, includeImages?: boolean | undefined): Observable<WBInspectionToAssetDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Inspections/{inspectionId}/Assets?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetIds === null)
            throw new Error("The parameter 'assetIds' cannot be null.");
        else if (assetIds !== undefined)
            assetIds && assetIds.forEach(item => { url_ += "assetIds=" + encodeURIComponent("" + item) + "&"; });
        if (circuitIds === null)
            throw new Error("The parameter 'circuitIds' cannot be null.");
        else if (circuitIds !== undefined)
            circuitIds && circuitIds.forEach(item => { url_ += "circuitIds=" + encodeURIComponent("" + item) + "&"; });
        if (inspected === null)
            throw new Error("The parameter 'inspected' cannot be null.");
        else if (inspected !== undefined)
            url_ += "inspected=" + encodeURIComponent("" + inspected) + "&";
        if (includeImages === null)
            throw new Error("The parameter 'includeImages' cannot be null.");
        else if (includeImages !== undefined)
            url_ += "includeImages=" + encodeURIComponent("" + includeImages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionToAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionToAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WBInspectionToAssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WBInspectionToAssetDto[]>;
        }));
    }

    protected processGetInspectionToAssets(response: HttpResponseBase): Observable<WBInspectionToAssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WBInspectionToAssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to query historical InspectionToAssets
     * @return Success
     */
    getHistoricalInspectionToAssets(assetId: number, inspectionId: number): Observable<WBInspectionToAssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspections/{inspectionId}/Assets/{assetId}/History";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalInspectionToAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalInspectionToAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WBInspectionToAssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WBInspectionToAssetDto[]>;
        }));
    }

    protected processGetHistoricalInspectionToAssets(response: HttpResponseBase): Observable<WBInspectionToAssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WBInspectionToAssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to grab the number of assets
     * @param circuitIds (optional)
     * @return Success
     */
    assetCount(inspectionId: number, circuitIds?: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/workbench/Inspection/{inspectionId}/AssetCount?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (circuitIds === null)
            throw new Error("The parameter 'circuitIds' cannot be null.");
        else if (circuitIds !== undefined)
            circuitIds && circuitIds.forEach(item => { url_ += "circuitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAssetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update QC for InspectionToAsset
     * @param body (optional)
     * @return Updated
     */
    qualityCheckReviewInspectionToAsset(inspectionId: number, assetId: number, body?: UpdateQCInspectionToAssetDto | undefined): Observable<QCInspectionToAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/Asset/{assetId}/QC";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQualityCheckReviewInspectionToAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQualityCheckReviewInspectionToAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QCInspectionToAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QCInspectionToAssetDto>;
        }));
    }

    protected processQualityCheckReviewInspectionToAsset(response: HttpResponseBase): Observable<QCInspectionToAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QCInspectionToAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Quick Pass InspectionToAsset
     * @param body (optional)
     * @return Updated
     */
    quickPassInspectionToAsset(inspectionId: number, assetId: number, body?: UpdateQCInspectionToAssetDto | undefined): Observable<QCInspectionToAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/Asset/{assetId}/QuickPass";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickPassInspectionToAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickPassInspectionToAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QCInspectionToAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QCInspectionToAssetDto>;
        }));
    }

    protected processQuickPassInspectionToAsset(response: HttpResponseBase): Observable<QCInspectionToAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QCInspectionToAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the ids of the assets on the inspection that have at least one image on them that is audit required.
     * @return Success
     */
    assetsWithAuditRequiredImages(inspectionId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Inspection/{inspectionId}/AssetsWithAuditRequiredImages";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetsWithAuditRequiredImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetsWithAuditRequiredImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAssetsWithAuditRequiredImages(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update/Create/Delete ConditionQualityAssuranceNote of the conditions in the provided list.
     * @param body (optional)
     * @return Created
     */
    upsertConditionQCNotes(inspectionId: number, assetId: number, body?: UpsertConditionQualityAssuranceNoteDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/Asset/{assetId}/ConditionNotes";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertConditionQCNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertConditionQCNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertConditionQCNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update/Create/Delete InventoryItemQualityAssuranceNote of the inventory itesm in the provided list.
     * @param body (optional)
     * @return Created
     */
    upsertInventoryItemQCNotes(inspectionId: number, assetId: number, body?: UpsertInventoryItemQualityAssuranceNoteDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/Asset/{assetId}/InventoryItemNotes";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertInventoryItemQCNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertInventoryItemQCNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertInventoryItemQCNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determine if a user has historical condition access for a given inspection
     * @return Success
     */
    getHistoricalConditionAccess(inspectionId: number): Observable<HistoricalConditionAccessDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/{inspectionId}/HistoricalConditionAccess";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalConditionAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalConditionAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalConditionAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalConditionAccessDto>;
        }));
    }

    protected processGetHistoricalConditionAccess(response: HttpResponseBase): Observable<HistoricalConditionAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalConditionAccessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInspectionJobTypesServiceProxy {
    /**
     * @return Success
     */
    getAllInspectionJobTypes(): Observable<InspectionJobTypeDto[]>;
}

@Injectable()
export class InspectionJobTypesServiceProxy implements IInspectionJobTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllInspectionJobTypes(): Observable<InspectionJobTypeDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/InspectionJobTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInspectionJobTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInspectionJobTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionJobTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionJobTypeDto[]>;
        }));
    }

    protected processGetAllInspectionJobTypes(response: HttpResponseBase): Observable<InspectionJobTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionJobTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInspectionStatusServiceProxy {
    /**
     * @param body (optional)
     * @return Success
     */
    create5(body?: CreateInspectionStatusDto | undefined): Observable<InspectionStatusDto>;
    /**
     * Get all inspections statuses
     * @param name (optional) Name of the Inspection Status
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll4(name?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<InspectionStatusDtoPagedResultDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    delete4(id?: number | undefined): Observable<void>;
    /**
     * @param body (optional)
     * @return Success
     */
    update5(body?: InspectionStatusDto | undefined): Observable<InspectionStatusDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    get4(id?: number | undefined): Observable<InspectionStatusDto>;
}

@Injectable()
export class InspectionStatusServiceProxy implements IInspectionStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create5(body?: CreateInspectionStatusDto | undefined): Observable<InspectionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionStatus/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionStatusDto>;
        }));
    }

    protected processCreate5(response: HttpResponseBase): Observable<InspectionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all inspections statuses
     * @param name (optional) Name of the Inspection Status
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll4(name?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<InspectionStatusDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionStatus/GetAll?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionStatusDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionStatusDtoPagedResultDto>;
        }));
    }

    protected processGetAll4(response: HttpResponseBase): Observable<InspectionStatusDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionStatusDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete4(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InspectionStatus/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update5(body?: InspectionStatusDto | undefined): Observable<InspectionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionStatus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionStatusDto>;
        }));
    }

    protected processUpdate5(response: HttpResponseBase): Observable<InspectionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get4(id?: number | undefined): Observable<InspectionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionStatus/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionStatusDto>;
        }));
    }

    protected processGet4(response: HttpResponseBase): Observable<InspectionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInspectionTypeServiceProxy {
    /**
     * @param body (optional)
     * @return Success
     */
    create6(body?: CreateInspectionTypeDto | undefined): Observable<InspectionTypeDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    delete5(id?: number | undefined): Observable<void>;
    /**
     * @param body (optional)
     * @return Success
     */
    update6(body?: InspectionTypeDto | undefined): Observable<InspectionTypeDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    get5(id?: number | undefined): Observable<InspectionTypeDto>;
    /**
     * @param name (optional) Name of the Inspection Type
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll5(name?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<InspectionTypeDtoPagedResultDto>;
}

@Injectable()
export class InspectionTypeServiceProxy implements IInspectionTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create6(body?: CreateInspectionTypeDto | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeDto>;
        }));
    }

    protected processCreate6(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete5(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete5(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update6(body?: InspectionTypeDto | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeDto>;
        }));
    }

    protected processUpdate6(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get5(id?: number | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeDto>;
        }));
    }

    protected processGet5(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) Name of the Inspection Type
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll5(name?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<InspectionTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/GetAll?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll5(response: HttpResponseBase): Observable<InspectionTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInventoryItemsServiceProxy {
    /**
     * Creates an inventory item
     * @param body (optional)
     * @return Success
     */
    createInventoryItem(body?: CreateInventoryItemDto | undefined): Observable<InventoryItemDto>;
    /**
     * Updates an inventory item
     * @param body (optional)
     * @return Success
     */
    updateInventoryItem(inventoryItemId: number, body?: UpdateInventoryItemDto | undefined): Observable<InventoryItemDto>;
    /**
     * Deletes/un-deletes an inventory item
     * @param body (optional)
     * @return Success
     */
    deleteInventoryItem(inventoryItemId: number, body?: boolean | undefined): Observable<void>;
    /**
     * Endpoint to retrieve an inventory item
     * @return Success
     */
    getInventoryItem(inventoryItemId: number): Observable<InventoryItemDto>;
    /**
     * Endpoint to retrieve inventory items based on inspection id and asset id
     * @param inspectionId (optional)
     * @param assetId (optional)
     * @param includeDeleted (optional)
     * @param orderByNote (optional)
     * @return Success
     */
    inventoryItems(inspectionId?: number | undefined, assetId?: number | undefined, includeDeleted?: boolean | undefined, orderByNote?: boolean | undefined): Observable<InventoryItemDto[]>;
    /**
     * Gets the suggested inventory for the given image and predicted bounding box minimum score threshold.
     * @param inspectionId (optional) The inspection for which to return suggested inventory
     * @return Success
     */
    getSuggestedInventory(inspectionId?: number | undefined): Observable<SuggestedInventoryResultsDto[]>;
}

@Injectable()
export class InventoryItemsServiceProxy implements IInventoryItemsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates an inventory item
     * @param body (optional)
     * @return Success
     */
    createInventoryItem(body?: CreateInventoryItemDto | undefined): Observable<InventoryItemDto> {
        let url_ = this.baseUrl + "/api/services/workbench/InventoryItems/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInventoryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInventoryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryItemDto>;
        }));
    }

    protected processCreateInventoryItem(response: HttpResponseBase): Observable<InventoryItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an inventory item
     * @param body (optional)
     * @return Success
     */
    updateInventoryItem(inventoryItemId: number, body?: UpdateInventoryItemDto | undefined): Observable<InventoryItemDto> {
        let url_ = this.baseUrl + "/api/services/workbench/InventoryItems/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInventoryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInventoryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryItemDto>;
        }));
    }

    protected processUpdateInventoryItem(response: HttpResponseBase): Observable<InventoryItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes/un-deletes an inventory item
     * @param body (optional)
     * @return Success
     */
    deleteInventoryItem(inventoryItemId: number, body?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/workbench/InventoryItems/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInventoryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInventoryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInventoryItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to retrieve an inventory item
     * @return Success
     */
    getInventoryItem(inventoryItemId: number): Observable<InventoryItemDto> {
        let url_ = this.baseUrl + "/api/services/workbench/InventoryItems/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryItemDto>;
        }));
    }

    protected processGetInventoryItem(response: HttpResponseBase): Observable<InventoryItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to retrieve inventory items based on inspection id and asset id
     * @param inspectionId (optional)
     * @param assetId (optional)
     * @param includeDeleted (optional)
     * @param orderByNote (optional)
     * @return Success
     */
    inventoryItems(inspectionId?: number | undefined, assetId?: number | undefined, includeDeleted?: boolean | undefined, orderByNote?: boolean | undefined): Observable<InventoryItemDto[]> {
        let url_ = this.baseUrl + "/api/services/workbench/InventoryItems?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (orderByNote === null)
            throw new Error("The parameter 'orderByNote' cannot be null.");
        else if (orderByNote !== undefined)
            url_ += "orderByNote=" + encodeURIComponent("" + orderByNote) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryItemDto[]>;
        }));
    }

    protected processInventoryItems(response: HttpResponseBase): Observable<InventoryItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggested inventory for the given image and predicted bounding box minimum score threshold.
     * @param inspectionId (optional) The inspection for which to return suggested inventory
     * @return Success
     */
    getSuggestedInventory(inspectionId?: number | undefined): Observable<SuggestedInventoryResultsDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/workbench/InventoryItems/SuggestedInventoryItems?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedInventoryResultsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedInventoryResultsDto[]>;
        }));
    }

    protected processGetSuggestedInventory(response: HttpResponseBase): Observable<SuggestedInventoryResultsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuggestedInventoryResultsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMetricsServiceProxy {
    /**
     * Retrieves the total counts of different items for data metrics
     * @return Success
     */
    getMetrics(): Observable<MetricsDto>;
}

@Injectable()
export class MetricsServiceProxy implements IMetricsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the total counts of different items for data metrics
     * @return Success
     */
    getMetrics(): Observable<MetricsDto> {
        let url_ = this.baseUrl + "/api/v1/services/app/Metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetricsDto>;
        }));
    }

    protected processGetMetrics(response: HttpResponseBase): Observable<MetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPoleServiceProxy {
    /**
     * @param body (optional)
     * @return Success
     */
    create7(body?: CreatePoleDto | undefined): Observable<AssetDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    delete6(id?: number | undefined): Observable<void>;
    /**
     * @param body (optional)
     * @return Success
     */
    updatePole(body?: UpdatePoleDto | undefined): Observable<AssetDto>;
    /**
     * Updates the address for an unaddressed asset.
     * @param assetId The ID of the asset to lookup an address for.
     * @return Success
     */
    lookupAddressForAsset(assetId: number): Observable<AssetDto>;
    /**
     * @param body (optional)
     * @return Success
     */
    addCircuitToAsset(assetId: number, body?: number | undefined): Observable<void>;
    /**
     * Gets the circuits that the specified asset is on.
     * @return Success
     */
    circuits(assetId: number): Observable<CircuitDto[]>;
    /**
     * @return Success
     */
    removeCircuitFromAsset(assetId: number, circuitId: number): Observable<void>;
    /**
     * Endpoint to update a pole from workbench
     * @param body (optional)
     * @return Success
     */
    updatePoleById(poleId: number, body?: UpdatePoleWBDto | undefined): Observable<void>;
    /**
     * Returns the images associated with the given asset on the inspection.
     * @param inspectionId (optional)
     * @return Success
     */
    getImagesForAsset(assetId: number, inspectionId?: number | undefined): Observable<ImageDto[]>;
    /**
     * @param inspectionId (optional)
     * @param body (optional)
     * @return Success
     */
    markAssetAsInspected(assetId: number, inspectionId?: number | undefined, body?: UpdateInspectedDto | undefined): Observable<WBInspectionToAssetDto>;
    /**
     * Update the ITA regarding whether or not the feedback has been reviewed
     * @param body (optional)
     * @return Success
     */
    markFeedbackAsReviewed(assetId: number, inspectionId: number, body?: UpdateFeedbackDto | undefined): Observable<void>;
    /**
     * Remove a condition from an asset
     * @return Success
     */
    removeConditionFromAsset(inspectionId: number, assetId: number, conditionId: number): Observable<void>;
    /**
     * Removes an inventory item from an asset
     * @return Success
     */
    removeInventoryItemFromAsset(inspectionId: number, assetId: number, inventoryItemId: number): Observable<void>;
    /**
     * Endpoint to get all asset types
     * @param tenantId (optional)
     * @return Success
     */
    comments(tenantId?: number | undefined): Observable<string[]>;
    /**
     * Returns the circuits on the given poles.
     * @param tenantId (optional) The tenant of the poles
     * @param assetIdToExclude (optional) The id of an asset whose circuits are excluded from the result.
     * @param body (optional) The ids of the assets whose circuits to return.
     * @return Success
     */
    getCircuitsFromPoles(tenantId?: number | undefined, assetIdToExclude?: number | undefined, body?: number[] | undefined): Observable<CircuitDto[]>;
}

@Injectable()
export class PoleServiceProxy implements IPoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create7(body?: CreatePoleDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Pole/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processCreate7(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete6(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pole/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete6(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updatePole(body?: UpdatePoleDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Assets/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processUpdatePole(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the address for an unaddressed asset.
     * @param assetId The ID of the asset to lookup an address for.
     * @return Success
     */
    lookupAddressForAsset(assetId: number): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Address";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupAddressForAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupAddressForAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processLookupAddressForAsset(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addCircuitToAsset(assetId: number, body?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Circuits";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCircuitToAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCircuitToAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCircuitToAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the circuits that the specified asset is on.
     * @return Success
     */
    circuits(assetId: number): Observable<CircuitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Circuits";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCircuits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCircuits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDto[]>;
        }));
    }

    protected processCircuits(response: HttpResponseBase): Observable<CircuitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CircuitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    removeCircuitFromAsset(assetId: number, circuitId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Circuits/{circuitId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (circuitId === undefined || circuitId === null)
            throw new Error("The parameter 'circuitId' must be defined.");
        url_ = url_.replace("{circuitId}", encodeURIComponent("" + circuitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCircuitFromAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCircuitFromAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCircuitFromAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to update a pole from workbench
     * @param body (optional)
     * @return Success
     */
    updatePoleById(poleId: number, body?: UpdatePoleWBDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/workbench/Poles/{poleId}";
        if (poleId === undefined || poleId === null)
            throw new Error("The parameter 'poleId' must be defined.");
        url_ = url_.replace("{poleId}", encodeURIComponent("" + poleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePoleById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the images associated with the given asset on the inspection.
     * @param inspectionId (optional)
     * @return Success
     */
    getImagesForAsset(assetId: number, inspectionId?: number | undefined): Observable<ImageDto[]> {
        let url_ = this.baseUrl + "/api/service/app/Assets/{assetId}/Images?";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImagesForAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImagesForAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto[]>;
        }));
    }

    protected processGetImagesForAsset(response: HttpResponseBase): Observable<ImageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inspectionId (optional)
     * @param body (optional)
     * @return Success
     */
    markAssetAsInspected(assetId: number, inspectionId?: number | undefined, body?: UpdateInspectedDto | undefined): Observable<WBInspectionToAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Inspected?";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAssetAsInspected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAssetAsInspected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WBInspectionToAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WBInspectionToAssetDto>;
        }));
    }

    protected processMarkAssetAsInspected(response: HttpResponseBase): Observable<WBInspectionToAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WBInspectionToAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the ITA regarding whether or not the feedback has been reviewed
     * @param body (optional)
     * @return Success
     */
    markFeedbackAsReviewed(assetId: number, inspectionId: number, body?: UpdateFeedbackDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Inspections/{inspectionId}/FeedbackReviewed";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFeedbackAsReviewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFeedbackAsReviewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkFeedbackAsReviewed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a condition from an asset
     * @return Success
     */
    removeConditionFromAsset(inspectionId: number, assetId: number, conditionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Inspections/{inspectionId}/Conditions/{conditionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (conditionId === undefined || conditionId === null)
            throw new Error("The parameter 'conditionId' must be defined.");
        url_ = url_.replace("{conditionId}", encodeURIComponent("" + conditionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveConditionFromAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveConditionFromAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveConditionFromAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an inventory item from an asset
     * @return Success
     */
    removeInventoryItemFromAsset(inspectionId: number, assetId: number, inventoryItemId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assets/{assetId}/Inspections/{inspectionId}/InventoryItems/{inventoryItemId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveInventoryItemFromAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveInventoryItemFromAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveInventoryItemFromAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to get all asset types
     * @param tenantId (optional)
     * @return Success
     */
    comments(tenantId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/workbench/Assets/Comments?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processComments(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the circuits on the given poles.
     * @param tenantId (optional) The tenant of the poles
     * @param assetIdToExclude (optional) The id of an asset whose circuits are excluded from the result.
     * @param body (optional) The ids of the assets whose circuits to return.
     * @return Success
     */
    getCircuitsFromPoles(tenantId?: number | undefined, assetIdToExclude?: number | undefined, body?: number[] | undefined): Observable<CircuitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Assets/Circuits?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (assetIdToExclude === null)
            throw new Error("The parameter 'assetIdToExclude' cannot be null.");
        else if (assetIdToExclude !== undefined)
            url_ += "assetIdToExclude=" + encodeURIComponent("" + assetIdToExclude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCircuitsFromPoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCircuitsFromPoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitDto[]>;
        }));
    }

    protected processGetCircuitsFromPoles(response: HttpResponseBase): Observable<CircuitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CircuitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPoleDrillFileServiceServiceProxy {
    /**
     * Saves RGP measurement values.
     * @param tenantId (optional) The identifier of the Tenant related to the RGP data
     * @param inspectionId (optional) The identifier of the Inspection related to the RGP data
     * @param collectorId (optional) The identifier of the Collector related to the RGP data
     * @param fileResult (optional) The nullable string status of the RGP measurement (PASS/FAIL/NON-PRIORITY)
     * @param md5 (optional) The MD5 hash representing the file in storage
     * @param body (optional) DTO containing the RGP measurement data
     * @return Success
     */
    addMeasurement(tenantId?: number | undefined, inspectionId?: number | undefined, collectorId?: string | undefined, fileResult?: string | undefined, md5?: string | undefined, body?: RGPMeasurementDto | undefined): Observable<string>;
}

@Injectable()
export class PoleDrillFileServiceServiceProxy implements IPoleDrillFileServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Saves RGP measurement values.
     * @param tenantId (optional) The identifier of the Tenant related to the RGP data
     * @param inspectionId (optional) The identifier of the Inspection related to the RGP data
     * @param collectorId (optional) The identifier of the Collector related to the RGP data
     * @param fileResult (optional) The nullable string status of the RGP measurement (PASS/FAIL/NON-PRIORITY)
     * @param md5 (optional) The MD5 hash representing the file in storage
     * @param body (optional) DTO containing the RGP measurement data
     * @return Success
     */
    addMeasurement(tenantId?: number | undefined, inspectionId?: number | undefined, collectorId?: string | undefined, fileResult?: string | undefined, md5?: string | undefined, body?: RGPMeasurementDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RGP/Measurement?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (collectorId === null)
            throw new Error("The parameter 'collectorId' cannot be null.");
        else if (collectorId !== undefined)
            url_ += "collectorId=" + encodeURIComponent("" + collectorId) + "&";
        if (fileResult === null)
            throw new Error("The parameter 'fileResult' cannot be null.");
        else if (fileResult !== undefined)
            url_ += "fileResult=" + encodeURIComponent("" + fileResult) + "&";
        if (md5 === null)
            throw new Error("The parameter 'md5' cannot be null.");
        else if (md5 !== undefined)
            url_ += "md5=" + encodeURIComponent("" + md5) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMeasurement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddMeasurement(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISessionServiceProxy {
    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput>;
}

@Injectable()
export class SessionServiceProxy implements ISessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISMEServiceProxy {
    /**
     * Gets all available SMEs from the Quality Assurance Level table.
     * @return Success
     */
    getSMEs(): Observable<QualityAssuranceLevelDto[]>;
    /**
     * Gets all users with Inspector or QC related rights.
     * @return Success
     */
    getDetailedSMEs(): Observable<UserDto[]>;
}

@Injectable()
export class SMEServiceProxy implements ISMEServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all available SMEs from the Quality Assurance Level table.
     * @return Success
     */
    getSMEs(): Observable<QualityAssuranceLevelDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/SMEs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualityAssuranceLevelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualityAssuranceLevelDto[]>;
        }));
    }

    protected processGetSMEs(response: HttpResponseBase): Observable<QualityAssuranceLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualityAssuranceLevelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all users with Inspector or QC related rights.
     * @return Success
     */
    getDetailedSMEs(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/v2/services/app/SMEs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedSMEs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedSMEs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetDetailedSMEs(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISpanServiceProxy {
    /**
     * @param body (optional)
     * @return Created
     */
    create8(body?: CreateSpanDto | undefined): Observable<SpanDto>;
    /**
     * @param body (optional)
     * @return Updated
     */
    update7(body?: UpdateSpanDto | undefined): Observable<SpanDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    get6(id?: number | undefined): Observable<SpanDto>;
    /**
     * @param tenantId (optional) Tenant image belongs to
     * @param inspectionId (optional) The Inspection Id for which the span is being returned for.
     * @param facilityId (optional) Facility Id of the span.
     * @param startAssetId (optional) Identifier for the starting point pole for the span
     * @param endAssetId (optional) Identifier for the ending point pole for the span
     * @param spanLength (optional) Length of the span
     * @param voltage (optional) The voltage carried by the span
     * @param lidarId (optional) Identifier from LIDAR import used to discern possibly duplication within upload
     * @param polyLineData (optional) A semicolon delimited string of coordinates for the polylines needed for the span
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll6(tenantId?: number | undefined, inspectionId?: number | undefined, facilityId?: string | undefined, startAssetId?: number | undefined, endAssetId?: number | undefined, spanLength?: number | undefined, voltage?: string | undefined, lidarId?: number | undefined, polyLineData?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<SpanDtoPagedResultDto>;
    /**
     * @param id (optional)
     * @return Deleted
     */
    delete7(id?: number | undefined): Observable<void>;
}

@Injectable()
export class SpanServiceProxy implements ISpanServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Created
     */
    create8(body?: CreateSpanDto | undefined): Observable<SpanDto> {
        let url_ = this.baseUrl + "/api/services/app/Spans/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanDto>;
        }));
    }

    protected processCreate8(response: HttpResponseBase): Observable<SpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SpanDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Updated
     */
    update7(body?: UpdateSpanDto | undefined): Observable<SpanDto> {
        let url_ = this.baseUrl + "/api/services/app/Spans/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanDto>;
        }));
    }

    protected processUpdate7(response: HttpResponseBase): Observable<SpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get6(id?: number | undefined): Observable<SpanDto> {
        let url_ = this.baseUrl + "/api/services/app/Spans/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanDto>;
        }));
    }

    protected processGet6(response: HttpResponseBase): Observable<SpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) Tenant image belongs to
     * @param inspectionId (optional) The Inspection Id for which the span is being returned for.
     * @param facilityId (optional) Facility Id of the span.
     * @param startAssetId (optional) Identifier for the starting point pole for the span
     * @param endAssetId (optional) Identifier for the ending point pole for the span
     * @param spanLength (optional) Length of the span
     * @param voltage (optional) The voltage carried by the span
     * @param lidarId (optional) Identifier from LIDAR import used to discern possibly duplication within upload
     * @param polyLineData (optional) A semicolon delimited string of coordinates for the polylines needed for the span
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll6(tenantId?: number | undefined, inspectionId?: number | undefined, facilityId?: string | undefined, startAssetId?: number | undefined, endAssetId?: number | undefined, spanLength?: number | undefined, voltage?: string | undefined, lidarId?: number | undefined, polyLineData?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<SpanDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Spans/GetAll?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "InspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (facilityId === null)
            throw new Error("The parameter 'facilityId' cannot be null.");
        else if (facilityId !== undefined)
            url_ += "FacilityId=" + encodeURIComponent("" + facilityId) + "&";
        if (startAssetId === null)
            throw new Error("The parameter 'startAssetId' cannot be null.");
        else if (startAssetId !== undefined)
            url_ += "StartAssetId=" + encodeURIComponent("" + startAssetId) + "&";
        if (endAssetId === null)
            throw new Error("The parameter 'endAssetId' cannot be null.");
        else if (endAssetId !== undefined)
            url_ += "EndAssetId=" + encodeURIComponent("" + endAssetId) + "&";
        if (spanLength === null)
            throw new Error("The parameter 'spanLength' cannot be null.");
        else if (spanLength !== undefined)
            url_ += "SpanLength=" + encodeURIComponent("" + spanLength) + "&";
        if (voltage === null)
            throw new Error("The parameter 'voltage' cannot be null.");
        else if (voltage !== undefined)
            url_ += "Voltage=" + encodeURIComponent("" + voltage) + "&";
        if (lidarId === null)
            throw new Error("The parameter 'lidarId' cannot be null.");
        else if (lidarId !== undefined)
            url_ += "LidarId=" + encodeURIComponent("" + lidarId) + "&";
        if (polyLineData === null)
            throw new Error("The parameter 'polyLineData' cannot be null.");
        else if (polyLineData !== undefined)
            url_ += "PolyLineData=" + encodeURIComponent("" + polyLineData) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanDtoPagedResultDto>;
        }));
    }

    protected processGetAll6(response: HttpResponseBase): Observable<SpanDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpanDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Deleted
     */
    delete7(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Spans/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete7(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStorageContainersServiceProxy {
    /**
     * Gets storage container info for all inspections along with the tenant information.
     * @return Success
     */
    getAll(): Observable<TenantStorageContainerInfoDto[]>;
}

@Injectable()
export class StorageContainersServiceProxy implements IStorageContainersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets storage container info for all inspections along with the tenant information.
     * @return Success
     */
    getAll(): Observable<TenantStorageContainerInfoDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/StorageContainers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantStorageContainerInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantStorageContainerInfoDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantStorageContainerInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantStorageContainerInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITenantServiceProxy {
    /**
     * Exports all Tenant Condition Suggestions to an xlsx file.
     * @param tenantId The ID of the selected tenant.
     * @param skittleChartId (optional) The ID of the selected skittle chart.
     * @return Success
     */
    exportTenantSkittleChart(tenantId: number, skittleChartId?: number | undefined): Observable<FileResponse>;
    /**
     * @param keyword (optional)
     * @param isActive (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllTenants(keyword?: string | undefined, isActive?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<TenantDtoPagedResultDto>;
    /**
     * Returns a list of active tenants with only a limited amount of extra data.
     * @param energySystemIds (optional) Energy systems by which to filter the tenants
     * @return Success
     */
    getAllActive(energySystemIds?: number[] | undefined): Observable<TenantInfoDto[]>;
    /**
     * Gets the Sites for the specified Tenant.
     * @param id The ID of the Tenant for which to get Sites.
     * @return Success
     */
    getTenantSites(id: number): Observable<SiteDto[]>;
    /**
     * Retrieve Data Collectors available for the given Tenant
     * @param id Identifier of the Tenant for which to retrieve Data Collectors
     * @return Success
     */
    getDataCollectors(id: number): Observable<DataCollectorDto[]>;
    /**
     * Retrieves Circuits for a given Tenant
     * @param id The ID of the Tenant to retrieve Circuits for
     * @return Success
     */
    getTenantCircuits(id: number): Observable<CircuitReportDto[]>;
    /**
     * Retrieves Custom Asset Properties for a given Tenant
     * @param id The ID of the Tenant to retrieve Custom Asset Properties for
     * @return Success
     */
    getTenantCustomAssetProperties(id: number): Observable<CustomAssetPropertyDto[]>;
    /**
     * Uploads the skittle chart sheet to the tenant
     * @param id The ID of the Tenant to upload skittle chart
     * @param skittleChartId The ID of the upload skittle chart
     * @param skittleChartSheet (optional)
     * @return Success
     */
    uploadTenantSkittleChart(id: number, skittleChartId: number, skittleChartSheet?: FileParameter | undefined): Observable<void>;
    /**
     * Update a Tenant Skittle Chart's Type
     * @param id The ID of the tenant to update the skittle chart
     * @param skittleChartId The ID of the skittle chart to update its type
     * @param type (optional) The new type to update skittle chart
     * @return Success
     */
    updateTenantSkittleChart(id: number, skittleChartId: number, type?: string | undefined): Observable<TenantSkittleChartDto>;
    /**
     * Delete a Tenant Skittle Chart
     * @param id The ID of the tenant to delete the specified skittle chart
     * @param skittleChartId The ID of the skittle chart to be deleted
     * @return Success
     */
    deleteTenantSkittleChart(id: number, skittleChartId: number): Observable<void>;
    /**
     * Creates a new Tenant Skittle Chart
     * @param id The ID of the tenant to create a new Tenant Skittle Chart
     * @param type (optional) The name of the new Tenant Skittle Chart
     * @return Success
     */
    createTenantSkittleChart(id: number, type?: string | undefined): Observable<void>;
    /**
     * Fetches all available Tenant Skittle Charts
     * @param id The ID of the tenant to get all tenant skittle charts
     * @return Success
     */
    getTenantSkittleCharts(id: number): Observable<TenantSkittleChartDto[]>;
    /**
     * Fetches the Tenant Condition List as a Tree for use in a Tree List
     * @param id The ID of the tenant to fetch skittle chart Tenant Condition List
     * @param skittleChartId The ID of the skittle chart to fetch TEnant Condition List
     * @return Success
     */
    getTenantSkittleChartTreeList(id: number, skittleChartId: number): Observable<TenantConditionNodeDto[]>;
    /**
     * Adds a given Tenant Item Type/Type/Condition Suggestion to the Tenant Skittle Chart
     * @param id The ID of the tenant of the skittle chart to add new row
     * @param skittleChartId The ID of the Tenant Skittle Chart to add new row
     * @param body (optional) The skittle chart data to add new row
     * @return Success
     */
    addTenantSkittleChartRow(id: number, skittleChartId: number, body?: TenantConditionNodeDto | undefined): Observable<void>;
    /**
     * Updates a given Tenant Item Type/Type/Condition Suggestion to the Tenant Skittle Chart
     * @param id The ID of the tenant of the skittle chart to update row
     * @param skittleChartId The ID of the Tenant Skittle Chart to update row
     * @param skittleChartCompoundId The skittle chart compound identifier (ObjectType_Id#) to update row
     * @param body (optional) The new skittle chart data to update row
     * @return Success
     */
    updateTenantSkittleChartRow(id: number, skittleChartId: number, skittleChartCompoundId: string, body?: TenantConditionNodeDto | undefined): Observable<void>;
    /**
     * Deletes a given Tenant Item Type/Type/Condition Suggestion to the Tenant Skittle Chart
     * @param id The ID of the tenant of the skittle chart to delete row
     * @param skittleChartId The ID of the Tenant Skittle Chart to delete row
     * @param skittleChartCompoundId The skittle chart compound identifier (ObjectType_Id#) to delete row
     * @return Deleted
     */
    deleteTenantSkittleChartRow(id: number, skittleChartId: number, skittleChartCompoundId: string): Observable<void>;
}

@Injectable()
export class TenantServiceProxy implements ITenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Exports all Tenant Condition Suggestions to an xlsx file.
     * @param tenantId The ID of the selected tenant.
     * @param skittleChartId (optional) The ID of the selected skittle chart.
     * @return Success
     */
    exportTenantSkittleChart(tenantId: number, skittleChartId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/{tenantId}/ExportSkittleChart?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' cannot be null.");
        else if (skittleChartId !== undefined)
            url_ += "skittleChartId=" + encodeURIComponent("" + skittleChartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTenantSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTenantSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportTenantSkittleChart(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional)
     * @param isActive (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllTenants(keyword?: string | undefined, isActive?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAllTenants(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of active tenants with only a limited amount of extra data.
     * @param energySystemIds (optional) Energy systems by which to filter the tenants
     * @return Success
     */
    getAllActive(energySystemIds?: number[] | undefined): Observable<TenantInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants?";
        if (energySystemIds === null)
            throw new Error("The parameter 'energySystemIds' cannot be null.");
        else if (energySystemIds !== undefined)
            energySystemIds && energySystemIds.forEach(item => { url_ += "energySystemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantInfoDto[]>;
        }));
    }

    protected processGetAllActive(response: HttpResponseBase): Observable<TenantInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Sites for the specified Tenant.
     * @param id The ID of the Tenant for which to get Sites.
     * @return Success
     */
    getTenantSites(id: number): Observable<SiteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/Sites";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteDto[]>;
        }));
    }

    protected processGetTenantSites(response: HttpResponseBase): Observable<SiteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve Data Collectors available for the given Tenant
     * @param id Identifier of the Tenant for which to retrieve Data Collectors
     * @return Success
     */
    getDataCollectors(id: number): Observable<DataCollectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/DataCollectors";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataCollectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataCollectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataCollectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataCollectorDto[]>;
        }));
    }

    protected processGetDataCollectors(response: HttpResponseBase): Observable<DataCollectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataCollectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves Circuits for a given Tenant
     * @param id The ID of the Tenant to retrieve Circuits for
     * @return Success
     */
    getTenantCircuits(id: number): Observable<CircuitReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/Circuits";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCircuits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCircuits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CircuitReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CircuitReportDto[]>;
        }));
    }

    protected processGetTenantCircuits(response: HttpResponseBase): Observable<CircuitReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CircuitReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves Custom Asset Properties for a given Tenant
     * @param id The ID of the Tenant to retrieve Custom Asset Properties for
     * @return Success
     */
    getTenantCustomAssetProperties(id: number): Observable<CustomAssetPropertyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/CustomAssetProperties";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCustomAssetProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCustomAssetProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAssetPropertyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAssetPropertyDto[]>;
        }));
    }

    protected processGetTenantCustomAssetProperties(response: HttpResponseBase): Observable<CustomAssetPropertyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomAssetPropertyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the skittle chart sheet to the tenant
     * @param id The ID of the Tenant to upload skittle chart
     * @param skittleChartId The ID of the upload skittle chart
     * @param skittleChartSheet (optional)
     * @return Success
     */
    uploadTenantSkittleChart(id: number, skittleChartId: number, skittleChartSheet?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleCharts/{skittleChartId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (skittleChartSheet === null || skittleChartSheet === undefined)
            throw new Error("The parameter 'skittleChartSheet' cannot be null.");
        else
            content_.append("skittleChartSheet", skittleChartSheet.data, skittleChartSheet.fileName ? skittleChartSheet.fileName : "skittleChartSheet");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTenantSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTenantSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadTenantSkittleChart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Tenant Skittle Chart's Type
     * @param id The ID of the tenant to update the skittle chart
     * @param skittleChartId The ID of the skittle chart to update its type
     * @param type (optional) The new type to update skittle chart
     * @return Success
     */
    updateTenantSkittleChart(id: number, skittleChartId: number, type?: string | undefined): Observable<TenantSkittleChartDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleCharts/{skittleChartId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSkittleChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSkittleChartDto>;
        }));
    }

    protected processUpdateTenantSkittleChart(response: HttpResponseBase): Observable<TenantSkittleChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSkittleChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Tenant Skittle Chart
     * @param id The ID of the tenant to delete the specified skittle chart
     * @param skittleChartId The ID of the skittle chart to be deleted
     * @return Success
     */
    deleteTenantSkittleChart(id: number, skittleChartId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleCharts/{skittleChartId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenantSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenantSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenantSkittleChart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Tenant Skittle Chart
     * @param id The ID of the tenant to create a new Tenant Skittle Chart
     * @param type (optional) The name of the new Tenant Skittle Chart
     * @return Success
     */
    createTenantSkittleChart(id: number, type?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleCharts?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenantSkittleChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenantSkittleChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenantSkittleChart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fetches all available Tenant Skittle Charts
     * @param id The ID of the tenant to get all tenant skittle charts
     * @return Success
     */
    getTenantSkittleCharts(id: number): Observable<TenantSkittleChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleCharts";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantSkittleCharts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantSkittleCharts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSkittleChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSkittleChartDto[]>;
        }));
    }

    protected processGetTenantSkittleCharts(response: HttpResponseBase): Observable<TenantSkittleChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantSkittleChartDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fetches the Tenant Condition List as a Tree for use in a Tree List
     * @param id The ID of the tenant to fetch skittle chart Tenant Condition List
     * @param skittleChartId The ID of the skittle chart to fetch TEnant Condition List
     * @return Success
     */
    getTenantSkittleChartTreeList(id: number, skittleChartId: number): Observable<TenantConditionNodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleChartTreeList/{skittleChartId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantSkittleChartTreeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantSkittleChartTreeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantConditionNodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantConditionNodeDto[]>;
        }));
    }

    protected processGetTenantSkittleChartTreeList(response: HttpResponseBase): Observable<TenantConditionNodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantConditionNodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a given Tenant Item Type/Type/Condition Suggestion to the Tenant Skittle Chart
     * @param id The ID of the tenant of the skittle chart to add new row
     * @param skittleChartId The ID of the Tenant Skittle Chart to add new row
     * @param body (optional) The skittle chart data to add new row
     * @return Success
     */
    addTenantSkittleChartRow(id: number, skittleChartId: number, body?: TenantConditionNodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleChartTreeList/{skittleChartId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTenantSkittleChartRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTenantSkittleChartRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTenantSkittleChartRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a given Tenant Item Type/Type/Condition Suggestion to the Tenant Skittle Chart
     * @param id The ID of the tenant of the skittle chart to update row
     * @param skittleChartId The ID of the Tenant Skittle Chart to update row
     * @param skittleChartCompoundId The skittle chart compound identifier (ObjectType_Id#) to update row
     * @param body (optional) The new skittle chart data to update row
     * @return Success
     */
    updateTenantSkittleChartRow(id: number, skittleChartId: number, skittleChartCompoundId: string, body?: TenantConditionNodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleChartTreeList/{skittleChartId}/{skittleChartCompoundId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        if (skittleChartCompoundId === undefined || skittleChartCompoundId === null)
            throw new Error("The parameter 'skittleChartCompoundId' must be defined.");
        url_ = url_.replace("{skittleChartCompoundId}", encodeURIComponent("" + skittleChartCompoundId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantSkittleChartRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantSkittleChartRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantSkittleChartRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a given Tenant Item Type/Type/Condition Suggestion to the Tenant Skittle Chart
     * @param id The ID of the tenant of the skittle chart to delete row
     * @param skittleChartId The ID of the Tenant Skittle Chart to delete row
     * @param skittleChartCompoundId The skittle chart compound identifier (ObjectType_Id#) to delete row
     * @return Deleted
     */
    deleteTenantSkittleChartRow(id: number, skittleChartId: number, skittleChartCompoundId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenants/{id}/SkittleChartTreeList/{skittleChartId}/{skittleChartCompoundId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skittleChartId === undefined || skittleChartId === null)
            throw new Error("The parameter 'skittleChartId' must be defined.");
        url_ = url_.replace("{skittleChartId}", encodeURIComponent("" + skittleChartId));
        if (skittleChartCompoundId === undefined || skittleChartCompoundId === null)
            throw new Error("The parameter 'skittleChartCompoundId' must be defined.");
        url_ = url_.replace("{skittleChartCompoundId}", encodeURIComponent("" + skittleChartCompoundId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenantSkittleChartRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenantSkittleChartRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenantSkittleChartRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITokenAuthServiceProxy {
    /**
     * Logs the current session user out of the application.
     * @return Success
     */
    logout(): Observable<void>;
    /**
     * @param body (optional)
     * @return Success
     */
    authenticate(body?: AuthenticateModel | undefined): Observable<AuthenticateResultModel>;
    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]>;
    /**
     * @param body (optional)
     * @return Success
     */
    externalAuthenticate(body?: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel>;
    /**
     * Endpoint through which a B2C token can be exchanged for an AIM token
     * @return Success
     */
    b2CAuthenticate(): Observable<ExternalAuthenticateResultModel>;
    /**
     * Endpoint to retrieve the publicly accessible RSAParameters needed to verify the signature.
     * @return Success
     */
    getPublicRSAParameters(): Observable<RSAParameters>;
}

@Injectable()
export class TokenAuthServiceProxy implements ITokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Logs the current session user out of the application.
     * @return Success
     */
    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    authenticate(body?: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    externalAuthenticate(body?: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint through which a B2C token can be exchanged for an AIM token
     * @return Success
     */
    b2CAuthenticate(): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/B2CAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processB2CAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processB2CAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processB2CAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Endpoint to retrieve the publicly accessible RSAParameters needed to verify the signature.
     * @return Success
     */
    getPublicRSAParameters(): Observable<RSAParameters> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetPublicRSAParameters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicRSAParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicRSAParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RSAParameters>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RSAParameters>;
        }));
    }

    protected processGetPublicRSAParameters(response: HttpResponseBase): Observable<RSAParameters> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RSAParameters.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUploadTemplatesServiceProxy {
    /**
     * Exports Inspected Asset Template to an xlsx file.
     * @return Success
     */
    inspectedAssetsTemplate(): Observable<FileResponse>;
    /**
     * Exports Customer Asset Template to an xlsx file.
     * @return Success
     */
    customerAssetsTemplate(inspectionId: number): Observable<FileResponse>;
    /**
     * Exports Span Template to an xlsx file.
     * @return Success
     */
    spansTemplate(): Observable<FileResponse>;
    /**
     * Exports Skittle Chart Template to an xlsx file.
     * @return Success
     */
    skittleChartTemplate(): Observable<FileResponse>;
    /**
     * Exports Conditions Template to an xlsx file.
     * @return Success
     */
    conditionsTemplate(): Observable<FileResponse>;
}

@Injectable()
export class UploadTemplatesServiceProxy implements IUploadTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Exports Inspected Asset Template to an xlsx file.
     * @return Success
     */
    inspectedAssetsTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/InspectedAssetsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInspectedAssetsTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInspectedAssetsTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInspectedAssetsTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports Customer Asset Template to an xlsx file.
     * @return Success
     */
    customerAssetsTemplate(inspectionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/CustomerAssetsTemplate/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerAssetsTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerAssetsTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCustomerAssetsTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports Span Template to an xlsx file.
     * @return Success
     */
    spansTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/SpansTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpansTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpansTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSpansTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports Skittle Chart Template to an xlsx file.
     * @return Success
     */
    skittleChartTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/SkittleChartTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSkittleChartTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSkittleChartTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSkittleChartTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports Conditions Template to an xlsx file.
     * @return Success
     */
    conditionsTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/ConditionsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConditionsTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConditionsTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConditionsTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserServiceProxy {
    /**
     * Gets all users meeting the criteria.
     * @param keyword (optional)
     * @param isActive (optional)
     * @param isAdminTenant (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll7(keyword?: string | undefined, isActive?: boolean | undefined, isAdminTenant?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<UserDtoPagedResultDto>;
    /**
     * Gets the specified user by ID.
     * @param id (optional)
     * @return Success
     */
    get7(id?: number | undefined): Observable<UserDto>;
    /**
     * Returns the current logged in user
     * @return Success
     */
    getCurrentUser(): Observable<UserDto>;
    /**
     * @param body (optional)
     * @return Success
     */
    create9(body?: CreateUserDto | undefined): Observable<UserDto>;
    /**
     * @param body (optional)
     * @return Success
     */
    update8(body?: UserDto | undefined): Observable<UserDto>;
    /**
     * @param id (optional)
     * @return Success
     */
    delete8(id?: number | undefined): Observable<void>;
    /**
     * Retrieve the host's available contractor users
     * @return Success
     */
    getContractors(): Observable<DisplayUserDtoListResultDto>;
    /**
     * Retrieve the host's available limited inspector users
     * @return Success
     */
    getLimitedInspectors(): Observable<DisplayUserDtoListResultDto>;
    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto>;
    /**
     * @return Success
     */
    getAdminRoles(): Observable<RoleDtoListResultDto>;
    /**
     * @param body (optional)
     * @return Success
     */
    changeLanguage(body?: ChangeUserLanguageDto | undefined): Observable<void>;
    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body?: ChangePasswordDto | undefined): Observable<boolean>;
    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body?: ResetPasswordDto | undefined): Observable<boolean>;
    /**
     * Retrieves a list of users along with the times of their most recent login
     * @return Success
     */
    getUserLoginMetrics(): Observable<UserLoginMetricsDto[]>;
    /**
     * Gets the QC performance stats for the specified user.
     * @param id Identifier of the user to obtain QC performance stats for.
     * @param from (optional) The date from which to find QC performance stats for the specifed user.
     * @param to (optional) The date to which to find QC performance stats for the specifed user.
     * @return Success
     */
    qCPerformance(id: number, from?: moment.Moment | undefined, to?: moment.Moment | undefined): Observable<QCPerformanceDto[]>;
}

@Injectable()
export class UserServiceProxy implements IUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all users meeting the criteria.
     * @param keyword (optional)
     * @param isActive (optional)
     * @param isAdminTenant (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll7(keyword?: string | undefined, isActive?: boolean | undefined, isAdminTenant?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAdminTenant === null)
            throw new Error("The parameter 'isAdminTenant' cannot be null.");
        else if (isAdminTenant !== undefined)
            url_ += "IsAdminTenant=" + encodeURIComponent("" + isAdminTenant) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll7(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the specified user by ID.
     * @param id (optional)
     * @return Success
     */
    get7(id?: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet7(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the current logged in user
     * @return Success
     */
    getCurrentUser(): Observable<UserDto> {
        let url_ = this.baseUrl + "/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create9(body?: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate9(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate9(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update8(body?: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate8(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete8(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete8(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the host's available contractor users
     * @return Success
     */
    getContractors(): Observable<DisplayUserDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Users/Contractors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisplayUserDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisplayUserDtoListResultDto>;
        }));
    }

    protected processGetContractors(response: HttpResponseBase): Observable<DisplayUserDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayUserDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the host's available limited inspector users
     * @return Success
     */
    getLimitedInspectors(): Observable<DisplayUserDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Users/LimitedInspectors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLimitedInspectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLimitedInspectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisplayUserDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisplayUserDtoListResultDto>;
        }));
    }

    protected processGetLimitedInspectors(response: HttpResponseBase): Observable<DisplayUserDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayUserDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdminRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAdminRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetAdminRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeLanguage(body?: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body?: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body?: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of users along with the times of their most recent login
     * @return Success
     */
    getUserLoginMetrics(): Observable<UserLoginMetricsDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/Users/LoginMetrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginMetricsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginMetricsDto[]>;
        }));
    }

    protected processGetUserLoginMetrics(response: HttpResponseBase): Observable<UserLoginMetricsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLoginMetricsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the QC performance stats for the specified user.
     * @param id Identifier of the user to obtain QC performance stats for.
     * @param from (optional) The date from which to find QC performance stats for the specifed user.
     * @param to (optional) The date to which to find QC performance stats for the specifed user.
     * @return Success
     */
    qCPerformance(id: number, from?: moment.Moment | undefined, to?: moment.Moment | undefined): Observable<QCPerformanceDto[]> {
        let url_ = this.baseUrl + "/api/v1/services/app/Users/{id}/QCPerformance?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQCPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQCPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QCPerformanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QCPerformanceDto[]>;
        }));
    }

    protected processQCPerformance(response: HttpResponseBase): Observable<QCPerformanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QCPerformanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserNavigationHistoryServiceProxy {
    /**
     * Create a Workbench UserNavigationHistoryItem.
     * @return Success
     */
    createUserNavigationHistoryItem(inspectionId: number, assetId: number): Observable<number>;
    /**
     * Get a list of Workbench UserNavigationHistoryItems created by the current user.
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getUserNavigationHistoryItems(skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<UserNavigationHistoryItemDtoPagedResultDto>;
    /**
     * Get the count of all Workbench UserNavigationHistoryItems.
     * @return Success
     */
    getAllUserNavigationHistoryItemCount(): Observable<number>;
}

@Injectable()
export class UserNavigationHistoryServiceProxy implements IUserNavigationHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a Workbench UserNavigationHistoryItem.
     * @return Success
     */
    createUserNavigationHistoryItem(inspectionId: number, assetId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/workbench/UserNavigationHistory/Create?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined and cannot be null.");
        else
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserNavigationHistoryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserNavigationHistoryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateUserNavigationHistoryItem(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Workbench UserNavigationHistoryItems created by the current user.
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getUserNavigationHistoryItems(skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<UserNavigationHistoryItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/workbench/UserNavigationHistory/UserNavigationHistory?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNavigationHistoryItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNavigationHistoryItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNavigationHistoryItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNavigationHistoryItemDtoPagedResultDto>;
        }));
    }

    protected processGetUserNavigationHistoryItems(response: HttpResponseBase): Observable<UserNavigationHistoryItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNavigationHistoryItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the count of all Workbench UserNavigationHistoryItems.
     * @return Success
     */
    getAllUserNavigationHistoryItemCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/workbench/UserNavigationHistory/AllUserNavigationHistoryCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserNavigationHistoryItemCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserNavigationHistoryItemCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAllUserNavigationHistoryItemCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AjaxResponse.fromJS(resultData500);
            return throwException("Failure", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AjaxResponse implements IAjaxResponse {
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo | undefined;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;
    result!: any | undefined;

    constructor(data?: IAjaxResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): AjaxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["result"] = this.result;
        return data;
    }

    clone(): AjaxResponse {
        const json = this.toJSON();
        let result = new AjaxResponse();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponse {
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean;
    __abp: boolean;
    result: any | undefined;
}

/** Dto for AnaylsisStatuses */
export class AnalysisStatusDto implements IAnalysisStatusDto {
    id!: number;
    /** The name of the AnalysisStatus */
    name!: string | undefined;
    /** Priority to use when determining importance */
    priority!: number;

    constructor(data?: IAnalysisStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): AnalysisStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["priority"] = this.priority;
        return data;
    }

    clone(): AnalysisStatusDto {
        const json = this.toJSON();
        let result = new AnalysisStatusDto();
        result.init(json);
        return result;
    }
}

/** Dto for AnaylsisStatuses */
export interface IAnalysisStatusDto {
    id: number;
    /** The name of the AnalysisStatus */
    name: string | undefined;
    /** Priority to use when determining importance */
    priority: number;
}

export class AnalysisStatusDtoPagedResultDto implements IAnalysisStatusDtoPagedResultDto {
    items!: AnalysisStatusDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAnalysisStatusDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AnalysisStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AnalysisStatusDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisStatusDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AnalysisStatusDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AnalysisStatusDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAnalysisStatusDtoPagedResultDto {
    items: AnalysisStatusDto[] | undefined;
    totalCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

/** Dto for Asset Assignment Area */
export class AssetAssignmentAreaDto implements IAssetAssignmentAreaDto {
    id!: number;
    /** The ID of the Tenant for this AssetAssignmentArea */
    tenantId!: number;
    /** The ID of the Inspection for this AssetAssignmentArea */
    inspectionId!: number;
    /** Identifier of the User that has been assigned this AssetAssignmentArea */
    assignedUserId!: number;
    /** Assigned User */
    assignedUser!: AssetAssignmentAreaUserDto | undefined;
    /** Unique EsriId assigned to this AssetAssignmentArea */
    esriId!: string;
    /** Polygon representing the AssetAssignmentArea */
    assignmentArea!: Polygon | undefined;
    /** String containing the points representing the area represented by this AssetAssignmentArea */
    assignmentAreaPoints!: string | undefined;

    constructor(data?: IAssetAssignmentAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUser = _data["assignedUser"] ? AssetAssignmentAreaUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.esriId = _data["esriId"];
            this.assignmentArea = _data["assignmentArea"] ? Polygon.fromJS(_data["assignmentArea"]) : <any>undefined;
            this.assignmentAreaPoints = _data["assignmentAreaPoints"];
        }
    }

    static fromJS(data: any): AssetAssignmentAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetAssignmentAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["esriId"] = this.esriId;
        data["assignmentArea"] = this.assignmentArea ? this.assignmentArea.toJSON() : <any>undefined;
        data["assignmentAreaPoints"] = this.assignmentAreaPoints;
        return data;
    }

    clone(): AssetAssignmentAreaDto {
        const json = this.toJSON();
        let result = new AssetAssignmentAreaDto();
        result.init(json);
        return result;
    }
}

/** Dto for Asset Assignment Area */
export interface IAssetAssignmentAreaDto {
    id: number;
    /** The ID of the Tenant for this AssetAssignmentArea */
    tenantId: number;
    /** The ID of the Inspection for this AssetAssignmentArea */
    inspectionId: number;
    /** Identifier of the User that has been assigned this AssetAssignmentArea */
    assignedUserId: number;
    /** Assigned User */
    assignedUser: AssetAssignmentAreaUserDto | undefined;
    /** Unique EsriId assigned to this AssetAssignmentArea */
    esriId: string;
    /** Polygon representing the AssetAssignmentArea */
    assignmentArea: Polygon | undefined;
    /** String containing the points representing the area represented by this AssetAssignmentArea */
    assignmentAreaPoints: string | undefined;
}

export class AssetAssignmentAreaUserDto implements IAssetAssignmentAreaUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    emailAddress!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: IAssetAssignmentAreaUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): AssetAssignmentAreaUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetAssignmentAreaUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): AssetAssignmentAreaUserDto {
        const json = this.toJSON();
        let result = new AssetAssignmentAreaUserDto();
        result.init(json);
        return result;
    }
}

export interface IAssetAssignmentAreaUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    fullName: string | undefined;
}

export class AssetDto implements IAssetDto {
    id!: number;
    /** Dto for AnaylsisStatuses */
    analysisStatus!: AnalysisStatusDto | undefined;
    tenantId!: number | undefined;
    address!: string | undefined;
    hasAddressInfo!: boolean;
    facilityId!: string | undefined;
    comments!: string | undefined;
    district!: string | undefined;
    collectorId!: string | undefined;
    inspectionId!: number;
    brandDate!: number | undefined;
    poleHeight!: number | undefined;
    poleClass!: string | undefined;
    riskZone!: string | undefined;
    constructionType!: string | undefined;
    truckAccessible!: boolean;
    groundResistance!: number | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    customerLatitude!: number | undefined;
    customerLongitude!: number | undefined;
    customProperties!: string | undefined;
    customPropertyValues!: CustomAssetPropertyValueDto[] | undefined;
    circuitDisplayList!: string | undefined;
    circuitToAssets!: CircuitToAssetDto[] | undefined;
    geo!: Point | undefined;
    customerGeo!: Point | undefined;
    inspectionToAssetLatitude!: number | undefined;
    inspectionToAssetLongitude!: number | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.analysisStatus = _data["analysisStatus"] ? AnalysisStatusDto.fromJS(_data["analysisStatus"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.address = _data["address"];
            this.hasAddressInfo = _data["hasAddressInfo"];
            this.facilityId = _data["facilityId"];
            this.comments = _data["comments"];
            this.district = _data["district"];
            this.collectorId = _data["collectorId"];
            this.inspectionId = _data["inspectionId"];
            this.brandDate = _data["brandDate"];
            this.poleHeight = _data["poleHeight"];
            this.poleClass = _data["poleClass"];
            this.riskZone = _data["riskZone"];
            this.constructionType = _data["constructionType"];
            this.truckAccessible = _data["truckAccessible"];
            this.groundResistance = _data["groundResistance"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.customerLatitude = _data["customerLatitude"];
            this.customerLongitude = _data["customerLongitude"];
            this.customProperties = _data["customProperties"];
            if (Array.isArray(_data["customPropertyValues"])) {
                this.customPropertyValues = [] as any;
                for (let item of _data["customPropertyValues"])
                    this.customPropertyValues!.push(CustomAssetPropertyValueDto.fromJS(item));
            }
            this.circuitDisplayList = _data["circuitDisplayList"];
            if (Array.isArray(_data["circuitToAssets"])) {
                this.circuitToAssets = [] as any;
                for (let item of _data["circuitToAssets"])
                    this.circuitToAssets!.push(CircuitToAssetDto.fromJS(item));
            }
            this.geo = _data["geo"] ? Point.fromJS(_data["geo"]) : <any>undefined;
            this.customerGeo = _data["customerGeo"] ? Point.fromJS(_data["customerGeo"]) : <any>undefined;
            this.inspectionToAssetLatitude = _data["inspectionToAssetLatitude"];
            this.inspectionToAssetLongitude = _data["inspectionToAssetLongitude"];
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["analysisStatus"] = this.analysisStatus ? this.analysisStatus.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["address"] = this.address;
        data["hasAddressInfo"] = this.hasAddressInfo;
        data["facilityId"] = this.facilityId;
        data["comments"] = this.comments;
        data["district"] = this.district;
        data["collectorId"] = this.collectorId;
        data["inspectionId"] = this.inspectionId;
        data["brandDate"] = this.brandDate;
        data["poleHeight"] = this.poleHeight;
        data["poleClass"] = this.poleClass;
        data["riskZone"] = this.riskZone;
        data["constructionType"] = this.constructionType;
        data["truckAccessible"] = this.truckAccessible;
        data["groundResistance"] = this.groundResistance;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["customerLatitude"] = this.customerLatitude;
        data["customerLongitude"] = this.customerLongitude;
        data["customProperties"] = this.customProperties;
        if (Array.isArray(this.customPropertyValues)) {
            data["customPropertyValues"] = [];
            for (let item of this.customPropertyValues)
                data["customPropertyValues"].push(item.toJSON());
        }
        data["circuitDisplayList"] = this.circuitDisplayList;
        if (Array.isArray(this.circuitToAssets)) {
            data["circuitToAssets"] = [];
            for (let item of this.circuitToAssets)
                data["circuitToAssets"].push(item.toJSON());
        }
        data["geo"] = this.geo ? this.geo.toJSON() : <any>undefined;
        data["customerGeo"] = this.customerGeo ? this.customerGeo.toJSON() : <any>undefined;
        data["inspectionToAssetLatitude"] = this.inspectionToAssetLatitude;
        data["inspectionToAssetLongitude"] = this.inspectionToAssetLongitude;
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto {
    id: number;
    /** Dto for AnaylsisStatuses */
    analysisStatus: AnalysisStatusDto | undefined;
    tenantId: number | undefined;
    address: string | undefined;
    hasAddressInfo: boolean;
    facilityId: string | undefined;
    comments: string | undefined;
    district: string | undefined;
    collectorId: string | undefined;
    inspectionId: number;
    brandDate: number | undefined;
    poleHeight: number | undefined;
    poleClass: string | undefined;
    riskZone: string | undefined;
    constructionType: string | undefined;
    truckAccessible: boolean;
    groundResistance: number | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    customerLatitude: number | undefined;
    customerLongitude: number | undefined;
    customProperties: string | undefined;
    customPropertyValues: CustomAssetPropertyValueDto[] | undefined;
    circuitDisplayList: string | undefined;
    circuitToAssets: CircuitToAssetDto[] | undefined;
    geo: Point | undefined;
    customerGeo: Point | undefined;
    inspectionToAssetLatitude: number | undefined;
    inspectionToAssetLongitude: number | undefined;
}

/** The assigned assets pending inspections dto */
export class AssignedAssetsPendingInspectionNotificationDto implements IAssignedAssetsPendingInspectionNotificationDto {
    /** The associated inspection */
    inspection!: InspectionDto | undefined;
    /** The associated Tenant */
    tenant!: TenantDto | undefined;
    /** The list of associated AssignedAssetsPendingInspectionNotificationUserDataDtos */
    userData!: AssignedAssetsPendingInspectionNotificationUserDataDto[] | undefined;

    constructor(data?: IAssignedAssetsPendingInspectionNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            if (Array.isArray(_data["userData"])) {
                this.userData = [] as any;
                for (let item of _data["userData"])
                    this.userData!.push(AssignedAssetsPendingInspectionNotificationUserDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignedAssetsPendingInspectionNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedAssetsPendingInspectionNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        if (Array.isArray(this.userData)) {
            data["userData"] = [];
            for (let item of this.userData)
                data["userData"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssignedAssetsPendingInspectionNotificationDto {
        const json = this.toJSON();
        let result = new AssignedAssetsPendingInspectionNotificationDto();
        result.init(json);
        return result;
    }
}

/** The assigned assets pending inspections dto */
export interface IAssignedAssetsPendingInspectionNotificationDto {
    /** The associated inspection */
    inspection: InspectionDto | undefined;
    /** The associated Tenant */
    tenant: TenantDto | undefined;
    /** The list of associated AssignedAssetsPendingInspectionNotificationUserDataDtos */
    userData: AssignedAssetsPendingInspectionNotificationUserDataDto[] | undefined;
}

/** The assigned assets pending inspection by a particular user */
export class AssignedAssetsPendingInspectionNotificationUserDataDto implements IAssignedAssetsPendingInspectionNotificationUserDataDto {
    /** The associated user */
    user!: UserDto | undefined;
    /** The total count of assigned assets */
    assignedCount!: number;
    /** The count of assigned assets pending inspection */
    assignedUninspectedCount!: number;
    /** The count of assigned assets pending inspection that also are Analyzed (Ready) */
    assignedUninspectedAnalyzedCount!: number;

    constructor(data?: IAssignedAssetsPendingInspectionNotificationUserDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.assignedCount = _data["assignedCount"];
            this.assignedUninspectedCount = _data["assignedUninspectedCount"];
            this.assignedUninspectedAnalyzedCount = _data["assignedUninspectedAnalyzedCount"];
        }
    }

    static fromJS(data: any): AssignedAssetsPendingInspectionNotificationUserDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedAssetsPendingInspectionNotificationUserDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["assignedCount"] = this.assignedCount;
        data["assignedUninspectedCount"] = this.assignedUninspectedCount;
        data["assignedUninspectedAnalyzedCount"] = this.assignedUninspectedAnalyzedCount;
        return data;
    }

    clone(): AssignedAssetsPendingInspectionNotificationUserDataDto {
        const json = this.toJSON();
        let result = new AssignedAssetsPendingInspectionNotificationUserDataDto();
        result.init(json);
        return result;
    }
}

/** The assigned assets pending inspection by a particular user */
export interface IAssignedAssetsPendingInspectionNotificationUserDataDto {
    /** The associated user */
    user: UserDto | undefined;
    /** The total count of assigned assets */
    assignedCount: number;
    /** The count of assigned assets pending inspection */
    assignedUninspectedCount: number;
    /** The count of assigned assets pending inspection that also are Analyzed (Ready) */
    assignedUninspectedAnalyzedCount: number;
}

export class AuditReasonType implements IAuditReasonType {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    name!: string;
    order!: number;

    constructor(data?: IAuditReasonType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): AuditReasonType {
        data = typeof data === 'object' ? data : {};
        let result = new AuditReasonType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["order"] = this.order;
        return data;
    }

    clone(): AuditReasonType {
        const json = this.toJSON();
        let result = new AuditReasonType();
        result.init(json);
        return result;
    }
}

export interface IAuditReasonType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    order: number;
}

/** Dto for AuditReasonType */
export class AuditReasonTypeDto implements IAuditReasonTypeDto {
    id!: number;
    /** The name of the AuditReasonType */
    name!: string | undefined;

    constructor(data?: IAuditReasonTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AuditReasonTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditReasonTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AuditReasonTypeDto {
        const json = this.toJSON();
        let result = new AuditReasonTypeDto();
        result.init(json);
        return result;
    }
}

/** Dto for AuditReasonType */
export interface IAuditReasonTypeDto {
    id: number;
    /** The name of the AuditReasonType */
    name: string | undefined;
}

export class AuditReasonTypeDtoPagedResultDto implements IAuditReasonTypeDtoPagedResultDto {
    items!: AuditReasonTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAuditReasonTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditReasonTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AuditReasonTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditReasonTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AuditReasonTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AuditReasonTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAuditReasonTypeDtoPagedResultDto {
    items: AuditReasonTypeDto[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

/** Dto for ComputerVisionModel */
export class BasicComputerVisionModelDto implements IBasicComputerVisionModelDto {
    id!: number;
    /** Name of the computer vision model */
    name!: string | undefined;
    /** Model name for the computer vision model */
    modelName!: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId!: number;

    constructor(data?: IBasicComputerVisionModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modelName = _data["modelName"];
            this.computerVisionModelTypeId = _data["computerVisionModelTypeId"];
        }
    }

    static fromJS(data: any): BasicComputerVisionModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicComputerVisionModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modelName"] = this.modelName;
        data["computerVisionModelTypeId"] = this.computerVisionModelTypeId;
        return data;
    }

    clone(): BasicComputerVisionModelDto {
        const json = this.toJSON();
        let result = new BasicComputerVisionModelDto();
        result.init(json);
        return result;
    }
}

/** Dto for ComputerVisionModel */
export interface IBasicComputerVisionModelDto {
    id: number;
    /** Name of the computer vision model */
    name: string | undefined;
    /** Model name for the computer vision model */
    modelName: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId: number;
}

/** Gets basic information about an inspection. */
export class BasicInspectionDto implements IBasicInspectionDto {
    id!: number;
    /** Identifier of the Tenant Inspection belongs to */
    tenantId!: number;
    /** Name of the Tenant */
    tenantName!: string | undefined;
    /** Name of the Inspection */
    inspectionName!: string | undefined;
    /** Flag to determine whether or not this inspection has been soft deleted */
    isDeleted!: boolean;

    constructor(data?: IBasicInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.inspectionName = _data["inspectionName"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): BasicInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["inspectionName"] = this.inspectionName;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): BasicInspectionDto {
        const json = this.toJSON();
        let result = new BasicInspectionDto();
        result.init(json);
        return result;
    }
}

/** Gets basic information about an inspection. */
export interface IBasicInspectionDto {
    id: number;
    /** Identifier of the Tenant Inspection belongs to */
    tenantId: number;
    /** Name of the Tenant */
    tenantName: string | undefined;
    /** Name of the Inspection */
    inspectionName: string | undefined;
    /** Flag to determine whether or not this inspection has been soft deleted */
    isDeleted: boolean;
}

/** Dto for BoundingBox */
export class BoundingBoxDto implements IBoundingBoxDto {
    id!: number;
    /** X position for the top-left corner of this box */
    x!: number;
    /** Y position for the top-left corner of this box */
    y!: number;
    /** Width of this box */
    width!: number;
    /** Height of this box */
    height!: number;
    /** Z-Index order for this bounding box on the image */
    zIndex!: number;
    /** Identifier of the related ImageToCondition object */
    imageToCondition!: ImageToConditionDto | undefined;
    /** Identifier of the related ImageToInventoryItem object */
    imageToInventoryItem!: ImageToInventoryItemDto | undefined;
    /** The id of the related PredictedBoundingBox to this bounding box */
    predictedBoundingBoxId!: number | undefined;

    constructor(data?: IBoundingBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.zIndex = _data["zIndex"];
            this.imageToCondition = _data["imageToCondition"] ? ImageToConditionDto.fromJS(_data["imageToCondition"]) : <any>undefined;
            this.imageToInventoryItem = _data["imageToInventoryItem"] ? ImageToInventoryItemDto.fromJS(_data["imageToInventoryItem"]) : <any>undefined;
            this.predictedBoundingBoxId = _data["predictedBoundingBoxId"];
        }
    }

    static fromJS(data: any): BoundingBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["zIndex"] = this.zIndex;
        data["imageToCondition"] = this.imageToCondition ? this.imageToCondition.toJSON() : <any>undefined;
        data["imageToInventoryItem"] = this.imageToInventoryItem ? this.imageToInventoryItem.toJSON() : <any>undefined;
        data["predictedBoundingBoxId"] = this.predictedBoundingBoxId;
        return data;
    }

    clone(): BoundingBoxDto {
        const json = this.toJSON();
        let result = new BoundingBoxDto();
        result.init(json);
        return result;
    }
}

/** Dto for BoundingBox */
export interface IBoundingBoxDto {
    id: number;
    /** X position for the top-left corner of this box */
    x: number;
    /** Y position for the top-left corner of this box */
    y: number;
    /** Width of this box */
    width: number;
    /** Height of this box */
    height: number;
    /** Z-Index order for this bounding box on the image */
    zIndex: number;
    /** Identifier of the related ImageToCondition object */
    imageToCondition: ImageToConditionDto | undefined;
    /** Identifier of the related ImageToInventoryItem object */
    imageToInventoryItem: ImageToInventoryItemDto | undefined;
    /** The id of the related PredictedBoundingBox to this bounding box */
    predictedBoundingBoxId: number | undefined;
}

/** Dto for BoundingBox used to save them against an Image */
export class BoundingBoxSaveDto implements IBoundingBoxSaveDto {
    /** The list of Bounding Boxes to add */
    boxesToAdd!: BoundingBoxDto[] | undefined;
    /** The list of Bounding Boxes to update */
    boxesToUpdate!: BoundingBoxDto[] | undefined;
    /** The list of Bounding Boxes to delete */
    boxesToDelete!: BoundingBoxDto[] | undefined;

    constructor(data?: IBoundingBoxSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["boxesToAdd"])) {
                this.boxesToAdd = [] as any;
                for (let item of _data["boxesToAdd"])
                    this.boxesToAdd!.push(BoundingBoxDto.fromJS(item));
            }
            if (Array.isArray(_data["boxesToUpdate"])) {
                this.boxesToUpdate = [] as any;
                for (let item of _data["boxesToUpdate"])
                    this.boxesToUpdate!.push(BoundingBoxDto.fromJS(item));
            }
            if (Array.isArray(_data["boxesToDelete"])) {
                this.boxesToDelete = [] as any;
                for (let item of _data["boxesToDelete"])
                    this.boxesToDelete!.push(BoundingBoxDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoundingBoxSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBoxSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.boxesToAdd)) {
            data["boxesToAdd"] = [];
            for (let item of this.boxesToAdd)
                data["boxesToAdd"].push(item.toJSON());
        }
        if (Array.isArray(this.boxesToUpdate)) {
            data["boxesToUpdate"] = [];
            for (let item of this.boxesToUpdate)
                data["boxesToUpdate"].push(item.toJSON());
        }
        if (Array.isArray(this.boxesToDelete)) {
            data["boxesToDelete"] = [];
            for (let item of this.boxesToDelete)
                data["boxesToDelete"].push(item.toJSON());
        }
        return data;
    }

    clone(): BoundingBoxSaveDto {
        const json = this.toJSON();
        let result = new BoundingBoxSaveDto();
        result.init(json);
        return result;
    }
}

/** Dto for BoundingBox used to save them against an Image */
export interface IBoundingBoxSaveDto {
    /** The list of Bounding Boxes to add */
    boxesToAdd: BoundingBoxDto[] | undefined;
    /** The list of Bounding Boxes to update */
    boxesToUpdate: BoundingBoxDto[] | undefined;
    /** The list of Bounding Boxes to delete */
    boxesToDelete: BoundingBoxDto[] | undefined;
}

/** Object to represent current batch runs for AIM */
export class BulkProcessingRunDto implements IBulkProcessingRunDto {
    /** Id of the model for this run */
    modelId!: number;
    /** Name of the model for this run */
    modelName!: string | undefined;
    /** Number of images that were run for an inspection and model */
    imagesRun!: number | undefined;
    /** Total number of images for the insepction and model */
    imagesOnInspectionModel!: number;
    /** Status of the bulk run */
    runStatus!: InspectionModelRunStatus | undefined;
    /** Status name of the bulk run */
    readonly runStatusName!: string | undefined;
    /** Whether or not the bulk run can be processed */
    readonly isReadyForProcessing!: boolean;
    /** Creation time of the model run */
    creationTime!: moment.Moment | undefined;

    constructor(data?: IBulkProcessingRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.modelName = _data["modelName"];
            this.imagesRun = _data["imagesRun"];
            this.imagesOnInspectionModel = _data["imagesOnInspectionModel"];
            this.runStatus = _data["runStatus"] ? InspectionModelRunStatus.fromJS(_data["runStatus"]) : <any>undefined;
            (<any>this).runStatusName = _data["runStatusName"];
            (<any>this).isReadyForProcessing = _data["isReadyForProcessing"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkProcessingRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkProcessingRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        data["imagesRun"] = this.imagesRun;
        data["imagesOnInspectionModel"] = this.imagesOnInspectionModel;
        data["runStatus"] = this.runStatus ? this.runStatus.toJSON() : <any>undefined;
        data["runStatusName"] = this.runStatusName;
        data["isReadyForProcessing"] = this.isReadyForProcessing;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): BulkProcessingRunDto {
        const json = this.toJSON();
        let result = new BulkProcessingRunDto();
        result.init(json);
        return result;
    }
}

/** Object to represent current batch runs for AIM */
export interface IBulkProcessingRunDto {
    /** Id of the model for this run */
    modelId: number;
    /** Name of the model for this run */
    modelName: string | undefined;
    /** Number of images that were run for an inspection and model */
    imagesRun: number | undefined;
    /** Total number of images for the insepction and model */
    imagesOnInspectionModel: number;
    /** Status of the bulk run */
    runStatus: InspectionModelRunStatus | undefined;
    /** Status name of the bulk run */
    runStatusName: string | undefined;
    /** Whether or not the bulk run can be processed */
    isReadyForProcessing: boolean;
    /** Creation time of the model run */
    creationTime: moment.Moment | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

/** Dto for Circuit */
export class CircuitDto implements ICircuitDto {
    id!: number;
    /** Tenant that circuit belongs to */
    tenantId!: number;
    /** Name of the Tenant */
    tenantName!: string | undefined;
    /** Name of Circuit */
    name!: string | undefined;
    /** Number of assets associated with this circuit */
    totalAssetCount!: number;
    /** Number of inspected assets associated with this circuit */
    totalInspectedAssetCount!: number;
    /** Number of imageless assets associated with this circuit */
    totalImagelessAssetCount!: number;

    constructor(data?: ICircuitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.name = _data["name"];
            this.totalAssetCount = _data["totalAssetCount"];
            this.totalInspectedAssetCount = _data["totalInspectedAssetCount"];
            this.totalImagelessAssetCount = _data["totalImagelessAssetCount"];
        }
    }

    static fromJS(data: any): CircuitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CircuitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["name"] = this.name;
        data["totalAssetCount"] = this.totalAssetCount;
        data["totalInspectedAssetCount"] = this.totalInspectedAssetCount;
        data["totalImagelessAssetCount"] = this.totalImagelessAssetCount;
        return data;
    }

    clone(): CircuitDto {
        const json = this.toJSON();
        let result = new CircuitDto();
        result.init(json);
        return result;
    }
}

/** Dto for Circuit */
export interface ICircuitDto {
    id: number;
    /** Tenant that circuit belongs to */
    tenantId: number;
    /** Name of the Tenant */
    tenantName: string | undefined;
    /** Name of Circuit */
    name: string | undefined;
    /** Number of assets associated with this circuit */
    totalAssetCount: number;
    /** Number of inspected assets associated with this circuit */
    totalInspectedAssetCount: number;
    /** Number of imageless assets associated with this circuit */
    totalImagelessAssetCount: number;
}

export class CircuitDtoPagedResultDto implements ICircuitDtoPagedResultDto {
    items!: CircuitDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICircuitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CircuitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CircuitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CircuitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CircuitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CircuitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICircuitDtoPagedResultDto {
    items: CircuitDto[] | undefined;
    totalCount: number;
}

/** Dto for Circuit */
export class CircuitReportDto implements ICircuitReportDto {
    id!: number;
    /** Tenant that circuit belongs to */
    tenantId!: number;
    /** Name of the Tenant */
    tenantName!: string | undefined;
    /** Name of Circuit */
    name!: string | undefined;
    /** Number of assets associated with this circuit */
    totalAssetCount!: number;
    /** Number of inspected assets associated with this circuit */
    totalInspectedAssetCount!: number;
    /** Number of imageless assets associated with this circuit */
    totalImagelessAssetCount!: number;

    constructor(data?: ICircuitReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.name = _data["name"];
            this.totalAssetCount = _data["totalAssetCount"];
            this.totalInspectedAssetCount = _data["totalInspectedAssetCount"];
            this.totalImagelessAssetCount = _data["totalImagelessAssetCount"];
        }
    }

    static fromJS(data: any): CircuitReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CircuitReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["name"] = this.name;
        data["totalAssetCount"] = this.totalAssetCount;
        data["totalInspectedAssetCount"] = this.totalInspectedAssetCount;
        data["totalImagelessAssetCount"] = this.totalImagelessAssetCount;
        return data;
    }

    clone(): CircuitReportDto {
        const json = this.toJSON();
        let result = new CircuitReportDto();
        result.init(json);
        return result;
    }
}

/** Dto for Circuit */
export interface ICircuitReportDto {
    id: number;
    /** Tenant that circuit belongs to */
    tenantId: number;
    /** Name of the Tenant */
    tenantName: string | undefined;
    /** Name of Circuit */
    name: string | undefined;
    /** Number of assets associated with this circuit */
    totalAssetCount: number;
    /** Number of inspected assets associated with this circuit */
    totalInspectedAssetCount: number;
    /** Number of imageless assets associated with this circuit */
    totalImagelessAssetCount: number;
}

export class CircuitToAssetDto implements ICircuitToAssetDto {
    id!: number;
    /** Identifier of the Related Circuit */
    circuitId!: number;
    /** The related Circuit. */
    circuit!: CircuitDto | undefined;

    constructor(data?: ICircuitToAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.circuitId = _data["circuitId"];
            this.circuit = _data["circuit"] ? CircuitDto.fromJS(_data["circuit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CircuitToAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CircuitToAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["circuitId"] = this.circuitId;
        data["circuit"] = this.circuit ? this.circuit.toJSON() : <any>undefined;
        return data;
    }

    clone(): CircuitToAssetDto {
        const json = this.toJSON();
        let result = new CircuitToAssetDto();
        result.init(json);
        return result;
    }
}

export interface ICircuitToAssetDto {
    id: number;
    /** Identifier of the Related Circuit */
    circuitId: number;
    /** The related Circuit. */
    circuit: CircuitDto | undefined;
}

export class CompressedImageDataDto implements ICompressedImageDataDto {
    tenantId!: number;
    md5!: string | undefined;
    compressedFileSize!: number;

    constructor(data?: ICompressedImageDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.md5 = _data["md5"];
            this.compressedFileSize = _data["compressedFileSize"];
        }
    }

    static fromJS(data: any): CompressedImageDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompressedImageDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["md5"] = this.md5;
        data["compressedFileSize"] = this.compressedFileSize;
        return data;
    }

    clone(): CompressedImageDataDto {
        const json = this.toJSON();
        let result = new CompressedImageDataDto();
        result.init(json);
        return result;
    }
}

export interface ICompressedImageDataDto {
    tenantId: number;
    md5: string | undefined;
    compressedFileSize: number;
}

/** Dto for ComputerVisionModel */
export class ComputerVisionModelDto implements IComputerVisionModelDto {
    id!: number;
    /** Name of the computer vision model */
    name!: string | undefined;
    /** Model name for the computer vision model */
    modelName!: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId!: number;
    /** List of associated ComputerVisionModelLabels */
    labels!: ComputerVisionModelLabelDto[] | undefined;
    /** List of ComputerVisionModels that require this ComputerVisionModel as a prerequisite */
    dependentComputerVisionModels!: BasicComputerVisionModelDto[] | undefined;
    /** List of ComputerVisionModels that this ComputerVisionModel requires as a prerequisite */
    prerequisiteComputerVisionModels!: BasicComputerVisionModelDto[] | undefined;

    constructor(data?: IComputerVisionModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modelName = _data["modelName"];
            this.computerVisionModelTypeId = _data["computerVisionModelTypeId"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(ComputerVisionModelLabelDto.fromJS(item));
            }
            if (Array.isArray(_data["dependentComputerVisionModels"])) {
                this.dependentComputerVisionModels = [] as any;
                for (let item of _data["dependentComputerVisionModels"])
                    this.dependentComputerVisionModels!.push(BasicComputerVisionModelDto.fromJS(item));
            }
            if (Array.isArray(_data["prerequisiteComputerVisionModels"])) {
                this.prerequisiteComputerVisionModels = [] as any;
                for (let item of _data["prerequisiteComputerVisionModels"])
                    this.prerequisiteComputerVisionModels!.push(BasicComputerVisionModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComputerVisionModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComputerVisionModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modelName"] = this.modelName;
        data["computerVisionModelTypeId"] = this.computerVisionModelTypeId;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        if (Array.isArray(this.dependentComputerVisionModels)) {
            data["dependentComputerVisionModels"] = [];
            for (let item of this.dependentComputerVisionModels)
                data["dependentComputerVisionModels"].push(item.toJSON());
        }
        if (Array.isArray(this.prerequisiteComputerVisionModels)) {
            data["prerequisiteComputerVisionModels"] = [];
            for (let item of this.prerequisiteComputerVisionModels)
                data["prerequisiteComputerVisionModels"].push(item.toJSON());
        }
        return data;
    }

    clone(): ComputerVisionModelDto {
        const json = this.toJSON();
        let result = new ComputerVisionModelDto();
        result.init(json);
        return result;
    }
}

/** Dto for ComputerVisionModel */
export interface IComputerVisionModelDto {
    id: number;
    /** Name of the computer vision model */
    name: string | undefined;
    /** Model name for the computer vision model */
    modelName: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId: number;
    /** List of associated ComputerVisionModelLabels */
    labels: ComputerVisionModelLabelDto[] | undefined;
    /** List of ComputerVisionModels that require this ComputerVisionModel as a prerequisite */
    dependentComputerVisionModels: BasicComputerVisionModelDto[] | undefined;
    /** List of ComputerVisionModels that this ComputerVisionModel requires as a prerequisite */
    prerequisiteComputerVisionModels: BasicComputerVisionModelDto[] | undefined;
}

export class ComputerVisionModelDtoPagedResultDto implements IComputerVisionModelDtoPagedResultDto {
    items!: ComputerVisionModelDto[] | undefined;
    totalCount!: number;

    constructor(data?: IComputerVisionModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ComputerVisionModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ComputerVisionModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComputerVisionModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ComputerVisionModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ComputerVisionModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IComputerVisionModelDtoPagedResultDto {
    items: ComputerVisionModelDto[] | undefined;
    totalCount: number;
}

/** Dto for ComputerVisionModelLabel */
export class ComputerVisionModelLabelDto implements IComputerVisionModelLabelDto {
    id!: number;
    /** ID of the parent ComputerVisionModel */
    computerVisionModelId!: number;
    /** Name of the computer vision model label */
    name!: string | undefined;
    /** The ComputerVisionModelSubLabels associated with this ComputerVisionModelLabel. */
    subLabels!: ComputerVisionModelSubLabelDto[] | undefined;

    constructor(data?: IComputerVisionModelLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.name = _data["name"];
            if (Array.isArray(_data["subLabels"])) {
                this.subLabels = [] as any;
                for (let item of _data["subLabels"])
                    this.subLabels!.push(ComputerVisionModelSubLabelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComputerVisionModelLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComputerVisionModelLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["name"] = this.name;
        if (Array.isArray(this.subLabels)) {
            data["subLabels"] = [];
            for (let item of this.subLabels)
                data["subLabels"].push(item.toJSON());
        }
        return data;
    }

    clone(): ComputerVisionModelLabelDto {
        const json = this.toJSON();
        let result = new ComputerVisionModelLabelDto();
        result.init(json);
        return result;
    }
}

/** Dto for ComputerVisionModelLabel */
export interface IComputerVisionModelLabelDto {
    id: number;
    /** ID of the parent ComputerVisionModel */
    computerVisionModelId: number;
    /** Name of the computer vision model label */
    name: string | undefined;
    /** The ComputerVisionModelSubLabels associated with this ComputerVisionModelLabel. */
    subLabels: ComputerVisionModelSubLabelDto[] | undefined;
}

/** Dto for ComputerVisionModelLabels for Suggested Inventory */
export class ComputerVisionModelLabelInventorySuggestionDto implements IComputerVisionModelLabelInventorySuggestionDto {
    /** The identifier of the label. */
    id!: number;
    /** The name of the label. */
    name!: string | undefined;
    /** The Inventory Item Suggestions associated with this ComputerVisionModelLabel */
    suggestions!: InventorySuggestionDto[] | undefined;

    constructor(data?: IComputerVisionModelLabelInventorySuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(InventorySuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComputerVisionModelLabelInventorySuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComputerVisionModelLabelInventorySuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ComputerVisionModelLabelInventorySuggestionDto {
        const json = this.toJSON();
        let result = new ComputerVisionModelLabelInventorySuggestionDto();
        result.init(json);
        return result;
    }
}

/** Dto for ComputerVisionModelLabels for Suggested Inventory */
export interface IComputerVisionModelLabelInventorySuggestionDto {
    /** The identifier of the label. */
    id: number;
    /** The name of the label. */
    name: string | undefined;
    /** The Inventory Item Suggestions associated with this ComputerVisionModelLabel */
    suggestions: InventorySuggestionDto[] | undefined;
}

/** Dto For ComputerVisionModelSubLabels */
export class ComputerVisionModelSubLabelDto implements IComputerVisionModelSubLabelDto {
    id!: number;
    /** The id of the parent ComputerVisionModelLabel */
    computerVisionModelLabelId!: number;
    /** The name of this ComputerVisionModelSubLabel */
    name!: string | undefined;

    constructor(data?: IComputerVisionModelSubLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.computerVisionModelLabelId = _data["computerVisionModelLabelId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ComputerVisionModelSubLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComputerVisionModelSubLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["computerVisionModelLabelId"] = this.computerVisionModelLabelId;
        data["name"] = this.name;
        return data;
    }

    clone(): ComputerVisionModelSubLabelDto {
        const json = this.toJSON();
        let result = new ComputerVisionModelSubLabelDto();
        result.init(json);
        return result;
    }
}

/** Dto For ComputerVisionModelSubLabels */
export interface IComputerVisionModelSubLabelDto {
    id: number;
    /** The id of the parent ComputerVisionModelLabel */
    computerVisionModelLabelId: number;
    /** The name of this ComputerVisionModelSubLabel */
    name: string | undefined;
}

/** Dto for ComputerVisionModelSubLabels */
export class ComputerVisionModelTypeDto implements IComputerVisionModelTypeDto {
    id!: number;
    /** The name of this ComputerVisionModelType. */
    name!: string | undefined;

    constructor(data?: IComputerVisionModelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ComputerVisionModelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComputerVisionModelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ComputerVisionModelTypeDto {
        const json = this.toJSON();
        let result = new ComputerVisionModelTypeDto();
        result.init(json);
        return result;
    }
}

/** Dto for ComputerVisionModelSubLabels */
export interface IComputerVisionModelTypeDto {
    id: number;
    /** The name of this ComputerVisionModelType. */
    name: string | undefined;
}

export class ConditionBoundingBoxDto implements IConditionBoundingBoxDto {
    id!: number;
    /** X position for the top-left corner of this box */
    x!: number;
    /** Y position for the top-left corner of this box */
    y!: number;
    /** Width of this box */
    width!: number;
    /** Height of this box */
    height!: number;
    /** Z-Index order for this bounding box on the image */
    zIndex!: number;
    /** The id of the related PredictedBoundingBox to this bounding box */
    predictedBoundingBoxId!: number | undefined;
    /** Identifier of the related ImageToCondition object */
    imageToConditionId!: number;
    /** The ImageToCondition that this bounding box represents */
    imageToCondition!: ImageToConditionDto | undefined;

    constructor(data?: IConditionBoundingBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.zIndex = _data["zIndex"];
            this.predictedBoundingBoxId = _data["predictedBoundingBoxId"];
            this.imageToConditionId = _data["imageToConditionId"];
            this.imageToCondition = _data["imageToCondition"] ? ImageToConditionDto.fromJS(_data["imageToCondition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConditionBoundingBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionBoundingBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["zIndex"] = this.zIndex;
        data["predictedBoundingBoxId"] = this.predictedBoundingBoxId;
        data["imageToConditionId"] = this.imageToConditionId;
        data["imageToCondition"] = this.imageToCondition ? this.imageToCondition.toJSON() : <any>undefined;
        return data;
    }

    clone(): ConditionBoundingBoxDto {
        const json = this.toJSON();
        let result = new ConditionBoundingBoxDto();
        result.init(json);
        return result;
    }
}

export interface IConditionBoundingBoxDto {
    id: number;
    /** X position for the top-left corner of this box */
    x: number;
    /** Y position for the top-left corner of this box */
    y: number;
    /** Width of this box */
    width: number;
    /** Height of this box */
    height: number;
    /** Z-Index order for this bounding box on the image */
    zIndex: number;
    /** The id of the related PredictedBoundingBox to this bounding box */
    predictedBoundingBoxId: number | undefined;
    /** Identifier of the related ImageToCondition object */
    imageToConditionId: number;
    /** The ImageToCondition that this bounding box represents */
    imageToCondition: ImageToConditionDto | undefined;
}

export class ConditionData implements IConditionData {
    assetId!: number;
    conditionItemType!: string | undefined;
    conditionType!: string | undefined;
    conditionName!: string | undefined;
    rwcid!: string | undefined;
    comments!: string | undefined;
    distance!: string | undefined;
    inspectionMethod!: string | undefined;
    foundInFieldTime!: moment.Moment | undefined;
    foundInFieldBy!: string | undefined;
    qcBypass!: boolean | undefined;
    imageId!: number | undefined;

    constructor(data?: IConditionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.conditionItemType = _data["conditionItemType"];
            this.conditionType = _data["conditionType"];
            this.conditionName = _data["conditionName"];
            this.rwcid = _data["rwcid"];
            this.comments = _data["comments"];
            this.distance = _data["distance"];
            this.inspectionMethod = _data["inspectionMethod"];
            this.foundInFieldTime = _data["foundInFieldTime"] ? moment(_data["foundInFieldTime"].toString()) : <any>undefined;
            this.foundInFieldBy = _data["foundInFieldBy"];
            this.qcBypass = _data["qcBypass"];
            this.imageId = _data["imageId"];
        }
    }

    static fromJS(data: any): ConditionData {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["conditionItemType"] = this.conditionItemType;
        data["conditionType"] = this.conditionType;
        data["conditionName"] = this.conditionName;
        data["rwcid"] = this.rwcid;
        data["comments"] = this.comments;
        data["distance"] = this.distance;
        data["inspectionMethod"] = this.inspectionMethod;
        data["foundInFieldTime"] = this.foundInFieldTime ? this.foundInFieldTime.toISOString() : <any>undefined;
        data["foundInFieldBy"] = this.foundInFieldBy;
        data["qcBypass"] = this.qcBypass;
        data["imageId"] = this.imageId;
        return data;
    }

    clone(): ConditionData {
        const json = this.toJSON();
        let result = new ConditionData();
        result.init(json);
        return result;
    }
}

export interface IConditionData {
    assetId: number;
    conditionItemType: string | undefined;
    conditionType: string | undefined;
    conditionName: string | undefined;
    rwcid: string | undefined;
    comments: string | undefined;
    distance: string | undefined;
    inspectionMethod: string | undefined;
    foundInFieldTime: moment.Moment | undefined;
    foundInFieldBy: string | undefined;
    qcBypass: boolean | undefined;
    imageId: number | undefined;
}

/** Dto for a Condition */
export class ConditionDto implements IConditionDto {
    id!: number;
    /** ID of the Tenant Condition belongs to */
    tenantId!: number;
    /** The inspection method for this Condition. */
    inspectionMethod!: string | undefined;
    /** Item type */
    itemType!: string | undefined;
    /** Type */
    type!: string | undefined;
    /** Condition */
    conditionName!: string | undefined;
    /** Comment */
    comments!: string | undefined;
    /** Identifier of the Condition Status */
    statusId!: number;
    /** Condition status */
    status!: ConditionStatusDto | undefined;
    /** The priority of this Condition. */
    rwcid!: string | undefined;
    /** Flag determining whether or not the condition is deleted */
    isDeleted!: boolean;
    /** Identifier of the related Asset */
    assetId!: number | undefined;
    /** Identifier of the related Inspection */
    inspectionId!: number | undefined;
    /** The number of bounding boxes associated with this condition */
    boundingBoxCount!: number;
    /** Circuits related to this Condition. */
    circuits!: CircuitDto[] | undefined;
    /** The related images */
    images!: ImageDto[] | undefined;
    /** ImageToConditions for this Condition */
    imageToConditions!: ImageToConditionDto[] | undefined;
    /** The associated condition quality assurance note */
    conditionQualityAssuranceNote!: ConditionQualityAssuranceNoteDto | undefined;

    constructor(data?: IConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionMethod = _data["inspectionMethod"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.conditionName = _data["conditionName"];
            this.comments = _data["comments"];
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? ConditionStatusDto.fromJS(_data["status"]) : <any>undefined;
            this.rwcid = _data["rwcid"];
            this.isDeleted = _data["isDeleted"];
            this.assetId = _data["assetId"];
            this.inspectionId = _data["inspectionId"];
            this.boundingBoxCount = _data["boundingBoxCount"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["imageToConditions"])) {
                this.imageToConditions = [] as any;
                for (let item of _data["imageToConditions"])
                    this.imageToConditions!.push(ImageToConditionDto.fromJS(item));
            }
            this.conditionQualityAssuranceNote = _data["conditionQualityAssuranceNote"] ? ConditionQualityAssuranceNoteDto.fromJS(_data["conditionQualityAssuranceNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionMethod"] = this.inspectionMethod;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["conditionName"] = this.conditionName;
        data["comments"] = this.comments;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["rwcid"] = this.rwcid;
        data["isDeleted"] = this.isDeleted;
        data["assetId"] = this.assetId;
        data["inspectionId"] = this.inspectionId;
        data["boundingBoxCount"] = this.boundingBoxCount;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.imageToConditions)) {
            data["imageToConditions"] = [];
            for (let item of this.imageToConditions)
                data["imageToConditions"].push(item.toJSON());
        }
        data["conditionQualityAssuranceNote"] = this.conditionQualityAssuranceNote ? this.conditionQualityAssuranceNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): ConditionDto {
        const json = this.toJSON();
        let result = new ConditionDto();
        result.init(json);
        return result;
    }
}

/** Dto for a Condition */
export interface IConditionDto {
    id: number;
    /** ID of the Tenant Condition belongs to */
    tenantId: number;
    /** The inspection method for this Condition. */
    inspectionMethod: string | undefined;
    /** Item type */
    itemType: string | undefined;
    /** Type */
    type: string | undefined;
    /** Condition */
    conditionName: string | undefined;
    /** Comment */
    comments: string | undefined;
    /** Identifier of the Condition Status */
    statusId: number;
    /** Condition status */
    status: ConditionStatusDto | undefined;
    /** The priority of this Condition. */
    rwcid: string | undefined;
    /** Flag determining whether or not the condition is deleted */
    isDeleted: boolean;
    /** Identifier of the related Asset */
    assetId: number | undefined;
    /** Identifier of the related Inspection */
    inspectionId: number | undefined;
    /** The number of bounding boxes associated with this condition */
    boundingBoxCount: number;
    /** Circuits related to this Condition. */
    circuits: CircuitDto[] | undefined;
    /** The related images */
    images: ImageDto[] | undefined;
    /** ImageToConditions for this Condition */
    imageToConditions: ImageToConditionDto[] | undefined;
    /** The associated condition quality assurance note */
    conditionQualityAssuranceNote: ConditionQualityAssuranceNoteDto | undefined;
}

/** Dto for ConditionItemType */
export class ConditionItemTypeDto implements IConditionItemTypeDto {
    /** Identifier of the parent Inspection */
    inspectionId!: number;
    /** Name of the Condition Item Type */
    conditionItemTypeName!: string | undefined;
    /** Flag denoting whether this Item Type and its descendants are available Conditions to use (determined from Item Type level) */
    isAvailableForConditions!: boolean;
    /** Flag denoting whether this Item Type and its descendants are Inventory Items to use (determined from Item Type level) */
    isAvailableForInventoryItems!: boolean;

    constructor(data?: IConditionItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.conditionItemTypeName = _data["conditionItemTypeName"];
            this.isAvailableForConditions = _data["isAvailableForConditions"];
            this.isAvailableForInventoryItems = _data["isAvailableForInventoryItems"];
        }
    }

    static fromJS(data: any): ConditionItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["conditionItemTypeName"] = this.conditionItemTypeName;
        data["isAvailableForConditions"] = this.isAvailableForConditions;
        data["isAvailableForInventoryItems"] = this.isAvailableForInventoryItems;
        return data;
    }

    clone(): ConditionItemTypeDto {
        const json = this.toJSON();
        let result = new ConditionItemTypeDto();
        result.init(json);
        return result;
    }
}

/** Dto for ConditionItemType */
export interface IConditionItemTypeDto {
    /** Identifier of the parent Inspection */
    inspectionId: number;
    /** Name of the Condition Item Type */
    conditionItemTypeName: string | undefined;
    /** Flag denoting whether this Item Type and its descendants are available Conditions to use (determined from Item Type level) */
    isAvailableForConditions: boolean;
    /** Flag denoting whether this Item Type and its descendants are Inventory Items to use (determined from Item Type level) */
    isAvailableForInventoryItems: boolean;
}

/** DTO specifically to handle displaying the Condition hierarchy to the Tree List components for DevExtreme in the UI */
export class ConditionNodeDto implements IConditionNodeDto {
    /** Compound IDs should be in the form EntityTypeName_# */
    compoundId!: string | undefined;
    /** Compound ID for Parent Object (for Plain Data structure) */
    parentCompoundId!: string | undefined;
    /** Name of the Entity level within the Condition tree hierarchy */
    entityName!: string | undefined;
    /** Utilized by Condition Suggestion nodes */
    suggestionId!: number | undefined;
    /** Utilized by Condition Type and Condition Suggestion nodes */
    typeId!: number | undefined;
    /** Utilized by any hierarchy of Condition related node */
    itemTypeId!: number | undefined;
    /** Name assigned to the Condition node object */
    name!: string | undefined;
    /** Default RWCID value, utilized by Condition Suggestion nodes */
    defaultRwcid!: string | undefined;
    /** Inspection Method, utilized by Condition Suggestion nodes */
    inspectionMethod!: string | undefined;
    /** Computer Vision Model Id, utilized by Condition Suggestion nodes */
    computerVisionModelId!: number | undefined;
    /** Computer Vision Model Label Id, utilized by Condition Type nodes */
    computerVisionModelLabelId!: number | undefined;
    /** Short Name, utilized by Condition Suggestion nodes */
    shortName!: string | undefined;
    /** Boolean determining whether or not the current condition hierarchy item
has any child items */
    hasItems!: boolean;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available Conditions to use */
    isAvailableForConditions!: boolean | undefined;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available for Inventory Items to use */
    isAvailableForInventoryItems!: boolean | undefined;
    /** Utilized by Suggestion nodes, a flag denoting whether this Suggestion is available in the Collector app */
    isAvailableInCollector!: boolean | undefined;

    constructor(data?: IConditionNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compoundId = _data["compoundId"];
            this.parentCompoundId = _data["parentCompoundId"];
            this.entityName = _data["entityName"];
            this.suggestionId = _data["suggestionId"];
            this.typeId = _data["typeId"];
            this.itemTypeId = _data["itemTypeId"];
            this.name = _data["name"];
            this.defaultRwcid = _data["defaultRwcid"];
            this.inspectionMethod = _data["inspectionMethod"];
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.computerVisionModelLabelId = _data["computerVisionModelLabelId"];
            this.shortName = _data["shortName"];
            this.hasItems = _data["hasItems"];
            this.isAvailableForConditions = _data["isAvailableForConditions"];
            this.isAvailableForInventoryItems = _data["isAvailableForInventoryItems"];
            this.isAvailableInCollector = _data["isAvailableInCollector"];
        }
    }

    static fromJS(data: any): ConditionNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compoundId"] = this.compoundId;
        data["parentCompoundId"] = this.parentCompoundId;
        data["entityName"] = this.entityName;
        data["suggestionId"] = this.suggestionId;
        data["typeId"] = this.typeId;
        data["itemTypeId"] = this.itemTypeId;
        data["name"] = this.name;
        data["defaultRwcid"] = this.defaultRwcid;
        data["inspectionMethod"] = this.inspectionMethod;
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["computerVisionModelLabelId"] = this.computerVisionModelLabelId;
        data["shortName"] = this.shortName;
        data["hasItems"] = this.hasItems;
        data["isAvailableForConditions"] = this.isAvailableForConditions;
        data["isAvailableForInventoryItems"] = this.isAvailableForInventoryItems;
        data["isAvailableInCollector"] = this.isAvailableInCollector;
        return data;
    }

    clone(): ConditionNodeDto {
        const json = this.toJSON();
        let result = new ConditionNodeDto();
        result.init(json);
        return result;
    }
}

/** DTO specifically to handle displaying the Condition hierarchy to the Tree List components for DevExtreme in the UI */
export interface IConditionNodeDto {
    /** Compound IDs should be in the form EntityTypeName_# */
    compoundId: string | undefined;
    /** Compound ID for Parent Object (for Plain Data structure) */
    parentCompoundId: string | undefined;
    /** Name of the Entity level within the Condition tree hierarchy */
    entityName: string | undefined;
    /** Utilized by Condition Suggestion nodes */
    suggestionId: number | undefined;
    /** Utilized by Condition Type and Condition Suggestion nodes */
    typeId: number | undefined;
    /** Utilized by any hierarchy of Condition related node */
    itemTypeId: number | undefined;
    /** Name assigned to the Condition node object */
    name: string | undefined;
    /** Default RWCID value, utilized by Condition Suggestion nodes */
    defaultRwcid: string | undefined;
    /** Inspection Method, utilized by Condition Suggestion nodes */
    inspectionMethod: string | undefined;
    /** Computer Vision Model Id, utilized by Condition Suggestion nodes */
    computerVisionModelId: number | undefined;
    /** Computer Vision Model Label Id, utilized by Condition Type nodes */
    computerVisionModelLabelId: number | undefined;
    /** Short Name, utilized by Condition Suggestion nodes */
    shortName: string | undefined;
    /** Boolean determining whether or not the current condition hierarchy item
has any child items */
    hasItems: boolean;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available Conditions to use */
    isAvailableForConditions: boolean | undefined;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available for Inventory Items to use */
    isAvailableForInventoryItems: boolean | undefined;
    /** Utilized by Suggestion nodes, a flag denoting whether this Suggestion is available in the Collector app */
    isAvailableInCollector: boolean | undefined;
}

export class ConditionQualityAssuranceNoteDto implements IConditionQualityAssuranceNoteDto {
    id!: number;
    /** The id of the condition to which this note applies */
    conditionId!: number;
    /** The notes for this ConditionQualityAssuranceNote. This should contain
information on why the related Condition was given a specific QC status. */
    notes!: string | undefined;
    /** Flag indicating if the qa note is deleted */
    isDeleted!: boolean;

    constructor(data?: IConditionQualityAssuranceNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionId = _data["conditionId"];
            this.notes = _data["notes"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ConditionQualityAssuranceNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionQualityAssuranceNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionId"] = this.conditionId;
        data["notes"] = this.notes;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ConditionQualityAssuranceNoteDto {
        const json = this.toJSON();
        let result = new ConditionQualityAssuranceNoteDto();
        result.init(json);
        return result;
    }
}

export interface IConditionQualityAssuranceNoteDto {
    id: number;
    /** The id of the condition to which this note applies */
    conditionId: number;
    /** The notes for this ConditionQualityAssuranceNote. This should contain
information on why the related Condition was given a specific QC status. */
    notes: string | undefined;
    /** Flag indicating if the qa note is deleted */
    isDeleted: boolean;
}

/** Dto for ConditionStatus */
export class ConditionStatusDto implements IConditionStatusDto {
    /** Id of the condition status */
    id!: number;
    /** Name of the condition status */
    name!: string | undefined;

    constructor(data?: IConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ConditionStatusDto {
        const json = this.toJSON();
        let result = new ConditionStatusDto();
        result.init(json);
        return result;
    }
}

/** Dto for ConditionStatus */
export interface IConditionStatusDto {
    /** Id of the condition status */
    id: number;
    /** Name of the condition status */
    name: string | undefined;
}

/** Dto for ConditionType */
export class ConditionTypeDto implements IConditionTypeDto {
    /** Identifier of the parent Condition Item Type */
    conditionItemTypeId!: number;
    /** The parent Condition Item Type */
    conditionItemType!: ConditionItemTypeDto | undefined;
    /** Name of the Condition Type */
    conditionTypeName!: string | undefined;

    constructor(data?: IConditionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionItemTypeId = _data["conditionItemTypeId"];
            this.conditionItemType = _data["conditionItemType"] ? ConditionItemTypeDto.fromJS(_data["conditionItemType"]) : <any>undefined;
            this.conditionTypeName = _data["conditionTypeName"];
        }
    }

    static fromJS(data: any): ConditionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionItemTypeId"] = this.conditionItemTypeId;
        data["conditionItemType"] = this.conditionItemType ? this.conditionItemType.toJSON() : <any>undefined;
        data["conditionTypeName"] = this.conditionTypeName;
        return data;
    }

    clone(): ConditionTypeDto {
        const json = this.toJSON();
        let result = new ConditionTypeDto();
        result.init(json);
        return result;
    }
}

/** Dto for ConditionType */
export interface IConditionTypeDto {
    /** Identifier of the parent Condition Item Type */
    conditionItemTypeId: number;
    /** The parent Condition Item Type */
    conditionItemType: ConditionItemTypeDto | undefined;
    /** Name of the Condition Type */
    conditionTypeName: string | undefined;
}

export class Coordinate implements ICoordinate {
    x!: number;
    y!: number;
    z!: number;
    m!: number;
    coordinateValue!: Coordinate | undefined;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.m = _data["m"];
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["m"] = this.m;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>undefined;
        return data;
    }

    clone(): Coordinate {
        const json = this.toJSON();
        let result = new Coordinate();
        result.init(json);
        return result;
    }
}

export interface ICoordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue: Coordinate | undefined;
}

export class CoordinateEqualityComparer implements ICoordinateEqualityComparer {

    constructor(data?: ICoordinateEqualityComparer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CoordinateEqualityComparer {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateEqualityComparer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CoordinateEqualityComparer {
        const json = this.toJSON();
        let result = new CoordinateEqualityComparer();
        result.init(json);
        return result;
    }
}

export interface ICoordinateEqualityComparer {
}

export class CoordinateSequence implements ICoordinateSequence {
    readonly dimension!: number;
    readonly measures!: number;
    readonly spatial!: number;
    readonly ordinates!: Ordinates;
    readonly hasZ!: boolean;
    readonly hasM!: boolean;
    readonly zOrdinateIndex!: number;
    readonly mOrdinateIndex!: number;
    readonly count!: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dimension = _data["dimension"];
            (<any>this).measures = _data["measures"];
            (<any>this).spatial = _data["spatial"];
            (<any>this).ordinates = _data["ordinates"];
            (<any>this).hasZ = _data["hasZ"];
            (<any>this).hasM = _data["hasM"];
            (<any>this).zOrdinateIndex = _data["zOrdinateIndex"];
            (<any>this).mOrdinateIndex = _data["mOrdinateIndex"];
            (<any>this).count = _data["count"];
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension;
        data["measures"] = this.measures;
        data["spatial"] = this.spatial;
        data["ordinates"] = this.ordinates;
        data["hasZ"] = this.hasZ;
        data["hasM"] = this.hasM;
        data["zOrdinateIndex"] = this.zOrdinateIndex;
        data["mOrdinateIndex"] = this.mOrdinateIndex;
        data["count"] = this.count;
        return data;
    }

    clone(): CoordinateSequence {
        const json = this.toJSON();
        let result = new CoordinateSequence();
        result.init(json);
        return result;
    }
}

export interface ICoordinateSequence {
    dimension: number;
    measures: number;
    spatial: number;
    ordinates: Ordinates;
    hasZ: boolean;
    hasM: boolean;
    zOrdinateIndex: number;
    mOrdinateIndex: number;
    count: number;
}

export class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    readonly ordinates!: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ordinates = _data["ordinates"];
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequenceFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates;
        return data;
    }

    clone(): CoordinateSequenceFactory {
        const json = this.toJSON();
        let result = new CoordinateSequenceFactory();
        result.init(json);
        return result;
    }
}

export interface ICoordinateSequenceFactory {
    ordinates: Ordinates;
}

/** Create DTO for Asset Assignment Area */
export class CreateAssetAssignmentAreaDto implements ICreateAssetAssignmentAreaDto {
    /** The ID of the Inspection for this AssetAssignmentArea */
    inspectionId!: number;
    /** Identifier of the User that has been assigned this AssetAssignmentArea */
    assignedUserId!: number;
    /** Unique EsriId assigned to this AssetAssignmentArea */
    esriId!: string;
    /** String containing the points representing the area represented by this AssetAssignmentArea */
    assignmentAreaPoints!: string;

    constructor(data?: ICreateAssetAssignmentAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.assignedUserId = _data["assignedUserId"];
            this.esriId = _data["esriId"];
            this.assignmentAreaPoints = _data["assignmentAreaPoints"];
        }
    }

    static fromJS(data: any): CreateAssetAssignmentAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetAssignmentAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["assignedUserId"] = this.assignedUserId;
        data["esriId"] = this.esriId;
        data["assignmentAreaPoints"] = this.assignmentAreaPoints;
        return data;
    }

    clone(): CreateAssetAssignmentAreaDto {
        const json = this.toJSON();
        let result = new CreateAssetAssignmentAreaDto();
        result.init(json);
        return result;
    }
}

/** Create DTO for Asset Assignment Area */
export interface ICreateAssetAssignmentAreaDto {
    /** The ID of the Inspection for this AssetAssignmentArea */
    inspectionId: number;
    /** Identifier of the User that has been assigned this AssetAssignmentArea */
    assignedUserId: number;
    /** Unique EsriId assigned to this AssetAssignmentArea */
    esriId: string;
    /** String containing the points representing the area represented by this AssetAssignmentArea */
    assignmentAreaPoints: string;
}

/** Dto for creating a circuit */
export class CreateCircuitDto implements ICreateCircuitDto {
    /** Tenant that circuit belongs to */
    tenantId!: number;
    /** Name of Circuit */
    name!: string;

    constructor(data?: ICreateCircuitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCircuitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCircuitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateCircuitDto {
        const json = this.toJSON();
        let result = new CreateCircuitDto();
        result.init(json);
        return result;
    }
}

/** Dto for creating a circuit */
export interface ICreateCircuitDto {
    /** Tenant that circuit belongs to */
    tenantId: number;
    /** Name of Circuit */
    name: string;
}

/** CreateComputerVisionModelDto represents a data structure for creating a new computer vision model. */
export class CreateComputerVisionModelDto implements ICreateComputerVisionModelDto {
    /** Name of the computer vision model */
    name!: string | undefined;
    /** Model name for the computer vision model */
    modelName!: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId!: number;
    /** List of Identifiers for ComputerVisionModels that this ComputerVisionModel requires as a prerequisite */
    prerequisiteComputerVisionModelIds!: number[] | undefined;

    constructor(data?: ICreateComputerVisionModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.modelName = _data["modelName"];
            this.computerVisionModelTypeId = _data["computerVisionModelTypeId"];
            if (Array.isArray(_data["prerequisiteComputerVisionModelIds"])) {
                this.prerequisiteComputerVisionModelIds = [] as any;
                for (let item of _data["prerequisiteComputerVisionModelIds"])
                    this.prerequisiteComputerVisionModelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateComputerVisionModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComputerVisionModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["modelName"] = this.modelName;
        data["computerVisionModelTypeId"] = this.computerVisionModelTypeId;
        if (Array.isArray(this.prerequisiteComputerVisionModelIds)) {
            data["prerequisiteComputerVisionModelIds"] = [];
            for (let item of this.prerequisiteComputerVisionModelIds)
                data["prerequisiteComputerVisionModelIds"].push(item);
        }
        return data;
    }

    clone(): CreateComputerVisionModelDto {
        const json = this.toJSON();
        let result = new CreateComputerVisionModelDto();
        result.init(json);
        return result;
    }
}

/** CreateComputerVisionModelDto represents a data structure for creating a new computer vision model. */
export interface ICreateComputerVisionModelDto {
    /** Name of the computer vision model */
    name: string | undefined;
    /** Model name for the computer vision model */
    modelName: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId: number;
    /** List of Identifiers for ComputerVisionModels that this ComputerVisionModel requires as a prerequisite */
    prerequisiteComputerVisionModelIds: number[] | undefined;
}

export class CreateConditionDto implements ICreateConditionDto {
    /** The inspection method for this Condition. */
    inspectionMethod!: string | undefined;
    /** Item type */
    itemType!: string | undefined;
    /** Type */
    type!: string | undefined;
    /** Condition */
    conditionName!: string | undefined;
    /** Comment */
    comments!: string | undefined;
    /** Rwcid/Priority */
    rwcid!: string | undefined;
    /** The date and time of when the condition was found in the field. */
    foundInFieldTime!: moment.Moment | undefined;
    /** The person/team/tool, etc. that found the condition in the field. */
    foundInFieldBy!: string | undefined;
    /** Whether this condition allows bypassing the normal QC logic. */
    qcBypass!: boolean;

    constructor(data?: ICreateConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionMethod = _data["inspectionMethod"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.conditionName = _data["conditionName"];
            this.comments = _data["comments"];
            this.rwcid = _data["rwcid"];
            this.foundInFieldTime = _data["foundInFieldTime"] ? moment(_data["foundInFieldTime"].toString()) : <any>undefined;
            this.foundInFieldBy = _data["foundInFieldBy"];
            this.qcBypass = _data["qcBypass"];
        }
    }

    static fromJS(data: any): CreateConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionMethod"] = this.inspectionMethod;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["conditionName"] = this.conditionName;
        data["comments"] = this.comments;
        data["rwcid"] = this.rwcid;
        data["foundInFieldTime"] = this.foundInFieldTime ? this.foundInFieldTime.toISOString() : <any>undefined;
        data["foundInFieldBy"] = this.foundInFieldBy;
        data["qcBypass"] = this.qcBypass;
        return data;
    }

    clone(): CreateConditionDto {
        const json = this.toJSON();
        let result = new CreateConditionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateConditionDto {
    /** The inspection method for this Condition. */
    inspectionMethod: string | undefined;
    /** Item type */
    itemType: string | undefined;
    /** Type */
    type: string | undefined;
    /** Condition */
    conditionName: string | undefined;
    /** Comment */
    comments: string | undefined;
    /** Rwcid/Priority */
    rwcid: string | undefined;
    /** The date and time of when the condition was found in the field. */
    foundInFieldTime: moment.Moment | undefined;
    /** The person/team/tool, etc. that found the condition in the field. */
    foundInFieldBy: string | undefined;
    /** Whether this condition allows bypassing the normal QC logic. */
    qcBypass: boolean;
}

/** Dto for creating a custom asset property */
export class CreateCustomAssetPropertyDto implements ICreateCustomAssetPropertyDto {
    /** Tenant that custom asset property belongs to */
    tenantId!: number;
    /** Name of Custom Asset Property */
    name!: string;
    /** Display name to use for the custom asset property */
    displayName!: string;
    /** Id for the Data type of the custom asset property */
    customPropertyTypeId!: number;
    /** List of custom asset property options (if applicable) to associate with the custom asset property */
    customAssetPropertyOptions!: CustomAssetPropertyOptionDto[] | undefined;

    constructor(data?: ICreateCustomAssetPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.customPropertyTypeId = _data["customPropertyTypeId"];
            if (Array.isArray(_data["customAssetPropertyOptions"])) {
                this.customAssetPropertyOptions = [] as any;
                for (let item of _data["customAssetPropertyOptions"])
                    this.customAssetPropertyOptions!.push(CustomAssetPropertyOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCustomAssetPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomAssetPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["customPropertyTypeId"] = this.customPropertyTypeId;
        if (Array.isArray(this.customAssetPropertyOptions)) {
            data["customAssetPropertyOptions"] = [];
            for (let item of this.customAssetPropertyOptions)
                data["customAssetPropertyOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateCustomAssetPropertyDto {
        const json = this.toJSON();
        let result = new CreateCustomAssetPropertyDto();
        result.init(json);
        return result;
    }
}

/** Dto for creating a custom asset property */
export interface ICreateCustomAssetPropertyDto {
    /** Tenant that custom asset property belongs to */
    tenantId: number;
    /** Name of Custom Asset Property */
    name: string;
    /** Display name to use for the custom asset property */
    displayName: string;
    /** Id for the Data type of the custom asset property */
    customPropertyTypeId: number;
    /** List of custom asset property options (if applicable) to associate with the custom asset property */
    customAssetPropertyOptions: CustomAssetPropertyOptionDto[] | undefined;
}

export class CreateDurableFunctionDto implements ICreateDurableFunctionDto {
    /** Tenant that the Durable Function belongs to */
    tenantId!: number;
    /** Inspection that the Upload Durable Function belongs to */
    inspectionId!: number;
    /** Instance Id of the durable function in Azure */
    instanceId!: string;
    /** Original file name for the uploaded file, will be used as the file
name if the user chooses to download the file back from storage */
    fileName!: string | undefined;
    /** File extension for the uploaded file */
    fileExtension!: string | undefined;
    /** The Md5 hash of the uploaded file, will be used as the file name in
Azure blob storage */
    md5!: string | undefined;
    /** The time at which the durable function was actually created */
    durableFunctionCreationTime!: moment.Moment;
    /** The discriminator to specify the type of the durable function */
    discriminator!: string | undefined;

    constructor(data?: ICreateDurableFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.instanceId = _data["instanceId"];
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.md5 = _data["md5"];
            this.durableFunctionCreationTime = _data["durableFunctionCreationTime"] ? moment(_data["durableFunctionCreationTime"].toString()) : <any>undefined;
            this.discriminator = _data["discriminator"];
        }
    }

    static fromJS(data: any): CreateDurableFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDurableFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["instanceId"] = this.instanceId;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["md5"] = this.md5;
        data["durableFunctionCreationTime"] = this.durableFunctionCreationTime ? this.durableFunctionCreationTime.toISOString() : <any>undefined;
        data["discriminator"] = this.discriminator;
        return data;
    }

    clone(): CreateDurableFunctionDto {
        const json = this.toJSON();
        let result = new CreateDurableFunctionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDurableFunctionDto {
    /** Tenant that the Durable Function belongs to */
    tenantId: number;
    /** Inspection that the Upload Durable Function belongs to */
    inspectionId: number;
    /** Instance Id of the durable function in Azure */
    instanceId: string;
    /** Original file name for the uploaded file, will be used as the file
name if the user chooses to download the file back from storage */
    fileName: string | undefined;
    /** File extension for the uploaded file */
    fileExtension: string | undefined;
    /** The Md5 hash of the uploaded file, will be used as the file name in
Azure blob storage */
    md5: string | undefined;
    /** The time at which the durable function was actually created */
    durableFunctionCreationTime: moment.Moment;
    /** The discriminator to specify the type of the durable function */
    discriminator: string | undefined;
}

export class CreateImageDto implements ICreateImageDto {
    /** Tenant image belongs to */
    tenantId!: number;
    inspectionId!: number;
    /** Url of the image */
    imageUrl!: string | undefined;
    /** Url of the compressed image */
    compressedImageUrl!: string | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl!: string | undefined;
    /** Latitude */
    latitude!: number | undefined;
    /** Longitude */
    longitude!: number | undefined;
    /** Local Directory name at which the Image resides when its metadata information was pulled */
    localDirectory!: string | undefined;
    /** Name of the File at the Local Directory provided from which image metadata information was pulled */
    fileName!: string | undefined;
    /** File size of the image in bytes. */
    fileSize!: number | undefined;
    /** The file size of the compressed image in bytes. */
    compressedFileSize!: number | undefined;
    /** The file size of the image thumbnail in bytes. */
    thumbnailFileSize!: number | undefined;
    /** The serial number of the drone that took the photo */
    serialNumber!: string | undefined;
    /** The Md5 hash of the image data */
    md5!: string | undefined;
    /** Gimbal Pitch Degree (the angle the camera was at when the image was taken) */
    gimbalPitchDegree!: number | undefined;
    /** Gimbal Yaw Degree (the angle the camera was at when the image was taken) */
    gimbalYawDegree!: number | undefined;
    /** Flight Yaw Degree (the angle the camera was at when the image was taken) */
    flightYawDegree!: number | undefined;
    /** Date on which the Image was taken */
    date!: moment.Moment | undefined;
    /** The Camera Make that was used to take the image. */
    cameraMake!: string | undefined;
    /** The Camera Model that was used to take the image */
    cameraModel!: string | undefined;
    /** A number (1 through 9) representing the orientation of the image */
    orientation!: number | undefined;
    /** Specifies whether this Image is a panorama. */
    isPanorama!: boolean;
    /** Asset Id to override the calculated asset Id. Override is defined in the Image Metadata Tags */
    assetId!: number | undefined;
    /** Optional condition dto to create and assign to the image */
    conditionData!: CreateConditionDto | undefined;
    /** Flag to mark if this image is a thermal/IR image */
    isThermalReport!: boolean;
    /** DPI of the image.  Will be set to null if DpiX != DpiY in the image's metadata. */
    dpi!: number | undefined;
    /** Width of the image */
    width!: number | undefined;
    /** Height of the image */
    height!: number | undefined;
    /** Raw exif data of the image file. */
    exifData!: ImageExifDto | undefined;
    /** Whether to treat the image as a poletop and run according processing. */
    treatAsPoletop!: boolean;

    constructor(data?: ICreateImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.imageUrl = _data["imageUrl"];
            this.compressedImageUrl = _data["compressedImageUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.localDirectory = _data["localDirectory"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.compressedFileSize = _data["compressedFileSize"];
            this.thumbnailFileSize = _data["thumbnailFileSize"];
            this.serialNumber = _data["serialNumber"];
            this.md5 = _data["md5"];
            this.gimbalPitchDegree = _data["gimbalPitchDegree"];
            this.gimbalYawDegree = _data["gimbalYawDegree"];
            this.flightYawDegree = _data["flightYawDegree"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.cameraMake = _data["cameraMake"];
            this.cameraModel = _data["cameraModel"];
            this.orientation = _data["orientation"];
            this.isPanorama = _data["isPanorama"];
            this.assetId = _data["assetId"];
            this.conditionData = _data["conditionData"] ? CreateConditionDto.fromJS(_data["conditionData"]) : <any>undefined;
            this.isThermalReport = _data["isThermalReport"];
            this.dpi = _data["dpi"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.exifData = _data["exifData"] ? ImageExifDto.fromJS(_data["exifData"]) : <any>undefined;
            this.treatAsPoletop = _data["treatAsPoletop"];
        }
    }

    static fromJS(data: any): CreateImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["imageUrl"] = this.imageUrl;
        data["compressedImageUrl"] = this.compressedImageUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["localDirectory"] = this.localDirectory;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["compressedFileSize"] = this.compressedFileSize;
        data["thumbnailFileSize"] = this.thumbnailFileSize;
        data["serialNumber"] = this.serialNumber;
        data["md5"] = this.md5;
        data["gimbalPitchDegree"] = this.gimbalPitchDegree;
        data["gimbalYawDegree"] = this.gimbalYawDegree;
        data["flightYawDegree"] = this.flightYawDegree;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["cameraMake"] = this.cameraMake;
        data["cameraModel"] = this.cameraModel;
        data["orientation"] = this.orientation;
        data["isPanorama"] = this.isPanorama;
        data["assetId"] = this.assetId;
        data["conditionData"] = this.conditionData ? this.conditionData.toJSON() : <any>undefined;
        data["isThermalReport"] = this.isThermalReport;
        data["dpi"] = this.dpi;
        data["width"] = this.width;
        data["height"] = this.height;
        data["exifData"] = this.exifData ? this.exifData.toJSON() : <any>undefined;
        data["treatAsPoletop"] = this.treatAsPoletop;
        return data;
    }

    clone(): CreateImageDto {
        const json = this.toJSON();
        let result = new CreateImageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateImageDto {
    /** Tenant image belongs to */
    tenantId: number;
    inspectionId: number;
    /** Url of the image */
    imageUrl: string | undefined;
    /** Url of the compressed image */
    compressedImageUrl: string | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl: string | undefined;
    /** Latitude */
    latitude: number | undefined;
    /** Longitude */
    longitude: number | undefined;
    /** Local Directory name at which the Image resides when its metadata information was pulled */
    localDirectory: string | undefined;
    /** Name of the File at the Local Directory provided from which image metadata information was pulled */
    fileName: string | undefined;
    /** File size of the image in bytes. */
    fileSize: number | undefined;
    /** The file size of the compressed image in bytes. */
    compressedFileSize: number | undefined;
    /** The file size of the image thumbnail in bytes. */
    thumbnailFileSize: number | undefined;
    /** The serial number of the drone that took the photo */
    serialNumber: string | undefined;
    /** The Md5 hash of the image data */
    md5: string | undefined;
    /** Gimbal Pitch Degree (the angle the camera was at when the image was taken) */
    gimbalPitchDegree: number | undefined;
    /** Gimbal Yaw Degree (the angle the camera was at when the image was taken) */
    gimbalYawDegree: number | undefined;
    /** Flight Yaw Degree (the angle the camera was at when the image was taken) */
    flightYawDegree: number | undefined;
    /** Date on which the Image was taken */
    date: moment.Moment | undefined;
    /** The Camera Make that was used to take the image. */
    cameraMake: string | undefined;
    /** The Camera Model that was used to take the image */
    cameraModel: string | undefined;
    /** A number (1 through 9) representing the orientation of the image */
    orientation: number | undefined;
    /** Specifies whether this Image is a panorama. */
    isPanorama: boolean;
    /** Asset Id to override the calculated asset Id. Override is defined in the Image Metadata Tags */
    assetId: number | undefined;
    /** Optional condition dto to create and assign to the image */
    conditionData: CreateConditionDto | undefined;
    /** Flag to mark if this image is a thermal/IR image */
    isThermalReport: boolean;
    /** DPI of the image.  Will be set to null if DpiX != DpiY in the image's metadata. */
    dpi: number | undefined;
    /** Width of the image */
    width: number | undefined;
    /** Height of the image */
    height: number | undefined;
    /** Raw exif data of the image file. */
    exifData: ImageExifDto | undefined;
    /** Whether to treat the image as a poletop and run according processing. */
    treatAsPoletop: boolean;
}

export class CreateInspectionDto implements ICreateInspectionDto {
    inspectionName!: string;
    inspectionTypeId!: number;
    imageAssociationRadius!: number;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    description!: string;
    displayWorkOrder!: boolean;
    workOrderTitle!: string | undefined;
    tenantId!: number;
    inspectionStatusId!: number;
    dataCollectorId!: number | undefined;
    inspectionNotes!: string | undefined;
    computerVisionModelIds!: number[] | undefined;
    inspectionJobTypeIds!: number[] | undefined;
    qcNotRequired!: boolean;

    constructor(data?: ICreateInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionName = _data["inspectionName"];
            this.inspectionTypeId = _data["inspectionTypeId"];
            this.imageAssociationRadius = _data["imageAssociationRadius"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.displayWorkOrder = _data["displayWorkOrder"];
            this.workOrderTitle = _data["workOrderTitle"];
            this.tenantId = _data["tenantId"];
            this.inspectionStatusId = _data["inspectionStatusId"];
            this.dataCollectorId = _data["dataCollectorId"];
            this.inspectionNotes = _data["inspectionNotes"];
            if (Array.isArray(_data["computerVisionModelIds"])) {
                this.computerVisionModelIds = [] as any;
                for (let item of _data["computerVisionModelIds"])
                    this.computerVisionModelIds!.push(item);
            }
            if (Array.isArray(_data["inspectionJobTypeIds"])) {
                this.inspectionJobTypeIds = [] as any;
                for (let item of _data["inspectionJobTypeIds"])
                    this.inspectionJobTypeIds!.push(item);
            }
            this.qcNotRequired = _data["qcNotRequired"];
        }
    }

    static fromJS(data: any): CreateInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionName"] = this.inspectionName;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["imageAssociationRadius"] = this.imageAssociationRadius;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["displayWorkOrder"] = this.displayWorkOrder;
        data["workOrderTitle"] = this.workOrderTitle;
        data["tenantId"] = this.tenantId;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["dataCollectorId"] = this.dataCollectorId;
        data["inspectionNotes"] = this.inspectionNotes;
        if (Array.isArray(this.computerVisionModelIds)) {
            data["computerVisionModelIds"] = [];
            for (let item of this.computerVisionModelIds)
                data["computerVisionModelIds"].push(item);
        }
        if (Array.isArray(this.inspectionJobTypeIds)) {
            data["inspectionJobTypeIds"] = [];
            for (let item of this.inspectionJobTypeIds)
                data["inspectionJobTypeIds"].push(item);
        }
        data["qcNotRequired"] = this.qcNotRequired;
        return data;
    }

    clone(): CreateInspectionDto {
        const json = this.toJSON();
        let result = new CreateInspectionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInspectionDto {
    inspectionName: string;
    inspectionTypeId: number;
    imageAssociationRadius: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    description: string;
    displayWorkOrder: boolean;
    workOrderTitle: string | undefined;
    tenantId: number;
    inspectionStatusId: number;
    dataCollectorId: number | undefined;
    inspectionNotes: string | undefined;
    computerVisionModelIds: number[] | undefined;
    inspectionJobTypeIds: number[] | undefined;
    qcNotRequired: boolean;
}

/** Create DTO for Inspection Permission relationship between a limited inspector User and an Inspection */
export class CreateInspectionPermissionDto implements ICreateInspectionPermissionDto {
    /** Identifier of the User that to be assigned this InspectionPermission */
    userId!: number;
    /** Boolean flag whether historical condition access is allowed for the user on the given inspection. */
    historicalConditionAccess!: boolean;

    constructor(data?: ICreateInspectionPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.historicalConditionAccess = _data["historicalConditionAccess"];
        }
    }

    static fromJS(data: any): CreateInspectionPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["historicalConditionAccess"] = this.historicalConditionAccess;
        return data;
    }

    clone(): CreateInspectionPermissionDto {
        const json = this.toJSON();
        let result = new CreateInspectionPermissionDto();
        result.init(json);
        return result;
    }
}

/** Create DTO for Inspection Permission relationship between a limited inspector User and an Inspection */
export interface ICreateInspectionPermissionDto {
    /** Identifier of the User that to be assigned this InspectionPermission */
    userId: number;
    /** Boolean flag whether historical condition access is allowed for the user on the given inspection. */
    historicalConditionAccess: boolean;
}

/** Dto for creating an Inspection Quality Assurance Level */
export class CreateInspectionQualityAssuranceLevelDto implements ICreateInspectionQualityAssuranceLevelDto {
    /** Identifier of the User that QC Percentage is being overidden for */
    userId!: number;
    /** The new QC Percentage value */
    qcPercentage!: number | undefined;

    constructor(data?: ICreateInspectionQualityAssuranceLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.qcPercentage = _data["qcPercentage"];
        }
    }

    static fromJS(data: any): CreateInspectionQualityAssuranceLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionQualityAssuranceLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["qcPercentage"] = this.qcPercentage;
        return data;
    }

    clone(): CreateInspectionQualityAssuranceLevelDto {
        const json = this.toJSON();
        let result = new CreateInspectionQualityAssuranceLevelDto();
        result.init(json);
        return result;
    }
}

/** Dto for creating an Inspection Quality Assurance Level */
export interface ICreateInspectionQualityAssuranceLevelDto {
    /** Identifier of the User that QC Percentage is being overidden for */
    userId: number;
    /** The new QC Percentage value */
    qcPercentage: number | undefined;
}

/** Create DTO for Inspection Status */
export class CreateInspectionStatusDto implements ICreateInspectionStatusDto {
    /** Name of the Inspection Status */
    name!: string;

    constructor(data?: ICreateInspectionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateInspectionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CreateInspectionStatusDto {
        const json = this.toJSON();
        let result = new CreateInspectionStatusDto();
        result.init(json);
        return result;
    }
}

/** Create DTO for Inspection Status */
export interface ICreateInspectionStatusDto {
    /** Name of the Inspection Status */
    name: string;
}

/** Create DTO for Inspection Type */
export class CreateInspectionTypeDto implements ICreateInspectionTypeDto {
    /** Name of the Inspection Type */
    name!: string;
    /** The default distance radius (in meters) used for checking whether an image
should be associated to an asset. */
    defaultImageAssociationRadius!: number;

    constructor(data?: ICreateInspectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.defaultImageAssociationRadius = _data["defaultImageAssociationRadius"];
        }
    }

    static fromJS(data: any): CreateInspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["defaultImageAssociationRadius"] = this.defaultImageAssociationRadius;
        return data;
    }

    clone(): CreateInspectionTypeDto {
        const json = this.toJSON();
        let result = new CreateInspectionTypeDto();
        result.init(json);
        return result;
    }
}

/** Create DTO for Inspection Type */
export interface ICreateInspectionTypeDto {
    /** Name of the Inspection Type */
    name: string;
    /** The default distance radius (in meters) used for checking whether an image
should be associated to an asset. */
    defaultImageAssociationRadius: number;
}

/** Dto of a new inventory item sent from the client */
export class CreateInventoryItemDto implements ICreateInventoryItemDto {
    /** ID of the Tenant Inventory Item belongs to */
    tenantId!: number;
    /** Identifier of the related Inspection */
    inspectionId!: number;
    /** Identifier of the related Asset */
    assetId!: number;
    /** String describing the item type in inventory on the asset */
    itemType!: string;
    /** String describing the type of the inventory item */
    type!: string;
    /** The number of instances of the inventory item on the asset */
    quantity!: number;
    /** Comments regarding the Inventory item */
    comments!: string | undefined;
    /** List of circuit ids related to the inventory item */
    circuitIds!: number[] | undefined;

    constructor(data?: ICreateInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.assetId = _data["assetId"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.quantity = _data["quantity"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["circuitIds"])) {
                this.circuitIds = [] as any;
                for (let item of _data["circuitIds"])
                    this.circuitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateInventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["assetId"] = this.assetId;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["quantity"] = this.quantity;
        data["comments"] = this.comments;
        if (Array.isArray(this.circuitIds)) {
            data["circuitIds"] = [];
            for (let item of this.circuitIds)
                data["circuitIds"].push(item);
        }
        return data;
    }

    clone(): CreateInventoryItemDto {
        const json = this.toJSON();
        let result = new CreateInventoryItemDto();
        result.init(json);
        return result;
    }
}

/** Dto of a new inventory item sent from the client */
export interface ICreateInventoryItemDto {
    /** ID of the Tenant Inventory Item belongs to */
    tenantId: number;
    /** Identifier of the related Inspection */
    inspectionId: number;
    /** Identifier of the related Asset */
    assetId: number;
    /** String describing the item type in inventory on the asset */
    itemType: string;
    /** String describing the type of the inventory item */
    type: string;
    /** The number of instances of the inventory item on the asset */
    quantity: number;
    /** Comments regarding the Inventory item */
    comments: string | undefined;
    /** List of circuit ids related to the inventory item */
    circuitIds: number[] | undefined;
}

export class CreateOrthomosaicDto implements ICreateOrthomosaicDto {
    /** Name of the Orthomosaic */
    name!: string;
    /** Url of the Orthomosaic */
    url!: string | undefined;
    /** Blob storage directory location at which the Orthomosaic resides */
    blobStorageLocation!: string | undefined;
    /** Specifies whether this Orthomosaic should be displayed by default on loading */
    displayOnLoad!: boolean;
    /** The minimum zoom level for this Orthomosaic. */
    minZoom!: number | undefined;
    /** The maximum zoom level for this Orthomosaic. */
    maxZoom!: number | undefined;
    /** The minimum latitude for this Orthomosaic. */
    minLatitude!: number | undefined;
    /** The maximum latitude for this Orthomosaic. */
    maxLatitude!: number | undefined;
    /** The minimum longitude for this Orthomosaic. */
    minLongitude!: number | undefined;
    /** The maximum longitude for this Orthomosaic. */
    maxLongitude!: number | undefined;

    constructor(data?: ICreateOrthomosaicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.blobStorageLocation = _data["blobStorageLocation"];
            this.displayOnLoad = _data["displayOnLoad"];
            this.minZoom = _data["minZoom"];
            this.maxZoom = _data["maxZoom"];
            this.minLatitude = _data["minLatitude"];
            this.maxLatitude = _data["maxLatitude"];
            this.minLongitude = _data["minLongitude"];
            this.maxLongitude = _data["maxLongitude"];
        }
    }

    static fromJS(data: any): CreateOrthomosaicDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrthomosaicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["blobStorageLocation"] = this.blobStorageLocation;
        data["displayOnLoad"] = this.displayOnLoad;
        data["minZoom"] = this.minZoom;
        data["maxZoom"] = this.maxZoom;
        data["minLatitude"] = this.minLatitude;
        data["maxLatitude"] = this.maxLatitude;
        data["minLongitude"] = this.minLongitude;
        data["maxLongitude"] = this.maxLongitude;
        return data;
    }

    clone(): CreateOrthomosaicDto {
        const json = this.toJSON();
        let result = new CreateOrthomosaicDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrthomosaicDto {
    /** Name of the Orthomosaic */
    name: string;
    /** Url of the Orthomosaic */
    url: string | undefined;
    /** Blob storage directory location at which the Orthomosaic resides */
    blobStorageLocation: string | undefined;
    /** Specifies whether this Orthomosaic should be displayed by default on loading */
    displayOnLoad: boolean;
    /** The minimum zoom level for this Orthomosaic. */
    minZoom: number | undefined;
    /** The maximum zoom level for this Orthomosaic. */
    maxZoom: number | undefined;
    /** The minimum latitude for this Orthomosaic. */
    minLatitude: number | undefined;
    /** The maximum latitude for this Orthomosaic. */
    maxLatitude: number | undefined;
    /** The minimum longitude for this Orthomosaic. */
    minLongitude: number | undefined;
    /** The maximum longitude for this Orthomosaic. */
    maxLongitude: number | undefined;
}

/** CreateAssetDto represents a data structure for creating a new pole type asset. */
export class CreatePoleDto implements ICreatePoleDto {
    /** The identifier of the tenant to which this pole belongs. */
    tenantId!: number | undefined;
    /** The human-readable address for this pole. */
    address!: string | undefined;
    /** Latitude at which to create the pole. */
    latitude!: number;
    /** Longitude at which to create the pole. */
    longitude!: number;

    constructor(data?: ICreatePoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.address = _data["address"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CreatePoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["address"] = this.address;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }

    clone(): CreatePoleDto {
        const json = this.toJSON();
        let result = new CreatePoleDto();
        result.init(json);
        return result;
    }
}

/** CreateAssetDto represents a data structure for creating a new pole type asset. */
export interface ICreatePoleDto {
    /** The identifier of the tenant to which this pole belongs. */
    tenantId: number | undefined;
    /** The human-readable address for this pole. */
    address: string | undefined;
    /** Latitude at which to create the pole. */
    latitude: number;
    /** Longitude at which to create the pole. */
    longitude: number;
}

/** CreateSpanDto represents a data structure for creating a new span type asset. */
export class CreateSpanDto implements ICreateSpanDto {
    /** The identifier of the tenant to which this pole belongs. */
    tenantId!: number | undefined;
    /** The identifier of the inspection to which this pole belongs. */
    inspectionId!: number;
    /** The identifier of the starting asset to which this span connects. */
    endAssetId!: number;
    /** The identifier of the starting asset to which this span connects. */
    startAssetId!: number;

    constructor(data?: ICreateSpanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.endAssetId = _data["endAssetId"];
            this.startAssetId = _data["startAssetId"];
        }
    }

    static fromJS(data: any): CreateSpanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["endAssetId"] = this.endAssetId;
        data["startAssetId"] = this.startAssetId;
        return data;
    }

    clone(): CreateSpanDto {
        const json = this.toJSON();
        let result = new CreateSpanDto();
        result.init(json);
        return result;
    }
}

/** CreateSpanDto represents a data structure for creating a new span type asset. */
export interface ICreateSpanDto {
    /** The identifier of the tenant to which this pole belongs. */
    tenantId: number | undefined;
    /** The identifier of the inspection to which this pole belongs. */
    inspectionId: number;
    /** The identifier of the starting asset to which this span connects. */
    endAssetId: number;
    /** The identifier of the starting asset to which this span connects. */
    startAssetId: number;
}

export class CreateUserDto implements ICreateUserDto {
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    password!: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

/** Dto to create a condition from workbench */
export class CreateWBConditionDto implements ICreateWBConditionDto {
    tenantId!: number;
    inspectionId!: number;
    assetId!: number;
    conditionName!: string;
    priority!: string;
    itemType!: string;
    type!: string;
    comments!: string | undefined;
    circuits!: CircuitDto[] | undefined;

    constructor(data?: ICreateWBConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.assetId = _data["assetId"];
            this.conditionName = _data["conditionName"];
            this.priority = _data["priority"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateWBConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWBConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["assetId"] = this.assetId;
        data["conditionName"] = this.conditionName;
        data["priority"] = this.priority;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["comments"] = this.comments;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateWBConditionDto {
        const json = this.toJSON();
        let result = new CreateWBConditionDto();
        result.init(json);
        return result;
    }
}

/** Dto to create a condition from workbench */
export interface ICreateWBConditionDto {
    tenantId: number;
    inspectionId: number;
    assetId: number;
    conditionName: string;
    priority: string;
    itemType: string;
    type: string;
    comments: string | undefined;
    circuits: CircuitDto[] | undefined;
}

/** Dto for BoundingBox that contains information to update Workbench with the real ID of a created box */
export class CreatedBoundingBoxDto implements ICreatedBoundingBoxDto {
    /** The Identifier of the Bounding Box as saved into the DB */
    id!: number;
    /** The differentiator Workbench used to tell different newly created boxes apart */
    differentiator!: number;

    constructor(data?: ICreatedBoundingBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.differentiator = _data["differentiator"];
        }
    }

    static fromJS(data: any): CreatedBoundingBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedBoundingBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["differentiator"] = this.differentiator;
        return data;
    }

    clone(): CreatedBoundingBoxDto {
        const json = this.toJSON();
        let result = new CreatedBoundingBoxDto();
        result.init(json);
        return result;
    }
}

/** Dto for BoundingBox that contains information to update Workbench with the real ID of a created box */
export interface ICreatedBoundingBoxDto {
    /** The Identifier of the Bounding Box as saved into the DB */
    id: number;
    /** The differentiator Workbench used to tell different newly created boxes apart */
    differentiator: number;
}

/** Dto for Custom Asset Property */
export class CustomAssetPropertyDto implements ICustomAssetPropertyDto {
    id!: number;
    /** Tenant that custom asset property belongs to */
    tenantId!: number;
    /** Name of the Tenant */
    tenantName!: string | undefined;
    /** Name of Custom Asset Property */
    name!: string | undefined;
    /** Id of the custom asset property's type */
    customPropertyTypeId!: number;
    /** Data Type of the Custom Property */
    customPropertyType!: CustomPropertyTypeDto | undefined;
    /** The display name of the Custom Property */
    displayName!: string | undefined;
    /** List of custom asset property options (if applicable) associated with this custom asset property */
    customAssetPropertyOptions!: CustomAssetPropertyOptionDto[] | undefined;

    constructor(data?: ICustomAssetPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.name = _data["name"];
            this.customPropertyTypeId = _data["customPropertyTypeId"];
            this.customPropertyType = _data["customPropertyType"] ? CustomPropertyTypeDto.fromJS(_data["customPropertyType"]) : <any>undefined;
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["customAssetPropertyOptions"])) {
                this.customAssetPropertyOptions = [] as any;
                for (let item of _data["customAssetPropertyOptions"])
                    this.customAssetPropertyOptions!.push(CustomAssetPropertyOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAssetPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAssetPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["name"] = this.name;
        data["customPropertyTypeId"] = this.customPropertyTypeId;
        data["customPropertyType"] = this.customPropertyType ? this.customPropertyType.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.customAssetPropertyOptions)) {
            data["customAssetPropertyOptions"] = [];
            for (let item of this.customAssetPropertyOptions)
                data["customAssetPropertyOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomAssetPropertyDto {
        const json = this.toJSON();
        let result = new CustomAssetPropertyDto();
        result.init(json);
        return result;
    }
}

/** Dto for Custom Asset Property */
export interface ICustomAssetPropertyDto {
    id: number;
    /** Tenant that custom asset property belongs to */
    tenantId: number;
    /** Name of the Tenant */
    tenantName: string | undefined;
    /** Name of Custom Asset Property */
    name: string | undefined;
    /** Id of the custom asset property's type */
    customPropertyTypeId: number;
    /** Data Type of the Custom Property */
    customPropertyType: CustomPropertyTypeDto | undefined;
    /** The display name of the Custom Property */
    displayName: string | undefined;
    /** List of custom asset property options (if applicable) associated with this custom asset property */
    customAssetPropertyOptions: CustomAssetPropertyOptionDto[] | undefined;
}

export class CustomAssetPropertyDtoPagedResultDto implements ICustomAssetPropertyDtoPagedResultDto {
    items!: CustomAssetPropertyDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomAssetPropertyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomAssetPropertyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomAssetPropertyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAssetPropertyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomAssetPropertyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomAssetPropertyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomAssetPropertyDtoPagedResultDto {
    items: CustomAssetPropertyDto[] | undefined;
    totalCount: number;
}

/** Dto for Custom Asset Property Option */
export class CustomAssetPropertyOptionDto implements ICustomAssetPropertyOptionDto {
    id!: number;
    /** Id of the custom property this option belongs to */
    customAssetPropertyId!: number;
    /** Name of the Custom Asset Property Option */
    name!: string | undefined;

    constructor(data?: ICustomAssetPropertyOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customAssetPropertyId = _data["customAssetPropertyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomAssetPropertyOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAssetPropertyOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customAssetPropertyId"] = this.customAssetPropertyId;
        data["name"] = this.name;
        return data;
    }

    clone(): CustomAssetPropertyOptionDto {
        const json = this.toJSON();
        let result = new CustomAssetPropertyOptionDto();
        result.init(json);
        return result;
    }
}

/** Dto for Custom Asset Property Option */
export interface ICustomAssetPropertyOptionDto {
    id: number;
    /** Id of the custom property this option belongs to */
    customAssetPropertyId: number;
    /** Name of the Custom Asset Property Option */
    name: string | undefined;
}

export class CustomAssetPropertyValueDto implements ICustomAssetPropertyValueDto {
    /** The value of the related Custom Property */
    value!: string | undefined;
    /** The Custom Property */
    customProperty!: CustomAssetPropertyDto | undefined;

    constructor(data?: ICustomAssetPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.customProperty = _data["customProperty"] ? CustomAssetPropertyDto.fromJS(_data["customProperty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomAssetPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAssetPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["customProperty"] = this.customProperty ? this.customProperty.toJSON() : <any>undefined;
        return data;
    }

    clone(): CustomAssetPropertyValueDto {
        const json = this.toJSON();
        let result = new CustomAssetPropertyValueDto();
        result.init(json);
        return result;
    }
}

export interface ICustomAssetPropertyValueDto {
    /** The value of the related Custom Property */
    value: string | undefined;
    /** The Custom Property */
    customProperty: CustomAssetPropertyDto | undefined;
}

/** Dto for Custom Asset Property Option */
export class CustomPropertyTypeDto implements ICustomPropertyTypeDto {
    id!: number;
    /** Name of the Custom Asset Property Type */
    name!: string | undefined;
    /** Unmapped boolean value that specifies whether this data type is the dropdown option */
    isDropdown!: boolean;

    constructor(data?: ICustomPropertyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDropdown = _data["isDropdown"];
        }
    }

    static fromJS(data: any): CustomPropertyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPropertyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDropdown"] = this.isDropdown;
        return data;
    }

    clone(): CustomPropertyTypeDto {
        const json = this.toJSON();
        let result = new CustomPropertyTypeDto();
        result.init(json);
        return result;
    }
}

/** Dto for Custom Asset Property Option */
export interface ICustomPropertyTypeDto {
    id: number;
    /** Name of the Custom Asset Property Type */
    name: string | undefined;
    /** Unmapped boolean value that specifies whether this data type is the dropdown option */
    isDropdown: boolean;
}

export class CustomerAssetData implements ICustomerAssetData {
    facilityId!: string | undefined;
    assessmentDate!: moment.Moment | undefined;
    comments!: string | undefined;
    district!: string | undefined;
    state!: string | undefined;
    assessmentCompany!: string | undefined;
    brandDate!: number | undefined;
    collectorId!: string | undefined;
    poleHeight!: number | undefined;
    poleClass!: string | undefined;
    circuits!: string[] | undefined;
    riskZone!: string | undefined;
    constructionType!: string | undefined;
    truckAccessible!: boolean | undefined;
    groundResistance!: number | undefined;
    windExposure!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    customProperties!: string | undefined;

    constructor(data?: ICustomerAssetData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.assessmentDate = _data["assessmentDate"] ? moment(_data["assessmentDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.district = _data["district"];
            this.state = _data["state"];
            this.assessmentCompany = _data["assessmentCompany"];
            this.brandDate = _data["brandDate"];
            this.collectorId = _data["collectorId"];
            this.poleHeight = _data["poleHeight"];
            this.poleClass = _data["poleClass"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(item);
            }
            this.riskZone = _data["riskZone"];
            this.constructionType = _data["constructionType"];
            this.truckAccessible = _data["truckAccessible"];
            this.groundResistance = _data["groundResistance"];
            this.windExposure = _data["windExposure"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.customProperties = _data["customProperties"];
        }
    }

    static fromJS(data: any): CustomerAssetData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAssetData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["district"] = this.district;
        data["state"] = this.state;
        data["assessmentCompany"] = this.assessmentCompany;
        data["brandDate"] = this.brandDate;
        data["collectorId"] = this.collectorId;
        data["poleHeight"] = this.poleHeight;
        data["poleClass"] = this.poleClass;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item);
        }
        data["riskZone"] = this.riskZone;
        data["constructionType"] = this.constructionType;
        data["truckAccessible"] = this.truckAccessible;
        data["groundResistance"] = this.groundResistance;
        data["windExposure"] = this.windExposure;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["customProperties"] = this.customProperties;
        return data;
    }

    clone(): CustomerAssetData {
        const json = this.toJSON();
        let result = new CustomerAssetData();
        result.init(json);
        return result;
    }
}

export interface ICustomerAssetData {
    facilityId: string | undefined;
    assessmentDate: moment.Moment | undefined;
    comments: string | undefined;
    district: string | undefined;
    state: string | undefined;
    assessmentCompany: string | undefined;
    brandDate: number | undefined;
    collectorId: string | undefined;
    poleHeight: number | undefined;
    poleClass: string | undefined;
    circuits: string[] | undefined;
    riskZone: string | undefined;
    constructionType: string | undefined;
    truckAccessible: boolean | undefined;
    groundResistance: number | undefined;
    windExposure: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    customProperties: string | undefined;
}

/** Dto for Data Collector */
export class DataCollectorDto implements IDataCollectorDto {
    id!: number;
    /** Tenant DataCollector belongs to */
    tenantId!: number | undefined;
    /** The name of the collector */
    name!: string | undefined;
    /** Determines whether this DataCollector is the default for the associated Tenant */
    isDefault!: boolean;

    constructor(data?: IDataCollectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): DataCollectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataCollectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): DataCollectorDto {
        const json = this.toJSON();
        let result = new DataCollectorDto();
        result.init(json);
        return result;
    }
}

/** Dto for Data Collector */
export interface IDataCollectorDto {
    id: number;
    /** Tenant DataCollector belongs to */
    tenantId: number | undefined;
    /** The name of the collector */
    name: string | undefined;
    /** Determines whether this DataCollector is the default for the associated Tenant */
    isDefault: boolean;
}

export enum Dimension {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    __3 = -3,
    __2 = -2,
    __1 = -1,
}

export class DisplayUserDto implements IDisplayUserDto {
    id!: number;
    /** User's first name */
    name!: string;
    /** User's given name */
    surname!: string;
    /** User's email address */
    emailAddress!: string;
    /** Combined display value for user's name with email */
    readonly fullNameWithEmail!: string | undefined;

    constructor(data?: IDisplayUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            (<any>this).fullNameWithEmail = _data["fullNameWithEmail"];
        }
    }

    static fromJS(data: any): DisplayUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["fullNameWithEmail"] = this.fullNameWithEmail;
        return data;
    }

    clone(): DisplayUserDto {
        const json = this.toJSON();
        let result = new DisplayUserDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayUserDto {
    id: number;
    /** User's first name */
    name: string;
    /** User's given name */
    surname: string;
    /** User's email address */
    emailAddress: string;
    /** Combined display value for user's name with email */
    fullNameWithEmail: string | undefined;
}

export class DisplayUserDtoListResultDto implements IDisplayUserDtoListResultDto {
    items!: DisplayUserDto[] | undefined;

    constructor(data?: IDisplayUserDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DisplayUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DisplayUserDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayUserDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): DisplayUserDtoListResultDto {
        const json = this.toJSON();
        let result = new DisplayUserDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayUserDtoListResultDto {
    items: DisplayUserDto[] | undefined;
}

/** Dto for a Durable Function. */
export class DurableFunctionDto implements IDurableFunctionDto {
    id!: number;
    /** Tenant that the Durable Function belongs. */
    tenantId!: number;
    /** Inspection that the Upload Durable Function belongs. */
    inspectionId!: number;
    /** Instance Id of the durable function in Azure. */
    instanceId!: string | undefined;
    /** Original file name for the uploaded file, will be used as the file
name if the user chooses to download the file back from storage. */
    fileName!: string | undefined;
    /** File extension for the uploaded file. */
    fileExtension!: string | undefined;
    /** The Md5 hash of the uploaded file, will be used as the file name in
Azure blob storage. */
    md5!: string | undefined;
    /** The time at which the durable function was actually created. */
    durableFunctionCreationTime!: moment.Moment;
    /** The status of the durable function.
i.e. Terminated, Completed, Failed, In Progress */
    status!: string | undefined;
    /** The total number of rows processed. */
    totalNumber!: number | undefined;
    /** The number of rows that were successfully processed. */
    numberSucceeded!: number | undefined;
    /** The number of rows that failed processing. */
    numberFailed!: number | undefined;
    /** The discriminator to specify the type of the durable function. */
    discriminator!: string | undefined;
    /** The message stored for this durable function -- this could be a status or error message. */
    message!: string | undefined;

    constructor(data?: IDurableFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.instanceId = _data["instanceId"];
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.md5 = _data["md5"];
            this.durableFunctionCreationTime = _data["durableFunctionCreationTime"] ? moment(_data["durableFunctionCreationTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.totalNumber = _data["totalNumber"];
            this.numberSucceeded = _data["numberSucceeded"];
            this.numberFailed = _data["numberFailed"];
            this.discriminator = _data["discriminator"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DurableFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurableFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["instanceId"] = this.instanceId;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["md5"] = this.md5;
        data["durableFunctionCreationTime"] = this.durableFunctionCreationTime ? this.durableFunctionCreationTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["totalNumber"] = this.totalNumber;
        data["numberSucceeded"] = this.numberSucceeded;
        data["numberFailed"] = this.numberFailed;
        data["discriminator"] = this.discriminator;
        data["message"] = this.message;
        return data;
    }

    clone(): DurableFunctionDto {
        const json = this.toJSON();
        let result = new DurableFunctionDto();
        result.init(json);
        return result;
    }
}

/** Dto for a Durable Function. */
export interface IDurableFunctionDto {
    id: number;
    /** Tenant that the Durable Function belongs. */
    tenantId: number;
    /** Inspection that the Upload Durable Function belongs. */
    inspectionId: number;
    /** Instance Id of the durable function in Azure. */
    instanceId: string | undefined;
    /** Original file name for the uploaded file, will be used as the file
name if the user chooses to download the file back from storage. */
    fileName: string | undefined;
    /** File extension for the uploaded file. */
    fileExtension: string | undefined;
    /** The Md5 hash of the uploaded file, will be used as the file name in
Azure blob storage. */
    md5: string | undefined;
    /** The time at which the durable function was actually created. */
    durableFunctionCreationTime: moment.Moment;
    /** The status of the durable function.
i.e. Terminated, Completed, Failed, In Progress */
    status: string | undefined;
    /** The total number of rows processed. */
    totalNumber: number | undefined;
    /** The number of rows that were successfully processed. */
    numberSucceeded: number | undefined;
    /** The number of rows that failed processing. */
    numberFailed: number | undefined;
    /** The discriminator to specify the type of the durable function. */
    discriminator: string | undefined;
    /** The message stored for this durable function -- this could be a status or error message. */
    message: string | undefined;
}

export class Envelope implements IEnvelope {
    readonly isNull!: boolean;
    readonly width!: number;
    readonly height!: number;
    readonly diameter!: number;
    readonly minX!: number;
    readonly maxX!: number;
    readonly minY!: number;
    readonly maxY!: number;
    readonly area!: number;
    readonly minExtent!: number;
    readonly maxExtent!: number;
    readonly centre!: Coordinate | undefined;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isNull = _data["isNull"];
            (<any>this).width = _data["width"];
            (<any>this).height = _data["height"];
            (<any>this).diameter = _data["diameter"];
            (<any>this).minX = _data["minX"];
            (<any>this).maxX = _data["maxX"];
            (<any>this).minY = _data["minY"];
            (<any>this).maxY = _data["maxY"];
            (<any>this).area = _data["area"];
            (<any>this).minExtent = _data["minExtent"];
            (<any>this).maxExtent = _data["maxExtent"];
            (<any>this).centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull;
        data["width"] = this.width;
        data["height"] = this.height;
        data["diameter"] = this.diameter;
        data["minX"] = this.minX;
        data["maxX"] = this.maxX;
        data["minY"] = this.minY;
        data["maxY"] = this.maxY;
        data["area"] = this.area;
        data["minExtent"] = this.minExtent;
        data["maxExtent"] = this.maxExtent;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>undefined;
        return data;
    }

    clone(): Envelope {
        const json = this.toJSON();
        let result = new Envelope();
        result.init(json);
        return result;
    }
}

export interface IEnvelope {
    isNull: boolean;
    width: number;
    height: number;
    diameter: number;
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
    area: number;
    minExtent: number;
    maxExtent: number;
    centre: Coordinate | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code!: number;
    message!: string | undefined;
    details!: string | undefined;
    validationErrors!: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class ExcelUploadCustomAssetProperty implements IExcelUploadCustomAssetProperty {
    customAssetPropertyId!: number;
    displayName!: string | undefined;

    constructor(data?: IExcelUploadCustomAssetProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customAssetPropertyId = _data["customAssetPropertyId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ExcelUploadCustomAssetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelUploadCustomAssetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customAssetPropertyId"] = this.customAssetPropertyId;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): ExcelUploadCustomAssetProperty {
        const json = this.toJSON();
        let result = new ExcelUploadCustomAssetProperty();
        result.init(json);
        return result;
    }
}

export interface IExcelUploadCustomAssetProperty {
    customAssetPropertyId: number;
    displayName: string | undefined;
}

export class ExcelUploadCustomStatus implements IExcelUploadCustomStatus {
    type!: string | undefined;
    inspectionId!: number;
    completed!: number;
    failed!: number;
    total!: number;
    uploadCompleted!: boolean;
    processFailed!: boolean;
    failureMessage!: string | undefined;
    userId!: number;

    constructor(data?: IExcelUploadCustomStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.inspectionId = _data["inspectionId"];
            this.completed = _data["completed"];
            this.failed = _data["failed"];
            this.total = _data["total"];
            this.uploadCompleted = _data["uploadCompleted"];
            this.processFailed = _data["processFailed"];
            this.failureMessage = _data["failureMessage"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ExcelUploadCustomStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelUploadCustomStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["inspectionId"] = this.inspectionId;
        data["completed"] = this.completed;
        data["failed"] = this.failed;
        data["total"] = this.total;
        data["uploadCompleted"] = this.uploadCompleted;
        data["processFailed"] = this.processFailed;
        data["failureMessage"] = this.failureMessage;
        data["userId"] = this.userId;
        return data;
    }

    clone(): ExcelUploadCustomStatus {
        const json = this.toJSON();
        let result = new ExcelUploadCustomStatus();
        result.init(json);
        return result;
    }
}

export interface IExcelUploadCustomStatus {
    type: string | undefined;
    inspectionId: number;
    completed: number;
    failed: number;
    total: number;
    uploadCompleted: boolean;
    processFailed: boolean;
    failureMessage: string | undefined;
    userId: number;
}

export class ExcelUploadOrchestratorRequest implements IExcelUploadOrchestratorRequest {
    inspectionId!: number;
    fileUrl!: string | undefined;
    distanceRange!: number | undefined;
    duplicateRange!: number | undefined;
    userId!: number;
    customAssetProperties!: ExcelUploadCustomAssetProperty[] | undefined;

    constructor(data?: IExcelUploadOrchestratorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.fileUrl = _data["fileUrl"];
            this.distanceRange = _data["distanceRange"];
            this.duplicateRange = _data["duplicateRange"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["customAssetProperties"])) {
                this.customAssetProperties = [] as any;
                for (let item of _data["customAssetProperties"])
                    this.customAssetProperties!.push(ExcelUploadCustomAssetProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelUploadOrchestratorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelUploadOrchestratorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["fileUrl"] = this.fileUrl;
        data["distanceRange"] = this.distanceRange;
        data["duplicateRange"] = this.duplicateRange;
        data["userId"] = this.userId;
        if (Array.isArray(this.customAssetProperties)) {
            data["customAssetProperties"] = [];
            for (let item of this.customAssetProperties)
                data["customAssetProperties"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExcelUploadOrchestratorRequest {
        const json = this.toJSON();
        let result = new ExcelUploadOrchestratorRequest();
        result.init(json);
        return result;
    }
}

export interface IExcelUploadOrchestratorRequest {
    inspectionId: number;
    fileUrl: string | undefined;
    distanceRange: number | undefined;
    duplicateRange: number | undefined;
    userId: number;
    customAssetProperties: ExcelUploadCustomAssetProperty[] | undefined;
}

export class ExcelUploadStatusResponse implements IExcelUploadStatusResponse {
    name!: string | undefined;
    instanceId!: string | undefined;
    runtimeStatus!: string | undefined;
    requestData!: ExcelUploadOrchestratorRequest | undefined;
    customStatus!: ExcelUploadCustomStatus | undefined;
    createdTime!: moment.Moment;
    lastUpdatedTime!: moment.Moment;

    constructor(data?: IExcelUploadStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.instanceId = _data["instanceId"];
            this.runtimeStatus = _data["runtimeStatus"];
            this.requestData = _data["requestData"] ? ExcelUploadOrchestratorRequest.fromJS(_data["requestData"]) : <any>undefined;
            this.customStatus = _data["customStatus"] ? ExcelUploadCustomStatus.fromJS(_data["customStatus"]) : <any>undefined;
            this.createdTime = _data["createdTime"] ? moment(_data["createdTime"].toString()) : <any>undefined;
            this.lastUpdatedTime = _data["lastUpdatedTime"] ? moment(_data["lastUpdatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcelUploadStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelUploadStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["instanceId"] = this.instanceId;
        data["runtimeStatus"] = this.runtimeStatus;
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        data["customStatus"] = this.customStatus ? this.customStatus.toJSON() : <any>undefined;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["lastUpdatedTime"] = this.lastUpdatedTime ? this.lastUpdatedTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExcelUploadStatusResponse {
        const json = this.toJSON();
        let result = new ExcelUploadStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IExcelUploadStatusResponse {
    name: string | undefined;
    instanceId: string | undefined;
    runtimeStatus: string | undefined;
    requestData: ExcelUploadOrchestratorRequest | undefined;
    customStatus: ExcelUploadCustomStatus | undefined;
    createdTime: moment.Moment;
    lastUpdatedTime: moment.Moment;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class Geometry implements IGeometry {
    readonly coordinate!: Coordinate | undefined;
    readonly coordinates!: Coordinate[] | undefined;
    readonly numPoints!: number;
    readonly dimension!: Dimension;
    readonly boundaryDimension!: Dimension;
    readonly isEmpty!: boolean;
    readonly geometryType!: string | undefined;
    readonly ogcGeometryType!: OgcGeometryType;
    readonly area!: number;
    readonly length!: number;
    readonly boundary!: Geometry | undefined;
    readonly isRectangle!: boolean;
    readonly factory!: GeometryFactory | undefined;
    userData!: any | undefined;
    srid!: number;
    readonly precisionModel!: PrecisionModel | undefined;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly centroid!: Point | undefined;
    readonly interiorPoint!: Point | undefined;
    readonly pointOnSurface!: Point | undefined;
    readonly envelope!: Geometry | undefined;
    readonly envelopeInternal!: Envelope | undefined;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).dimension = _data["dimension"];
            (<any>this).boundaryDimension = _data["boundaryDimension"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).geometryType = _data["geometryType"];
            (<any>this).ogcGeometryType = _data["ogcGeometryType"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            (<any>this).boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            (<any>this).factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            (<any>this).interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            (<any>this).pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            (<any>this).envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            (<any>this).envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["isEmpty"] = this.isEmpty;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["area"] = this.area;
        data["length"] = this.length;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        return data;
    }

    clone(): Geometry {
        const json = this.toJSON();
        let result = new Geometry();
        result.init(json);
        return result;
    }
}

export interface IGeometry {
    coordinate: Coordinate | undefined;
    coordinates: Coordinate[] | undefined;
    numPoints: number;
    dimension: Dimension;
    boundaryDimension: Dimension;
    isEmpty: boolean;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    area: number;
    length: number;
    boundary: Geometry | undefined;
    isRectangle: boolean;
    factory: GeometryFactory | undefined;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel | undefined;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    centroid: Point | undefined;
    interiorPoint: Point | undefined;
    pointOnSurface: Point | undefined;
    envelope: Geometry | undefined;
    envelopeInternal: Envelope | undefined;
}

export class GeometryFactory implements IGeometryFactory {
    readonly precisionModel!: PrecisionModel | undefined;
    readonly coordinateSequenceFactory!: CoordinateSequenceFactory | undefined;
    readonly srid!: number;
    readonly geometryServices!: NtsGeometryServices | undefined;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : <any>undefined;
            (<any>this).srid = _data["srid"];
            (<any>this).geometryServices = _data["geometryServices"] ? NtsGeometryServices.fromJS(_data["geometryServices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>undefined;
        data["srid"] = this.srid;
        data["geometryServices"] = this.geometryServices ? this.geometryServices.toJSON() : <any>undefined;
        return data;
    }

    clone(): GeometryFactory {
        const json = this.toJSON();
        let result = new GeometryFactory();
        result.init(json);
        return result;
    }
}

export interface IGeometryFactory {
    precisionModel: PrecisionModel | undefined;
    coordinateSequenceFactory: CoordinateSequenceFactory | undefined;
    srid: number;
    geometryServices: NtsGeometryServices | undefined;
}

export class GeometryOverlay implements IGeometryOverlay {

    constructor(data?: IGeometryOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GeometryOverlay {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryOverlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): GeometryOverlay {
        const json = this.toJSON();
        let result = new GeometryOverlay();
        result.init(json);
        return result;
    }
}

export interface IGeometryOverlay {
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto | undefined;
    user!: UserLoginInfoDto | undefined;
    tenant!: TenantLoginInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
}

/** A dto representing the high priority qc pending notifications */
export class HighPriorityQCPendingNotificationDto implements IHighPriorityQCPendingNotificationDto {
    /** The inspection */
    inspection!: InspectionDto | undefined;
    /** The tenant */
    tenant!: TenantDto | undefined;
    /** The number of P10s */
    p10Count!: number;
    /** The number of P20s */
    p20Count!: number;

    constructor(data?: IHighPriorityQCPendingNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.p10Count = _data["p10Count"];
            this.p20Count = _data["p20Count"];
        }
    }

    static fromJS(data: any): HighPriorityQCPendingNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HighPriorityQCPendingNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["p10Count"] = this.p10Count;
        data["p20Count"] = this.p20Count;
        return data;
    }

    clone(): HighPriorityQCPendingNotificationDto {
        const json = this.toJSON();
        let result = new HighPriorityQCPendingNotificationDto();
        result.init(json);
        return result;
    }
}

/** A dto representing the high priority qc pending notifications */
export interface IHighPriorityQCPendingNotificationDto {
    /** The inspection */
    inspection: InspectionDto | undefined;
    /** The tenant */
    tenant: TenantDto | undefined;
    /** The number of P10s */
    p10Count: number;
    /** The number of P20s */
    p20Count: number;
}

export class HistoricalConditionAccessDto implements IHistoricalConditionAccessDto {
    access!: boolean;

    constructor(data?: IHistoricalConditionAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["access"];
        }
    }

    static fromJS(data: any): HistoricalConditionAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalConditionAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        return data;
    }

    clone(): HistoricalConditionAccessDto {
        const json = this.toJSON();
        let result = new HistoricalConditionAccessDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalConditionAccessDto {
    access: boolean;
}

/** DTO to return to client for asset profile update */
export class ImageAssetProfileDto implements IImageAssetProfileDto {
    assetProfile!: boolean;
    lastModificationTime!: moment.Moment;

    constructor(data?: IImageAssetProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetProfile = _data["assetProfile"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageAssetProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAssetProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetProfile"] = this.assetProfile;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ImageAssetProfileDto {
        const json = this.toJSON();
        let result = new ImageAssetProfileDto();
        result.init(json);
        return result;
    }
}

/** DTO to return to client for asset profile update */
export interface IImageAssetProfileDto {
    assetProfile: boolean;
    lastModificationTime: moment.Moment;
}

/** DTO to return to client for image audit update */
export class ImageAuditDto implements IImageAuditDto {
    shouldBeAudited!: boolean;
    auditReasonTypeId!: number | undefined;
    auditReason!: string | undefined;
    lastModificationTime!: moment.Moment;

    constructor(data?: IImageAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldBeAudited = _data["shouldBeAudited"];
            this.auditReasonTypeId = _data["auditReasonTypeId"];
            this.auditReason = _data["auditReason"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldBeAudited"] = this.shouldBeAudited;
        data["auditReasonTypeId"] = this.auditReasonTypeId;
        data["auditReason"] = this.auditReason;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ImageAuditDto {
        const json = this.toJSON();
        let result = new ImageAuditDto();
        result.init(json);
        return result;
    }
}

/** DTO to return to client for image audit update */
export interface IImageAuditDto {
    shouldBeAudited: boolean;
    auditReasonTypeId: number | undefined;
    auditReason: string | undefined;
    lastModificationTime: moment.Moment;
}

export class ImageData implements IImageData {
    localDirectory!: string | undefined;
    fileName!: string | undefined;
    serialNumber!: string | undefined;
    longitude!: number | undefined;
    latitude!: number | undefined;
    gimbalPitchDegree!: number | undefined;
    gimbalYawDegree!: number | undefined;
    flightYawDegree!: number | undefined;
    md5!: string | undefined;
    date!: moment.Moment | undefined;
    cameraMake!: string | undefined;
    cameraModel!: string | undefined;
    orientation!: number | undefined;

    constructor(data?: IImageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDirectory = _data["localDirectory"];
            this.fileName = _data["fileName"];
            this.serialNumber = _data["serialNumber"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.gimbalPitchDegree = _data["gimbalPitchDegree"];
            this.gimbalYawDegree = _data["gimbalYawDegree"];
            this.flightYawDegree = _data["flightYawDegree"];
            this.md5 = _data["md5"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.cameraMake = _data["cameraMake"];
            this.cameraModel = _data["cameraModel"];
            this.orientation = _data["orientation"];
        }
    }

    static fromJS(data: any): ImageData {
        data = typeof data === 'object' ? data : {};
        let result = new ImageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDirectory"] = this.localDirectory;
        data["fileName"] = this.fileName;
        data["serialNumber"] = this.serialNumber;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["gimbalPitchDegree"] = this.gimbalPitchDegree;
        data["gimbalYawDegree"] = this.gimbalYawDegree;
        data["flightYawDegree"] = this.flightYawDegree;
        data["md5"] = this.md5;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["cameraMake"] = this.cameraMake;
        data["cameraModel"] = this.cameraModel;
        data["orientation"] = this.orientation;
        return data;
    }

    clone(): ImageData {
        const json = this.toJSON();
        let result = new ImageData();
        result.init(json);
        return result;
    }
}

export interface IImageData {
    localDirectory: string | undefined;
    fileName: string | undefined;
    serialNumber: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    gimbalPitchDegree: number | undefined;
    gimbalYawDegree: number | undefined;
    flightYawDegree: number | undefined;
    md5: string | undefined;
    date: moment.Moment | undefined;
    cameraMake: string | undefined;
    cameraModel: string | undefined;
    orientation: number | undefined;
}

/** Dto for Image */
export class ImageDto implements IImageDto {
    id!: number;
    /** Tenant image belongs to */
    tenantId!: number;
    /** Asset this image belongs to */
    assetId!: number | undefined;
    /** Id of the inspection */
    inspectionId!: number | undefined;
    /** The Facility Id of the Asset for the image */
    facilityId!: string | undefined;
    /** Url of the image */
    imageUrl!: string | undefined;
    /** Url of the compressed image */
    compressedImageUrl!: string | undefined;
    /** Compressed file size of the image */
    compressedFileSize!: number | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl!: string | undefined;
    /** Local Directory name at which the Image resides when its metadata information was pulled */
    localDirectory!: string | undefined;
    /** Name of the File at the Local Directory provided from which image metadata information was pulled */
    fileName!: string | undefined;
    /** Size of the image file in bytes. */
    fileSize!: number | undefined;
    /** The serial number of the drone that took the photo */
    serialNumber!: string | undefined;
    /** Gimbal Pitch Degree (the angle the camera was at when the image was taken) */
    gimbalPitchDegree!: number | undefined;
    /** Gimbal Yaw Degree (the angle the camera was at when the image was taken) */
    gimbalYawDegree!: number | undefined;
    /** Date on which the Image was taken */
    date!: moment.Moment | undefined;
    /** Boolean flag indicating whether or not the Image should be audited */
    shouldBeAudited!: boolean;
    /** Identifier of the related Audit Reason Type */
    auditReasonTypeId!: number | undefined;
    /** The Type of Audit Reason related to this Image */
    auditReasonType!: AuditReasonType | undefined;
    /** String message used to describe the reason why the image should be audited */
    auditReason!: string | undefined;
    /** Latitude */
    latitude!: number;
    /** Longitude */
    longitude!: number;
    geo!: Point | undefined;
    /** The distance from which this image was taken in relation to its associated asset. */
    distanceTakenFromAsset!: number | undefined;
    /** Flag for Deletion (Irrelevancy) of the Image */
    isDeleted!: boolean;
    /** Specifies whether this Image is a panorama. */
    isPanorama!: boolean;
    /** Boolean flag indicating whether or not the Image is the best representation for an Asset */
    assetProfile!: boolean;
    /** Last modification date of this entity. */
    lastModificationTime!: moment.Moment | undefined;
    /** Many-to-many relation that represents the Conditions linked to this Image */
    imageToConditions!: ImageToConditionDto[] | undefined;
    /** Many-to-many relation that represents the Inventory Items linked to this Image */
    imageToInventoryItems!: ImageToInventoryItemDto[] | undefined;

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.assetId = _data["assetId"];
            this.inspectionId = _data["inspectionId"];
            this.facilityId = _data["facilityId"];
            this.imageUrl = _data["imageUrl"];
            this.compressedImageUrl = _data["compressedImageUrl"];
            this.compressedFileSize = _data["compressedFileSize"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.localDirectory = _data["localDirectory"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.serialNumber = _data["serialNumber"];
            this.gimbalPitchDegree = _data["gimbalPitchDegree"];
            this.gimbalYawDegree = _data["gimbalYawDegree"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.shouldBeAudited = _data["shouldBeAudited"];
            this.auditReasonTypeId = _data["auditReasonTypeId"];
            this.auditReasonType = _data["auditReasonType"] ? AuditReasonType.fromJS(_data["auditReasonType"]) : <any>undefined;
            this.auditReason = _data["auditReason"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.geo = _data["geo"] ? Point.fromJS(_data["geo"]) : <any>undefined;
            this.distanceTakenFromAsset = _data["distanceTakenFromAsset"];
            this.isDeleted = _data["isDeleted"];
            this.isPanorama = _data["isPanorama"];
            this.assetProfile = _data["assetProfile"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["imageToConditions"])) {
                this.imageToConditions = [] as any;
                for (let item of _data["imageToConditions"])
                    this.imageToConditions!.push(ImageToConditionDto.fromJS(item));
            }
            if (Array.isArray(_data["imageToInventoryItems"])) {
                this.imageToInventoryItems = [] as any;
                for (let item of _data["imageToInventoryItems"])
                    this.imageToInventoryItems!.push(ImageToInventoryItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["assetId"] = this.assetId;
        data["inspectionId"] = this.inspectionId;
        data["facilityId"] = this.facilityId;
        data["imageUrl"] = this.imageUrl;
        data["compressedImageUrl"] = this.compressedImageUrl;
        data["compressedFileSize"] = this.compressedFileSize;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["localDirectory"] = this.localDirectory;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["serialNumber"] = this.serialNumber;
        data["gimbalPitchDegree"] = this.gimbalPitchDegree;
        data["gimbalYawDegree"] = this.gimbalYawDegree;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["shouldBeAudited"] = this.shouldBeAudited;
        data["auditReasonTypeId"] = this.auditReasonTypeId;
        data["auditReasonType"] = this.auditReasonType ? this.auditReasonType.toJSON() : <any>undefined;
        data["auditReason"] = this.auditReason;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["geo"] = this.geo ? this.geo.toJSON() : <any>undefined;
        data["distanceTakenFromAsset"] = this.distanceTakenFromAsset;
        data["isDeleted"] = this.isDeleted;
        data["isPanorama"] = this.isPanorama;
        data["assetProfile"] = this.assetProfile;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.imageToConditions)) {
            data["imageToConditions"] = [];
            for (let item of this.imageToConditions)
                data["imageToConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.imageToInventoryItems)) {
            data["imageToInventoryItems"] = [];
            for (let item of this.imageToInventoryItems)
                data["imageToInventoryItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): ImageDto {
        const json = this.toJSON();
        let result = new ImageDto();
        result.init(json);
        return result;
    }
}

/** Dto for Image */
export interface IImageDto {
    id: number;
    /** Tenant image belongs to */
    tenantId: number;
    /** Asset this image belongs to */
    assetId: number | undefined;
    /** Id of the inspection */
    inspectionId: number | undefined;
    /** The Facility Id of the Asset for the image */
    facilityId: string | undefined;
    /** Url of the image */
    imageUrl: string | undefined;
    /** Url of the compressed image */
    compressedImageUrl: string | undefined;
    /** Compressed file size of the image */
    compressedFileSize: number | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl: string | undefined;
    /** Local Directory name at which the Image resides when its metadata information was pulled */
    localDirectory: string | undefined;
    /** Name of the File at the Local Directory provided from which image metadata information was pulled */
    fileName: string | undefined;
    /** Size of the image file in bytes. */
    fileSize: number | undefined;
    /** The serial number of the drone that took the photo */
    serialNumber: string | undefined;
    /** Gimbal Pitch Degree (the angle the camera was at when the image was taken) */
    gimbalPitchDegree: number | undefined;
    /** Gimbal Yaw Degree (the angle the camera was at when the image was taken) */
    gimbalYawDegree: number | undefined;
    /** Date on which the Image was taken */
    date: moment.Moment | undefined;
    /** Boolean flag indicating whether or not the Image should be audited */
    shouldBeAudited: boolean;
    /** Identifier of the related Audit Reason Type */
    auditReasonTypeId: number | undefined;
    /** The Type of Audit Reason related to this Image */
    auditReasonType: AuditReasonType | undefined;
    /** String message used to describe the reason why the image should be audited */
    auditReason: string | undefined;
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
    geo: Point | undefined;
    /** The distance from which this image was taken in relation to its associated asset. */
    distanceTakenFromAsset: number | undefined;
    /** Flag for Deletion (Irrelevancy) of the Image */
    isDeleted: boolean;
    /** Specifies whether this Image is a panorama. */
    isPanorama: boolean;
    /** Boolean flag indicating whether or not the Image is the best representation for an Asset */
    assetProfile: boolean;
    /** Last modification date of this entity. */
    lastModificationTime: moment.Moment | undefined;
    /** Many-to-many relation that represents the Conditions linked to this Image */
    imageToConditions: ImageToConditionDto[] | undefined;
    /** Many-to-many relation that represents the Inventory Items linked to this Image */
    imageToInventoryItems: ImageToInventoryItemDto[] | undefined;
}

export class ImageExifDto implements IImageExifDto {
    metadata!: { [key: string]: any; } | undefined;
    xmp!: { [key: string]: { [key: string]: string; }; } | undefined;

    constructor(data?: IImageExifDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            if (_data["xmp"]) {
                this.xmp = {} as any;
                for (let key in _data["xmp"]) {
                    if (_data["xmp"].hasOwnProperty(key))
                        (<any>this.xmp)![key] = _data["xmp"][key];
                }
            }
        }
    }

    static fromJS(data: any): ImageExifDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageExifDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        if (this.xmp) {
            data["xmp"] = {};
            for (let key in this.xmp) {
                if (this.xmp.hasOwnProperty(key))
                    (<any>data["xmp"])[key] = (<any>this.xmp)[key];
            }
        }
        return data;
    }

    clone(): ImageExifDto {
        const json = this.toJSON();
        let result = new ImageExifDto();
        result.init(json);
        return result;
    }
}

export interface IImageExifDto {
    metadata: { [key: string]: any; } | undefined;
    xmp: { [key: string]: { [key: string]: string; }; } | undefined;
}

/** Dto for image relevance endpoint */
export class ImageRelevanceDto implements IImageRelevanceDto {
    isDeleted!: boolean;
    deletionTime!: moment.Moment | undefined;

    constructor(data?: IImageRelevanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageRelevanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageRelevanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ImageRelevanceDto {
        const json = this.toJSON();
        let result = new ImageRelevanceDto();
        result.init(json);
        return result;
    }
}

/** Dto for image relevance endpoint */
export interface IImageRelevanceDto {
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
}

/** Dto for Image Storage Info */
export class ImageStorageInfoDto implements IImageStorageInfoDto {
    inspectionName!: string | undefined;
    storageAccountName!: string | undefined;
    directoryPath!: string | undefined;
    processedImagesCount!: number;

    constructor(data?: IImageStorageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionName = _data["inspectionName"];
            this.storageAccountName = _data["storageAccountName"];
            this.directoryPath = _data["directoryPath"];
            this.processedImagesCount = _data["processedImagesCount"];
        }
    }

    static fromJS(data: any): ImageStorageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageStorageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionName"] = this.inspectionName;
        data["storageAccountName"] = this.storageAccountName;
        data["directoryPath"] = this.directoryPath;
        data["processedImagesCount"] = this.processedImagesCount;
        return data;
    }

    clone(): ImageStorageInfoDto {
        const json = this.toJSON();
        let result = new ImageStorageInfoDto();
        result.init(json);
        return result;
    }
}

/** Dto for Image Storage Info */
export interface IImageStorageInfoDto {
    inspectionName: string | undefined;
    storageAccountName: string | undefined;
    directoryPath: string | undefined;
    processedImagesCount: number;
}

/** Dto for ImageToCondition */
export class ImageToConditionDto implements IImageToConditionDto {
    id!: number;
    /** Identifier of the related image */
    imageId!: number;
    /** Identifier of the related condition */
    conditionId!: number;
    /** The related image */
    image!: ImageDto | undefined;
    /** The related condition */
    condition!: ConditionDto | undefined;
    /** Dtos of the related ConditionBoundingBoxes */
    conditionBoundingBoxes!: ConditionBoundingBoxDto[] | undefined;

    constructor(data?: IImageToConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageId = _data["imageId"];
            this.conditionId = _data["conditionId"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.condition = _data["condition"] ? ConditionDto.fromJS(_data["condition"]) : <any>undefined;
            if (Array.isArray(_data["conditionBoundingBoxes"])) {
                this.conditionBoundingBoxes = [] as any;
                for (let item of _data["conditionBoundingBoxes"])
                    this.conditionBoundingBoxes!.push(ConditionBoundingBoxDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageToConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageToConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageId"] = this.imageId;
        data["conditionId"] = this.conditionId;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        if (Array.isArray(this.conditionBoundingBoxes)) {
            data["conditionBoundingBoxes"] = [];
            for (let item of this.conditionBoundingBoxes)
                data["conditionBoundingBoxes"].push(item.toJSON());
        }
        return data;
    }

    clone(): ImageToConditionDto {
        const json = this.toJSON();
        let result = new ImageToConditionDto();
        result.init(json);
        return result;
    }
}

/** Dto for ImageToCondition */
export interface IImageToConditionDto {
    id: number;
    /** Identifier of the related image */
    imageId: number;
    /** Identifier of the related condition */
    conditionId: number;
    /** The related image */
    image: ImageDto | undefined;
    /** The related condition */
    condition: ConditionDto | undefined;
    /** Dtos of the related ConditionBoundingBoxes */
    conditionBoundingBoxes: ConditionBoundingBoxDto[] | undefined;
}

export class ImageToInventoryItemDto implements IImageToInventoryItemDto {
    id!: number;
    /** Identifier of the related image */
    imageId!: number;
    /** Identifier of the related inventory item */
    inventoryItemId!: number;
    /** The related image */
    image!: ImageDto | undefined;
    /** The related inventory item */
    inventoryItem!: InventoryItemDto | undefined;
    /** Dtos of the related inventory item bounding boxes */
    inventoryItemBoundingBoxes!: InventoryItemBoundingBoxDto[] | undefined;

    constructor(data?: IImageToInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageId = _data["imageId"];
            this.inventoryItemId = _data["inventoryItemId"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.inventoryItem = _data["inventoryItem"] ? InventoryItemDto.fromJS(_data["inventoryItem"]) : <any>undefined;
            if (Array.isArray(_data["inventoryItemBoundingBoxes"])) {
                this.inventoryItemBoundingBoxes = [] as any;
                for (let item of _data["inventoryItemBoundingBoxes"])
                    this.inventoryItemBoundingBoxes!.push(InventoryItemBoundingBoxDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageToInventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageToInventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageId"] = this.imageId;
        data["inventoryItemId"] = this.inventoryItemId;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["inventoryItem"] = this.inventoryItem ? this.inventoryItem.toJSON() : <any>undefined;
        if (Array.isArray(this.inventoryItemBoundingBoxes)) {
            data["inventoryItemBoundingBoxes"] = [];
            for (let item of this.inventoryItemBoundingBoxes)
                data["inventoryItemBoundingBoxes"].push(item.toJSON());
        }
        return data;
    }

    clone(): ImageToInventoryItemDto {
        const json = this.toJSON();
        let result = new ImageToInventoryItemDto();
        result.init(json);
        return result;
    }
}

export interface IImageToInventoryItemDto {
    id: number;
    /** Identifier of the related image */
    imageId: number;
    /** Identifier of the related inventory item */
    inventoryItemId: number;
    /** The related image */
    image: ImageDto | undefined;
    /** The related inventory item */
    inventoryItem: InventoryItemDto | undefined;
    /** Dtos of the related inventory item bounding boxes */
    inventoryItemBoundingBoxes: InventoryItemBoundingBoxDto[] | undefined;
}

export class ImageType implements IImageType {
    id!: number;
    readonly name!: string | undefined;

    constructor(data?: IImageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): ImageType {
        data = typeof data === 'object' ? data : {};
        let result = new ImageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ImageType {
        const json = this.toJSON();
        let result = new ImageType();
        result.init(json);
        return result;
    }
}

export interface IImageType {
    id: number;
    name: string | undefined;
}

export class InspectedAssetData implements IInspectedAssetData {
    latitude!: number | undefined;
    longitude!: number | undefined;

    constructor(data?: IInspectedAssetData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): InspectedAssetData {
        data = typeof data === 'object' ? data : {};
        let result = new InspectedAssetData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }

    clone(): InspectedAssetData {
        const json = this.toJSON();
        let result = new InspectedAssetData();
        result.init(json);
        return result;
    }
}

export interface IInspectedAssetData {
    latitude: number | undefined;
    longitude: number | undefined;
}

export class InspectionDto implements IInspectionDto {
    id!: number;
    /** Identifier of the Tenant Inspection belongs to */
    tenantId!: number;
    /** Name of the Tenant */
    tenantName!: string | undefined;
    /** Name of the Inspection */
    inspectionName!: string;
    /** Identifier of the Inspection Type */
    inspectionTypeId!: number | undefined;
    /** Name of the Inspection Type */
    inspectionTypeName!: string | undefined;
    /** Identifier of the Inspection Status */
    inspectionStatusId!: number | undefined;
    /** Inspection Status Name */
    inspectionStatusName!: string | undefined;
    /** Inspection start date */
    startDate!: moment.Moment | undefined;
    /** Inspection end date */
    endDate!: moment.Moment | undefined;
    /** Inspection description */
    description!: string | undefined;
    /** Inspection flag to determine whether or not work order should be displayed */
    displayWorkOrder!: boolean;
    /** Inspection Work Order Title */
    workOrderTitle!: string | undefined;
    /** Image association radius in meters */
    imageAssociationRadius!: number;
    /** Notes for this Inspection */
    inspectionNotes!: string | undefined;
    /** Identifier of the Data Collector associated with the inspection */
    dataCollectorId!: number | undefined;
    /** Flag to determine whether or not this inspection applies the automatic QC flagging */
    qcNotRequired!: boolean;
    /** Flag to determine whether or not this inspection has been soft deleted */
    isDeleted!: boolean;
    /** The inspection permissions associated with this Inspection */
    inspectionPermissions!: InspectionPermissionDto[] | undefined;
    /** The Job Types associated with this Inspection. */
    inspectionJobTypes!: InspectionJobTypeDto[] | undefined;

    constructor(data?: IInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.inspectionName = _data["inspectionName"];
            this.inspectionTypeId = _data["inspectionTypeId"];
            this.inspectionTypeName = _data["inspectionTypeName"];
            this.inspectionStatusId = _data["inspectionStatusId"];
            this.inspectionStatusName = _data["inspectionStatusName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.displayWorkOrder = _data["displayWorkOrder"];
            this.workOrderTitle = _data["workOrderTitle"];
            this.imageAssociationRadius = _data["imageAssociationRadius"];
            this.inspectionNotes = _data["inspectionNotes"];
            this.dataCollectorId = _data["dataCollectorId"];
            this.qcNotRequired = _data["qcNotRequired"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["inspectionPermissions"])) {
                this.inspectionPermissions = [] as any;
                for (let item of _data["inspectionPermissions"])
                    this.inspectionPermissions!.push(InspectionPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionJobTypes"])) {
                this.inspectionJobTypes = [] as any;
                for (let item of _data["inspectionJobTypes"])
                    this.inspectionJobTypes!.push(InspectionJobTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["inspectionName"] = this.inspectionName;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["inspectionTypeName"] = this.inspectionTypeName;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["inspectionStatusName"] = this.inspectionStatusName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["displayWorkOrder"] = this.displayWorkOrder;
        data["workOrderTitle"] = this.workOrderTitle;
        data["imageAssociationRadius"] = this.imageAssociationRadius;
        data["inspectionNotes"] = this.inspectionNotes;
        data["dataCollectorId"] = this.dataCollectorId;
        data["qcNotRequired"] = this.qcNotRequired;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.inspectionPermissions)) {
            data["inspectionPermissions"] = [];
            for (let item of this.inspectionPermissions)
                data["inspectionPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.inspectionJobTypes)) {
            data["inspectionJobTypes"] = [];
            for (let item of this.inspectionJobTypes)
                data["inspectionJobTypes"].push(item.toJSON());
        }
        return data;
    }

    clone(): InspectionDto {
        const json = this.toJSON();
        let result = new InspectionDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionDto {
    id: number;
    /** Identifier of the Tenant Inspection belongs to */
    tenantId: number;
    /** Name of the Tenant */
    tenantName: string | undefined;
    /** Name of the Inspection */
    inspectionName: string;
    /** Identifier of the Inspection Type */
    inspectionTypeId: number | undefined;
    /** Name of the Inspection Type */
    inspectionTypeName: string | undefined;
    /** Identifier of the Inspection Status */
    inspectionStatusId: number | undefined;
    /** Inspection Status Name */
    inspectionStatusName: string | undefined;
    /** Inspection start date */
    startDate: moment.Moment | undefined;
    /** Inspection end date */
    endDate: moment.Moment | undefined;
    /** Inspection description */
    description: string | undefined;
    /** Inspection flag to determine whether or not work order should be displayed */
    displayWorkOrder: boolean;
    /** Inspection Work Order Title */
    workOrderTitle: string | undefined;
    /** Image association radius in meters */
    imageAssociationRadius: number;
    /** Notes for this Inspection */
    inspectionNotes: string | undefined;
    /** Identifier of the Data Collector associated with the inspection */
    dataCollectorId: number | undefined;
    /** Flag to determine whether or not this inspection applies the automatic QC flagging */
    qcNotRequired: boolean;
    /** Flag to determine whether or not this inspection has been soft deleted */
    isDeleted: boolean;
    /** The inspection permissions associated with this Inspection */
    inspectionPermissions: InspectionPermissionDto[] | undefined;
    /** The Job Types associated with this Inspection. */
    inspectionJobTypes: InspectionJobTypeDto[] | undefined;
}

export class InspectionDtoPagedResultDto implements IInspectionDtoPagedResultDto {
    items!: InspectionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInspectionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InspectionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InspectionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InspectionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InspectionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionDtoPagedResultDto {
    items: InspectionDto[] | undefined;
    totalCount: number;
}

export class InspectionFileDto implements IInspectionFileDto {
    id!: number;
    /** DateTime at which the Report entry was created */
    creationTime!: moment.Moment;
    /** Name of the Report file */
    name!: string;
    /** Description of the Report */
    description!: string;
    /** Identifier for the Inspection related to the Report */
    inspectionId!: number;
    /** The file extension for the file. */
    fileExtension!: string | undefined;
    humanReadableFileSize!: string | undefined;

    constructor(data?: IInspectionFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.inspectionId = _data["inspectionId"];
            this.fileExtension = _data["fileExtension"];
            this.humanReadableFileSize = _data["humanReadableFileSize"];
        }
    }

    static fromJS(data: any): InspectionFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["inspectionId"] = this.inspectionId;
        data["fileExtension"] = this.fileExtension;
        data["humanReadableFileSize"] = this.humanReadableFileSize;
        return data;
    }

    clone(): InspectionFileDto {
        const json = this.toJSON();
        let result = new InspectionFileDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionFileDto {
    id: number;
    /** DateTime at which the Report entry was created */
    creationTime: moment.Moment;
    /** Name of the Report file */
    name: string;
    /** Description of the Report */
    description: string;
    /** Identifier for the Inspection related to the Report */
    inspectionId: number;
    /** The file extension for the file. */
    fileExtension: string | undefined;
    humanReadableFileSize: string | undefined;
}

/** DTO representing the link between an Inspection and Inspection Job Type. */
export class InspectionJobTypeDto implements IInspectionJobTypeDto {
    id!: number;
    /** Name of the Inspection Job Type. */
    name!: string | undefined;

    constructor(data?: IInspectionJobTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InspectionJobTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionJobTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): InspectionJobTypeDto {
        const json = this.toJSON();
        let result = new InspectionJobTypeDto();
        result.init(json);
        return result;
    }
}

/** DTO representing the link between an Inspection and Inspection Job Type. */
export interface IInspectionJobTypeDto {
    id: number;
    /** Name of the Inspection Job Type. */
    name: string | undefined;
}

export class InspectionModelRunStatus implements IInspectionModelRunStatus {
    id!: number;
    readonly name!: string | undefined;

    constructor(data?: IInspectionModelRunStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): InspectionModelRunStatus {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionModelRunStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): InspectionModelRunStatus {
        const json = this.toJSON();
        let result = new InspectionModelRunStatus();
        result.init(json);
        return result;
    }
}

export interface IInspectionModelRunStatus {
    id: number;
    name: string | undefined;
}

/** DTO for Inspection Permission relationship between a limited inspector User and an Inspection */
export class InspectionPermissionDto implements IInspectionPermissionDto {
    id!: number;
    /** Identifier of the User that is being restricted. */
    userId!: number;
    /** The User that is being restricted to certain inspections. */
    user!: DisplayUserDto | undefined;
    /** The identifier of the inspection this user is allowed to access. */
    inspectionId!: number;
    /** The inspection related to the inspection ID. */
    inspection!: InspectionDto | undefined;
    /** Whether historical condition access is allowed. */
    historicalConditionAccess!: boolean;

    constructor(data?: IInspectionPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? DisplayUserDto.fromJS(_data["user"]) : <any>undefined;
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.historicalConditionAccess = _data["historicalConditionAccess"];
        }
    }

    static fromJS(data: any): InspectionPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["historicalConditionAccess"] = this.historicalConditionAccess;
        return data;
    }

    clone(): InspectionPermissionDto {
        const json = this.toJSON();
        let result = new InspectionPermissionDto();
        result.init(json);
        return result;
    }
}

/** DTO for Inspection Permission relationship between a limited inspector User and an Inspection */
export interface IInspectionPermissionDto {
    id: number;
    /** Identifier of the User that is being restricted. */
    userId: number;
    /** The User that is being restricted to certain inspections. */
    user: DisplayUserDto | undefined;
    /** The identifier of the inspection this user is allowed to access. */
    inspectionId: number;
    /** The inspection related to the inspection ID. */
    inspection: InspectionDto | undefined;
    /** Whether historical condition access is allowed. */
    historicalConditionAccess: boolean;
}

/** Dto for InspectionQualityAssuranceLevel */
export class InspectionQualityAssuranceLevelDto implements IInspectionQualityAssuranceLevelDto {
    id!: number;
    /** Identifier of the Inspection that the user's QC Percentage is being overidden for */
    inspectionId!: number;
    /** Identifier of the User that QC Percentage is being overidden for */
    userId!: number;
    /** The Name of the User that QC Percentage is being overidden for */
    userName!: string | undefined;
    /** The new QC Percentage value */
    qcPercentage!: number | undefined;

    constructor(data?: IInspectionQualityAssuranceLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.qcPercentage = _data["qcPercentage"];
        }
    }

    static fromJS(data: any): InspectionQualityAssuranceLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionQualityAssuranceLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["qcPercentage"] = this.qcPercentage;
        return data;
    }

    clone(): InspectionQualityAssuranceLevelDto {
        const json = this.toJSON();
        let result = new InspectionQualityAssuranceLevelDto();
        result.init(json);
        return result;
    }
}

/** Dto for InspectionQualityAssuranceLevel */
export interface IInspectionQualityAssuranceLevelDto {
    id: number;
    /** Identifier of the Inspection that the user's QC Percentage is being overidden for */
    inspectionId: number;
    /** Identifier of the User that QC Percentage is being overidden for */
    userId: number;
    /** The Name of the User that QC Percentage is being overidden for */
    userName: string | undefined;
    /** The new QC Percentage value */
    qcPercentage: number | undefined;
}

/** This gets information about the number of poles on the inspection. */
export class InspectionStatsDto implements IInspectionStatsDto {
    /** Total number of poles in the inspection */
    totalPoleCount!: number;
    /** Number of assets on this inspection which are already inspected */
    inspectedPoleCount!: number;
    /** Number of assets on this inspection which have no images */
    imagelessPoleCount!: number;

    constructor(data?: IInspectionStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPoleCount = _data["totalPoleCount"];
            this.inspectedPoleCount = _data["inspectedPoleCount"];
            this.imagelessPoleCount = _data["imagelessPoleCount"];
        }
    }

    static fromJS(data: any): InspectionStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPoleCount"] = this.totalPoleCount;
        data["inspectedPoleCount"] = this.inspectedPoleCount;
        data["imagelessPoleCount"] = this.imagelessPoleCount;
        return data;
    }

    clone(): InspectionStatsDto {
        const json = this.toJSON();
        let result = new InspectionStatsDto();
        result.init(json);
        return result;
    }
}

/** This gets information about the number of poles on the inspection. */
export interface IInspectionStatsDto {
    /** Total number of poles in the inspection */
    totalPoleCount: number;
    /** Number of assets on this inspection which are already inspected */
    inspectedPoleCount: number;
    /** Number of assets on this inspection which have no images */
    imagelessPoleCount: number;
}

/** Dto for Inspection Status */
export class InspectionStatusDto implements IInspectionStatusDto {
    id!: number;
    /** Name of the Inspection Status */
    name!: string | undefined;

    constructor(data?: IInspectionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InspectionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): InspectionStatusDto {
        const json = this.toJSON();
        let result = new InspectionStatusDto();
        result.init(json);
        return result;
    }
}

/** Dto for Inspection Status */
export interface IInspectionStatusDto {
    id: number;
    /** Name of the Inspection Status */
    name: string | undefined;
}

export class InspectionStatusDtoPagedResultDto implements IInspectionStatusDtoPagedResultDto {
    items!: InspectionStatusDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInspectionStatusDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InspectionStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InspectionStatusDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStatusDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InspectionStatusDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InspectionStatusDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionStatusDtoPagedResultDto {
    items: InspectionStatusDto[] | undefined;
    totalCount: number;
}

/** Dto for Inspection Storage Container Info */
export class InspectionStorageContainerInfoDto implements IInspectionStorageContainerInfoDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    container!: string | undefined;

    constructor(data?: IInspectionStorageContainerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.container = _data["container"];
        }
    }

    static fromJS(data: any): InspectionStorageContainerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStorageContainerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["container"] = this.container;
        return data;
    }

    clone(): InspectionStorageContainerInfoDto {
        const json = this.toJSON();
        let result = new InspectionStorageContainerInfoDto();
        result.init(json);
        return result;
    }
}

/** Dto for Inspection Storage Container Info */
export interface IInspectionStorageContainerInfoDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    container: string | undefined;
}

/** Dto for InspectionToComputerVisionModel */
export class InspectionToComputerVisionModelDto implements IInspectionToComputerVisionModelDto {
    id!: number;
    /** The id of the associated inspection */
    inspectionId!: number;
    /** The associated inspection */
    inspection!: InspectionDto | undefined;
    /** The id of the associated computer vision model */
    computerVisionModelId!: number;
    /** The associated computer vision model */
    computerVisionModel!: ComputerVisionModelDto | undefined;

    constructor(data?: IInspectionToComputerVisionModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.computerVisionModel = _data["computerVisionModel"] ? ComputerVisionModelDto.fromJS(_data["computerVisionModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InspectionToComputerVisionModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionToComputerVisionModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["computerVisionModel"] = this.computerVisionModel ? this.computerVisionModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): InspectionToComputerVisionModelDto {
        const json = this.toJSON();
        let result = new InspectionToComputerVisionModelDto();
        result.init(json);
        return result;
    }
}

/** Dto for InspectionToComputerVisionModel */
export interface IInspectionToComputerVisionModelDto {
    id: number;
    /** The id of the associated inspection */
    inspectionId: number;
    /** The associated inspection */
    inspection: InspectionDto | undefined;
    /** The id of the associated computer vision model */
    computerVisionModelId: number;
    /** The associated computer vision model */
    computerVisionModel: ComputerVisionModelDto | undefined;
}

/** Dto for Inspection Type */
export class InspectionTypeDto implements IInspectionTypeDto {
    id!: number;
    /** Name of the Inspection Type */
    name!: string | undefined;
    /** The default distance radius (in meters) used for checking whether an image
should be associated to an asset. */
    defaultImageAssociationRadius!: number;

    constructor(data?: IInspectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultImageAssociationRadius = _data["defaultImageAssociationRadius"];
        }
    }

    static fromJS(data: any): InspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultImageAssociationRadius"] = this.defaultImageAssociationRadius;
        return data;
    }

    clone(): InspectionTypeDto {
        const json = this.toJSON();
        let result = new InspectionTypeDto();
        result.init(json);
        return result;
    }
}

/** Dto for Inspection Type */
export interface IInspectionTypeDto {
    id: number;
    /** Name of the Inspection Type */
    name: string | undefined;
    /** The default distance radius (in meters) used for checking whether an image
should be associated to an asset. */
    defaultImageAssociationRadius: number;
}

export class InspectionTypeDtoPagedResultDto implements IInspectionTypeDtoPagedResultDto {
    items!: InspectionTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInspectionTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InspectionTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InspectionTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InspectionTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InspectionTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionTypeDtoPagedResultDto {
    items: InspectionTypeDto[] | undefined;
    totalCount: number;
}

export class InventoryItemBoundingBoxDto implements IInventoryItemBoundingBoxDto {
    id!: number;
    /** X position for the top-left corner of this box */
    x!: number;
    /** Y position for the top-left corner of this box */
    y!: number;
    /** Width of this box */
    width!: number;
    /** Height of this box */
    height!: number;
    /** Z-Index order for this bounding box on the image */
    zIndex!: number;
    /** The id of the related PredictedBoundingBox to this bounding box */
    predictedBoundingBoxId!: number | undefined;
    /** Identifier of the related ImageToInventoryItem object */
    imageToInventoryItemId!: number;
    /** The ImageToInventoryItem that this bounding box represents */
    imageToInventoryItem!: ImageToInventoryItemDto | undefined;

    constructor(data?: IInventoryItemBoundingBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.zIndex = _data["zIndex"];
            this.predictedBoundingBoxId = _data["predictedBoundingBoxId"];
            this.imageToInventoryItemId = _data["imageToInventoryItemId"];
            this.imageToInventoryItem = _data["imageToInventoryItem"] ? ImageToInventoryItemDto.fromJS(_data["imageToInventoryItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryItemBoundingBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemBoundingBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["zIndex"] = this.zIndex;
        data["predictedBoundingBoxId"] = this.predictedBoundingBoxId;
        data["imageToInventoryItemId"] = this.imageToInventoryItemId;
        data["imageToInventoryItem"] = this.imageToInventoryItem ? this.imageToInventoryItem.toJSON() : <any>undefined;
        return data;
    }

    clone(): InventoryItemBoundingBoxDto {
        const json = this.toJSON();
        let result = new InventoryItemBoundingBoxDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemBoundingBoxDto {
    id: number;
    /** X position for the top-left corner of this box */
    x: number;
    /** Y position for the top-left corner of this box */
    y: number;
    /** Width of this box */
    width: number;
    /** Height of this box */
    height: number;
    /** Z-Index order for this bounding box on the image */
    zIndex: number;
    /** The id of the related PredictedBoundingBox to this bounding box */
    predictedBoundingBoxId: number | undefined;
    /** Identifier of the related ImageToInventoryItem object */
    imageToInventoryItemId: number;
    /** The ImageToInventoryItem that this bounding box represents */
    imageToInventoryItem: ImageToInventoryItemDto | undefined;
}

/** DTO for InventoryItem */
export class InventoryItemDto implements IInventoryItemDto {
    id!: number;
    /** ID of the Tenant Inventory Item belongs to */
    tenantId!: number;
    /** String describing the item type in inventory on the asset */
    itemType!: string | undefined;
    /** String describing the type of the inventory item */
    type!: string | undefined;
    /** The number of instances of the inventory item on the asset */
    quantity!: number;
    /** Comments regarding the Inventory item */
    comments!: string | undefined;
    /** Identifier of the related Asset */
    assetId!: number | undefined;
    /** Identifier of the related Inspection */
    inspectionId!: number | undefined;
    /** Flag indicating if this entity is soft-deleted */
    isDeleted!: boolean;
    /** The number of bounding boxes associated with this inventory item */
    boundingBoxCount!: number;
    /** The related circuits */
    circuits!: CircuitDto[] | undefined;
    /** The related images */
    images!: ImageDto[] | undefined;
    /** List of bounding boxes related to the inventory item */
    boundingBoxes!: BoundingBoxDto[] | undefined;
    /** List of image-to-inventory-items */
    imageToInventoryItems!: ImageToInventoryItemDto[] | undefined;
    /** The associated inventory item quality assurance note */
    inventoryItemQualityAssuranceNote!: InventoryItemQualityAssuranceNoteDto | undefined;

    constructor(data?: IInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.quantity = _data["quantity"];
            this.comments = _data["comments"];
            this.assetId = _data["assetId"];
            this.inspectionId = _data["inspectionId"];
            this.isDeleted = _data["isDeleted"];
            this.boundingBoxCount = _data["boundingBoxCount"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["boundingBoxes"])) {
                this.boundingBoxes = [] as any;
                for (let item of _data["boundingBoxes"])
                    this.boundingBoxes!.push(BoundingBoxDto.fromJS(item));
            }
            if (Array.isArray(_data["imageToInventoryItems"])) {
                this.imageToInventoryItems = [] as any;
                for (let item of _data["imageToInventoryItems"])
                    this.imageToInventoryItems!.push(ImageToInventoryItemDto.fromJS(item));
            }
            this.inventoryItemQualityAssuranceNote = _data["inventoryItemQualityAssuranceNote"] ? InventoryItemQualityAssuranceNoteDto.fromJS(_data["inventoryItemQualityAssuranceNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["quantity"] = this.quantity;
        data["comments"] = this.comments;
        data["assetId"] = this.assetId;
        data["inspectionId"] = this.inspectionId;
        data["isDeleted"] = this.isDeleted;
        data["boundingBoxCount"] = this.boundingBoxCount;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.boundingBoxes)) {
            data["boundingBoxes"] = [];
            for (let item of this.boundingBoxes)
                data["boundingBoxes"].push(item.toJSON());
        }
        if (Array.isArray(this.imageToInventoryItems)) {
            data["imageToInventoryItems"] = [];
            for (let item of this.imageToInventoryItems)
                data["imageToInventoryItems"].push(item.toJSON());
        }
        data["inventoryItemQualityAssuranceNote"] = this.inventoryItemQualityAssuranceNote ? this.inventoryItemQualityAssuranceNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): InventoryItemDto {
        const json = this.toJSON();
        let result = new InventoryItemDto();
        result.init(json);
        return result;
    }
}

/** DTO for InventoryItem */
export interface IInventoryItemDto {
    id: number;
    /** ID of the Tenant Inventory Item belongs to */
    tenantId: number;
    /** String describing the item type in inventory on the asset */
    itemType: string | undefined;
    /** String describing the type of the inventory item */
    type: string | undefined;
    /** The number of instances of the inventory item on the asset */
    quantity: number;
    /** Comments regarding the Inventory item */
    comments: string | undefined;
    /** Identifier of the related Asset */
    assetId: number | undefined;
    /** Identifier of the related Inspection */
    inspectionId: number | undefined;
    /** Flag indicating if this entity is soft-deleted */
    isDeleted: boolean;
    /** The number of bounding boxes associated with this inventory item */
    boundingBoxCount: number;
    /** The related circuits */
    circuits: CircuitDto[] | undefined;
    /** The related images */
    images: ImageDto[] | undefined;
    /** List of bounding boxes related to the inventory item */
    boundingBoxes: BoundingBoxDto[] | undefined;
    /** List of image-to-inventory-items */
    imageToInventoryItems: ImageToInventoryItemDto[] | undefined;
    /** The associated inventory item quality assurance note */
    inventoryItemQualityAssuranceNote: InventoryItemQualityAssuranceNoteDto | undefined;
}

export class InventoryItemQualityAssuranceNoteDto implements IInventoryItemQualityAssuranceNoteDto {
    id!: number;
    /** The id of the inventoryItem to which this note applies */
    inventoryItemId!: number;
    /** The notes for this InventoryItemQualityAssuranceNote. This should contain
information on why the related InventoryItem was given a specific QC status. */
    notes!: string | undefined;
    /** Flag indicating if the qa note is deleted */
    isDeleted!: boolean;

    constructor(data?: IInventoryItemQualityAssuranceNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inventoryItemId = _data["inventoryItemId"];
            this.notes = _data["notes"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): InventoryItemQualityAssuranceNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemQualityAssuranceNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inventoryItemId"] = this.inventoryItemId;
        data["notes"] = this.notes;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): InventoryItemQualityAssuranceNoteDto {
        const json = this.toJSON();
        let result = new InventoryItemQualityAssuranceNoteDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemQualityAssuranceNoteDto {
    id: number;
    /** The id of the inventoryItem to which this note applies */
    inventoryItemId: number;
    /** The notes for this InventoryItemQualityAssuranceNote. This should contain
information on why the related InventoryItem was given a specific QC status. */
    notes: string | undefined;
    /** Flag indicating if the qa note is deleted */
    isDeleted: boolean;
}

/** Dto for Inventory Suggestions */
export class InventorySuggestionDto implements IInventorySuggestionDto {
    /** Identifer of the Type (from priority matrix) for this InventorySuggestion */
    typeId!: number;
    /** The suggested Inventory Item Type */
    itemType!: string | undefined;
    /** The suggested Inventory Type */
    type!: string | undefined;

    constructor(data?: IInventorySuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InventorySuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventorySuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        return data;
    }

    clone(): InventorySuggestionDto {
        const json = this.toJSON();
        let result = new InventorySuggestionDto();
        result.init(json);
        return result;
    }
}

/** Dto for Inventory Suggestions */
export interface IInventorySuggestionDto {
    /** Identifer of the Type (from priority matrix) for this InventorySuggestion */
    typeId: number;
    /** The suggested Inventory Item Type */
    itemType: string | undefined;
    /** The suggested Inventory Type */
    type: string | undefined;
}

/** Dto for Irrelevant Image */
export class IrrelevantImageDto implements IIrrelevantImageDto {
    id!: number;
    /** Tenant image belongs to */
    tenantId!: number;
    /** Asset this image belongs to */
    assetId!: number | undefined;
    /** Id of the inspection */
    inspectionId!: number;
    /** The Asset that the image belongs to. */
    asset!: WBAssetDto | undefined;
    /** Url of the image */
    imageUrl!: string | undefined;
    /** Url of the compressed image */
    compressedImageUrl!: string | undefined;
    /** Compressed file size of the image */
    compressedFileSize!: number | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl!: string | undefined;
    /** Size of the image file in bytes. */
    fileSize!: number | undefined;
    /** Flag for Deletion (Irrelevancy) of the Image */
    isDeleted!: boolean;
    /** Specifies whether this Image is a panorama. */
    isPanorama!: boolean;

    constructor(data?: IIrrelevantImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.assetId = _data["assetId"];
            this.inspectionId = _data["inspectionId"];
            this.asset = _data["asset"] ? WBAssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
            this.compressedImageUrl = _data["compressedImageUrl"];
            this.compressedFileSize = _data["compressedFileSize"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.fileSize = _data["fileSize"];
            this.isDeleted = _data["isDeleted"];
            this.isPanorama = _data["isPanorama"];
        }
    }

    static fromJS(data: any): IrrelevantImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new IrrelevantImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["assetId"] = this.assetId;
        data["inspectionId"] = this.inspectionId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        data["compressedImageUrl"] = this.compressedImageUrl;
        data["compressedFileSize"] = this.compressedFileSize;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["fileSize"] = this.fileSize;
        data["isDeleted"] = this.isDeleted;
        data["isPanorama"] = this.isPanorama;
        return data;
    }

    clone(): IrrelevantImageDto {
        const json = this.toJSON();
        let result = new IrrelevantImageDto();
        result.init(json);
        return result;
    }
}

/** Dto for Irrelevant Image */
export interface IIrrelevantImageDto {
    id: number;
    /** Tenant image belongs to */
    tenantId: number;
    /** Asset this image belongs to */
    assetId: number | undefined;
    /** Id of the inspection */
    inspectionId: number;
    /** The Asset that the image belongs to. */
    asset: WBAssetDto | undefined;
    /** Url of the image */
    imageUrl: string | undefined;
    /** Url of the compressed image */
    compressedImageUrl: string | undefined;
    /** Compressed file size of the image */
    compressedFileSize: number | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl: string | undefined;
    /** Size of the image file in bytes. */
    fileSize: number | undefined;
    /** Flag for Deletion (Irrelevancy) of the Image */
    isDeleted: boolean;
    /** Specifies whether this Image is a panorama. */
    isPanorama: boolean;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class LineString implements ILineString {
    readonly factory!: GeometryFactory | undefined;
    userData!: any | undefined;
    srid!: number;
    readonly precisionModel!: PrecisionModel | undefined;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly area!: number;
    readonly centroid!: Point | undefined;
    readonly interiorPoint!: Point | undefined;
    readonly pointOnSurface!: Point | undefined;
    readonly envelope!: Geometry | undefined;
    readonly envelopeInternal!: Envelope | undefined;
    readonly isRectangle!: boolean;
    readonly coordinates!: Coordinate[] | undefined;
    readonly coordinateSequence!: CoordinateSequence | undefined;
    readonly coordinate!: Coordinate | undefined;
    readonly dimension!: Dimension;
    readonly boundaryDimension!: Dimension;
    readonly isEmpty!: boolean;
    readonly numPoints!: number;
    readonly startPoint!: Point | undefined;
    readonly endPoint!: Point | undefined;
    readonly isClosed!: boolean;
    readonly isRing!: boolean;
    readonly geometryType!: string | undefined;
    readonly ogcGeometryType!: OgcGeometryType;
    readonly length!: number;
    readonly boundary!: Geometry | undefined;
    readonly count!: number;

    constructor(data?: ILineString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).area = _data["area"];
            (<any>this).centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            (<any>this).interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            (<any>this).pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            (<any>this).envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            (<any>this).envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            (<any>this).coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            (<any>this).dimension = _data["dimension"];
            (<any>this).boundaryDimension = _data["boundaryDimension"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).startPoint = _data["startPoint"] ? Point.fromJS(_data["startPoint"]) : <any>undefined;
            (<any>this).endPoint = _data["endPoint"] ? Point.fromJS(_data["endPoint"]) : <any>undefined;
            (<any>this).isClosed = _data["isClosed"];
            (<any>this).isRing = _data["isRing"];
            (<any>this).geometryType = _data["geometryType"];
            (<any>this).ogcGeometryType = _data["ogcGeometryType"];
            (<any>this).length = _data["length"];
            (<any>this).boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            (<any>this).count = _data["count"];
        }
    }

    static fromJS(data: any): LineString {
        data = typeof data === 'object' ? data : {};
        let result = new LineString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["area"] = this.area;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["isEmpty"] = this.isEmpty;
        data["numPoints"] = this.numPoints;
        data["startPoint"] = this.startPoint ? this.startPoint.toJSON() : <any>undefined;
        data["endPoint"] = this.endPoint ? this.endPoint.toJSON() : <any>undefined;
        data["isClosed"] = this.isClosed;
        data["isRing"] = this.isRing;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["length"] = this.length;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }

    clone(): LineString {
        const json = this.toJSON();
        let result = new LineString();
        result.init(json);
        return result;
    }
}

export interface ILineString {
    factory: GeometryFactory | undefined;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel | undefined;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    area: number;
    centroid: Point | undefined;
    interiorPoint: Point | undefined;
    pointOnSurface: Point | undefined;
    envelope: Geometry | undefined;
    envelopeInternal: Envelope | undefined;
    isRectangle: boolean;
    coordinates: Coordinate[] | undefined;
    coordinateSequence: CoordinateSequence | undefined;
    coordinate: Coordinate | undefined;
    dimension: Dimension;
    boundaryDimension: Dimension;
    isEmpty: boolean;
    numPoints: number;
    startPoint: Point | undefined;
    endPoint: Point | undefined;
    isClosed: boolean;
    isRing: boolean;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    length: number;
    boundary: Geometry | undefined;
    count: number;
}

export class LinearRing implements ILinearRing {
    readonly factory!: GeometryFactory | undefined;
    userData!: any | undefined;
    srid!: number;
    readonly precisionModel!: PrecisionModel | undefined;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly area!: number;
    readonly centroid!: Point | undefined;
    readonly interiorPoint!: Point | undefined;
    readonly pointOnSurface!: Point | undefined;
    readonly envelope!: Geometry | undefined;
    readonly envelopeInternal!: Envelope | undefined;
    readonly isRectangle!: boolean;
    readonly coordinates!: Coordinate[] | undefined;
    readonly coordinateSequence!: CoordinateSequence | undefined;
    readonly coordinate!: Coordinate | undefined;
    readonly dimension!: Dimension;
    readonly isEmpty!: boolean;
    readonly numPoints!: number;
    readonly startPoint!: Point | undefined;
    readonly endPoint!: Point | undefined;
    readonly isRing!: boolean;
    readonly ogcGeometryType!: OgcGeometryType;
    readonly length!: number;
    readonly boundary!: Geometry | undefined;
    readonly count!: number;
    readonly boundaryDimension!: Dimension;
    readonly isClosed!: boolean;
    readonly geometryType!: string | undefined;
    readonly isCCW!: boolean;

    constructor(data?: ILinearRing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).area = _data["area"];
            (<any>this).centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            (<any>this).interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            (<any>this).pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            (<any>this).envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            (<any>this).envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            (<any>this).coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            (<any>this).dimension = _data["dimension"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).startPoint = _data["startPoint"] ? Point.fromJS(_data["startPoint"]) : <any>undefined;
            (<any>this).endPoint = _data["endPoint"] ? Point.fromJS(_data["endPoint"]) : <any>undefined;
            (<any>this).isRing = _data["isRing"];
            (<any>this).ogcGeometryType = _data["ogcGeometryType"];
            (<any>this).length = _data["length"];
            (<any>this).boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            (<any>this).count = _data["count"];
            (<any>this).boundaryDimension = _data["boundaryDimension"];
            (<any>this).isClosed = _data["isClosed"];
            (<any>this).geometryType = _data["geometryType"];
            (<any>this).isCCW = _data["isCCW"];
        }
    }

    static fromJS(data: any): LinearRing {
        data = typeof data === 'object' ? data : {};
        let result = new LinearRing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["area"] = this.area;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["dimension"] = this.dimension;
        data["isEmpty"] = this.isEmpty;
        data["numPoints"] = this.numPoints;
        data["startPoint"] = this.startPoint ? this.startPoint.toJSON() : <any>undefined;
        data["endPoint"] = this.endPoint ? this.endPoint.toJSON() : <any>undefined;
        data["isRing"] = this.isRing;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["length"] = this.length;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["count"] = this.count;
        data["boundaryDimension"] = this.boundaryDimension;
        data["isClosed"] = this.isClosed;
        data["geometryType"] = this.geometryType;
        data["isCCW"] = this.isCCW;
        return data;
    }

    clone(): LinearRing {
        const json = this.toJSON();
        let result = new LinearRing();
        result.init(json);
        return result;
    }
}

export interface ILinearRing {
    factory: GeometryFactory | undefined;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel | undefined;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    area: number;
    centroid: Point | undefined;
    interiorPoint: Point | undefined;
    pointOnSurface: Point | undefined;
    envelope: Geometry | undefined;
    envelopeInternal: Envelope | undefined;
    isRectangle: boolean;
    coordinates: Coordinate[] | undefined;
    coordinateSequence: CoordinateSequence | undefined;
    coordinate: Coordinate | undefined;
    dimension: Dimension;
    isEmpty: boolean;
    numPoints: number;
    startPoint: Point | undefined;
    endPoint: Point | undefined;
    isRing: boolean;
    ogcGeometryType: OgcGeometryType;
    length: number;
    boundary: Geometry | undefined;
    count: number;
    boundaryDimension: Dimension;
    isClosed: boolean;
    geometryType: string | undefined;
    isCCW: boolean;
}

export class LinkDto implements ILinkDto {
    id!: number;
    /** DateTime at which the Report entry was created */
    creationTime!: moment.Moment;
    /** Name of the Report file */
    name!: string;
    /** Description of the Report */
    description!: string;
    /** Identifier for the Inspection related to the Report */
    inspectionId!: number;
    /** The url for this Link. */
    url!: string;
    /** The embeddable flag for this link */
    isUrlEmbeddable!: boolean;

    constructor(data?: ILinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.inspectionId = _data["inspectionId"];
            this.url = _data["url"];
            this.isUrlEmbeddable = _data["isUrlEmbeddable"];
        }
    }

    static fromJS(data: any): LinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["inspectionId"] = this.inspectionId;
        data["url"] = this.url;
        data["isUrlEmbeddable"] = this.isUrlEmbeddable;
        return data;
    }

    clone(): LinkDto {
        const json = this.toJSON();
        let result = new LinkDto();
        result.init(json);
        return result;
    }
}

export interface ILinkDto {
    id: number;
    /** DateTime at which the Report entry was created */
    creationTime: moment.Moment;
    /** Name of the Report file */
    name: string;
    /** Description of the Report */
    description: string;
    /** Identifier for the Inspection related to the Report */
    inspectionId: number;
    /** The url for this Link. */
    url: string;
    /** The embeddable flag for this link */
    isUrlEmbeddable: boolean;
}

/** MapAssetPullDto represents the customer and image objects to be pulled to a given asset */
export class MapAssetPullDto implements IMapAssetPullDto {
    /** List of Image identifiers to be pulled to the given asset */
    imagesToPull!: number[] | undefined;
    /** (Optional) Only for use when pulling to a pole. List of identifiers of customer assets which are in the
selected area where the closest one can be pulled. May not always be the closest customer asset to the pole. */
    unassociatedAssetList!: number[] | undefined;
    /** Whether data is being pulled to a span */
    isSpan!: boolean;

    constructor(data?: IMapAssetPullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imagesToPull"])) {
                this.imagesToPull = [] as any;
                for (let item of _data["imagesToPull"])
                    this.imagesToPull!.push(item);
            }
            if (Array.isArray(_data["unassociatedAssetList"])) {
                this.unassociatedAssetList = [] as any;
                for (let item of _data["unassociatedAssetList"])
                    this.unassociatedAssetList!.push(item);
            }
            this.isSpan = _data["isSpan"];
        }
    }

    static fromJS(data: any): MapAssetPullDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapAssetPullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imagesToPull)) {
            data["imagesToPull"] = [];
            for (let item of this.imagesToPull)
                data["imagesToPull"].push(item);
        }
        if (Array.isArray(this.unassociatedAssetList)) {
            data["unassociatedAssetList"] = [];
            for (let item of this.unassociatedAssetList)
                data["unassociatedAssetList"].push(item);
        }
        data["isSpan"] = this.isSpan;
        return data;
    }

    clone(): MapAssetPullDto {
        const json = this.toJSON();
        let result = new MapAssetPullDto();
        result.init(json);
        return result;
    }
}

/** MapAssetPullDto represents the customer and image objects to be pulled to a given asset */
export interface IMapAssetPullDto {
    /** List of Image identifiers to be pulled to the given asset */
    imagesToPull: number[] | undefined;
    /** (Optional) Only for use when pulling to a pole. List of identifiers of customer assets which are in the
selected area where the closest one can be pulled. May not always be the closest customer asset to the pole. */
    unassociatedAssetList: number[] | undefined;
    /** Whether data is being pulled to a span */
    isSpan: boolean;
}

/** Minimal Dto that returns only the data necessary to display the image on the map. */
export class MapImageDto implements IMapImageDto {
    id!: number;
    /** Asset this image belongs to */
    assetId!: number | undefined;
    /** True if the image url is not null, false otherwise. */
    hasImageUrl!: boolean;
    /** Url of the image */
    imageUrl!: string | undefined;
    /** Size of the image file in bytes. */
    fileSize!: number | undefined;
    /** Url of the compressed image */
    compressedImageUrl!: string | undefined;
    /** Compressed file size of the image */
    compressedFileSize!: number | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl!: string | undefined;
    /** Local Directory name at which the Image resides when its metadata information was pulled */
    localDirectory!: string | undefined;
    /** Name of the File at the Local Directory provided from which image metadata information was pulled */
    fileName!: string | undefined;
    /** Latitude */
    latitude!: number;
    /** Longitude */
    longitude!: number;
    /** The distance from which this image was taken in relation to its associated inspection to asset. */
    distanceTakenFromAsset!: number | undefined;
    /** Gimbal Yaw Degree (the angle the camera was at when the image was taken) */
    gimbalYawDegree!: number | undefined;
    /** Boolean flag indicating whether or not the Image should be audited */
    shouldBeAudited!: boolean;
    /** String message used to describe the reason why the image should be audited */
    auditReason!: string | undefined;
    /** The Type of Audit Reason related to this Image */
    auditReasonType!: AuditReasonType | undefined;
    /** Specifies whether this Image is a panorama. */
    isPanorama!: boolean;
    /** Flag determining whether the image should be displayed as a transparent (filtered out) ghost image */
    isGhost!: boolean;

    constructor(data?: IMapImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.hasImageUrl = _data["hasImageUrl"];
            this.imageUrl = _data["imageUrl"];
            this.fileSize = _data["fileSize"];
            this.compressedImageUrl = _data["compressedImageUrl"];
            this.compressedFileSize = _data["compressedFileSize"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.localDirectory = _data["localDirectory"];
            this.fileName = _data["fileName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.distanceTakenFromAsset = _data["distanceTakenFromAsset"];
            this.gimbalYawDegree = _data["gimbalYawDegree"];
            this.shouldBeAudited = _data["shouldBeAudited"];
            this.auditReason = _data["auditReason"];
            this.auditReasonType = _data["auditReasonType"] ? AuditReasonType.fromJS(_data["auditReasonType"]) : <any>undefined;
            this.isPanorama = _data["isPanorama"];
            this.isGhost = _data["isGhost"];
        }
    }

    static fromJS(data: any): MapImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["hasImageUrl"] = this.hasImageUrl;
        data["imageUrl"] = this.imageUrl;
        data["fileSize"] = this.fileSize;
        data["compressedImageUrl"] = this.compressedImageUrl;
        data["compressedFileSize"] = this.compressedFileSize;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["localDirectory"] = this.localDirectory;
        data["fileName"] = this.fileName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["distanceTakenFromAsset"] = this.distanceTakenFromAsset;
        data["gimbalYawDegree"] = this.gimbalYawDegree;
        data["shouldBeAudited"] = this.shouldBeAudited;
        data["auditReason"] = this.auditReason;
        data["auditReasonType"] = this.auditReasonType ? this.auditReasonType.toJSON() : <any>undefined;
        data["isPanorama"] = this.isPanorama;
        data["isGhost"] = this.isGhost;
        return data;
    }

    clone(): MapImageDto {
        const json = this.toJSON();
        let result = new MapImageDto();
        result.init(json);
        return result;
    }
}

/** Minimal Dto that returns only the data necessary to display the image on the map. */
export interface IMapImageDto {
    id: number;
    /** Asset this image belongs to */
    assetId: number | undefined;
    /** True if the image url is not null, false otherwise. */
    hasImageUrl: boolean;
    /** Url of the image */
    imageUrl: string | undefined;
    /** Size of the image file in bytes. */
    fileSize: number | undefined;
    /** Url of the compressed image */
    compressedImageUrl: string | undefined;
    /** Compressed file size of the image */
    compressedFileSize: number | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl: string | undefined;
    /** Local Directory name at which the Image resides when its metadata information was pulled */
    localDirectory: string | undefined;
    /** Name of the File at the Local Directory provided from which image metadata information was pulled */
    fileName: string | undefined;
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
    /** The distance from which this image was taken in relation to its associated inspection to asset. */
    distanceTakenFromAsset: number | undefined;
    /** Gimbal Yaw Degree (the angle the camera was at when the image was taken) */
    gimbalYawDegree: number | undefined;
    /** Boolean flag indicating whether or not the Image should be audited */
    shouldBeAudited: boolean;
    /** String message used to describe the reason why the image should be audited */
    auditReason: string | undefined;
    /** The Type of Audit Reason related to this Image */
    auditReasonType: AuditReasonType | undefined;
    /** Specifies whether this Image is a panorama. */
    isPanorama: boolean;
    /** Flag determining whether the image should be displayed as a transparent (filtered out) ghost image */
    isGhost: boolean;
}

/** MapAssetDto represents a data structure for the information needed to display an asset on the map. */
export class MapPoleDto implements IMapPoleDto {
    id!: number;
    /** Facility Id of the asset. */
    facilityId!: string | undefined;
    /** The human-readable address of the asset. */
    address!: string | undefined;
    /** Latitude of the location of the asset. */
    latitude!: number | undefined;
    /** Longitude of the location of the asset. */
    longitude!: number | undefined;
    /** Latitude of the customer location of the asset. */
    customerLatitude!: number | undefined;
    /** Longitude of the customer location of the asset. */
    customerLongitude!: number | undefined;
    /** JSON column containing custom information */
    customProperties!: string | undefined;
    /** Flag determining whether the pole has been inspected on the inspection the map has been queried for */
    isInspected!: boolean;
    /** Determines whether this pole has Inspected GPS coordinates.
This should be set based on the value pulled from an InspectionToAsset that is pertinent to the inspection this DTO is being loaded for. */
    hasInspectedGPS!: boolean;
    /** Determines whether this pole has Customer GPS coordinates */
    readonly hasCustomerGPS!: boolean;
    /** Determines whether this asset has address info (i.e. not a null or whitespace address
or the "Address not found for this location." that is returned from the AddressFinder. */
    hasAddressInfo!: boolean;
    /** Id of Analysis Status of this Pole */
    analysisStatusId!: number | undefined;
    /** Number of Images related to the pole on the inspection the map has been queried for */
    imageCount!: number;
    /** Flag determining whether the pole should be displayed as a transparent (filtered out) ghost pole */
    isGhost!: boolean;

    constructor(data?: IMapPoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.facilityId = _data["facilityId"];
            this.address = _data["address"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.customerLatitude = _data["customerLatitude"];
            this.customerLongitude = _data["customerLongitude"];
            this.customProperties = _data["customProperties"];
            this.isInspected = _data["isInspected"];
            this.hasInspectedGPS = _data["hasInspectedGPS"];
            (<any>this).hasCustomerGPS = _data["hasCustomerGPS"];
            this.hasAddressInfo = _data["hasAddressInfo"];
            this.analysisStatusId = _data["analysisStatusId"];
            this.imageCount = _data["imageCount"];
            this.isGhost = _data["isGhost"];
        }
    }

    static fromJS(data: any): MapPoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapPoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facilityId"] = this.facilityId;
        data["address"] = this.address;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["customerLatitude"] = this.customerLatitude;
        data["customerLongitude"] = this.customerLongitude;
        data["customProperties"] = this.customProperties;
        data["isInspected"] = this.isInspected;
        data["hasInspectedGPS"] = this.hasInspectedGPS;
        data["hasCustomerGPS"] = this.hasCustomerGPS;
        data["hasAddressInfo"] = this.hasAddressInfo;
        data["analysisStatusId"] = this.analysisStatusId;
        data["imageCount"] = this.imageCount;
        data["isGhost"] = this.isGhost;
        return data;
    }

    clone(): MapPoleDto {
        const json = this.toJSON();
        let result = new MapPoleDto();
        result.init(json);
        return result;
    }
}

/** MapAssetDto represents a data structure for the information needed to display an asset on the map. */
export interface IMapPoleDto {
    id: number;
    /** Facility Id of the asset. */
    facilityId: string | undefined;
    /** The human-readable address of the asset. */
    address: string | undefined;
    /** Latitude of the location of the asset. */
    latitude: number | undefined;
    /** Longitude of the location of the asset. */
    longitude: number | undefined;
    /** Latitude of the customer location of the asset. */
    customerLatitude: number | undefined;
    /** Longitude of the customer location of the asset. */
    customerLongitude: number | undefined;
    /** JSON column containing custom information */
    customProperties: string | undefined;
    /** Flag determining whether the pole has been inspected on the inspection the map has been queried for */
    isInspected: boolean;
    /** Determines whether this pole has Inspected GPS coordinates.
This should be set based on the value pulled from an InspectionToAsset that is pertinent to the inspection this DTO is being loaded for. */
    hasInspectedGPS: boolean;
    /** Determines whether this pole has Customer GPS coordinates */
    hasCustomerGPS: boolean;
    /** Determines whether this asset has address info (i.e. not a null or whitespace address
or the "Address not found for this location." that is returned from the AddressFinder. */
    hasAddressInfo: boolean;
    /** Id of Analysis Status of this Pole */
    analysisStatusId: number | undefined;
    /** Number of Images related to the pole on the inspection the map has been queried for */
    imageCount: number;
    /** Flag determining whether the pole should be displayed as a transparent (filtered out) ghost pole */
    isGhost: boolean;
}

/** The filters with which to search for poles on the asset map. */
export class MapPoleFilterDto implements IMapPoleFilterDto {
    /** Filter for the Facility ID of the assets in the inspection */
    facilityId!: string | undefined;
    /** Filter for Assets that have internal Asset GPS and Customer GPS distance that exceeds the number of meters */
    minExcessiveAssetInternalDistance!: number | undefined;
    /** Filter for Assets that are within the the given number of meters from other assets */
    maxDistanceBetweenAssets!: number | undefined;
    /** Filter for the asset IDs of the inspection */
    assetId!: number | undefined;
    /** Filter for the Collector IDs of the assets in the inspection */
    collectorId!: string | undefined;
    /** Filter for the custom properties of the assets in the inspection */
    customPropertiesDictionary!: { [key: string]: string; } | undefined;
    /** Filter for the audit reason types on images on assets in the inspection */
    auditReasonTypes!: number[] | undefined;
    /** Filter for whether images on assets on an inspection have audit notes */
    hasAuditNotes!: boolean;
    /** Filter for the analysis status on assets in the inspection */
    analysisStatuses!: number[] | undefined;

    constructor(data?: IMapPoleFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.minExcessiveAssetInternalDistance = _data["minExcessiveAssetInternalDistance"];
            this.maxDistanceBetweenAssets = _data["maxDistanceBetweenAssets"];
            this.assetId = _data["assetId"];
            this.collectorId = _data["collectorId"];
            if (_data["customPropertiesDictionary"]) {
                this.customPropertiesDictionary = {} as any;
                for (let key in _data["customPropertiesDictionary"]) {
                    if (_data["customPropertiesDictionary"].hasOwnProperty(key))
                        (<any>this.customPropertiesDictionary)![key] = _data["customPropertiesDictionary"][key];
                }
            }
            if (Array.isArray(_data["auditReasonTypes"])) {
                this.auditReasonTypes = [] as any;
                for (let item of _data["auditReasonTypes"])
                    this.auditReasonTypes!.push(item);
            }
            this.hasAuditNotes = _data["hasAuditNotes"];
            if (Array.isArray(_data["analysisStatuses"])) {
                this.analysisStatuses = [] as any;
                for (let item of _data["analysisStatuses"])
                    this.analysisStatuses!.push(item);
            }
        }
    }

    static fromJS(data: any): MapPoleFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapPoleFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["minExcessiveAssetInternalDistance"] = this.minExcessiveAssetInternalDistance;
        data["maxDistanceBetweenAssets"] = this.maxDistanceBetweenAssets;
        data["assetId"] = this.assetId;
        data["collectorId"] = this.collectorId;
        if (this.customPropertiesDictionary) {
            data["customPropertiesDictionary"] = {};
            for (let key in this.customPropertiesDictionary) {
                if (this.customPropertiesDictionary.hasOwnProperty(key))
                    (<any>data["customPropertiesDictionary"])[key] = (<any>this.customPropertiesDictionary)[key];
            }
        }
        if (Array.isArray(this.auditReasonTypes)) {
            data["auditReasonTypes"] = [];
            for (let item of this.auditReasonTypes)
                data["auditReasonTypes"].push(item);
        }
        data["hasAuditNotes"] = this.hasAuditNotes;
        if (Array.isArray(this.analysisStatuses)) {
            data["analysisStatuses"] = [];
            for (let item of this.analysisStatuses)
                data["analysisStatuses"].push(item);
        }
        return data;
    }

    clone(): MapPoleFilterDto {
        const json = this.toJSON();
        let result = new MapPoleFilterDto();
        result.init(json);
        return result;
    }
}

/** The filters with which to search for poles on the asset map. */
export interface IMapPoleFilterDto {
    /** Filter for the Facility ID of the assets in the inspection */
    facilityId: string | undefined;
    /** Filter for Assets that have internal Asset GPS and Customer GPS distance that exceeds the number of meters */
    minExcessiveAssetInternalDistance: number | undefined;
    /** Filter for Assets that are within the the given number of meters from other assets */
    maxDistanceBetweenAssets: number | undefined;
    /** Filter for the asset IDs of the inspection */
    assetId: number | undefined;
    /** Filter for the Collector IDs of the assets in the inspection */
    collectorId: string | undefined;
    /** Filter for the custom properties of the assets in the inspection */
    customPropertiesDictionary: { [key: string]: string; } | undefined;
    /** Filter for the audit reason types on images on assets in the inspection */
    auditReasonTypes: number[] | undefined;
    /** Filter for whether images on assets on an inspection have audit notes */
    hasAuditNotes: boolean;
    /** Filter for the analysis status on assets in the inspection */
    analysisStatuses: number[] | undefined;
}

/** DTO containing the filter result data of poles and ghost poles */
export class MapPoleFilterResultDto implements IMapPoleFilterResultDto {
    /** List of poles to display */
    poles!: MapPoleDto[] | undefined;
    /** List of ghost poles to display ghostily */
    ghostPoles!: MapPoleDto[] | undefined;

    constructor(data?: IMapPoleFilterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["poles"])) {
                this.poles = [] as any;
                for (let item of _data["poles"])
                    this.poles!.push(MapPoleDto.fromJS(item));
            }
            if (Array.isArray(_data["ghostPoles"])) {
                this.ghostPoles = [] as any;
                for (let item of _data["ghostPoles"])
                    this.ghostPoles!.push(MapPoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapPoleFilterResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapPoleFilterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.poles)) {
            data["poles"] = [];
            for (let item of this.poles)
                data["poles"].push(item.toJSON());
        }
        if (Array.isArray(this.ghostPoles)) {
            data["ghostPoles"] = [];
            for (let item of this.ghostPoles)
                data["ghostPoles"].push(item.toJSON());
        }
        return data;
    }

    clone(): MapPoleFilterResultDto {
        const json = this.toJSON();
        let result = new MapPoleFilterResultDto();
        result.init(json);
        return result;
    }
}

/** DTO containing the filter result data of poles and ghost poles */
export interface IMapPoleFilterResultDto {
    /** List of poles to display */
    poles: MapPoleDto[] | undefined;
    /** List of ghost poles to display ghostily */
    ghostPoles: MapPoleDto[] | undefined;
}

/** MapAssetDto represents a data structure for the information needed to display an asset on the map. */
export class MapSpanDto implements IMapSpanDto {
    id!: number;
    /** Facility Id of the span. */
    facilityId!: string | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId!: number | undefined;
    /** Latitude of the starting pole for the span */
    startAssetLatitude!: number;
    /** Longitude of the starting pole for the span */
    startAssetLongitude!: number;
    /** Identifier for the ending point pole for the span */
    endAssetId!: number | undefined;
    /** Latitude of the ending pole for the span */
    endAssetLatitude!: number;
    /** Longitude of the ending pole for the span */
    endAssetLongitude!: number;
    /** JSON column containing custom information */
    customProperties!: string | undefined;
    /** Flag determining whether the span should be displayed as a transparent (filtered out) ghost span */
    isGhost!: boolean;
    /** Span ids in the same span gap */
    spanIdsInGap!: number[] | undefined;

    constructor(data?: IMapSpanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.facilityId = _data["facilityId"];
            this.startAssetId = _data["startAssetId"];
            this.startAssetLatitude = _data["startAssetLatitude"];
            this.startAssetLongitude = _data["startAssetLongitude"];
            this.endAssetId = _data["endAssetId"];
            this.endAssetLatitude = _data["endAssetLatitude"];
            this.endAssetLongitude = _data["endAssetLongitude"];
            this.customProperties = _data["customProperties"];
            this.isGhost = _data["isGhost"];
            if (Array.isArray(_data["spanIdsInGap"])) {
                this.spanIdsInGap = [] as any;
                for (let item of _data["spanIdsInGap"])
                    this.spanIdsInGap!.push(item);
            }
        }
    }

    static fromJS(data: any): MapSpanDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapSpanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facilityId"] = this.facilityId;
        data["startAssetId"] = this.startAssetId;
        data["startAssetLatitude"] = this.startAssetLatitude;
        data["startAssetLongitude"] = this.startAssetLongitude;
        data["endAssetId"] = this.endAssetId;
        data["endAssetLatitude"] = this.endAssetLatitude;
        data["endAssetLongitude"] = this.endAssetLongitude;
        data["customProperties"] = this.customProperties;
        data["isGhost"] = this.isGhost;
        if (Array.isArray(this.spanIdsInGap)) {
            data["spanIdsInGap"] = [];
            for (let item of this.spanIdsInGap)
                data["spanIdsInGap"].push(item);
        }
        return data;
    }

    clone(): MapSpanDto {
        const json = this.toJSON();
        let result = new MapSpanDto();
        result.init(json);
        return result;
    }
}

/** MapAssetDto represents a data structure for the information needed to display an asset on the map. */
export interface IMapSpanDto {
    id: number;
    /** Facility Id of the span. */
    facilityId: string | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId: number | undefined;
    /** Latitude of the starting pole for the span */
    startAssetLatitude: number;
    /** Longitude of the starting pole for the span */
    startAssetLongitude: number;
    /** Identifier for the ending point pole for the span */
    endAssetId: number | undefined;
    /** Latitude of the ending pole for the span */
    endAssetLatitude: number;
    /** Longitude of the ending pole for the span */
    endAssetLongitude: number;
    /** JSON column containing custom information */
    customProperties: string | undefined;
    /** Flag determining whether the span should be displayed as a transparent (filtered out) ghost span */
    isGhost: boolean;
    /** Span ids in the same span gap */
    spanIdsInGap: number[] | undefined;
}

/** The filters with which to search for spans on the asset map. */
export class MapSpanFilterDto implements IMapSpanFilterDto {
    /** The facility ID of the inspection */
    facilityId!: string | undefined;
    /** Filter for the asset IDs of the inspection */
    assetId!: number | undefined;
    /** Filter for the Collector IDs of the assets in the inspection */
    collectorId!: string | undefined;
    /** Filter for the custom properties of the assets in the inspection */
    customPropertiesDictionary!: { [key: string]: string; } | undefined;
    /** Filter for the audit reason types on images on assets in the inspection */
    auditReasonTypes!: number[] | undefined;
    /** Filter for whether images on assets on an inspection have audit notes */
    hasAuditNotes!: boolean;

    constructor(data?: IMapSpanFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.assetId = _data["assetId"];
            this.collectorId = _data["collectorId"];
            if (_data["customPropertiesDictionary"]) {
                this.customPropertiesDictionary = {} as any;
                for (let key in _data["customPropertiesDictionary"]) {
                    if (_data["customPropertiesDictionary"].hasOwnProperty(key))
                        (<any>this.customPropertiesDictionary)![key] = _data["customPropertiesDictionary"][key];
                }
            }
            if (Array.isArray(_data["auditReasonTypes"])) {
                this.auditReasonTypes = [] as any;
                for (let item of _data["auditReasonTypes"])
                    this.auditReasonTypes!.push(item);
            }
            this.hasAuditNotes = _data["hasAuditNotes"];
        }
    }

    static fromJS(data: any): MapSpanFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapSpanFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["assetId"] = this.assetId;
        data["collectorId"] = this.collectorId;
        if (this.customPropertiesDictionary) {
            data["customPropertiesDictionary"] = {};
            for (let key in this.customPropertiesDictionary) {
                if (this.customPropertiesDictionary.hasOwnProperty(key))
                    (<any>data["customPropertiesDictionary"])[key] = (<any>this.customPropertiesDictionary)[key];
            }
        }
        if (Array.isArray(this.auditReasonTypes)) {
            data["auditReasonTypes"] = [];
            for (let item of this.auditReasonTypes)
                data["auditReasonTypes"].push(item);
        }
        data["hasAuditNotes"] = this.hasAuditNotes;
        return data;
    }

    clone(): MapSpanFilterDto {
        const json = this.toJSON();
        let result = new MapSpanFilterDto();
        result.init(json);
        return result;
    }
}

/** The filters with which to search for spans on the asset map. */
export interface IMapSpanFilterDto {
    /** The facility ID of the inspection */
    facilityId: string | undefined;
    /** Filter for the asset IDs of the inspection */
    assetId: number | undefined;
    /** Filter for the Collector IDs of the assets in the inspection */
    collectorId: string | undefined;
    /** Filter for the custom properties of the assets in the inspection */
    customPropertiesDictionary: { [key: string]: string; } | undefined;
    /** Filter for the audit reason types on images on assets in the inspection */
    auditReasonTypes: number[] | undefined;
    /** Filter for whether images on assets on an inspection have audit notes */
    hasAuditNotes: boolean;
}

/** DTO containing the filter result data of spans and ghost spans */
export class MapSpanFilterResultDto implements IMapSpanFilterResultDto {
    /** List of spans to display */
    spans!: MapSpanDto[] | undefined;
    /** List of ghost spans to display ghostily */
    ghostSpans!: MapSpanDto[] | undefined;

    constructor(data?: IMapSpanFilterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["spans"])) {
                this.spans = [] as any;
                for (let item of _data["spans"])
                    this.spans!.push(MapSpanDto.fromJS(item));
            }
            if (Array.isArray(_data["ghostSpans"])) {
                this.ghostSpans = [] as any;
                for (let item of _data["ghostSpans"])
                    this.ghostSpans!.push(MapSpanDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapSpanFilterResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapSpanFilterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.spans)) {
            data["spans"] = [];
            for (let item of this.spans)
                data["spans"].push(item.toJSON());
        }
        if (Array.isArray(this.ghostSpans)) {
            data["ghostSpans"] = [];
            for (let item of this.ghostSpans)
                data["ghostSpans"].push(item.toJSON());
        }
        return data;
    }

    clone(): MapSpanFilterResultDto {
        const json = this.toJSON();
        let result = new MapSpanFilterResultDto();
        result.init(json);
        return result;
    }
}

/** DTO containing the filter result data of spans and ghost spans */
export interface IMapSpanFilterResultDto {
    /** List of spans to display */
    spans: MapSpanDto[] | undefined;
    /** List of ghost spans to display ghostily */
    ghostSpans: MapSpanDto[] | undefined;
}

export class MappedInspectionToAssetDto implements IMappedInspectionToAssetDto {
    id!: number;
    /** Identifier of the Related Inspection */
    inspectionId!: number;
    /** Identifier of the related Asset. */
    assetId!: number;
    /** The related Asset. */
    asset!: AssetDto | undefined;
    /** Whether the inspection to asset is inspected */
    isInspected!: boolean;
    /** The collector id for this InspectionToAssest */
    collectorId!: string | undefined;
    /** The latitude of the related Asset on the given Inspection. */
    latitude!: number | undefined;
    /** The longitude of the related Asset on the given Inspection. */
    longitude!: number | undefined;
    /** The list of Images tied to the Asset on the given Inspection */
    images!: ImageDto[] | undefined;
    /** Number of images on this inspection to asset */
    imageCount!: number;
    /** The Geography point for the position of the asset on the given Inspection. */
    geo!: Point | undefined;

    constructor(data?: IMappedInspectionToAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.isInspected = _data["isInspected"];
            this.collectorId = _data["collectorId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            this.imageCount = _data["imageCount"];
            this.geo = _data["geo"] ? Point.fromJS(_data["geo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MappedInspectionToAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappedInspectionToAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["isInspected"] = this.isInspected;
        data["collectorId"] = this.collectorId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["imageCount"] = this.imageCount;
        data["geo"] = this.geo ? this.geo.toJSON() : <any>undefined;
        return data;
    }

    clone(): MappedInspectionToAssetDto {
        const json = this.toJSON();
        let result = new MappedInspectionToAssetDto();
        result.init(json);
        return result;
    }
}

export interface IMappedInspectionToAssetDto {
    id: number;
    /** Identifier of the Related Inspection */
    inspectionId: number;
    /** Identifier of the related Asset. */
    assetId: number;
    /** The related Asset. */
    asset: AssetDto | undefined;
    /** Whether the inspection to asset is inspected */
    isInspected: boolean;
    /** The collector id for this InspectionToAssest */
    collectorId: string | undefined;
    /** The latitude of the related Asset on the given Inspection. */
    latitude: number | undefined;
    /** The longitude of the related Asset on the given Inspection. */
    longitude: number | undefined;
    /** The list of Images tied to the Asset on the given Inspection */
    images: ImageDto[] | undefined;
    /** Number of images on this inspection to asset */
    imageCount: number;
    /** The Geography point for the position of the asset on the given Inspection. */
    geo: Point | undefined;
}

/** DTO to contain the total counts of each item */
export class MetricsDto implements IMetricsDto {
    /** Total count of tenants */
    totalTenants!: number;
    /** Total count of inspections */
    totalInspections!: number;
    /** Total count of assets */
    totalAssets!: number;
    /** Total count of inventory items */
    totalInventory!: number;
    /** Total count of conditions, grouped by priority */
    totalConditions!: { [key: string]: number; } | undefined;
    /** Total count of images */
    totalImages!: number;

    constructor(data?: IMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTenants = _data["totalTenants"];
            this.totalInspections = _data["totalInspections"];
            this.totalAssets = _data["totalAssets"];
            this.totalInventory = _data["totalInventory"];
            if (_data["totalConditions"]) {
                this.totalConditions = {} as any;
                for (let key in _data["totalConditions"]) {
                    if (_data["totalConditions"].hasOwnProperty(key))
                        (<any>this.totalConditions)![key] = _data["totalConditions"][key];
                }
            }
            this.totalImages = _data["totalImages"];
        }
    }

    static fromJS(data: any): MetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTenants"] = this.totalTenants;
        data["totalInspections"] = this.totalInspections;
        data["totalAssets"] = this.totalAssets;
        data["totalInventory"] = this.totalInventory;
        if (this.totalConditions) {
            data["totalConditions"] = {};
            for (let key in this.totalConditions) {
                if (this.totalConditions.hasOwnProperty(key))
                    (<any>data["totalConditions"])[key] = (<any>this.totalConditions)[key];
            }
        }
        data["totalImages"] = this.totalImages;
        return data;
    }

    clone(): MetricsDto {
        const json = this.toJSON();
        let result = new MetricsDto();
        result.init(json);
        return result;
    }
}

/** DTO to contain the total counts of each item */
export interface IMetricsDto {
    /** Total count of tenants */
    totalTenants: number;
    /** Total count of inspections */
    totalInspections: number;
    /** Total count of assets */
    totalAssets: number;
    /** Total count of inventory items */
    totalInventory: number;
    /** Total count of conditions, grouped by priority */
    totalConditions: { [key: string]: number; } | undefined;
    /** Total count of images */
    totalImages: number;
}

export class NtsGeometryServices implements INtsGeometryServices {
    readonly geometryOverlay!: GeometryOverlay | undefined;
    readonly coordinateEqualityComparer!: CoordinateEqualityComparer | undefined;
    readonly defaultSRID!: number;
    readonly defaultCoordinateSequenceFactory!: CoordinateSequenceFactory | undefined;
    readonly defaultPrecisionModel!: PrecisionModel | undefined;

    constructor(data?: INtsGeometryServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).geometryOverlay = _data["geometryOverlay"] ? GeometryOverlay.fromJS(_data["geometryOverlay"]) : <any>undefined;
            (<any>this).coordinateEqualityComparer = _data["coordinateEqualityComparer"] ? CoordinateEqualityComparer.fromJS(_data["coordinateEqualityComparer"]) : <any>undefined;
            (<any>this).defaultSRID = _data["defaultSRID"];
            (<any>this).defaultCoordinateSequenceFactory = _data["defaultCoordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["defaultCoordinateSequenceFactory"]) : <any>undefined;
            (<any>this).defaultPrecisionModel = _data["defaultPrecisionModel"] ? PrecisionModel.fromJS(_data["defaultPrecisionModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NtsGeometryServices {
        data = typeof data === 'object' ? data : {};
        let result = new NtsGeometryServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometryOverlay"] = this.geometryOverlay ? this.geometryOverlay.toJSON() : <any>undefined;
        data["coordinateEqualityComparer"] = this.coordinateEqualityComparer ? this.coordinateEqualityComparer.toJSON() : <any>undefined;
        data["defaultSRID"] = this.defaultSRID;
        data["defaultCoordinateSequenceFactory"] = this.defaultCoordinateSequenceFactory ? this.defaultCoordinateSequenceFactory.toJSON() : <any>undefined;
        data["defaultPrecisionModel"] = this.defaultPrecisionModel ? this.defaultPrecisionModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): NtsGeometryServices {
        const json = this.toJSON();
        let result = new NtsGeometryServices();
        result.init(json);
        return result;
    }
}

export interface INtsGeometryServices {
    geometryOverlay: GeometryOverlay | undefined;
    coordinateEqualityComparer: CoordinateEqualityComparer | undefined;
    defaultSRID: number;
    defaultCoordinateSequenceFactory: CoordinateSequenceFactory | undefined;
    defaultPrecisionModel: PrecisionModel | undefined;
}

export enum OgcGeometryType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
}

export enum Ordinates {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _65535 = 65535,
    _65536 = 65536,
    _65539 = 65539,
    _65543 = 65543,
    _131072 = 131072,
    _262144 = 262144,
    _524288 = 524288,
    _1048576 = 1048576,
    _2097152 = 2097152,
    _4194304 = 4194304,
    _8388608 = 8388608,
    _16777216 = 16777216,
    _33554432 = 33554432,
    _67108864 = 67108864,
    _134217728 = 134217728,
    _268435456 = 268435456,
    _536870912 = 536870912,
    _1073741824 = 1073741824,
    __2147483648 = -2147483648,
    __65536 = -65536,
    __1 = -1,
}

/** Dto for Orthomosaic */
export class OrthomosaicDto implements IOrthomosaicDto {
    id!: number;
    /** Identifier of the related Tenant */
    tenantId!: number;
    /** Identifier of the related Inspection */
    inspectionId!: number;
    /** Name of the Orthomosaic */
    name!: string;
    /** Url of the Orthomosaic */
    url!: string;
    /** Blob storage directory location at which the Orthomosaic resides */
    blobStorageLocation!: string;
    /** Specifies whether this Orthomosaic should be displayed by default on loading */
    displayOnLoad!: boolean;
    /** The minimum zoom level for this Orthomosaic. */
    minZoom!: number | undefined;
    /** The maximum zoom level for this Orthomosaic. */
    maxZoom!: number | undefined;
    /** The minimum latitude for this Orthomosaic. */
    minLatitude!: number | undefined;
    /** The maximum latitude for this Orthomosaic. */
    maxLatitude!: number | undefined;
    /** The minimum longitude for this Orthomosaic. */
    minLongitude!: number | undefined;
    /** The maximum longitude for this Orthomosaic. */
    maxLongitude!: number | undefined;

    constructor(data?: IOrthomosaicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.blobStorageLocation = _data["blobStorageLocation"];
            this.displayOnLoad = _data["displayOnLoad"];
            this.minZoom = _data["minZoom"];
            this.maxZoom = _data["maxZoom"];
            this.minLatitude = _data["minLatitude"];
            this.maxLatitude = _data["maxLatitude"];
            this.minLongitude = _data["minLongitude"];
            this.maxLongitude = _data["maxLongitude"];
        }
    }

    static fromJS(data: any): OrthomosaicDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrthomosaicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["blobStorageLocation"] = this.blobStorageLocation;
        data["displayOnLoad"] = this.displayOnLoad;
        data["minZoom"] = this.minZoom;
        data["maxZoom"] = this.maxZoom;
        data["minLatitude"] = this.minLatitude;
        data["maxLatitude"] = this.maxLatitude;
        data["minLongitude"] = this.minLongitude;
        data["maxLongitude"] = this.maxLongitude;
        return data;
    }

    clone(): OrthomosaicDto {
        const json = this.toJSON();
        let result = new OrthomosaicDto();
        result.init(json);
        return result;
    }
}

/** Dto for Orthomosaic */
export interface IOrthomosaicDto {
    id: number;
    /** Identifier of the related Tenant */
    tenantId: number;
    /** Identifier of the related Inspection */
    inspectionId: number;
    /** Name of the Orthomosaic */
    name: string;
    /** Url of the Orthomosaic */
    url: string;
    /** Blob storage directory location at which the Orthomosaic resides */
    blobStorageLocation: string;
    /** Specifies whether this Orthomosaic should be displayed by default on loading */
    displayOnLoad: boolean;
    /** The minimum zoom level for this Orthomosaic. */
    minZoom: number | undefined;
    /** The maximum zoom level for this Orthomosaic. */
    maxZoom: number | undefined;
    /** The minimum latitude for this Orthomosaic. */
    minLatitude: number | undefined;
    /** The maximum latitude for this Orthomosaic. */
    maxLatitude: number | undefined;
    /** The minimum longitude for this Orthomosaic. */
    minLongitude: number | undefined;
    /** The maximum longitude for this Orthomosaic. */
    maxLongitude: number | undefined;
}

/** Dto for Orthomosaic Storage Info */
export class OrthomosaicStorageInfoDto implements IOrthomosaicStorageInfoDto {
    inspectionName!: string | undefined;
    storageAccountName!: string | undefined;
    directoryPath!: string | undefined;

    constructor(data?: IOrthomosaicStorageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionName = _data["inspectionName"];
            this.storageAccountName = _data["storageAccountName"];
            this.directoryPath = _data["directoryPath"];
        }
    }

    static fromJS(data: any): OrthomosaicStorageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrthomosaicStorageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionName"] = this.inspectionName;
        data["storageAccountName"] = this.storageAccountName;
        data["directoryPath"] = this.directoryPath;
        return data;
    }

    clone(): OrthomosaicStorageInfoDto {
        const json = this.toJSON();
        let result = new OrthomosaicStorageInfoDto();
        result.init(json);
        return result;
    }
}

/** Dto for Orthomosaic Storage Info */
export interface IOrthomosaicStorageInfoDto {
    inspectionName: string | undefined;
    storageAccountName: string | undefined;
    directoryPath: string | undefined;
}

export class Point implements IPoint {
    readonly factory!: GeometryFactory | undefined;
    userData!: any | undefined;
    srid!: number;
    readonly precisionModel!: PrecisionModel | undefined;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly area!: number;
    readonly length!: number;
    readonly centroid!: Point | undefined;
    readonly interiorPoint!: Point | undefined;
    readonly pointOnSurface!: Point | undefined;
    readonly envelope!: Geometry | undefined;
    readonly envelopeInternal!: Envelope | undefined;
    readonly isRectangle!: boolean;
    readonly coordinateSequence!: CoordinateSequence | undefined;
    readonly coordinates!: Coordinate[] | undefined;
    readonly numPoints!: number;
    readonly isEmpty!: boolean;
    readonly dimension!: Dimension;
    readonly boundaryDimension!: Dimension;
    x!: number;
    y!: number;
    coordinate!: Coordinate | undefined;
    readonly geometryType!: string | undefined;
    readonly ogcGeometryType!: OgcGeometryType;
    readonly boundary!: Geometry | undefined;
    z!: number;
    m!: number;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            (<any>this).centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            (<any>this).interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            (<any>this).pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            (<any>this).envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            (<any>this).envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            (<any>this).coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).dimension = _data["dimension"];
            (<any>this).boundaryDimension = _data["boundaryDimension"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            (<any>this).geometryType = _data["geometryType"];
            (<any>this).ogcGeometryType = _data["ogcGeometryType"];
            (<any>this).boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.z = _data["z"];
            this.m = _data["m"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["isEmpty"] = this.isEmpty;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["x"] = this.x;
        data["y"] = this.y;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["z"] = this.z;
        data["m"] = this.m;
        return data;
    }

    clone(): Point {
        const json = this.toJSON();
        let result = new Point();
        result.init(json);
        return result;
    }
}

export interface IPoint {
    factory: GeometryFactory | undefined;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel | undefined;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    area: number;
    length: number;
    centroid: Point | undefined;
    interiorPoint: Point | undefined;
    pointOnSurface: Point | undefined;
    envelope: Geometry | undefined;
    envelopeInternal: Envelope | undefined;
    isRectangle: boolean;
    coordinateSequence: CoordinateSequence | undefined;
    coordinates: Coordinate[] | undefined;
    numPoints: number;
    isEmpty: boolean;
    dimension: Dimension;
    boundaryDimension: Dimension;
    x: number;
    y: number;
    coordinate: Coordinate | undefined;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    boundary: Geometry | undefined;
    z: number;
    m: number;
}

/** Dto for Pole Drill Files Storage Info */
export class PoleDrillFileStorageInfoDto implements IPoleDrillFileStorageInfoDto {
    inspectionName!: string | undefined;
    storageAccountName!: string | undefined;
    directoryPath!: string | undefined;
    processedPoleDrillFilesCount!: number;

    constructor(data?: IPoleDrillFileStorageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionName = _data["inspectionName"];
            this.storageAccountName = _data["storageAccountName"];
            this.directoryPath = _data["directoryPath"];
            this.processedPoleDrillFilesCount = _data["processedPoleDrillFilesCount"];
        }
    }

    static fromJS(data: any): PoleDrillFileStorageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoleDrillFileStorageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionName"] = this.inspectionName;
        data["storageAccountName"] = this.storageAccountName;
        data["directoryPath"] = this.directoryPath;
        data["processedPoleDrillFilesCount"] = this.processedPoleDrillFilesCount;
        return data;
    }

    clone(): PoleDrillFileStorageInfoDto {
        const json = this.toJSON();
        let result = new PoleDrillFileStorageInfoDto();
        result.init(json);
        return result;
    }
}

/** Dto for Pole Drill Files Storage Info */
export interface IPoleDrillFileStorageInfoDto {
    inspectionName: string | undefined;
    storageAccountName: string | undefined;
    directoryPath: string | undefined;
    processedPoleDrillFilesCount: number;
}

export class Polygon implements IPolygon {
    readonly factory!: GeometryFactory | undefined;
    userData!: any | undefined;
    srid!: number;
    readonly precisionModel!: PrecisionModel | undefined;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly centroid!: Point | undefined;
    readonly interiorPoint!: Point | undefined;
    readonly pointOnSurface!: Point | undefined;
    readonly envelope!: Geometry | undefined;
    readonly envelopeInternal!: Envelope | undefined;
    readonly coordinate!: Coordinate | undefined;
    readonly coordinates!: Coordinate[] | undefined;
    readonly numPoints!: number;
    readonly dimension!: Dimension;
    readonly boundaryDimension!: Dimension;
    readonly isEmpty!: boolean;
    readonly exteriorRing!: LineString | undefined;
    readonly numInteriorRings!: number;
    readonly interiorRings!: LineString[] | undefined;
    readonly geometryType!: string | undefined;
    readonly ogcGeometryType!: OgcGeometryType;
    readonly area!: number;
    readonly length!: number;
    readonly boundary!: Geometry | undefined;
    readonly isRectangle!: boolean;
    shell!: LinearRing | undefined;
    holes!: LinearRing[] | undefined;

    constructor(data?: IPolygon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            (<any>this).interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            (<any>this).pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            (<any>this).envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            (<any>this).envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).dimension = _data["dimension"];
            (<any>this).boundaryDimension = _data["boundaryDimension"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).exteriorRing = _data["exteriorRing"] ? LineString.fromJS(_data["exteriorRing"]) : <any>undefined;
            (<any>this).numInteriorRings = _data["numInteriorRings"];
            if (Array.isArray(_data["interiorRings"])) {
                (<any>this).interiorRings = [] as any;
                for (let item of _data["interiorRings"])
                    (<any>this).interiorRings!.push(LineString.fromJS(item));
            }
            (<any>this).geometryType = _data["geometryType"];
            (<any>this).ogcGeometryType = _data["ogcGeometryType"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            (<any>this).boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            this.shell = _data["shell"] ? LinearRing.fromJS(_data["shell"]) : <any>undefined;
            if (Array.isArray(_data["holes"])) {
                this.holes = [] as any;
                for (let item of _data["holes"])
                    this.holes!.push(LinearRing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Polygon {
        data = typeof data === 'object' ? data : {};
        let result = new Polygon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["isEmpty"] = this.isEmpty;
        data["exteriorRing"] = this.exteriorRing ? this.exteriorRing.toJSON() : <any>undefined;
        data["numInteriorRings"] = this.numInteriorRings;
        if (Array.isArray(this.interiorRings)) {
            data["interiorRings"] = [];
            for (let item of this.interiorRings)
                data["interiorRings"].push(item.toJSON());
        }
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["area"] = this.area;
        data["length"] = this.length;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        data["shell"] = this.shell ? this.shell.toJSON() : <any>undefined;
        if (Array.isArray(this.holes)) {
            data["holes"] = [];
            for (let item of this.holes)
                data["holes"].push(item.toJSON());
        }
        return data;
    }

    clone(): Polygon {
        const json = this.toJSON();
        let result = new Polygon();
        result.init(json);
        return result;
    }
}

export interface IPolygon {
    factory: GeometryFactory | undefined;
    userData: any | undefined;
    srid: number;
    precisionModel: PrecisionModel | undefined;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    centroid: Point | undefined;
    interiorPoint: Point | undefined;
    pointOnSurface: Point | undefined;
    envelope: Geometry | undefined;
    envelopeInternal: Envelope | undefined;
    coordinate: Coordinate | undefined;
    coordinates: Coordinate[] | undefined;
    numPoints: number;
    dimension: Dimension;
    boundaryDimension: Dimension;
    isEmpty: boolean;
    exteriorRing: LineString | undefined;
    numInteriorRings: number;
    interiorRings: LineString[] | undefined;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    area: number;
    length: number;
    boundary: Geometry | undefined;
    isRectangle: boolean;
    shell: LinearRing | undefined;
    holes: LinearRing[] | undefined;
}

export class PrecisionModel implements IPrecisionModel {
    readonly isFloating!: boolean;
    readonly maximumSignificantDigits!: number;
    scale!: number;
    readonly precisionModelType!: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isFloating = _data["isFloating"];
            (<any>this).maximumSignificantDigits = _data["maximumSignificantDigits"];
            this.scale = _data["scale"];
            (<any>this).precisionModelType = _data["precisionModelType"];
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits;
        data["scale"] = this.scale;
        data["precisionModelType"] = this.precisionModelType;
        return data;
    }

    clone(): PrecisionModel {
        const json = this.toJSON();
        let result = new PrecisionModel();
        result.init(json);
        return result;
    }
}

export interface IPrecisionModel {
    isFloating: boolean;
    maximumSignificantDigits: number;
    scale: number;
    precisionModelType: PrecisionModels;
}

export enum PrecisionModels {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** Dto for PredictedConditionBoundingBox */
export class PredictedConditionBoundingBoxDto implements IPredictedConditionBoundingBoxDto {
    id!: number;
    /** Id of the Inspection associated with this PredictedBoundingBox */
    inspectionId!: number;
    /** Reference to the Inspection associated with this PredictedBoundingBox */
    inspection!: InspectionDto | undefined;
    /** Id of the Image this PredictedBoundingBox is associated with */
    imageId!: number;
    /** Reference to the Image this PredictionBoundingBox is associated with */
    image!: ImageDto | undefined;
    /** Id of the ComputerVisionModel used to generate this PredictedBoundingBox */
    computerVisionModelId!: number;
    /** Reference to the ComputerVisionModel used to generate this PredictedBoundingBox */
    computerVisionModel!: ComputerVisionModelDto | undefined;
    /** Label for the PredictedBoundingBox */
    label!: string | undefined;
    /** X Position in pixels for the bounding box */
    x!: number;
    /** Y Position in pixels for the bounding box */
    y!: number;
    /** Width in pixels for the bounding box */
    width!: number;
    /** Height in pixels for the bounding box */
    height!: number;
    /** Score given to the bounding box by the AI */
    score!: number | undefined;

    constructor(data?: IPredictedConditionBoundingBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.imageId = _data["imageId"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.computerVisionModel = _data["computerVisionModel"] ? ComputerVisionModelDto.fromJS(_data["computerVisionModel"]) : <any>undefined;
            this.label = _data["label"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): PredictedConditionBoundingBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictedConditionBoundingBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["imageId"] = this.imageId;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["computerVisionModel"] = this.computerVisionModel ? this.computerVisionModel.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["score"] = this.score;
        return data;
    }

    clone(): PredictedConditionBoundingBoxDto {
        const json = this.toJSON();
        let result = new PredictedConditionBoundingBoxDto();
        result.init(json);
        return result;
    }
}

/** Dto for PredictedConditionBoundingBox */
export interface IPredictedConditionBoundingBoxDto {
    id: number;
    /** Id of the Inspection associated with this PredictedBoundingBox */
    inspectionId: number;
    /** Reference to the Inspection associated with this PredictedBoundingBox */
    inspection: InspectionDto | undefined;
    /** Id of the Image this PredictedBoundingBox is associated with */
    imageId: number;
    /** Reference to the Image this PredictionBoundingBox is associated with */
    image: ImageDto | undefined;
    /** Id of the ComputerVisionModel used to generate this PredictedBoundingBox */
    computerVisionModelId: number;
    /** Reference to the ComputerVisionModel used to generate this PredictedBoundingBox */
    computerVisionModel: ComputerVisionModelDto | undefined;
    /** Label for the PredictedBoundingBox */
    label: string | undefined;
    /** X Position in pixels for the bounding box */
    x: number;
    /** Y Position in pixels for the bounding box */
    y: number;
    /** Width in pixels for the bounding box */
    width: number;
    /** Height in pixels for the bounding box */
    height: number;
    /** Score given to the bounding box by the AI */
    score: number | undefined;
}

/** Dto for PredictedInventoryBoundingBox */
export class PredictedInventoryBoundingBoxDto implements IPredictedInventoryBoundingBoxDto {
    id!: number;
    /** Id of the ComputerVisionModel used to generate this PredictedBoundingBox */
    computerVisionModelId!: number;
    /** Label for the PredictedBoundingBox */
    label!: string | undefined;
    /** X Position in pixels for the bounding box */
    x!: number;
    /** Y Position in pixels for the bounding box */
    y!: number;
    /** Width in pixels for the bounding box */
    width!: number;
    /** Height in pixels for the bounding box */
    height!: number;
    /** Score given to the bounding box by the AI */
    score!: number | undefined;
    /** Identifiers of the types from the priority matrix that are suggested for this Predicted Inventory Bounding Box. */
    typeIds!: number[] | undefined;

    constructor(data?: IPredictedInventoryBoundingBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.label = _data["label"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.score = _data["score"];
            if (Array.isArray(_data["typeIds"])) {
                this.typeIds = [] as any;
                for (let item of _data["typeIds"])
                    this.typeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PredictedInventoryBoundingBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictedInventoryBoundingBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["label"] = this.label;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["score"] = this.score;
        if (Array.isArray(this.typeIds)) {
            data["typeIds"] = [];
            for (let item of this.typeIds)
                data["typeIds"].push(item);
        }
        return data;
    }

    clone(): PredictedInventoryBoundingBoxDto {
        const json = this.toJSON();
        let result = new PredictedInventoryBoundingBoxDto();
        result.init(json);
        return result;
    }
}

/** Dto for PredictedInventoryBoundingBox */
export interface IPredictedInventoryBoundingBoxDto {
    id: number;
    /** Id of the ComputerVisionModel used to generate this PredictedBoundingBox */
    computerVisionModelId: number;
    /** Label for the PredictedBoundingBox */
    label: string | undefined;
    /** X Position in pixels for the bounding box */
    x: number;
    /** Y Position in pixels for the bounding box */
    y: number;
    /** Width in pixels for the bounding box */
    width: number;
    /** Height in pixels for the bounding box */
    height: number;
    /** Score given to the bounding box by the AI */
    score: number | undefined;
    /** Identifiers of the types from the priority matrix that are suggested for this Predicted Inventory Bounding Box. */
    typeIds: number[] | undefined;
}

/** A QCFeedback dto */
export class QCFeedbackDto implements IQCFeedbackDto {
    /** The associated inspection */
    inspection!: QCInspectionDto | undefined;
    /** The associated tenant */
    tenant!: TenantDto | undefined;
    /** The count of failures */
    failCount!: number;
    /** The count of errors */
    errorCount!: number;
    /** The count of passes without comments */
    passWithCommentsCount!: number;

    constructor(data?: IQCFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspection = _data["inspection"] ? QCInspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.failCount = _data["failCount"];
            this.errorCount = _data["errorCount"];
            this.passWithCommentsCount = _data["passWithCommentsCount"];
        }
    }

    static fromJS(data: any): QCFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new QCFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["failCount"] = this.failCount;
        data["errorCount"] = this.errorCount;
        data["passWithCommentsCount"] = this.passWithCommentsCount;
        return data;
    }

    clone(): QCFeedbackDto {
        const json = this.toJSON();
        let result = new QCFeedbackDto();
        result.init(json);
        return result;
    }
}

/** A QCFeedback dto */
export interface IQCFeedbackDto {
    /** The associated inspection */
    inspection: QCInspectionDto | undefined;
    /** The associated tenant */
    tenant: TenantDto | undefined;
    /** The count of failures */
    failCount: number;
    /** The count of errors */
    errorCount: number;
    /** The count of passes without comments */
    passWithCommentsCount: number;
}

export class QCInspectionDto implements IQCInspectionDto {
    id!: number;
    /** The id of the associated tenant */
    tenantId!: number;
    /** Name of the Inspection */
    inspectionName!: string | undefined;
    /** The end date of the inspection */
    endDate!: moment.Moment | undefined;
    /** The status id of the associated inspection */
    inspectionStatusId!: number | undefined;
    /** The notes on the related inspection */
    inspectionNotes!: string | undefined;
    /** The inspection permissions associated with this Inspection */
    inspectionPermissions!: InspectionPermissionDto[] | undefined;

    constructor(data?: IQCInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionName = _data["inspectionName"];
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.inspectionStatusId = _data["inspectionStatusId"];
            this.inspectionNotes = _data["inspectionNotes"];
            if (Array.isArray(_data["inspectionPermissions"])) {
                this.inspectionPermissions = [] as any;
                for (let item of _data["inspectionPermissions"])
                    this.inspectionPermissions!.push(InspectionPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QCInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QCInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionName"] = this.inspectionName;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["inspectionNotes"] = this.inspectionNotes;
        if (Array.isArray(this.inspectionPermissions)) {
            data["inspectionPermissions"] = [];
            for (let item of this.inspectionPermissions)
                data["inspectionPermissions"].push(item.toJSON());
        }
        return data;
    }

    clone(): QCInspectionDto {
        const json = this.toJSON();
        let result = new QCInspectionDto();
        result.init(json);
        return result;
    }
}

export interface IQCInspectionDto {
    id: number;
    /** The id of the associated tenant */
    tenantId: number;
    /** Name of the Inspection */
    inspectionName: string | undefined;
    /** The end date of the inspection */
    endDate: moment.Moment | undefined;
    /** The status id of the associated inspection */
    inspectionStatusId: number | undefined;
    /** The notes on the related inspection */
    inspectionNotes: string | undefined;
    /** The inspection permissions associated with this Inspection */
    inspectionPermissions: InspectionPermissionDto[] | undefined;
}

/** Dto sent to client */
export class QCInspectionToAssetDto implements IQCInspectionToAssetDto {
    qcReviewedBy!: string | undefined;
    /** Time at which the Asset was marked as having been QC Reviewed */
    qcReviewTime!: moment.Moment | undefined;
    /** The notes pertaining to the QC of the Asset */
    qcReviewNotes!: string | undefined;
    /** Identifier of the quality assurance status of the Asset on the given Inspection */
    qualityAssuranceStatusId!: number | undefined;

    constructor(data?: IQCInspectionToAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qcReviewedBy = _data["qcReviewedBy"];
            this.qcReviewTime = _data["qcReviewTime"] ? moment(_data["qcReviewTime"].toString()) : <any>undefined;
            this.qcReviewNotes = _data["qcReviewNotes"];
            this.qualityAssuranceStatusId = _data["qualityAssuranceStatusId"];
        }
    }

    static fromJS(data: any): QCInspectionToAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new QCInspectionToAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qcReviewedBy"] = this.qcReviewedBy;
        data["qcReviewTime"] = this.qcReviewTime ? this.qcReviewTime.toISOString() : <any>undefined;
        data["qcReviewNotes"] = this.qcReviewNotes;
        data["qualityAssuranceStatusId"] = this.qualityAssuranceStatusId;
        return data;
    }

    clone(): QCInspectionToAssetDto {
        const json = this.toJSON();
        let result = new QCInspectionToAssetDto();
        result.init(json);
        return result;
    }
}

/** Dto sent to client */
export interface IQCInspectionToAssetDto {
    qcReviewedBy: string | undefined;
    /** Time at which the Asset was marked as having been QC Reviewed */
    qcReviewTime: moment.Moment | undefined;
    /** The notes pertaining to the QC of the Asset */
    qcReviewNotes: string | undefined;
    /** Identifier of the quality assurance status of the Asset on the given Inspection */
    qualityAssuranceStatusId: number | undefined;
}

/** QCPerformanceDTO represents QC statistics for a user on an inspection. */
export class QCPerformanceDto implements IQCPerformanceDto {
    /** The name of the inspection. */
    inspectionName!: string | undefined;
    /** The number of assets that passed QC. */
    passCount!: number;
    /** The number of assets that failed QC. */
    failCount!: number;
    /** The number of assets that errored QC. */
    errorCount!: number;
    /** The number of assets inspected by the user. */
    totalCount!: number;
    /** The number of fails/errors on a P10 condition. */
    p10FailErrorCount!: number;
    /** The number of fails/errors on a P20 condition. */
    p20FailErrorCount!: number;
    /** The number of fails/errors on a P30 condition. */
    p30FailErrorCount!: number;
    /** The number of fails/errors on a P40 condition. */
    p40FailErrorCount!: number;
    /** The number of fails/errors on an IO condition. */
    ioFailErrorCount!: number;
    /** The number of assets with conditions that passed QC. */
    passWithConditionsCount!: number;
    /** The number of assets that failed QC. */
    failWithConditionsCount!: number;
    /** The number of assets that errored QC. */
    errorWithConditionsCount!: number;
    /** The number of assets with conditions inspected by the user. */
    totalWithConditionsCount!: number;

    constructor(data?: IQCPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionName = _data["inspectionName"];
            this.passCount = _data["passCount"];
            this.failCount = _data["failCount"];
            this.errorCount = _data["errorCount"];
            this.totalCount = _data["totalCount"];
            this.p10FailErrorCount = _data["p10FailErrorCount"];
            this.p20FailErrorCount = _data["p20FailErrorCount"];
            this.p30FailErrorCount = _data["p30FailErrorCount"];
            this.p40FailErrorCount = _data["p40FailErrorCount"];
            this.ioFailErrorCount = _data["ioFailErrorCount"];
            this.passWithConditionsCount = _data["passWithConditionsCount"];
            this.failWithConditionsCount = _data["failWithConditionsCount"];
            this.errorWithConditionsCount = _data["errorWithConditionsCount"];
            this.totalWithConditionsCount = _data["totalWithConditionsCount"];
        }
    }

    static fromJS(data: any): QCPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new QCPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionName"] = this.inspectionName;
        data["passCount"] = this.passCount;
        data["failCount"] = this.failCount;
        data["errorCount"] = this.errorCount;
        data["totalCount"] = this.totalCount;
        data["p10FailErrorCount"] = this.p10FailErrorCount;
        data["p20FailErrorCount"] = this.p20FailErrorCount;
        data["p30FailErrorCount"] = this.p30FailErrorCount;
        data["p40FailErrorCount"] = this.p40FailErrorCount;
        data["ioFailErrorCount"] = this.ioFailErrorCount;
        data["passWithConditionsCount"] = this.passWithConditionsCount;
        data["failWithConditionsCount"] = this.failWithConditionsCount;
        data["errorWithConditionsCount"] = this.errorWithConditionsCount;
        data["totalWithConditionsCount"] = this.totalWithConditionsCount;
        return data;
    }

    clone(): QCPerformanceDto {
        const json = this.toJSON();
        let result = new QCPerformanceDto();
        result.init(json);
        return result;
    }
}

/** QCPerformanceDTO represents QC statistics for a user on an inspection. */
export interface IQCPerformanceDto {
    /** The name of the inspection. */
    inspectionName: string | undefined;
    /** The number of assets that passed QC. */
    passCount: number;
    /** The number of assets that failed QC. */
    failCount: number;
    /** The number of assets that errored QC. */
    errorCount: number;
    /** The number of assets inspected by the user. */
    totalCount: number;
    /** The number of fails/errors on a P10 condition. */
    p10FailErrorCount: number;
    /** The number of fails/errors on a P20 condition. */
    p20FailErrorCount: number;
    /** The number of fails/errors on a P30 condition. */
    p30FailErrorCount: number;
    /** The number of fails/errors on a P40 condition. */
    p40FailErrorCount: number;
    /** The number of fails/errors on an IO condition. */
    ioFailErrorCount: number;
    /** The number of assets with conditions that passed QC. */
    passWithConditionsCount: number;
    /** The number of assets that failed QC. */
    failWithConditionsCount: number;
    /** The number of assets that errored QC. */
    errorWithConditionsCount: number;
    /** The number of assets with conditions inspected by the user. */
    totalWithConditionsCount: number;
}

/** Dto for QualityAssuranceLevel */
export class QualityAssuranceLevelDto implements IQualityAssuranceLevelDto {
    id!: number;
    /** The Identifier of the User that the Quality Assurance Level is for */
    userId!: number;
    /** The Name of the User that the Quality Assurance Level is for */
    userName!: string | undefined;
    /** The QC Percentage recorded for the user for assets that they have inspected */
    qcPercentage!: number;

    constructor(data?: IQualityAssuranceLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.qcPercentage = _data["qcPercentage"];
        }
    }

    static fromJS(data: any): QualityAssuranceLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualityAssuranceLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["qcPercentage"] = this.qcPercentage;
        return data;
    }

    clone(): QualityAssuranceLevelDto {
        const json = this.toJSON();
        let result = new QualityAssuranceLevelDto();
        result.init(json);
        return result;
    }
}

/** Dto for QualityAssuranceLevel */
export interface IQualityAssuranceLevelDto {
    id: number;
    /** The Identifier of the User that the Quality Assurance Level is for */
    userId: number;
    /** The Name of the User that the Quality Assurance Level is for */
    userName: string | undefined;
    /** The QC Percentage recorded for the user for assets that they have inspected */
    qcPercentage: number;
}

export enum RGPAbortStateType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
}

export enum RGPAnalyzeMeasurementType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** App specific settings */
export class RGPAppSettingsDto implements IRGPAppSettingsDto {
    /** Graph direction */
    graphDirection!: number;
    /** Graph foreground */
    graphForeground!: number;
    /** Graph Y Factor */
    graphFactorY!: number;
    /** Graph - Drill Average Show */
    graphDrillAverageShow!: number;
    /** Graph - Drill Average Length */
    graphDrillAverageLength!: number;
    /** Graph - Feed Average Show */
    graphFeedAverageShow!: number;
    /** Graph - Feed Average Length */
    graphFeedAverageLength!: number;
    /** Object array */
    object!: string[] | undefined;
    /** App Settings Assessment */
    assessment!: RGPAssessmentDto | undefined;
    /** File contents checksum */
    checksum!: number;

    constructor(data?: IRGPAppSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.graphDirection = _data["graphDirection"];
            this.graphForeground = _data["graphForeground"];
            this.graphFactorY = _data["graphFactorY"];
            this.graphDrillAverageShow = _data["graphDrillAverageShow"];
            this.graphDrillAverageLength = _data["graphDrillAverageLength"];
            this.graphFeedAverageShow = _data["graphFeedAverageShow"];
            this.graphFeedAverageLength = _data["graphFeedAverageLength"];
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(item);
            }
            this.assessment = _data["assessment"] ? RGPAssessmentDto.fromJS(_data["assessment"]) : <any>undefined;
            this.checksum = _data["checksum"];
        }
    }

    static fromJS(data: any): RGPAppSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPAppSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["graphDirection"] = this.graphDirection;
        data["graphForeground"] = this.graphForeground;
        data["graphFactorY"] = this.graphFactorY;
        data["graphDrillAverageShow"] = this.graphDrillAverageShow;
        data["graphDrillAverageLength"] = this.graphDrillAverageLength;
        data["graphFeedAverageShow"] = this.graphFeedAverageShow;
        data["graphFeedAverageLength"] = this.graphFeedAverageLength;
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item);
        }
        data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
        data["checksum"] = this.checksum;
        return data;
    }

    clone(): RGPAppSettingsDto {
        const json = this.toJSON();
        let result = new RGPAppSettingsDto();
        result.init(json);
        return result;
    }
}

/** App specific settings */
export interface IRGPAppSettingsDto {
    /** Graph direction */
    graphDirection: number;
    /** Graph foreground */
    graphForeground: number;
    /** Graph Y Factor */
    graphFactorY: number;
    /** Graph - Drill Average Show */
    graphDrillAverageShow: number;
    /** Graph - Drill Average Length */
    graphDrillAverageLength: number;
    /** Graph - Feed Average Show */
    graphFeedAverageShow: number;
    /** Graph - Feed Average Length */
    graphFeedAverageLength: number;
    /** Object array */
    object: string[] | undefined;
    /** App Settings Assessment */
    assessment: RGPAssessmentDto | undefined;
    /** File contents checksum */
    checksum: number;
}

/** Contains value arrays for App Assessment settings */
export class RGPAssessmentDto implements IRGPAssessmentDto {
    /** Start array */
    start!: number[] | undefined;
    /** Stop array */
    stop!: number[] | undefined;
    /** Text array */
    text!: string[] | undefined;
    /** Color array */
    color!: number[] | undefined;

    constructor(data?: IRGPAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["start"])) {
                this.start = [] as any;
                for (let item of _data["start"])
                    this.start!.push(item);
            }
            if (Array.isArray(_data["stop"])) {
                this.stop = [] as any;
                for (let item of _data["stop"])
                    this.stop!.push(item);
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(item);
            }
            if (Array.isArray(_data["color"])) {
                this.color = [] as any;
                for (let item of _data["color"])
                    this.color!.push(item);
            }
        }
    }

    static fromJS(data: any): RGPAssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPAssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.start)) {
            data["start"] = [];
            for (let item of this.start)
                data["start"].push(item);
        }
        if (Array.isArray(this.stop)) {
            data["stop"] = [];
            for (let item of this.stop)
                data["stop"].push(item);
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item);
        }
        if (Array.isArray(this.color)) {
            data["color"] = [];
            for (let item of this.color)
                data["color"].push(item);
        }
        return data;
    }

    clone(): RGPAssessmentDto {
        const json = this.toJSON();
        let result = new RGPAssessmentDto();
        result.init(json);
        return result;
    }
}

/** Contains value arrays for App Assessment settings */
export interface IRGPAssessmentDto {
    /** Start array */
    start: number[] | undefined;
    /** Stop array */
    stop: number[] | undefined;
    /** Text array */
    text: string[] | undefined;
    /** Color array */
    color: number[] | undefined;
}

/** Automatic Decay Detection (ADD) properties */
export class RGPAutomaticDiameterDetectionDto implements IRGPAutomaticDiameterDetectionDto {
    /** ADD is enabled */
    enabled!: boolean;
    /** Data source (Drill or Feed) */
    dataSource!: RGPDataSourceType;
    /** Entry level (%) */
    entryLevel!: number;
    /** Exit level (%) */
    exitDeltaLevel!: number;
    /** Exit width (cm) */
    exitDeltaWidth!: number;

    constructor(data?: IRGPAutomaticDiameterDetectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.dataSource = _data["dataSource"];
            this.entryLevel = _data["entryLevel"];
            this.exitDeltaLevel = _data["exitDeltaLevel"];
            this.exitDeltaWidth = _data["exitDeltaWidth"];
        }
    }

    static fromJS(data: any): RGPAutomaticDiameterDetectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPAutomaticDiameterDetectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["dataSource"] = this.dataSource;
        data["entryLevel"] = this.entryLevel;
        data["exitDeltaLevel"] = this.exitDeltaLevel;
        data["exitDeltaWidth"] = this.exitDeltaWidth;
        return data;
    }

    clone(): RGPAutomaticDiameterDetectionDto {
        const json = this.toJSON();
        let result = new RGPAutomaticDiameterDetectionDto();
        result.init(json);
        return result;
    }
}

/** Automatic Decay Detection (ADD) properties */
export interface IRGPAutomaticDiameterDetectionDto {
    /** ADD is enabled */
    enabled: boolean;
    /** Data source (Drill or Feed) */
    dataSource: RGPDataSourceType;
    /** Entry level (%) */
    entryLevel: number;
    /** Exit level (%) */
    exitDeltaLevel: number;
    /** Exit width (cm) */
    exitDeltaWidth: number;
}

export enum RGPDataSourceType {
    _0 = 0,
    _1 = 1,
}

/** Contains Decay Detection (DD) values */
export class RGPDecayDetectionDto implements IRGPDecayDetectionDto {
    /** DD is enabled */
    enabled!: boolean;
    /** Data source (Drill or Feed) */
    dataSource!: RGPDataSourceType;
    /** Smoothing length (cm) */
    smoothing!: number;
    /** Defect level (%) */
    level!: number;
    /** Defect width (cm) */
    width!: number;
    /** Connect ring defect */
    connectRing!: boolean;
    /** Number of defects */
    count!: number;
    /** Overall defect length (cm) */
    length!: number;
    /** Overall defect ratio (%) */
    ratio!: number;
    /** Green result text */
    greenResultText!: string | undefined;
    /** Yellow result text */
    yellowResultText!: string | undefined;
    /** Red result text */
    redResultText!: string | undefined;
    /** Check shell defect - should be a Boolean flag, can come in as a string */
    checkShellDefect!: string | undefined;
    /** Shell defect exists - should be a Boolean flag, can come in as a string */
    shellDefectExists!: string | undefined;
    /** DD Profile 1 */
    profile1!: RGPDecayDetectionProfileDto | undefined;
    /** DD Profile 2 */
    profile2!: RGPDecayDetectionProfileDto | undefined;

    constructor(data?: IRGPDecayDetectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.dataSource = _data["dataSource"];
            this.smoothing = _data["smoothing"];
            this.level = _data["level"];
            this.width = _data["width"];
            this.connectRing = _data["connectRing"];
            this.count = _data["count"];
            this.length = _data["length"];
            this.ratio = _data["ratio"];
            this.greenResultText = _data["greenResultText"];
            this.yellowResultText = _data["yellowResultText"];
            this.redResultText = _data["redResultText"];
            this.checkShellDefect = _data["checkShellDefect"];
            this.shellDefectExists = _data["shellDefectExists"];
            this.profile1 = _data["profile1"] ? RGPDecayDetectionProfileDto.fromJS(_data["profile1"]) : <any>undefined;
            this.profile2 = _data["profile2"] ? RGPDecayDetectionProfileDto.fromJS(_data["profile2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RGPDecayDetectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPDecayDetectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["dataSource"] = this.dataSource;
        data["smoothing"] = this.smoothing;
        data["level"] = this.level;
        data["width"] = this.width;
        data["connectRing"] = this.connectRing;
        data["count"] = this.count;
        data["length"] = this.length;
        data["ratio"] = this.ratio;
        data["greenResultText"] = this.greenResultText;
        data["yellowResultText"] = this.yellowResultText;
        data["redResultText"] = this.redResultText;
        data["checkShellDefect"] = this.checkShellDefect;
        data["shellDefectExists"] = this.shellDefectExists;
        data["profile1"] = this.profile1 ? this.profile1.toJSON() : <any>undefined;
        data["profile2"] = this.profile2 ? this.profile2.toJSON() : <any>undefined;
        return data;
    }

    clone(): RGPDecayDetectionDto {
        const json = this.toJSON();
        let result = new RGPDecayDetectionDto();
        result.init(json);
        return result;
    }
}

/** Contains Decay Detection (DD) values */
export interface IRGPDecayDetectionDto {
    /** DD is enabled */
    enabled: boolean;
    /** Data source (Drill or Feed) */
    dataSource: RGPDataSourceType;
    /** Smoothing length (cm) */
    smoothing: number;
    /** Defect level (%) */
    level: number;
    /** Defect width (cm) */
    width: number;
    /** Connect ring defect */
    connectRing: boolean;
    /** Number of defects */
    count: number;
    /** Overall defect length (cm) */
    length: number;
    /** Overall defect ratio (%) */
    ratio: number;
    /** Green result text */
    greenResultText: string | undefined;
    /** Yellow result text */
    yellowResultText: string | undefined;
    /** Red result text */
    redResultText: string | undefined;
    /** Check shell defect - should be a Boolean flag, can come in as a string */
    checkShellDefect: string | undefined;
    /** Shell defect exists - should be a Boolean flag, can come in as a string */
    shellDefectExists: string | undefined;
    /** DD Profile 1 */
    profile1: RGPDecayDetectionProfileDto | undefined;
    /** DD Profile 2 */
    profile2: RGPDecayDetectionProfileDto | undefined;
}

/** Properties of one of the Decay Detection (DD) Profiles */
export class RGPDecayDetectionProfileDto implements IRGPDecayDetectionProfileDto {
    /** Analyze Automatic Diameter Detection (ADD) */
    analyzeAutomaticDiameterDetection!: RGPAnalyzeMeasurementType;
    /** Analyze Above Ground Line (AGL) */
    analyzeAboveGroundLine!: RGPAnalyzeMeasurementType;
    /** Analyze Below Ground Line (BGL) */
    analyzeBelowGroundLine!: RGPAnalyzeMeasurementType;
    /** Data source (Drill or Feed) */
    dataSource!: RGPDataSourceType;
    /** Smoothing length (cm) */
    smoothingLength!: number;
    /** Reference length (cm) */
    referenceLength!: number;
    /** Reference factor (%) */
    referenceFactor!: number;
    /** Reference minimum (%) */
    referenceMin!: number;
    /** Reference difference factor */
    referenceDiffFactor!: number;
    /** Attenuation shell (%) */
    attenuationShellPercent!: number;
    /** Attenuation center (%) */
    attenuationCenterPercent!: number;
    /** Defect level (%) */
    defectLevelPercent!: number;
    /** Defect width (cm) */
    defectWidth!: number;
    /** Connect ring defect */
    connectRingDefect!: boolean;
    /** Inspector checks shell entry */
    shellEntryInspector!: RGPDefectPatternType;
    /** Inspector checks shell exit */
    shellExitInspector!: RGPDefectPatternType;
    /** Analyze Pipe Automatic Diameter Detection (ADD) */
    analyzePipeAutomaticDiameterDetection!: RGPAnalyzeMeasurementType;
    /** Analyze Pipe Above Ground Level (AGL) */
    analyzePipeAboveGroundLevel!: RGPAnalyzeMeasurementType;
    /** Analyze Pipe Below Ground Level (BGL) */
    analyzePipeBelowGroundLevel!: RGPAnalyzeMeasurementType;
    /** Rate Result Automatic Diameter Detection Measurement */
    rateResultAutomaticDiameterDetection!: boolean;
    /** Rate Result Above Ground Level Measurement */
    rateResultAboveGroundLevel!: boolean;
    /** Rate Result Below Ground Level Measurement */
    rateResultBelowGroundLevel!: boolean;
    /** Check defect pattern */
    checkPattern!: boolean;
    /** Sum pipe conjunction (false=or, true=and) */
    sumPipeConjunctionAnd!: boolean;
    /** Sum mode yellow level for one half (%) */
    sumHalfYellow!: number;
    /** Sum mode red level for one half (%) */
    sumHalfRed!: number;
    /** Sum mode yellow level for both half (%) */
    sumBothYellow!: number;
    /** Sum mode red level for one half (%) */
    sumBothRed!: number;
    /** Pocket mode enabled */
    pocketModeEnable!: boolean;
    /** Pocket yellow factor (%) */
    pocketYellowFactorPercent!: number;
    /** Pocket red factor (%) */
    pocketRedFactorPercent!: number;
    /** Remaining wall yellow level array (%), only profile 1 */
    remainingWallYellow!: number[] | undefined;
    /** Remaining wall red level array (%), only profile 1 */
    remainingWallRed!: number[] | undefined;
    /** Measurement has been analyzed */
    analyzed!: RGPAnalyzeMeasurementType;
    /** Defect count */
    defectCount!: number;
    /** Defect sum first half (%) */
    entryDefectSumPercent!: number;
    /** Defect sum second half (%) */
    exitDefectSumPercent!: number;
    /** Inner defect first half found */
    innerEntryFound!: boolean;
    /** Inner defect first half (%) */
    entryInnerDefectPercent!: number;
    /** Inner defect second half found */
    innerExitFound!: boolean;
    /** Inner defect second half (%) */
    exitInnerDefectPercent!: number;
    /** Shell defect entry found */
    shellEntryFound!: boolean;
    /** Shell defect entry (%) */
    shellDefectEntryPercent!: number;
    /** Shell defect exit found */
    shellExitFound!: boolean;
    /** Shell defect exit (%) */
    shellDefectExitPercent!: number;
    /** Ring defect found */
    ringDefectFound!: boolean;
    /** Ring defect start (cm) */
    ringDefectStart!: number;
    /** Ring defect stop (cm) */
    ringDefectStop!: number;
    /** Defect pattern */
    pattern!: RGPDefectPatternType;
    /** Pipe has been analyzed */
    analyzePipe!: RGPAnalyzeMeasurementType;
    /** Wall width entry (%) */
    wallWidthEntryPercent!: number;
    /** Wall width exit (%) */
    wallWidthExitPercent!: number;
    /** Remaining strength entry (%) */
    remainingStrengthEntryPercent!: number;
    /** Remaining strength exit (%) */
    remainingStrengthExitPercent!: number;
    /** Decay detection result */
    result!: RGPPoleResultType;
    /** Check shell entry defect */
    shellEntryCheck!: boolean;
    /** Shell entry defect warning */
    shellEntryWarning!: boolean;
    /** Check shell exit defect */
    shellExitCheck!: boolean;
    /** Shell exit defect warning */
    shellExitWarning!: boolean;

    constructor(data?: IRGPDecayDetectionProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.analyzeAutomaticDiameterDetection = _data["analyzeAutomaticDiameterDetection"];
            this.analyzeAboveGroundLine = _data["analyzeAboveGroundLine"];
            this.analyzeBelowGroundLine = _data["analyzeBelowGroundLine"];
            this.dataSource = _data["dataSource"];
            this.smoothingLength = _data["smoothingLength"];
            this.referenceLength = _data["referenceLength"];
            this.referenceFactor = _data["referenceFactor"];
            this.referenceMin = _data["referenceMin"];
            this.referenceDiffFactor = _data["referenceDiffFactor"];
            this.attenuationShellPercent = _data["attenuationShellPercent"];
            this.attenuationCenterPercent = _data["attenuationCenterPercent"];
            this.defectLevelPercent = _data["defectLevelPercent"];
            this.defectWidth = _data["defectWidth"];
            this.connectRingDefect = _data["connectRingDefect"];
            this.shellEntryInspector = _data["shellEntryInspector"];
            this.shellExitInspector = _data["shellExitInspector"];
            this.analyzePipeAutomaticDiameterDetection = _data["analyzePipeAutomaticDiameterDetection"];
            this.analyzePipeAboveGroundLevel = _data["analyzePipeAboveGroundLevel"];
            this.analyzePipeBelowGroundLevel = _data["analyzePipeBelowGroundLevel"];
            this.rateResultAutomaticDiameterDetection = _data["rateResultAutomaticDiameterDetection"];
            this.rateResultAboveGroundLevel = _data["rateResultAboveGroundLevel"];
            this.rateResultBelowGroundLevel = _data["rateResultBelowGroundLevel"];
            this.checkPattern = _data["checkPattern"];
            this.sumPipeConjunctionAnd = _data["sumPipeConjunctionAnd"];
            this.sumHalfYellow = _data["sumHalfYellow"];
            this.sumHalfRed = _data["sumHalfRed"];
            this.sumBothYellow = _data["sumBothYellow"];
            this.sumBothRed = _data["sumBothRed"];
            this.pocketModeEnable = _data["pocketModeEnable"];
            this.pocketYellowFactorPercent = _data["pocketYellowFactorPercent"];
            this.pocketRedFactorPercent = _data["pocketRedFactorPercent"];
            if (Array.isArray(_data["remainingWallYellow"])) {
                this.remainingWallYellow = [] as any;
                for (let item of _data["remainingWallYellow"])
                    this.remainingWallYellow!.push(item);
            }
            if (Array.isArray(_data["remainingWallRed"])) {
                this.remainingWallRed = [] as any;
                for (let item of _data["remainingWallRed"])
                    this.remainingWallRed!.push(item);
            }
            this.analyzed = _data["analyzed"];
            this.defectCount = _data["defectCount"];
            this.entryDefectSumPercent = _data["entryDefectSumPercent"];
            this.exitDefectSumPercent = _data["exitDefectSumPercent"];
            this.innerEntryFound = _data["innerEntryFound"];
            this.entryInnerDefectPercent = _data["entryInnerDefectPercent"];
            this.innerExitFound = _data["innerExitFound"];
            this.exitInnerDefectPercent = _data["exitInnerDefectPercent"];
            this.shellEntryFound = _data["shellEntryFound"];
            this.shellDefectEntryPercent = _data["shellDefectEntryPercent"];
            this.shellExitFound = _data["shellExitFound"];
            this.shellDefectExitPercent = _data["shellDefectExitPercent"];
            this.ringDefectFound = _data["ringDefectFound"];
            this.ringDefectStart = _data["ringDefectStart"];
            this.ringDefectStop = _data["ringDefectStop"];
            this.pattern = _data["pattern"];
            this.analyzePipe = _data["analyzePipe"];
            this.wallWidthEntryPercent = _data["wallWidthEntryPercent"];
            this.wallWidthExitPercent = _data["wallWidthExitPercent"];
            this.remainingStrengthEntryPercent = _data["remainingStrengthEntryPercent"];
            this.remainingStrengthExitPercent = _data["remainingStrengthExitPercent"];
            this.result = _data["result"];
            this.shellEntryCheck = _data["shellEntryCheck"];
            this.shellEntryWarning = _data["shellEntryWarning"];
            this.shellExitCheck = _data["shellExitCheck"];
            this.shellExitWarning = _data["shellExitWarning"];
        }
    }

    static fromJS(data: any): RGPDecayDetectionProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPDecayDetectionProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["analyzeAutomaticDiameterDetection"] = this.analyzeAutomaticDiameterDetection;
        data["analyzeAboveGroundLine"] = this.analyzeAboveGroundLine;
        data["analyzeBelowGroundLine"] = this.analyzeBelowGroundLine;
        data["dataSource"] = this.dataSource;
        data["smoothingLength"] = this.smoothingLength;
        data["referenceLength"] = this.referenceLength;
        data["referenceFactor"] = this.referenceFactor;
        data["referenceMin"] = this.referenceMin;
        data["referenceDiffFactor"] = this.referenceDiffFactor;
        data["attenuationShellPercent"] = this.attenuationShellPercent;
        data["attenuationCenterPercent"] = this.attenuationCenterPercent;
        data["defectLevelPercent"] = this.defectLevelPercent;
        data["defectWidth"] = this.defectWidth;
        data["connectRingDefect"] = this.connectRingDefect;
        data["shellEntryInspector"] = this.shellEntryInspector;
        data["shellExitInspector"] = this.shellExitInspector;
        data["analyzePipeAutomaticDiameterDetection"] = this.analyzePipeAutomaticDiameterDetection;
        data["analyzePipeAboveGroundLevel"] = this.analyzePipeAboveGroundLevel;
        data["analyzePipeBelowGroundLevel"] = this.analyzePipeBelowGroundLevel;
        data["rateResultAutomaticDiameterDetection"] = this.rateResultAutomaticDiameterDetection;
        data["rateResultAboveGroundLevel"] = this.rateResultAboveGroundLevel;
        data["rateResultBelowGroundLevel"] = this.rateResultBelowGroundLevel;
        data["checkPattern"] = this.checkPattern;
        data["sumPipeConjunctionAnd"] = this.sumPipeConjunctionAnd;
        data["sumHalfYellow"] = this.sumHalfYellow;
        data["sumHalfRed"] = this.sumHalfRed;
        data["sumBothYellow"] = this.sumBothYellow;
        data["sumBothRed"] = this.sumBothRed;
        data["pocketModeEnable"] = this.pocketModeEnable;
        data["pocketYellowFactorPercent"] = this.pocketYellowFactorPercent;
        data["pocketRedFactorPercent"] = this.pocketRedFactorPercent;
        if (Array.isArray(this.remainingWallYellow)) {
            data["remainingWallYellow"] = [];
            for (let item of this.remainingWallYellow)
                data["remainingWallYellow"].push(item);
        }
        if (Array.isArray(this.remainingWallRed)) {
            data["remainingWallRed"] = [];
            for (let item of this.remainingWallRed)
                data["remainingWallRed"].push(item);
        }
        data["analyzed"] = this.analyzed;
        data["defectCount"] = this.defectCount;
        data["entryDefectSumPercent"] = this.entryDefectSumPercent;
        data["exitDefectSumPercent"] = this.exitDefectSumPercent;
        data["innerEntryFound"] = this.innerEntryFound;
        data["entryInnerDefectPercent"] = this.entryInnerDefectPercent;
        data["innerExitFound"] = this.innerExitFound;
        data["exitInnerDefectPercent"] = this.exitInnerDefectPercent;
        data["shellEntryFound"] = this.shellEntryFound;
        data["shellDefectEntryPercent"] = this.shellDefectEntryPercent;
        data["shellExitFound"] = this.shellExitFound;
        data["shellDefectExitPercent"] = this.shellDefectExitPercent;
        data["ringDefectFound"] = this.ringDefectFound;
        data["ringDefectStart"] = this.ringDefectStart;
        data["ringDefectStop"] = this.ringDefectStop;
        data["pattern"] = this.pattern;
        data["analyzePipe"] = this.analyzePipe;
        data["wallWidthEntryPercent"] = this.wallWidthEntryPercent;
        data["wallWidthExitPercent"] = this.wallWidthExitPercent;
        data["remainingStrengthEntryPercent"] = this.remainingStrengthEntryPercent;
        data["remainingStrengthExitPercent"] = this.remainingStrengthExitPercent;
        data["result"] = this.result;
        data["shellEntryCheck"] = this.shellEntryCheck;
        data["shellEntryWarning"] = this.shellEntryWarning;
        data["shellExitCheck"] = this.shellExitCheck;
        data["shellExitWarning"] = this.shellExitWarning;
        return data;
    }

    clone(): RGPDecayDetectionProfileDto {
        const json = this.toJSON();
        let result = new RGPDecayDetectionProfileDto();
        result.init(json);
        return result;
    }
}

/** Properties of one of the Decay Detection (DD) Profiles */
export interface IRGPDecayDetectionProfileDto {
    /** Analyze Automatic Diameter Detection (ADD) */
    analyzeAutomaticDiameterDetection: RGPAnalyzeMeasurementType;
    /** Analyze Above Ground Line (AGL) */
    analyzeAboveGroundLine: RGPAnalyzeMeasurementType;
    /** Analyze Below Ground Line (BGL) */
    analyzeBelowGroundLine: RGPAnalyzeMeasurementType;
    /** Data source (Drill or Feed) */
    dataSource: RGPDataSourceType;
    /** Smoothing length (cm) */
    smoothingLength: number;
    /** Reference length (cm) */
    referenceLength: number;
    /** Reference factor (%) */
    referenceFactor: number;
    /** Reference minimum (%) */
    referenceMin: number;
    /** Reference difference factor */
    referenceDiffFactor: number;
    /** Attenuation shell (%) */
    attenuationShellPercent: number;
    /** Attenuation center (%) */
    attenuationCenterPercent: number;
    /** Defect level (%) */
    defectLevelPercent: number;
    /** Defect width (cm) */
    defectWidth: number;
    /** Connect ring defect */
    connectRingDefect: boolean;
    /** Inspector checks shell entry */
    shellEntryInspector: RGPDefectPatternType;
    /** Inspector checks shell exit */
    shellExitInspector: RGPDefectPatternType;
    /** Analyze Pipe Automatic Diameter Detection (ADD) */
    analyzePipeAutomaticDiameterDetection: RGPAnalyzeMeasurementType;
    /** Analyze Pipe Above Ground Level (AGL) */
    analyzePipeAboveGroundLevel: RGPAnalyzeMeasurementType;
    /** Analyze Pipe Below Ground Level (BGL) */
    analyzePipeBelowGroundLevel: RGPAnalyzeMeasurementType;
    /** Rate Result Automatic Diameter Detection Measurement */
    rateResultAutomaticDiameterDetection: boolean;
    /** Rate Result Above Ground Level Measurement */
    rateResultAboveGroundLevel: boolean;
    /** Rate Result Below Ground Level Measurement */
    rateResultBelowGroundLevel: boolean;
    /** Check defect pattern */
    checkPattern: boolean;
    /** Sum pipe conjunction (false=or, true=and) */
    sumPipeConjunctionAnd: boolean;
    /** Sum mode yellow level for one half (%) */
    sumHalfYellow: number;
    /** Sum mode red level for one half (%) */
    sumHalfRed: number;
    /** Sum mode yellow level for both half (%) */
    sumBothYellow: number;
    /** Sum mode red level for one half (%) */
    sumBothRed: number;
    /** Pocket mode enabled */
    pocketModeEnable: boolean;
    /** Pocket yellow factor (%) */
    pocketYellowFactorPercent: number;
    /** Pocket red factor (%) */
    pocketRedFactorPercent: number;
    /** Remaining wall yellow level array (%), only profile 1 */
    remainingWallYellow: number[] | undefined;
    /** Remaining wall red level array (%), only profile 1 */
    remainingWallRed: number[] | undefined;
    /** Measurement has been analyzed */
    analyzed: RGPAnalyzeMeasurementType;
    /** Defect count */
    defectCount: number;
    /** Defect sum first half (%) */
    entryDefectSumPercent: number;
    /** Defect sum second half (%) */
    exitDefectSumPercent: number;
    /** Inner defect first half found */
    innerEntryFound: boolean;
    /** Inner defect first half (%) */
    entryInnerDefectPercent: number;
    /** Inner defect second half found */
    innerExitFound: boolean;
    /** Inner defect second half (%) */
    exitInnerDefectPercent: number;
    /** Shell defect entry found */
    shellEntryFound: boolean;
    /** Shell defect entry (%) */
    shellDefectEntryPercent: number;
    /** Shell defect exit found */
    shellExitFound: boolean;
    /** Shell defect exit (%) */
    shellDefectExitPercent: number;
    /** Ring defect found */
    ringDefectFound: boolean;
    /** Ring defect start (cm) */
    ringDefectStart: number;
    /** Ring defect stop (cm) */
    ringDefectStop: number;
    /** Defect pattern */
    pattern: RGPDefectPatternType;
    /** Pipe has been analyzed */
    analyzePipe: RGPAnalyzeMeasurementType;
    /** Wall width entry (%) */
    wallWidthEntryPercent: number;
    /** Wall width exit (%) */
    wallWidthExitPercent: number;
    /** Remaining strength entry (%) */
    remainingStrengthEntryPercent: number;
    /** Remaining strength exit (%) */
    remainingStrengthExitPercent: number;
    /** Decay detection result */
    result: RGPPoleResultType;
    /** Check shell entry defect */
    shellEntryCheck: boolean;
    /** Shell entry defect warning */
    shellEntryWarning: boolean;
    /** Check shell exit defect */
    shellExitCheck: boolean;
    /** Shell exit defect warning */
    shellExitWarning: boolean;
}

export enum RGPDefectPatternType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum RGPDepthModeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** Pole Drill Measurements */
export class RGPMeasurementDto implements IRGPMeasurementDto {
    /** Device Code (0F02=PD-Series) */
    deviceCode!: string | undefined;
    /** Source file version */
    sourceFileVersion!: number;
    /** Source file checksum */
    sourceFileChecksum!: number;
    /** Source file contents MD5 hash */
    sourceFileHash!: string | undefined;
    /** Measurement header, which contains most measurement data */
    measurementHeader!: RGPMeasurementHeaderDto | undefined;
    /** Measurement profile */
    profile!: RGPProfileDto | undefined;
    /** WoodInspector (WI) Pole Result */
    woodInspectorPoleResult!: RGPWoodInspectorPoleResultDto | undefined;
    /** App-specific settings */
    appSettings!: RGPAppSettingsDto | undefined;

    constructor(data?: IRGPMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceCode = _data["deviceCode"];
            this.sourceFileVersion = _data["sourceFileVersion"];
            this.sourceFileChecksum = _data["sourceFileChecksum"];
            this.sourceFileHash = _data["sourceFileHash"];
            this.measurementHeader = _data["measurementHeader"] ? RGPMeasurementHeaderDto.fromJS(_data["measurementHeader"]) : <any>undefined;
            this.profile = _data["profile"] ? RGPProfileDto.fromJS(_data["profile"]) : <any>undefined;
            this.woodInspectorPoleResult = _data["woodInspectorPoleResult"] ? RGPWoodInspectorPoleResultDto.fromJS(_data["woodInspectorPoleResult"]) : <any>undefined;
            this.appSettings = _data["appSettings"] ? RGPAppSettingsDto.fromJS(_data["appSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RGPMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceCode"] = this.deviceCode;
        data["sourceFileVersion"] = this.sourceFileVersion;
        data["sourceFileChecksum"] = this.sourceFileChecksum;
        data["sourceFileHash"] = this.sourceFileHash;
        data["measurementHeader"] = this.measurementHeader ? this.measurementHeader.toJSON() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["woodInspectorPoleResult"] = this.woodInspectorPoleResult ? this.woodInspectorPoleResult.toJSON() : <any>undefined;
        data["appSettings"] = this.appSettings ? this.appSettings.toJSON() : <any>undefined;
        return data;
    }

    clone(): RGPMeasurementDto {
        const json = this.toJSON();
        let result = new RGPMeasurementDto();
        result.init(json);
        return result;
    }
}

/** Pole Drill Measurements */
export interface IRGPMeasurementDto {
    /** Device Code (0F02=PD-Series) */
    deviceCode: string | undefined;
    /** Source file version */
    sourceFileVersion: number;
    /** Source file checksum */
    sourceFileChecksum: number;
    /** Source file contents MD5 hash */
    sourceFileHash: string | undefined;
    /** Measurement header, which contains most measurement data */
    measurementHeader: RGPMeasurementHeaderDto | undefined;
    /** Measurement profile */
    profile: RGPProfileDto | undefined;
    /** WoodInspector (WI) Pole Result */
    woodInspectorPoleResult: RGPWoodInspectorPoleResultDto | undefined;
    /** App-specific settings */
    appSettings: RGPAppSettingsDto | undefined;
}

/** Pole Drill Measurement Header */
export class RGPMeasurementHeaderDto implements IRGPMeasurementHeaderDto {
    /** Drill Serial Number */
    machineSerialNumber!: string | undefined;
    /** Firmware version */
    firmwareVersion!: string | undefined;
    /** Serial number of electronic components */
    electronicsSerialNumber!: string | undefined;
    /** Hardware version of electronic components */
    electronicsHardwareVersion!: string | undefined;
    /** Machine memory ID */
    machineMemoryId!: string | undefined;
    /** Measurement number */
    measurementNumber!: number;
    /** ID number - ties measurement records together */
    idNumber!: string | undefined;
    /** Remark */
    remark!: string | undefined;
    /** Measurement recording year */
    dateYear!: number;
    /** Measurement recording month */
    dateMonth!: number;
    /** Measurement recording month */
    dateDay!: number;
    /** Measurement recording hour */
    timeHour!: number;
    /** Measurement recording minute */
    timeMinute!: number;
    /** Measurement recording second */
    timeSecond!: number;
    /** Number of samples per mm */
    resolutionFeed!: number;
    /** Number of samples amplitude */
    resolutionAmplitude!: number;
    /** Maximum drilling depth machine (cm) */
    deviceLength!: number;
    /** Depth mode */
    depthMode!: RGPDepthModeType;
    /** Preselected drilling depth (cm) */
    preselectedDrillingDepth!: number;
    /** Drilling depth (cm) */
    drillingDepth!: number;
    /** Feed speed (cm/min) */
    feedSpeed!: number;
    /** Needle speed (rpm/min) */
    needleSpeed!: number;
    /** Offset feed motor */
    offsetFeedMotor!: number;
    /** Offset drill motor */
    offsetDrillMotor!: number;
    /** Maximum feed amplitude (load) */
    maxFeedAmplitude!: number;
    /** Maximum drill amplitude (load) */
    maxDrillAmplitude!: number;
    /** Abort state/reason */
    abortState!: RGPAbortStateType;
    /** Feed data enabled */
    feedDataEnabled!: boolean;
    /** Needle check enabled */
    needleCheckEnabled!: boolean;
    /** Needle check result */
    needleCheckResult!: RGPNeedleCheckResultType;
    /** Tilt sensor enabled */
    tiltSensorEnabled!: boolean;
    /** Tilt sensor relative mode enabled */
    tiltSensorRelativeModeEnabled!: boolean;
    /** Tilt sensor relative angle (degree) */
    tiltSensorRelativeAngle!: number;
    /** Tilt sensor angle (degree). Horizontal=90. */
    tiltSensorAngle!: number;
    /** Diameter (cm) */
    diameter!: number;
    /** WoodInspector installed */
    woodInspectorInstalled!: boolean;
    /** WoodInspector settings */
    woodInspector!: RGPWoodInspectorDto | undefined;
    /** Measurement header checksum */
    checksum!: number;
    /** Proper DateTime from the fields */
    readonly measurementDateTime!: moment.Moment;

    constructor(data?: IRGPMeasurementHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineSerialNumber = _data["machineSerialNumber"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.electronicsSerialNumber = _data["electronicsSerialNumber"];
            this.electronicsHardwareVersion = _data["electronicsHardwareVersion"];
            this.machineMemoryId = _data["machineMemoryId"];
            this.measurementNumber = _data["measurementNumber"];
            this.idNumber = _data["idNumber"];
            this.remark = _data["remark"];
            this.dateYear = _data["dateYear"];
            this.dateMonth = _data["dateMonth"];
            this.dateDay = _data["dateDay"];
            this.timeHour = _data["timeHour"];
            this.timeMinute = _data["timeMinute"];
            this.timeSecond = _data["timeSecond"];
            this.resolutionFeed = _data["resolutionFeed"];
            this.resolutionAmplitude = _data["resolutionAmplitude"];
            this.deviceLength = _data["deviceLength"];
            this.depthMode = _data["depthMode"];
            this.preselectedDrillingDepth = _data["preselectedDrillingDepth"];
            this.drillingDepth = _data["drillingDepth"];
            this.feedSpeed = _data["feedSpeed"];
            this.needleSpeed = _data["needleSpeed"];
            this.offsetFeedMotor = _data["offsetFeedMotor"];
            this.offsetDrillMotor = _data["offsetDrillMotor"];
            this.maxFeedAmplitude = _data["maxFeedAmplitude"];
            this.maxDrillAmplitude = _data["maxDrillAmplitude"];
            this.abortState = _data["abortState"];
            this.feedDataEnabled = _data["feedDataEnabled"];
            this.needleCheckEnabled = _data["needleCheckEnabled"];
            this.needleCheckResult = _data["needleCheckResult"];
            this.tiltSensorEnabled = _data["tiltSensorEnabled"];
            this.tiltSensorRelativeModeEnabled = _data["tiltSensorRelativeModeEnabled"];
            this.tiltSensorRelativeAngle = _data["tiltSensorRelativeAngle"];
            this.tiltSensorAngle = _data["tiltSensorAngle"];
            this.diameter = _data["diameter"];
            this.woodInspectorInstalled = _data["woodInspectorInstalled"];
            this.woodInspector = _data["woodInspector"] ? RGPWoodInspectorDto.fromJS(_data["woodInspector"]) : <any>undefined;
            this.checksum = _data["checksum"];
            (<any>this).measurementDateTime = _data["measurementDateTime"] ? moment(_data["measurementDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RGPMeasurementHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPMeasurementHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineSerialNumber"] = this.machineSerialNumber;
        data["firmwareVersion"] = this.firmwareVersion;
        data["electronicsSerialNumber"] = this.electronicsSerialNumber;
        data["electronicsHardwareVersion"] = this.electronicsHardwareVersion;
        data["machineMemoryId"] = this.machineMemoryId;
        data["measurementNumber"] = this.measurementNumber;
        data["idNumber"] = this.idNumber;
        data["remark"] = this.remark;
        data["dateYear"] = this.dateYear;
        data["dateMonth"] = this.dateMonth;
        data["dateDay"] = this.dateDay;
        data["timeHour"] = this.timeHour;
        data["timeMinute"] = this.timeMinute;
        data["timeSecond"] = this.timeSecond;
        data["resolutionFeed"] = this.resolutionFeed;
        data["resolutionAmplitude"] = this.resolutionAmplitude;
        data["deviceLength"] = this.deviceLength;
        data["depthMode"] = this.depthMode;
        data["preselectedDrillingDepth"] = this.preselectedDrillingDepth;
        data["drillingDepth"] = this.drillingDepth;
        data["feedSpeed"] = this.feedSpeed;
        data["needleSpeed"] = this.needleSpeed;
        data["offsetFeedMotor"] = this.offsetFeedMotor;
        data["offsetDrillMotor"] = this.offsetDrillMotor;
        data["maxFeedAmplitude"] = this.maxFeedAmplitude;
        data["maxDrillAmplitude"] = this.maxDrillAmplitude;
        data["abortState"] = this.abortState;
        data["feedDataEnabled"] = this.feedDataEnabled;
        data["needleCheckEnabled"] = this.needleCheckEnabled;
        data["needleCheckResult"] = this.needleCheckResult;
        data["tiltSensorEnabled"] = this.tiltSensorEnabled;
        data["tiltSensorRelativeModeEnabled"] = this.tiltSensorRelativeModeEnabled;
        data["tiltSensorRelativeAngle"] = this.tiltSensorRelativeAngle;
        data["tiltSensorAngle"] = this.tiltSensorAngle;
        data["diameter"] = this.diameter;
        data["woodInspectorInstalled"] = this.woodInspectorInstalled;
        data["woodInspector"] = this.woodInspector ? this.woodInspector.toJSON() : <any>undefined;
        data["checksum"] = this.checksum;
        data["measurementDateTime"] = this.measurementDateTime ? this.measurementDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RGPMeasurementHeaderDto {
        const json = this.toJSON();
        let result = new RGPMeasurementHeaderDto();
        result.init(json);
        return result;
    }
}

/** Pole Drill Measurement Header */
export interface IRGPMeasurementHeaderDto {
    /** Drill Serial Number */
    machineSerialNumber: string | undefined;
    /** Firmware version */
    firmwareVersion: string | undefined;
    /** Serial number of electronic components */
    electronicsSerialNumber: string | undefined;
    /** Hardware version of electronic components */
    electronicsHardwareVersion: string | undefined;
    /** Machine memory ID */
    machineMemoryId: string | undefined;
    /** Measurement number */
    measurementNumber: number;
    /** ID number - ties measurement records together */
    idNumber: string | undefined;
    /** Remark */
    remark: string | undefined;
    /** Measurement recording year */
    dateYear: number;
    /** Measurement recording month */
    dateMonth: number;
    /** Measurement recording month */
    dateDay: number;
    /** Measurement recording hour */
    timeHour: number;
    /** Measurement recording minute */
    timeMinute: number;
    /** Measurement recording second */
    timeSecond: number;
    /** Number of samples per mm */
    resolutionFeed: number;
    /** Number of samples amplitude */
    resolutionAmplitude: number;
    /** Maximum drilling depth machine (cm) */
    deviceLength: number;
    /** Depth mode */
    depthMode: RGPDepthModeType;
    /** Preselected drilling depth (cm) */
    preselectedDrillingDepth: number;
    /** Drilling depth (cm) */
    drillingDepth: number;
    /** Feed speed (cm/min) */
    feedSpeed: number;
    /** Needle speed (rpm/min) */
    needleSpeed: number;
    /** Offset feed motor */
    offsetFeedMotor: number;
    /** Offset drill motor */
    offsetDrillMotor: number;
    /** Maximum feed amplitude (load) */
    maxFeedAmplitude: number;
    /** Maximum drill amplitude (load) */
    maxDrillAmplitude: number;
    /** Abort state/reason */
    abortState: RGPAbortStateType;
    /** Feed data enabled */
    feedDataEnabled: boolean;
    /** Needle check enabled */
    needleCheckEnabled: boolean;
    /** Needle check result */
    needleCheckResult: RGPNeedleCheckResultType;
    /** Tilt sensor enabled */
    tiltSensorEnabled: boolean;
    /** Tilt sensor relative mode enabled */
    tiltSensorRelativeModeEnabled: boolean;
    /** Tilt sensor relative angle (degree) */
    tiltSensorRelativeAngle: number;
    /** Tilt sensor angle (degree). Horizontal=90. */
    tiltSensorAngle: number;
    /** Diameter (cm) */
    diameter: number;
    /** WoodInspector installed */
    woodInspectorInstalled: boolean;
    /** WoodInspector settings */
    woodInspector: RGPWoodInspectorDto | undefined;
    /** Measurement header checksum */
    checksum: number;
    /** Proper DateTime from the fields */
    measurementDateTime: moment.Moment;
}

export enum RGPNeedleCheckResultType {
    _0 = 0,
    _1 = 1,
}

/** Pole settings and results */
export class RGPPoleDto implements IRGPPoleDto {
    /** Pole Settings */
    settings!: RGPSettingsDto | undefined;
    /** Pole Results */
    results!: RGPResultsDto | undefined;

    constructor(data?: IRGPPoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settings = _data["settings"] ? RGPSettingsDto.fromJS(_data["settings"]) : <any>undefined;
            this.results = _data["results"] ? RGPResultsDto.fromJS(_data["results"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RGPPoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPPoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["results"] = this.results ? this.results.toJSON() : <any>undefined;
        return data;
    }

    clone(): RGPPoleDto {
        const json = this.toJSON();
        let result = new RGPPoleDto();
        result.init(json);
        return result;
    }
}

/** Pole settings and results */
export interface IRGPPoleDto {
    /** Pole Settings */
    settings: RGPSettingsDto | undefined;
    /** Pole Results */
    results: RGPResultsDto | undefined;
}

export enum RGPPoleResultType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Data input profile - contains raw drill values */
export class RGPProfileDto implements IRGPProfileDto {
    /** Drill data array (%) */
    drill!: number[] | undefined;
    /** Feed data array (%) */
    feed!: number[] | undefined;
    /** Measurement profile file checksum */
    checksum!: number;

    constructor(data?: IRGPProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["drill"])) {
                this.drill = [] as any;
                for (let item of _data["drill"])
                    this.drill!.push(item);
            }
            if (Array.isArray(_data["feed"])) {
                this.feed = [] as any;
                for (let item of _data["feed"])
                    this.feed!.push(item);
            }
            this.checksum = _data["checksum"];
        }
    }

    static fromJS(data: any): RGPProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drill)) {
            data["drill"] = [];
            for (let item of this.drill)
                data["drill"].push(item);
        }
        if (Array.isArray(this.feed)) {
            data["feed"] = [];
            for (let item of this.feed)
                data["feed"].push(item);
        }
        data["checksum"] = this.checksum;
        return data;
    }

    clone(): RGPProfileDto {
        const json = this.toJSON();
        let result = new RGPProfileDto();
        result.init(json);
        return result;
    }
}

/** Data input profile - contains raw drill values */
export interface IRGPProfileDto {
    /** Drill data array (%) */
    drill: number[] | undefined;
    /** Feed data array (%) */
    feed: number[] | undefined;
    /** Measurement profile file checksum */
    checksum: number;
}

/** Contains results from drilling */
export class RGPResultsDto implements IRGPResultsDto {
    /** Start/Stop Detection (SSD) values */
    ssd!: RGPStartStopDetectionDto | undefined;
    /** Decay Detection (DD) values */
    dd!: RGPDecayDetectionDto | undefined;
    /** Pole Id */
    id!: string | undefined;
    /** Pole type (from results) */
    type!: number;
    /** Measurement number at pole */
    numberTotal!: number;
    /** Number of measurements at ground level */
    numberLevel!: number;
    /** Ground level */
    groundLevel!: number;
    /** Opposite measurement */
    opposite!: boolean;
    /** Inspection is finished */
    inspectionFinished!: boolean;
    /** Auto result status */
    autoResult!: RGPPoleResultType;
    /** Auto result check shell defect */
    autoShellCheck!: boolean;
    /** Auto result shell defect existing */
    autoShellExist!: boolean;
    /** Result modified by inspector */
    inspectorModifiedResult!: boolean;
    /** Final result */
    finalResult!: RGPPoleResultType;
    /** Final result check shell defect */
    finalShellCheck!: boolean;
    /** Final result shell defect existing */
    finalShellExist!: boolean;

    constructor(data?: IRGPResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssd = _data["ssd"] ? RGPStartStopDetectionDto.fromJS(_data["ssd"]) : <any>undefined;
            this.dd = _data["dd"] ? RGPDecayDetectionDto.fromJS(_data["dd"]) : <any>undefined;
            this.id = _data["id"];
            this.type = _data["type"];
            this.numberTotal = _data["numberTotal"];
            this.numberLevel = _data["numberLevel"];
            this.groundLevel = _data["groundLevel"];
            this.opposite = _data["opposite"];
            this.inspectionFinished = _data["inspectionFinished"];
            this.autoResult = _data["autoResult"];
            this.autoShellCheck = _data["autoShellCheck"];
            this.autoShellExist = _data["autoShellExist"];
            this.inspectorModifiedResult = _data["inspectorModifiedResult"];
            this.finalResult = _data["finalResult"];
            this.finalShellCheck = _data["finalShellCheck"];
            this.finalShellExist = _data["finalShellExist"];
        }
    }

    static fromJS(data: any): RGPResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssd"] = this.ssd ? this.ssd.toJSON() : <any>undefined;
        data["dd"] = this.dd ? this.dd.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["type"] = this.type;
        data["numberTotal"] = this.numberTotal;
        data["numberLevel"] = this.numberLevel;
        data["groundLevel"] = this.groundLevel;
        data["opposite"] = this.opposite;
        data["inspectionFinished"] = this.inspectionFinished;
        data["autoResult"] = this.autoResult;
        data["autoShellCheck"] = this.autoShellCheck;
        data["autoShellExist"] = this.autoShellExist;
        data["inspectorModifiedResult"] = this.inspectorModifiedResult;
        data["finalResult"] = this.finalResult;
        data["finalShellCheck"] = this.finalShellCheck;
        data["finalShellExist"] = this.finalShellExist;
        return data;
    }

    clone(): RGPResultsDto {
        const json = this.toJSON();
        let result = new RGPResultsDto();
        result.init(json);
        return result;
    }
}

/** Contains results from drilling */
export interface IRGPResultsDto {
    /** Start/Stop Detection (SSD) values */
    ssd: RGPStartStopDetectionDto | undefined;
    /** Decay Detection (DD) values */
    dd: RGPDecayDetectionDto | undefined;
    /** Pole Id */
    id: string | undefined;
    /** Pole type (from results) */
    type: number;
    /** Measurement number at pole */
    numberTotal: number;
    /** Number of measurements at ground level */
    numberLevel: number;
    /** Ground level */
    groundLevel: number;
    /** Opposite measurement */
    opposite: boolean;
    /** Inspection is finished */
    inspectionFinished: boolean;
    /** Auto result status */
    autoResult: RGPPoleResultType;
    /** Auto result check shell defect */
    autoShellCheck: boolean;
    /** Auto result shell defect existing */
    autoShellExist: boolean;
    /** Result modified by inspector */
    inspectorModifiedResult: boolean;
    /** Final result */
    finalResult: RGPPoleResultType;
    /** Final result check shell defect */
    finalShellCheck: boolean;
    /** Final result shell defect existing */
    finalShellExist: boolean;
}

/** General drilling settings */
export class RGPSettingsDto implements IRGPSettingsDto {
    /** Tilt correction enabled */
    tiltCorrectionEnabled!: boolean;
    /** Automatic Diameter Detection (ADD) settings */
    add!: RGPAutomaticDiameterDetectionDto | undefined;
    /** Decay Detection (DD) settings */
    dd!: RGPDecayDetectionDto | undefined;
    /** Start/Stop Detection (SSD) settings */
    ssd!: RGPStartStopDetectionDto | undefined;
    /** Configuration name */
    configName!: string | undefined;
    /** Configuration version */
    configVersion!: string | undefined;
    /** Pole type (from settings) */
    type!: string | undefined;
    /** Analyze Automatic Diameter Detection measurement */
    analyzeAutomaticDiameterDetection!: boolean;
    /** Analyze Above Ground Line measurement */
    analyzeAboveGroundLine!: boolean;
    /** Analyze Below Ground Line measurement */
    analyzeBelowGroundLine!: boolean;

    constructor(data?: IRGPSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tiltCorrectionEnabled = _data["tiltCorrectionEnabled"];
            this.add = _data["add"] ? RGPAutomaticDiameterDetectionDto.fromJS(_data["add"]) : <any>undefined;
            this.dd = _data["dd"] ? RGPDecayDetectionDto.fromJS(_data["dd"]) : <any>undefined;
            this.ssd = _data["ssd"] ? RGPStartStopDetectionDto.fromJS(_data["ssd"]) : <any>undefined;
            this.configName = _data["configName"];
            this.configVersion = _data["configVersion"];
            this.type = _data["type"];
            this.analyzeAutomaticDiameterDetection = _data["analyzeAutomaticDiameterDetection"];
            this.analyzeAboveGroundLine = _data["analyzeAboveGroundLine"];
            this.analyzeBelowGroundLine = _data["analyzeBelowGroundLine"];
        }
    }

    static fromJS(data: any): RGPSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tiltCorrectionEnabled"] = this.tiltCorrectionEnabled;
        data["add"] = this.add ? this.add.toJSON() : <any>undefined;
        data["dd"] = this.dd ? this.dd.toJSON() : <any>undefined;
        data["ssd"] = this.ssd ? this.ssd.toJSON() : <any>undefined;
        data["configName"] = this.configName;
        data["configVersion"] = this.configVersion;
        data["type"] = this.type;
        data["analyzeAutomaticDiameterDetection"] = this.analyzeAutomaticDiameterDetection;
        data["analyzeAboveGroundLine"] = this.analyzeAboveGroundLine;
        data["analyzeBelowGroundLine"] = this.analyzeBelowGroundLine;
        return data;
    }

    clone(): RGPSettingsDto {
        const json = this.toJSON();
        let result = new RGPSettingsDto();
        result.init(json);
        return result;
    }
}

/** General drilling settings */
export interface IRGPSettingsDto {
    /** Tilt correction enabled */
    tiltCorrectionEnabled: boolean;
    /** Automatic Diameter Detection (ADD) settings */
    add: RGPAutomaticDiameterDetectionDto | undefined;
    /** Decay Detection (DD) settings */
    dd: RGPDecayDetectionDto | undefined;
    /** Start/Stop Detection (SSD) settings */
    ssd: RGPStartStopDetectionDto | undefined;
    /** Configuration name */
    configName: string | undefined;
    /** Configuration version */
    configVersion: string | undefined;
    /** Pole type (from settings) */
    type: string | undefined;
    /** Analyze Automatic Diameter Detection measurement */
    analyzeAutomaticDiameterDetection: boolean;
    /** Analyze Above Ground Line measurement */
    analyzeAboveGroundLine: boolean;
    /** Analyze Below Ground Line measurement */
    analyzeBelowGroundLine: boolean;
}

/** Standard program values */
export class RGPStandardDto implements IRGPStandardDto {
    /** Standard program settings */
    settings!: RGPSettingsDto | undefined;
    /** Standard program results */
    results!: RGPResultsDto | undefined;

    constructor(data?: IRGPStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settings = _data["settings"] ? RGPSettingsDto.fromJS(_data["settings"]) : <any>undefined;
            this.results = _data["results"] ? RGPResultsDto.fromJS(_data["results"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RGPStandardDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPStandardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["results"] = this.results ? this.results.toJSON() : <any>undefined;
        return data;
    }

    clone(): RGPStandardDto {
        const json = this.toJSON();
        let result = new RGPStandardDto();
        result.init(json);
        return result;
    }
}

/** Standard program values */
export interface IRGPStandardDto {
    /** Standard program settings */
    settings: RGPSettingsDto | undefined;
    /** Standard program results */
    results: RGPResultsDto | undefined;
}

/** Start/Stop Detection (SSD) Values */
export class RGPStartStopDetectionDto implements IRGPStartStopDetectionDto {
    /** Start/Stop detection enabled */
    enabled!: boolean;
    /** Data source (Drill or Feed) */
    dataSource!: RGPDataSourceType;
    /** Entry level (%) */
    entryLevelPercent!: number;
    /** Maximum entry depth (cm) */
    entryLengthMax!: number;
    /** Piercing mode (false=partial, true=full) */
    fullPiercingMode!: boolean;
    /** Exit mode (false=fixed, true=delta) */
    deltaExitMode!: boolean;
    /** Fixed mode exit level (%) */
    exitFixedLevel!: number;
    /** Delta mode exit level (%) */
    exitDeltaLevel!: number;
    /** Delta mode exit width (cm) */
    exitDeltaWidth!: number;
    /** Includes user defined start/stop values */
    manualValues!: boolean;
    /** Detection result (0=success, >0=error) */
    detectionResult!: number;
    /** Start depth (cm) */
    startDepth!: number;
    /** Stop depth (cm) */
    stopDepth!: number;
    /** Length, stop minus start depth (cm) */
    length!: number;
    /** Center depth (cm) */
    center!: number;
    /** Needle entry found */
    entryFound!: boolean;
    /** Needle exit found */
    exitFound!: boolean;
    /** Glitch filter on/off */
    glitchFilterEnabled!: boolean;
    /** Glitch filter width (cm) */
    glitchFilterWidth!: number;
    /** Detect needle exit automatic diameter detection measurement */
    exitDetectAutomaticDiameterDetection!: boolean;
    /** Detect needle exit above ground level measurement */
    exitDetectAboveGroundLine!: boolean;
    /** Detect needle exit below ground level measurement */
    exitDetectBelowGroundLine!: boolean;
    /** Needle exit vertical needle drift (degree) */
    exitDriftVertical!: number;
    /** Needle exit horizontal needle drift (degree) */
    exitDriftHorizontal!: number;
    /** Needle exit minimum needle drift (cm) */
    exitDriftMin!: number;
    /** Needle exit reference length (cm) */
    exitReferenceLength!: number;
    /** Needle exit reference factor (%) */
    exitReferenceFactor!: number;
    /** Needle exit reference minimum (%) */
    exitReferenceMin!: number;
    /** Needle exit slope width (cm) */
    exitSlopeWidth!: number;
    /** Needle exit slope level (%) */
    exitSlopeLevel!: number;
    /** Needle exit difference to minimum (%) */
    exitSlopeDiffToMin!: number;
    /** Needle exit separation reference length (cm) */
    exitSeparationReferenceLength!: number;
    /** Needle exit separation reference atn. (%) */
    exitSeparationReferenceAtten!: number;
    /** Needle exit separation minimum level (%) */
    exitSeparationLevelMin!: number;
    /** Needle exit separation width (cm) */
    exitSeparationWidth!: number;
    /** Pole start depth (cm) */
    poleStart!: number;
    /** Pole stop depth (cm) */
    poleStop!: number;
    /** Needle exit detection start depth (cm) */
    poleExitStart!: number;
    /** Needle exit detection stop depth (cm) */
    poleExitStop!: number;

    constructor(data?: IRGPStartStopDetectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.dataSource = _data["dataSource"];
            this.entryLevelPercent = _data["entryLevelPercent"];
            this.entryLengthMax = _data["entryLengthMax"];
            this.fullPiercingMode = _data["fullPiercingMode"];
            this.deltaExitMode = _data["deltaExitMode"];
            this.exitFixedLevel = _data["exitFixedLevel"];
            this.exitDeltaLevel = _data["exitDeltaLevel"];
            this.exitDeltaWidth = _data["exitDeltaWidth"];
            this.manualValues = _data["manualValues"];
            this.detectionResult = _data["detectionResult"];
            this.startDepth = _data["startDepth"];
            this.stopDepth = _data["stopDepth"];
            this.length = _data["length"];
            this.center = _data["center"];
            this.entryFound = _data["entryFound"];
            this.exitFound = _data["exitFound"];
            this.glitchFilterEnabled = _data["glitchFilterEnabled"];
            this.glitchFilterWidth = _data["glitchFilterWidth"];
            this.exitDetectAutomaticDiameterDetection = _data["exitDetectAutomaticDiameterDetection"];
            this.exitDetectAboveGroundLine = _data["exitDetectAboveGroundLine"];
            this.exitDetectBelowGroundLine = _data["exitDetectBelowGroundLine"];
            this.exitDriftVertical = _data["exitDriftVertical"];
            this.exitDriftHorizontal = _data["exitDriftHorizontal"];
            this.exitDriftMin = _data["exitDriftMin"];
            this.exitReferenceLength = _data["exitReferenceLength"];
            this.exitReferenceFactor = _data["exitReferenceFactor"];
            this.exitReferenceMin = _data["exitReferenceMin"];
            this.exitSlopeWidth = _data["exitSlopeWidth"];
            this.exitSlopeLevel = _data["exitSlopeLevel"];
            this.exitSlopeDiffToMin = _data["exitSlopeDiffToMin"];
            this.exitSeparationReferenceLength = _data["exitSeparationReferenceLength"];
            this.exitSeparationReferenceAtten = _data["exitSeparationReferenceAtten"];
            this.exitSeparationLevelMin = _data["exitSeparationLevelMin"];
            this.exitSeparationWidth = _data["exitSeparationWidth"];
            this.poleStart = _data["poleStart"];
            this.poleStop = _data["poleStop"];
            this.poleExitStart = _data["poleExitStart"];
            this.poleExitStop = _data["poleExitStop"];
        }
    }

    static fromJS(data: any): RGPStartStopDetectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPStartStopDetectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["dataSource"] = this.dataSource;
        data["entryLevelPercent"] = this.entryLevelPercent;
        data["entryLengthMax"] = this.entryLengthMax;
        data["fullPiercingMode"] = this.fullPiercingMode;
        data["deltaExitMode"] = this.deltaExitMode;
        data["exitFixedLevel"] = this.exitFixedLevel;
        data["exitDeltaLevel"] = this.exitDeltaLevel;
        data["exitDeltaWidth"] = this.exitDeltaWidth;
        data["manualValues"] = this.manualValues;
        data["detectionResult"] = this.detectionResult;
        data["startDepth"] = this.startDepth;
        data["stopDepth"] = this.stopDepth;
        data["length"] = this.length;
        data["center"] = this.center;
        data["entryFound"] = this.entryFound;
        data["exitFound"] = this.exitFound;
        data["glitchFilterEnabled"] = this.glitchFilterEnabled;
        data["glitchFilterWidth"] = this.glitchFilterWidth;
        data["exitDetectAutomaticDiameterDetection"] = this.exitDetectAutomaticDiameterDetection;
        data["exitDetectAboveGroundLine"] = this.exitDetectAboveGroundLine;
        data["exitDetectBelowGroundLine"] = this.exitDetectBelowGroundLine;
        data["exitDriftVertical"] = this.exitDriftVertical;
        data["exitDriftHorizontal"] = this.exitDriftHorizontal;
        data["exitDriftMin"] = this.exitDriftMin;
        data["exitReferenceLength"] = this.exitReferenceLength;
        data["exitReferenceFactor"] = this.exitReferenceFactor;
        data["exitReferenceMin"] = this.exitReferenceMin;
        data["exitSlopeWidth"] = this.exitSlopeWidth;
        data["exitSlopeLevel"] = this.exitSlopeLevel;
        data["exitSlopeDiffToMin"] = this.exitSlopeDiffToMin;
        data["exitSeparationReferenceLength"] = this.exitSeparationReferenceLength;
        data["exitSeparationReferenceAtten"] = this.exitSeparationReferenceAtten;
        data["exitSeparationLevelMin"] = this.exitSeparationLevelMin;
        data["exitSeparationWidth"] = this.exitSeparationWidth;
        data["poleStart"] = this.poleStart;
        data["poleStop"] = this.poleStop;
        data["poleExitStart"] = this.poleExitStart;
        data["poleExitStop"] = this.poleExitStop;
        return data;
    }

    clone(): RGPStartStopDetectionDto {
        const json = this.toJSON();
        let result = new RGPStartStopDetectionDto();
        result.init(json);
        return result;
    }
}

/** Start/Stop Detection (SSD) Values */
export interface IRGPStartStopDetectionDto {
    /** Start/Stop detection enabled */
    enabled: boolean;
    /** Data source (Drill or Feed) */
    dataSource: RGPDataSourceType;
    /** Entry level (%) */
    entryLevelPercent: number;
    /** Maximum entry depth (cm) */
    entryLengthMax: number;
    /** Piercing mode (false=partial, true=full) */
    fullPiercingMode: boolean;
    /** Exit mode (false=fixed, true=delta) */
    deltaExitMode: boolean;
    /** Fixed mode exit level (%) */
    exitFixedLevel: number;
    /** Delta mode exit level (%) */
    exitDeltaLevel: number;
    /** Delta mode exit width (cm) */
    exitDeltaWidth: number;
    /** Includes user defined start/stop values */
    manualValues: boolean;
    /** Detection result (0=success, >0=error) */
    detectionResult: number;
    /** Start depth (cm) */
    startDepth: number;
    /** Stop depth (cm) */
    stopDepth: number;
    /** Length, stop minus start depth (cm) */
    length: number;
    /** Center depth (cm) */
    center: number;
    /** Needle entry found */
    entryFound: boolean;
    /** Needle exit found */
    exitFound: boolean;
    /** Glitch filter on/off */
    glitchFilterEnabled: boolean;
    /** Glitch filter width (cm) */
    glitchFilterWidth: number;
    /** Detect needle exit automatic diameter detection measurement */
    exitDetectAutomaticDiameterDetection: boolean;
    /** Detect needle exit above ground level measurement */
    exitDetectAboveGroundLine: boolean;
    /** Detect needle exit below ground level measurement */
    exitDetectBelowGroundLine: boolean;
    /** Needle exit vertical needle drift (degree) */
    exitDriftVertical: number;
    /** Needle exit horizontal needle drift (degree) */
    exitDriftHorizontal: number;
    /** Needle exit minimum needle drift (cm) */
    exitDriftMin: number;
    /** Needle exit reference length (cm) */
    exitReferenceLength: number;
    /** Needle exit reference factor (%) */
    exitReferenceFactor: number;
    /** Needle exit reference minimum (%) */
    exitReferenceMin: number;
    /** Needle exit slope width (cm) */
    exitSlopeWidth: number;
    /** Needle exit slope level (%) */
    exitSlopeLevel: number;
    /** Needle exit difference to minimum (%) */
    exitSlopeDiffToMin: number;
    /** Needle exit separation reference length (cm) */
    exitSeparationReferenceLength: number;
    /** Needle exit separation reference atn. (%) */
    exitSeparationReferenceAtten: number;
    /** Needle exit separation minimum level (%) */
    exitSeparationLevelMin: number;
    /** Needle exit separation width (cm) */
    exitSeparationWidth: number;
    /** Pole start depth (cm) */
    poleStart: number;
    /** Pole stop depth (cm) */
    poleStop: number;
    /** Needle exit detection start depth (cm) */
    poleExitStart: number;
    /** Needle exit detection stop depth (cm) */
    poleExitStop: number;
}

/** WoodInspector Values */
export class RGPWoodInspectorDto implements IRGPWoodInspectorDto {
    /** WoodInspector enabled */
    enabled!: boolean;
    /** WoodInspector program type */
    program!: RGPWoodInspectorProgramType;
    /** WoodInspector standard program */
    standard!: RGPStandardDto | undefined;
    /** WoodInspector pole program */
    pole!: RGPPoleDto | undefined;

    constructor(data?: IRGPWoodInspectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.program = _data["program"];
            this.standard = _data["standard"] ? RGPStandardDto.fromJS(_data["standard"]) : <any>undefined;
            this.pole = _data["pole"] ? RGPPoleDto.fromJS(_data["pole"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RGPWoodInspectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPWoodInspectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["program"] = this.program;
        data["standard"] = this.standard ? this.standard.toJSON() : <any>undefined;
        data["pole"] = this.pole ? this.pole.toJSON() : <any>undefined;
        return data;
    }

    clone(): RGPWoodInspectorDto {
        const json = this.toJSON();
        let result = new RGPWoodInspectorDto();
        result.init(json);
        return result;
    }
}

/** WoodInspector Values */
export interface IRGPWoodInspectorDto {
    /** WoodInspector enabled */
    enabled: boolean;
    /** WoodInspector program type */
    program: RGPWoodInspectorProgramType;
    /** WoodInspector standard program */
    standard: RGPStandardDto | undefined;
    /** WoodInspector pole program */
    pole: RGPPoleDto | undefined;
}

/** Pole measurement results */
export class RGPWoodInspectorPoleResultDto implements IRGPWoodInspectorPoleResultDto {
    /** Pole Result status */
    result!: RGPPoleResultType;
    /** Contains shell rot */
    foundShellRot!: boolean;
    /** Data section checksum */
    checksum!: number;

    constructor(data?: IRGPWoodInspectorPoleResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.foundShellRot = _data["foundShellRot"];
            this.checksum = _data["checksum"];
        }
    }

    static fromJS(data: any): RGPWoodInspectorPoleResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RGPWoodInspectorPoleResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["foundShellRot"] = this.foundShellRot;
        data["checksum"] = this.checksum;
        return data;
    }

    clone(): RGPWoodInspectorPoleResultDto {
        const json = this.toJSON();
        let result = new RGPWoodInspectorPoleResultDto();
        result.init(json);
        return result;
    }
}

/** Pole measurement results */
export interface IRGPWoodInspectorPoleResultDto {
    /** Pole Result status */
    result: RGPPoleResultType;
    /** Contains shell rot */
    foundShellRot: boolean;
    /** Data section checksum */
    checksum: number;
}

export enum RGPWoodInspectorProgramType {
    _0 = 0,
    _1 = 1,
}

export class RSAParameters implements IRSAParameters {

    constructor(data?: IRSAParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RSAParameters {
        data = typeof data === 'object' ? data : {};
        let result = new RSAParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): RSAParameters {
        const json = this.toJSON();
        let result = new RSAParameters();
        result.init(json);
        return result;
    }
}

export interface IRSAParameters {
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items!: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class SiteDto implements ISiteDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SiteDto {
        const json = this.toJSON();
        let result = new SiteDto();
        result.init(json);
        return result;
    }
}

export interface ISiteDto {
    id: number;
    name: string | undefined;
}

export class SpanConditionData implements ISpanConditionData {
    inspectionMethod!: string | undefined;
    conditionItemType!: string | undefined;
    conditionType!: string | undefined;
    foundInFieldTime!: moment.Moment | undefined;
    foundInFieldBy!: string | undefined;
    qcBypass!: boolean;
    conditionName!: string | undefined;
    comments!: string | undefined;
    rwcid!: string | undefined;
    distance!: string | undefined;
    centroidLatitude!: number | undefined;
    centroidLongitude!: number | undefined;
    lidarId!: string | undefined;
    spanLidarId!: number;
    polyLineData!: string | undefined;

    constructor(data?: ISpanConditionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionMethod = _data["inspectionMethod"];
            this.conditionItemType = _data["conditionItemType"];
            this.conditionType = _data["conditionType"];
            this.foundInFieldTime = _data["foundInFieldTime"] ? moment(_data["foundInFieldTime"].toString()) : <any>undefined;
            this.foundInFieldBy = _data["foundInFieldBy"];
            this.qcBypass = _data["qcBypass"];
            this.conditionName = _data["conditionName"];
            this.comments = _data["comments"];
            this.rwcid = _data["rwcid"];
            this.distance = _data["distance"];
            this.centroidLatitude = _data["centroidLatitude"];
            this.centroidLongitude = _data["centroidLongitude"];
            this.lidarId = _data["lidarId"];
            this.spanLidarId = _data["spanLidarId"];
            this.polyLineData = _data["polyLineData"];
        }
    }

    static fromJS(data: any): SpanConditionData {
        data = typeof data === 'object' ? data : {};
        let result = new SpanConditionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionMethod"] = this.inspectionMethod;
        data["conditionItemType"] = this.conditionItemType;
        data["conditionType"] = this.conditionType;
        data["foundInFieldTime"] = this.foundInFieldTime ? this.foundInFieldTime.toISOString() : <any>undefined;
        data["foundInFieldBy"] = this.foundInFieldBy;
        data["qcBypass"] = this.qcBypass;
        data["conditionName"] = this.conditionName;
        data["comments"] = this.comments;
        data["rwcid"] = this.rwcid;
        data["distance"] = this.distance;
        data["centroidLatitude"] = this.centroidLatitude;
        data["centroidLongitude"] = this.centroidLongitude;
        data["lidarId"] = this.lidarId;
        data["spanLidarId"] = this.spanLidarId;
        data["polyLineData"] = this.polyLineData;
        return data;
    }

    clone(): SpanConditionData {
        const json = this.toJSON();
        let result = new SpanConditionData();
        result.init(json);
        return result;
    }
}

export interface ISpanConditionData {
    inspectionMethod: string | undefined;
    conditionItemType: string | undefined;
    conditionType: string | undefined;
    foundInFieldTime: moment.Moment | undefined;
    foundInFieldBy: string | undefined;
    qcBypass: boolean;
    conditionName: string | undefined;
    comments: string | undefined;
    rwcid: string | undefined;
    distance: string | undefined;
    centroidLatitude: number | undefined;
    centroidLongitude: number | undefined;
    lidarId: string | undefined;
    spanLidarId: number;
    polyLineData: string | undefined;
}

export class SpanData implements ISpanData {
    spanName!: string | undefined;
    lidarId!: number;
    spanLength!: number | undefined;
    voltage!: string | undefined;
    wireMaterial!: string | undefined;
    startAssetId!: number | undefined;
    endAssetId!: number | undefined;
    polyLineData!: string | undefined;

    constructor(data?: ISpanData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spanName = _data["spanName"];
            this.lidarId = _data["lidarId"];
            this.spanLength = _data["spanLength"];
            this.voltage = _data["voltage"];
            this.wireMaterial = _data["wireMaterial"];
            this.startAssetId = _data["startAssetId"];
            this.endAssetId = _data["endAssetId"];
            this.polyLineData = _data["polyLineData"];
        }
    }

    static fromJS(data: any): SpanData {
        data = typeof data === 'object' ? data : {};
        let result = new SpanData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spanName"] = this.spanName;
        data["lidarId"] = this.lidarId;
        data["spanLength"] = this.spanLength;
        data["voltage"] = this.voltage;
        data["wireMaterial"] = this.wireMaterial;
        data["startAssetId"] = this.startAssetId;
        data["endAssetId"] = this.endAssetId;
        data["polyLineData"] = this.polyLineData;
        return data;
    }

    clone(): SpanData {
        const json = this.toJSON();
        let result = new SpanData();
        result.init(json);
        return result;
    }
}

export interface ISpanData {
    spanName: string | undefined;
    lidarId: number;
    spanLength: number | undefined;
    voltage: string | undefined;
    wireMaterial: string | undefined;
    startAssetId: number | undefined;
    endAssetId: number | undefined;
    polyLineData: string | undefined;
}

/** SpanDto represents data for a span type asset. */
export class SpanDto implements ISpanDto {
    id!: number;
    /** The Tenant Id for which the span is being returned for. */
    tenantId!: number;
    /** The Inspection Id for which the span is being returned for. */
    inspectionId!: number;
    /** The Inspection for which the span is being returned for. */
    inspection!: InspectionDto | undefined;
    /** Facility Id of the span. */
    facilityId!: string | undefined;
    /** THe Collector Id for the span, available on a given inspection */
    collectorId!: string | undefined;
    /** JSon data of custom asset properties values */
    customProperties!: string | undefined;
    /** The list of custom asset properties and their values related to the span */
    customPropertyValues!: CustomAssetPropertyValueDto[] | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId!: number | undefined;
    /** Facility id of the starting point pole for the span */
    startAssetFacilityId!: string | undefined;
    /** Identifier for the ending point pole for the span */
    endAssetId!: number | undefined;
    /** Facility id for the ending point pole for the span */
    endAssetFacilityId!: string | undefined;
    /** Length of the span */
    spanLength!: number | undefined;
    /** The construction type of the span */
    constructionType!: string | undefined;
    /** The voltage carried by the span */
    voltage!: string | undefined;
    /** Identifier from LIDAR import used to discern possibly duplication within upload */
    lidarId!: number;
    /** A semicolon delimited string of coordinates for the polylines needed for the span */
    polyLineData!: string | undefined;
    /** Display string for circuits related to the span */
    circuitDisplayList!: string | undefined;
    /** List of relationships between circuits and assets related to the span */
    circuitToAssets!: CircuitToAssetDto[] | undefined;

    constructor(data?: ISpanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.facilityId = _data["facilityId"];
            this.collectorId = _data["collectorId"];
            this.customProperties = _data["customProperties"];
            if (Array.isArray(_data["customPropertyValues"])) {
                this.customPropertyValues = [] as any;
                for (let item of _data["customPropertyValues"])
                    this.customPropertyValues!.push(CustomAssetPropertyValueDto.fromJS(item));
            }
            this.startAssetId = _data["startAssetId"];
            this.startAssetFacilityId = _data["startAssetFacilityId"];
            this.endAssetId = _data["endAssetId"];
            this.endAssetFacilityId = _data["endAssetFacilityId"];
            this.spanLength = _data["spanLength"];
            this.constructionType = _data["constructionType"];
            this.voltage = _data["voltage"];
            this.lidarId = _data["lidarId"];
            this.polyLineData = _data["polyLineData"];
            this.circuitDisplayList = _data["circuitDisplayList"];
            if (Array.isArray(_data["circuitToAssets"])) {
                this.circuitToAssets = [] as any;
                for (let item of _data["circuitToAssets"])
                    this.circuitToAssets!.push(CircuitToAssetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpanDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["facilityId"] = this.facilityId;
        data["collectorId"] = this.collectorId;
        data["customProperties"] = this.customProperties;
        if (Array.isArray(this.customPropertyValues)) {
            data["customPropertyValues"] = [];
            for (let item of this.customPropertyValues)
                data["customPropertyValues"].push(item.toJSON());
        }
        data["startAssetId"] = this.startAssetId;
        data["startAssetFacilityId"] = this.startAssetFacilityId;
        data["endAssetId"] = this.endAssetId;
        data["endAssetFacilityId"] = this.endAssetFacilityId;
        data["spanLength"] = this.spanLength;
        data["constructionType"] = this.constructionType;
        data["voltage"] = this.voltage;
        data["lidarId"] = this.lidarId;
        data["polyLineData"] = this.polyLineData;
        data["circuitDisplayList"] = this.circuitDisplayList;
        if (Array.isArray(this.circuitToAssets)) {
            data["circuitToAssets"] = [];
            for (let item of this.circuitToAssets)
                data["circuitToAssets"].push(item.toJSON());
        }
        return data;
    }

    clone(): SpanDto {
        const json = this.toJSON();
        let result = new SpanDto();
        result.init(json);
        return result;
    }
}

/** SpanDto represents data for a span type asset. */
export interface ISpanDto {
    id: number;
    /** The Tenant Id for which the span is being returned for. */
    tenantId: number;
    /** The Inspection Id for which the span is being returned for. */
    inspectionId: number;
    /** The Inspection for which the span is being returned for. */
    inspection: InspectionDto | undefined;
    /** Facility Id of the span. */
    facilityId: string | undefined;
    /** THe Collector Id for the span, available on a given inspection */
    collectorId: string | undefined;
    /** JSon data of custom asset properties values */
    customProperties: string | undefined;
    /** The list of custom asset properties and their values related to the span */
    customPropertyValues: CustomAssetPropertyValueDto[] | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId: number | undefined;
    /** Facility id of the starting point pole for the span */
    startAssetFacilityId: string | undefined;
    /** Identifier for the ending point pole for the span */
    endAssetId: number | undefined;
    /** Facility id for the ending point pole for the span */
    endAssetFacilityId: string | undefined;
    /** Length of the span */
    spanLength: number | undefined;
    /** The construction type of the span */
    constructionType: string | undefined;
    /** The voltage carried by the span */
    voltage: string | undefined;
    /** Identifier from LIDAR import used to discern possibly duplication within upload */
    lidarId: number;
    /** A semicolon delimited string of coordinates for the polylines needed for the span */
    polyLineData: string | undefined;
    /** Display string for circuits related to the span */
    circuitDisplayList: string | undefined;
    /** List of relationships between circuits and assets related to the span */
    circuitToAssets: CircuitToAssetDto[] | undefined;
}

export class SpanDtoPagedResultDto implements ISpanDtoPagedResultDto {
    items!: SpanDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISpanDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpanDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SpanDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpanDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SpanDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SpanDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISpanDtoPagedResultDto {
    items: SpanDto[] | undefined;
    totalCount: number;
}

export class SpanInfoDto implements ISpanInfoDto {
    id!: number;
    /** The Tenant Id for which the span is being returned for. */
    tenantId!: number;
    /** The Inspection Id for which the span is being returned for. */
    inspectionId!: number;
    /** The Inspection for which the span is being returned for. */
    inspection!: InspectionDto | undefined;
    /** Facility Id of the span. */
    facilityId!: string | undefined;
    /** THe Collector Id for the span, available on a given inspection */
    collectorId!: string | undefined;
    /** JSon data of custom asset properties values */
    customProperties!: string | undefined;
    /** The list of custom asset properties and their values related to the span */
    customPropertyValues!: CustomAssetPropertyValueDto[] | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId!: number | undefined;
    /** Facility id of the starting point pole for the span */
    startAssetFacilityId!: string | undefined;
    /** Identifier for the ending point pole for the span */
    endAssetId!: number | undefined;
    /** Facility id for the ending point pole for the span */
    endAssetFacilityId!: string | undefined;
    /** Length of the span */
    spanLength!: number | undefined;
    /** The construction type of the span */
    constructionType!: string | undefined;
    /** The voltage carried by the span */
    voltage!: string | undefined;
    /** Identifier from LIDAR import used to discern possibly duplication within upload */
    lidarId!: number;
    /** A semicolon delimited string of coordinates for the polylines needed for the span */
    polyLineData!: string | undefined;
    /** Display string for circuits related to the span */
    circuitDisplayList!: string | undefined;
    /** List of relationships between circuits and assets related to the span */
    circuitToAssets!: CircuitToAssetDto[] | undefined;
    /** List of circuits to set to the asset. */
    circuits!: CircuitDto[] | undefined;
    /** List of images on the span for the inspection being retrieved */
    images!: ImageDto[] | undefined;
    /** The display name of the span */
    readonly displayName!: string | undefined;

    constructor(data?: ISpanInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.facilityId = _data["facilityId"];
            this.collectorId = _data["collectorId"];
            this.customProperties = _data["customProperties"];
            if (Array.isArray(_data["customPropertyValues"])) {
                this.customPropertyValues = [] as any;
                for (let item of _data["customPropertyValues"])
                    this.customPropertyValues!.push(CustomAssetPropertyValueDto.fromJS(item));
            }
            this.startAssetId = _data["startAssetId"];
            this.startAssetFacilityId = _data["startAssetFacilityId"];
            this.endAssetId = _data["endAssetId"];
            this.endAssetFacilityId = _data["endAssetFacilityId"];
            this.spanLength = _data["spanLength"];
            this.constructionType = _data["constructionType"];
            this.voltage = _data["voltage"];
            this.lidarId = _data["lidarId"];
            this.polyLineData = _data["polyLineData"];
            this.circuitDisplayList = _data["circuitDisplayList"];
            if (Array.isArray(_data["circuitToAssets"])) {
                this.circuitToAssets = [] as any;
                for (let item of _data["circuitToAssets"])
                    this.circuitToAssets!.push(CircuitToAssetDto.fromJS(item));
            }
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            (<any>this).displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SpanInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpanInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["facilityId"] = this.facilityId;
        data["collectorId"] = this.collectorId;
        data["customProperties"] = this.customProperties;
        if (Array.isArray(this.customPropertyValues)) {
            data["customPropertyValues"] = [];
            for (let item of this.customPropertyValues)
                data["customPropertyValues"].push(item.toJSON());
        }
        data["startAssetId"] = this.startAssetId;
        data["startAssetFacilityId"] = this.startAssetFacilityId;
        data["endAssetId"] = this.endAssetId;
        data["endAssetFacilityId"] = this.endAssetFacilityId;
        data["spanLength"] = this.spanLength;
        data["constructionType"] = this.constructionType;
        data["voltage"] = this.voltage;
        data["lidarId"] = this.lidarId;
        data["polyLineData"] = this.polyLineData;
        data["circuitDisplayList"] = this.circuitDisplayList;
        if (Array.isArray(this.circuitToAssets)) {
            data["circuitToAssets"] = [];
            for (let item of this.circuitToAssets)
                data["circuitToAssets"].push(item.toJSON());
        }
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): SpanInfoDto {
        const json = this.toJSON();
        let result = new SpanInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISpanInfoDto {
    id: number;
    /** The Tenant Id for which the span is being returned for. */
    tenantId: number;
    /** The Inspection Id for which the span is being returned for. */
    inspectionId: number;
    /** The Inspection for which the span is being returned for. */
    inspection: InspectionDto | undefined;
    /** Facility Id of the span. */
    facilityId: string | undefined;
    /** THe Collector Id for the span, available on a given inspection */
    collectorId: string | undefined;
    /** JSon data of custom asset properties values */
    customProperties: string | undefined;
    /** The list of custom asset properties and their values related to the span */
    customPropertyValues: CustomAssetPropertyValueDto[] | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId: number | undefined;
    /** Facility id of the starting point pole for the span */
    startAssetFacilityId: string | undefined;
    /** Identifier for the ending point pole for the span */
    endAssetId: number | undefined;
    /** Facility id for the ending point pole for the span */
    endAssetFacilityId: string | undefined;
    /** Length of the span */
    spanLength: number | undefined;
    /** The construction type of the span */
    constructionType: string | undefined;
    /** The voltage carried by the span */
    voltage: string | undefined;
    /** Identifier from LIDAR import used to discern possibly duplication within upload */
    lidarId: number;
    /** A semicolon delimited string of coordinates for the polylines needed for the span */
    polyLineData: string | undefined;
    /** Display string for circuits related to the span */
    circuitDisplayList: string | undefined;
    /** List of relationships between circuits and assets related to the span */
    circuitToAssets: CircuitToAssetDto[] | undefined;
    /** List of circuits to set to the asset. */
    circuits: CircuitDto[] | undefined;
    /** List of images on the span for the inspection being retrieved */
    images: ImageDto[] | undefined;
    /** The display name of the span */
    displayName: string | undefined;
}

/** Dto for ComputerVisionModels for Suggested Inventory */
export class SuggestedInventoryResultsDto implements ISuggestedInventoryResultsDto {
    /** The id of the ComputerVisionModel */
    computerVisionModelId!: number;
    /** The name of the ComputerVisionModel */
    computerVisionModelName!: string | undefined;
    /** The ComputerVisionModelLabels under this ComputerVisionModel */
    computerVisionModelLabels!: ComputerVisionModelLabelInventorySuggestionDto[] | undefined;

    constructor(data?: ISuggestedInventoryResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.computerVisionModelName = _data["computerVisionModelName"];
            if (Array.isArray(_data["computerVisionModelLabels"])) {
                this.computerVisionModelLabels = [] as any;
                for (let item of _data["computerVisionModelLabels"])
                    this.computerVisionModelLabels!.push(ComputerVisionModelLabelInventorySuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuggestedInventoryResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestedInventoryResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["computerVisionModelName"] = this.computerVisionModelName;
        if (Array.isArray(this.computerVisionModelLabels)) {
            data["computerVisionModelLabels"] = [];
            for (let item of this.computerVisionModelLabels)
                data["computerVisionModelLabels"].push(item.toJSON());
        }
        return data;
    }

    clone(): SuggestedInventoryResultsDto {
        const json = this.toJSON();
        let result = new SuggestedInventoryResultsDto();
        result.init(json);
        return result;
    }
}

/** Dto for ComputerVisionModels for Suggested Inventory */
export interface ISuggestedInventoryResultsDto {
    /** The id of the ComputerVisionModel */
    computerVisionModelId: number;
    /** The name of the ComputerVisionModel */
    computerVisionModelName: string | undefined;
    /** The ComputerVisionModelLabels under this ComputerVisionModel */
    computerVisionModelLabels: ComputerVisionModelLabelInventorySuggestionDto[] | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** DTO specifically to handle displaying the Tenant Condition hierarchy to the Tree List components for DevExtreme in the UI */
export class TenantConditionNodeDto implements ITenantConditionNodeDto {
    /** Compound IDs should be in the form EntityTypeName_# */
    compoundId!: string | undefined;
    /** Compound ID for Parent Object (for Plain Data structure) */
    parentCompoundId!: string | undefined;
    /** Name of the Entity level within the Condition tree hierarchy */
    entityName!: string | undefined;
    /** Utilized by Condition Suggestion nodes */
    suggestionId!: number | undefined;
    /** Utilized by Condition Type and Condition Suggestion nodes */
    typeId!: number | undefined;
    /** Utilized by any hierarchy of Condition related node */
    itemTypeId!: number | undefined;
    /** Name assigned to the Condition node object */
    name!: string | undefined;
    /** Default RWCID value, utilized by Condition Suggestion nodes */
    defaultRwcid!: string | undefined;
    /** Inspection Method, utilized by Condition Suggestion nodes */
    inspectionMethod!: string | undefined;
    /** Computer Vision Model Id, utilized by Condition Suggestion nodes */
    computerVisionModelId!: number | undefined;
    /** Computer Vision Model Label Id, utilized by the Condition Type nodes */
    computerVisionModelLabelId!: number | undefined;
    /** Short Name, utilized by Condition Suggestion nodes */
    shortName!: string | undefined;
    /** Boolean determining whether or not the current condition hierarchy item
has any child items */
    hasItems!: boolean;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available Conditions to use */
    isAvailableForConditions!: boolean | undefined;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available for Inventory Items to use */
    isAvailableForInventoryItems!: boolean | undefined;
    /** Utilized by Suggestion nodes, a flag denoting whether this Suggestion is available in the Collector app */
    isAvailableInCollector!: boolean | undefined;

    constructor(data?: ITenantConditionNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compoundId = _data["compoundId"];
            this.parentCompoundId = _data["parentCompoundId"];
            this.entityName = _data["entityName"];
            this.suggestionId = _data["suggestionId"];
            this.typeId = _data["typeId"];
            this.itemTypeId = _data["itemTypeId"];
            this.name = _data["name"];
            this.defaultRwcid = _data["defaultRwcid"];
            this.inspectionMethod = _data["inspectionMethod"];
            this.computerVisionModelId = _data["computerVisionModelId"];
            this.computerVisionModelLabelId = _data["computerVisionModelLabelId"];
            this.shortName = _data["shortName"];
            this.hasItems = _data["hasItems"];
            this.isAvailableForConditions = _data["isAvailableForConditions"];
            this.isAvailableForInventoryItems = _data["isAvailableForInventoryItems"];
            this.isAvailableInCollector = _data["isAvailableInCollector"];
        }
    }

    static fromJS(data: any): TenantConditionNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantConditionNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compoundId"] = this.compoundId;
        data["parentCompoundId"] = this.parentCompoundId;
        data["entityName"] = this.entityName;
        data["suggestionId"] = this.suggestionId;
        data["typeId"] = this.typeId;
        data["itemTypeId"] = this.itemTypeId;
        data["name"] = this.name;
        data["defaultRwcid"] = this.defaultRwcid;
        data["inspectionMethod"] = this.inspectionMethod;
        data["computerVisionModelId"] = this.computerVisionModelId;
        data["computerVisionModelLabelId"] = this.computerVisionModelLabelId;
        data["shortName"] = this.shortName;
        data["hasItems"] = this.hasItems;
        data["isAvailableForConditions"] = this.isAvailableForConditions;
        data["isAvailableForInventoryItems"] = this.isAvailableForInventoryItems;
        data["isAvailableInCollector"] = this.isAvailableInCollector;
        return data;
    }

    clone(): TenantConditionNodeDto {
        const json = this.toJSON();
        let result = new TenantConditionNodeDto();
        result.init(json);
        return result;
    }
}

/** DTO specifically to handle displaying the Tenant Condition hierarchy to the Tree List components for DevExtreme in the UI */
export interface ITenantConditionNodeDto {
    /** Compound IDs should be in the form EntityTypeName_# */
    compoundId: string | undefined;
    /** Compound ID for Parent Object (for Plain Data structure) */
    parentCompoundId: string | undefined;
    /** Name of the Entity level within the Condition tree hierarchy */
    entityName: string | undefined;
    /** Utilized by Condition Suggestion nodes */
    suggestionId: number | undefined;
    /** Utilized by Condition Type and Condition Suggestion nodes */
    typeId: number | undefined;
    /** Utilized by any hierarchy of Condition related node */
    itemTypeId: number | undefined;
    /** Name assigned to the Condition node object */
    name: string | undefined;
    /** Default RWCID value, utilized by Condition Suggestion nodes */
    defaultRwcid: string | undefined;
    /** Inspection Method, utilized by Condition Suggestion nodes */
    inspectionMethod: string | undefined;
    /** Computer Vision Model Id, utilized by Condition Suggestion nodes */
    computerVisionModelId: number | undefined;
    /** Computer Vision Model Label Id, utilized by the Condition Type nodes */
    computerVisionModelLabelId: number | undefined;
    /** Short Name, utilized by Condition Suggestion nodes */
    shortName: string | undefined;
    /** Boolean determining whether or not the current condition hierarchy item
has any child items */
    hasItems: boolean;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available Conditions to use */
    isAvailableForConditions: boolean | undefined;
    /** Utilized by Item Type nodes, a flag denoting whether this Suggestion is available for Inventory Items to use */
    isAvailableForInventoryItems: boolean | undefined;
    /** Utilized by Suggestion nodes, a flag denoting whether this Suggestion is available in the Collector app */
    isAvailableInCollector: boolean | undefined;
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;
    /** Determines whether work order fields are turned on or off */
    defaultWorkOrderFields!: boolean;
    /** Tenant work order name */
    defaultWorkOrderTitle!: string | undefined;
    inspections!: InspectionDto[] | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.defaultWorkOrderFields = _data["defaultWorkOrderFields"];
            this.defaultWorkOrderTitle = _data["defaultWorkOrderTitle"];
            if (Array.isArray(_data["inspections"])) {
                this.inspections = [] as any;
                for (let item of _data["inspections"])
                    this.inspections!.push(InspectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["defaultWorkOrderFields"] = this.defaultWorkOrderFields;
        data["defaultWorkOrderTitle"] = this.defaultWorkOrderTitle;
        if (Array.isArray(this.inspections)) {
            data["inspections"] = [];
            for (let item of this.inspections)
                data["inspections"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    /** Determines whether work order fields are turned on or off */
    defaultWorkOrderFields: boolean;
    /** Tenant work order name */
    defaultWorkOrderTitle: string | undefined;
    inspections: InspectionDto[] | undefined;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantInfoDto implements ITenantInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    /** Determines whether work order fields are turned on or off */
    defaultWorkOrderFields!: boolean;
    /** Tenant work order name */
    defaultWorkOrderTitle!: string | undefined;

    constructor(data?: ITenantInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.defaultWorkOrderFields = _data["defaultWorkOrderFields"];
            this.defaultWorkOrderTitle = _data["defaultWorkOrderTitle"];
        }
    }

    static fromJS(data: any): TenantInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["defaultWorkOrderFields"] = this.defaultWorkOrderFields;
        data["defaultWorkOrderTitle"] = this.defaultWorkOrderTitle;
        return data;
    }

    clone(): TenantInfoDto {
        const json = this.toJSON();
        let result = new TenantInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    /** Determines whether work order fields are turned on or off */
    defaultWorkOrderFields: boolean;
    /** Tenant work order name */
    defaultWorkOrderTitle: string | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

/** DTO represents Tenant Skittle Chart */
export class TenantSkittleChartDto implements ITenantSkittleChartDto {
    id!: number;
    /** String describing the type of the TenantSkittleChart */
    type!: string | undefined;

    constructor(data?: ITenantSkittleChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TenantSkittleChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSkittleChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }

    clone(): TenantSkittleChartDto {
        const json = this.toJSON();
        let result = new TenantSkittleChartDto();
        result.init(json);
        return result;
    }
}

/** DTO represents Tenant Skittle Chart */
export interface ITenantSkittleChartDto {
    id: number;
    /** String describing the type of the TenantSkittleChart */
    type: string | undefined;
}

/** Dto for Tenant Storage Container Info */
export class TenantStorageContainerInfoDto implements ITenantStorageContainerInfoDto {
    id!: number;
    name!: string | undefined;
    container!: string | undefined;
    inspections!: InspectionStorageContainerInfoDto[] | undefined;

    constructor(data?: ITenantStorageContainerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.container = _data["container"];
            if (Array.isArray(_data["inspections"])) {
                this.inspections = [] as any;
                for (let item of _data["inspections"])
                    this.inspections!.push(InspectionStorageContainerInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantStorageContainerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantStorageContainerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["container"] = this.container;
        if (Array.isArray(this.inspections)) {
            data["inspections"] = [];
            for (let item of this.inspections)
                data["inspections"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantStorageContainerInfoDto {
        const json = this.toJSON();
        let result = new TenantStorageContainerInfoDto();
        result.init(json);
        return result;
    }
}

/** Dto for Tenant Storage Container Info */
export interface ITenantStorageContainerInfoDto {
    id: number;
    name: string | undefined;
    container: string | undefined;
    inspections: InspectionStorageContainerInfoDto[] | undefined;
}

/** Update DTO for Asset Assignment Area */
export class UpdateAssetAssignmentAreaDto implements IUpdateAssetAssignmentAreaDto {
    id!: number;
    /** String containing the points representing the area represented by this AssetAssignmentArea */
    assignmentAreaPoints!: string;

    constructor(data?: IUpdateAssetAssignmentAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignmentAreaPoints = _data["assignmentAreaPoints"];
        }
    }

    static fromJS(data: any): UpdateAssetAssignmentAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetAssignmentAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignmentAreaPoints"] = this.assignmentAreaPoints;
        return data;
    }

    clone(): UpdateAssetAssignmentAreaDto {
        const json = this.toJSON();
        let result = new UpdateAssetAssignmentAreaDto();
        result.init(json);
        return result;
    }
}

/** Update DTO for Asset Assignment Area */
export interface IUpdateAssetAssignmentAreaDto {
    id: number;
    /** String containing the points representing the area represented by this AssetAssignmentArea */
    assignmentAreaPoints: string;
}

/** Dto for updating a circuit */
export class UpdateCircuitDto implements IUpdateCircuitDto {
    id!: number;
    /** Name of Circuit */
    name!: string;

    constructor(data?: IUpdateCircuitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateCircuitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCircuitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): UpdateCircuitDto {
        const json = this.toJSON();
        let result = new UpdateCircuitDto();
        result.init(json);
        return result;
    }
}

/** Dto for updating a circuit */
export interface IUpdateCircuitDto {
    id: number;
    /** Name of Circuit */
    name: string;
}

/** UpdateAssetDto represents data for updating a pole type asset. */
export class UpdateComputerVisionModelDto implements IUpdateComputerVisionModelDto {
    id!: number;
    /** Name of the computer vision model */
    name!: string | undefined;
    /** Model name for the computer vision model */
    modelName!: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId!: number;
    /** List of Identifiers for ComputerVisionModels that this ComputerVisionModel requires as a prerequisite */
    prerequisiteComputerVisionModelIds!: number[] | undefined;

    constructor(data?: IUpdateComputerVisionModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modelName = _data["modelName"];
            this.computerVisionModelTypeId = _data["computerVisionModelTypeId"];
            if (Array.isArray(_data["prerequisiteComputerVisionModelIds"])) {
                this.prerequisiteComputerVisionModelIds = [] as any;
                for (let item of _data["prerequisiteComputerVisionModelIds"])
                    this.prerequisiteComputerVisionModelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateComputerVisionModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComputerVisionModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modelName"] = this.modelName;
        data["computerVisionModelTypeId"] = this.computerVisionModelTypeId;
        if (Array.isArray(this.prerequisiteComputerVisionModelIds)) {
            data["prerequisiteComputerVisionModelIds"] = [];
            for (let item of this.prerequisiteComputerVisionModelIds)
                data["prerequisiteComputerVisionModelIds"].push(item);
        }
        return data;
    }

    clone(): UpdateComputerVisionModelDto {
        const json = this.toJSON();
        let result = new UpdateComputerVisionModelDto();
        result.init(json);
        return result;
    }
}

/** UpdateAssetDto represents data for updating a pole type asset. */
export interface IUpdateComputerVisionModelDto {
    id: number;
    /** Name of the computer vision model */
    name: string | undefined;
    /** Model name for the computer vision model */
    modelName: string | undefined;
    /** The ID of the Computer Vision Model Type for this Computer Vision Model. */
    computerVisionModelTypeId: number;
    /** List of Identifiers for ComputerVisionModels that this ComputerVisionModel requires as a prerequisite */
    prerequisiteComputerVisionModelIds: number[] | undefined;
}

/** Dto for updating a Custom Asset Property */
export class UpdateCustomAssetPropertyDto implements IUpdateCustomAssetPropertyDto {
    id!: number;
    /** Name of Custom Asset Property */
    name!: string;
    /** Display name of the custom asset property */
    displayName!: string;
    /** Id of the Data type of the custom asset property */
    customPropertyTypeId!: number;
    /** List of custom asset property options associated with the custom asset property */
    customAssetPropertyOptions!: CustomAssetPropertyOptionDto[] | undefined;

    constructor(data?: IUpdateCustomAssetPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.customPropertyTypeId = _data["customPropertyTypeId"];
            if (Array.isArray(_data["customAssetPropertyOptions"])) {
                this.customAssetPropertyOptions = [] as any;
                for (let item of _data["customAssetPropertyOptions"])
                    this.customAssetPropertyOptions!.push(CustomAssetPropertyOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomAssetPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomAssetPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["customPropertyTypeId"] = this.customPropertyTypeId;
        if (Array.isArray(this.customAssetPropertyOptions)) {
            data["customAssetPropertyOptions"] = [];
            for (let item of this.customAssetPropertyOptions)
                data["customAssetPropertyOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateCustomAssetPropertyDto {
        const json = this.toJSON();
        let result = new UpdateCustomAssetPropertyDto();
        result.init(json);
        return result;
    }
}

/** Dto for updating a Custom Asset Property */
export interface IUpdateCustomAssetPropertyDto {
    id: number;
    /** Name of Custom Asset Property */
    name: string;
    /** Display name of the custom asset property */
    displayName: string;
    /** Id of the Data type of the custom asset property */
    customPropertyTypeId: number;
    /** List of custom asset property options associated with the custom asset property */
    customAssetPropertyOptions: CustomAssetPropertyOptionDto[] | undefined;
}

export class UpdateDurableFunctionDto implements IUpdateDurableFunctionDto {
    id!: number;
    /** Tenant that the Durable Function belongs to */
    tenantId!: number;
    /** Inspection that the Upload Durable Function belongs to */
    inspectionId!: number;
    /** Instance Id of the durable function in Azure */
    instanceId!: string;
    /** The message for this durable function. */
    message!: string | undefined;
    /** The status for this durable function. */
    status!: string | undefined;

    constructor(data?: IUpdateDurableFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.inspectionId = _data["inspectionId"];
            this.instanceId = _data["instanceId"];
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateDurableFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDurableFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["inspectionId"] = this.inspectionId;
        data["instanceId"] = this.instanceId;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateDurableFunctionDto {
        const json = this.toJSON();
        let result = new UpdateDurableFunctionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDurableFunctionDto {
    id: number;
    /** Tenant that the Durable Function belongs to */
    tenantId: number;
    /** Inspection that the Upload Durable Function belongs to */
    inspectionId: number;
    /** Instance Id of the durable function in Azure */
    instanceId: string;
    /** The message for this durable function. */
    message: string | undefined;
    /** The status for this durable function. */
    status: string | undefined;
}

export class UpdateFeedbackDto implements IUpdateFeedbackDto {
    isReviewed!: boolean;

    constructor(data?: IUpdateFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReviewed = _data["isReviewed"];
        }
    }

    static fromJS(data: any): UpdateFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReviewed"] = this.isReviewed;
        return data;
    }

    clone(): UpdateFeedbackDto {
        const json = this.toJSON();
        let result = new UpdateFeedbackDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFeedbackDto {
    isReviewed: boolean;
}

/** DTO from client to update image asset profile */
export class UpdateImageAssetProfileDto implements IUpdateImageAssetProfileDto {
    isProfile!: boolean;

    constructor(data?: IUpdateImageAssetProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isProfile = _data["isProfile"];
        }
    }

    static fromJS(data: any): UpdateImageAssetProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageAssetProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isProfile"] = this.isProfile;
        return data;
    }

    clone(): UpdateImageAssetProfileDto {
        const json = this.toJSON();
        let result = new UpdateImageAssetProfileDto();
        result.init(json);
        return result;
    }
}

/** DTO from client to update image asset profile */
export interface IUpdateImageAssetProfileDto {
    isProfile: boolean;
}

/** DTO from client to update image audit */
export class UpdateImageAuditDto implements IUpdateImageAuditDto {
    shouldBeAudited!: boolean;
    auditReasonTypeId!: number | undefined;
    auditReason!: string | undefined;

    constructor(data?: IUpdateImageAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldBeAudited = _data["shouldBeAudited"];
            this.auditReasonTypeId = _data["auditReasonTypeId"];
            this.auditReason = _data["auditReason"];
        }
    }

    static fromJS(data: any): UpdateImageAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldBeAudited"] = this.shouldBeAudited;
        data["auditReasonTypeId"] = this.auditReasonTypeId;
        data["auditReason"] = this.auditReason;
        return data;
    }

    clone(): UpdateImageAuditDto {
        const json = this.toJSON();
        let result = new UpdateImageAuditDto();
        result.init(json);
        return result;
    }
}

/** DTO from client to update image audit */
export interface IUpdateImageAuditDto {
    shouldBeAudited: boolean;
    auditReasonTypeId: number | undefined;
    auditReason: string | undefined;
}

export class UpdateImageDto implements IUpdateImageDto {
    id!: number;
    /** Tenant image belongs to */
    tenantId!: number;
    /** The identifier of the asset to which this image belongs */
    assetId!: number | undefined;
    /** Url of the image */
    imageUrl!: string | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl!: string | undefined;
    /** Latitude */
    latitude!: number;
    /** Longitude */
    longitude!: number;

    constructor(data?: IUpdateImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.assetId = _data["assetId"];
            this.imageUrl = _data["imageUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): UpdateImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["assetId"] = this.assetId;
        data["imageUrl"] = this.imageUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }

    clone(): UpdateImageDto {
        const json = this.toJSON();
        let result = new UpdateImageDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateImageDto {
    id: number;
    /** Tenant image belongs to */
    tenantId: number;
    /** The identifier of the asset to which this image belongs */
    assetId: number | undefined;
    /** Url of the image */
    imageUrl: string | undefined;
    /** Url of the thumbnail image */
    thumbnailUrl: string | undefined;
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
}

export class UpdateInspectedDto implements IUpdateInspectedDto {
    isCheckingIsInspected!: boolean;
    uncheckedFromInspectedCheckbox!: boolean;
    isInspected!: boolean;
    inspectorUserEmail!: string | undefined;
    inspectionTime!: moment.Moment | undefined;

    constructor(data?: IUpdateInspectedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCheckingIsInspected = _data["isCheckingIsInspected"];
            this.uncheckedFromInspectedCheckbox = _data["uncheckedFromInspectedCheckbox"];
            this.isInspected = _data["isInspected"];
            this.inspectorUserEmail = _data["inspectorUserEmail"];
            this.inspectionTime = _data["inspectionTime"] ? moment(_data["inspectionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateInspectedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCheckingIsInspected"] = this.isCheckingIsInspected;
        data["uncheckedFromInspectedCheckbox"] = this.uncheckedFromInspectedCheckbox;
        data["isInspected"] = this.isInspected;
        data["inspectorUserEmail"] = this.inspectorUserEmail;
        data["inspectionTime"] = this.inspectionTime ? this.inspectionTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateInspectedDto {
        const json = this.toJSON();
        let result = new UpdateInspectedDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateInspectedDto {
    isCheckingIsInspected: boolean;
    uncheckedFromInspectedCheckbox: boolean;
    isInspected: boolean;
    inspectorUserEmail: string | undefined;
    inspectionTime: moment.Moment | undefined;
}

export class UpdateInspectionDto implements IUpdateInspectionDto {
    id!: number;
    inspectionName!: string;
    inspectionTypeId!: number;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    description!: string;
    displayWorkOrder!: boolean;
    workOrderTitle!: string | undefined;
    imageAssociationRadius!: number;
    tenantId!: number;
    inspectionStatusId!: number;
    dataCollectorId!: number | undefined;
    inspectionNotes!: string | undefined;
    computerVisionModelIds!: number[] | undefined;
    inspectionJobTypeIds!: number[] | undefined;
    qcNotRequired!: boolean;

    constructor(data?: IUpdateInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionName = _data["inspectionName"];
            this.inspectionTypeId = _data["inspectionTypeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.displayWorkOrder = _data["displayWorkOrder"];
            this.workOrderTitle = _data["workOrderTitle"];
            this.imageAssociationRadius = _data["imageAssociationRadius"];
            this.tenantId = _data["tenantId"];
            this.inspectionStatusId = _data["inspectionStatusId"];
            this.dataCollectorId = _data["dataCollectorId"];
            this.inspectionNotes = _data["inspectionNotes"];
            if (Array.isArray(_data["computerVisionModelIds"])) {
                this.computerVisionModelIds = [] as any;
                for (let item of _data["computerVisionModelIds"])
                    this.computerVisionModelIds!.push(item);
            }
            if (Array.isArray(_data["inspectionJobTypeIds"])) {
                this.inspectionJobTypeIds = [] as any;
                for (let item of _data["inspectionJobTypeIds"])
                    this.inspectionJobTypeIds!.push(item);
            }
            this.qcNotRequired = _data["qcNotRequired"];
        }
    }

    static fromJS(data: any): UpdateInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionName"] = this.inspectionName;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["displayWorkOrder"] = this.displayWorkOrder;
        data["workOrderTitle"] = this.workOrderTitle;
        data["imageAssociationRadius"] = this.imageAssociationRadius;
        data["tenantId"] = this.tenantId;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["dataCollectorId"] = this.dataCollectorId;
        data["inspectionNotes"] = this.inspectionNotes;
        if (Array.isArray(this.computerVisionModelIds)) {
            data["computerVisionModelIds"] = [];
            for (let item of this.computerVisionModelIds)
                data["computerVisionModelIds"].push(item);
        }
        if (Array.isArray(this.inspectionJobTypeIds)) {
            data["inspectionJobTypeIds"] = [];
            for (let item of this.inspectionJobTypeIds)
                data["inspectionJobTypeIds"].push(item);
        }
        data["qcNotRequired"] = this.qcNotRequired;
        return data;
    }

    clone(): UpdateInspectionDto {
        const json = this.toJSON();
        let result = new UpdateInspectionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateInspectionDto {
    id: number;
    inspectionName: string;
    inspectionTypeId: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    description: string;
    displayWorkOrder: boolean;
    workOrderTitle: string | undefined;
    imageAssociationRadius: number;
    tenantId: number;
    inspectionStatusId: number;
    dataCollectorId: number | undefined;
    inspectionNotes: string | undefined;
    computerVisionModelIds: number[] | undefined;
    inspectionJobTypeIds: number[] | undefined;
    qcNotRequired: boolean;
}

/** Dto for updating an Inspection Permission */
export class UpdateInspectionPermissionDto implements IUpdateInspectionPermissionDto {
    /** Boolean flag whether historical condition access is allowed for the user on the given inspection. */
    historicalConditionAccess!: boolean;

    constructor(data?: IUpdateInspectionPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.historicalConditionAccess = _data["historicalConditionAccess"];
        }
    }

    static fromJS(data: any): UpdateInspectionPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectionPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["historicalConditionAccess"] = this.historicalConditionAccess;
        return data;
    }

    clone(): UpdateInspectionPermissionDto {
        const json = this.toJSON();
        let result = new UpdateInspectionPermissionDto();
        result.init(json);
        return result;
    }
}

/** Dto for updating an Inspection Permission */
export interface IUpdateInspectionPermissionDto {
    /** Boolean flag whether historical condition access is allowed for the user on the given inspection. */
    historicalConditionAccess: boolean;
}

/** Dto of an inventory item to update sent from the client */
export class UpdateInventoryItemDto implements IUpdateInventoryItemDto {
    /** Identifier of the related Inspection */
    inspectionId!: number;
    /** Identifier of the related Asset */
    assetId!: number;
    /** String describing the item type in inventory on the asset */
    itemType!: string;
    /** String describing the type of the inventory item */
    type!: string;
    /** The number of instances of the inventory item on the asset */
    quantity!: number;
    /** Comments regarding the Inventory item */
    comments!: string | undefined;
    /** List of circuit ids related to the inventory item */
    circuitIds!: number[] | undefined;

    constructor(data?: IUpdateInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.assetId = _data["assetId"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.quantity = _data["quantity"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["circuitIds"])) {
                this.circuitIds = [] as any;
                for (let item of _data["circuitIds"])
                    this.circuitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateInventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["assetId"] = this.assetId;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["quantity"] = this.quantity;
        data["comments"] = this.comments;
        if (Array.isArray(this.circuitIds)) {
            data["circuitIds"] = [];
            for (let item of this.circuitIds)
                data["circuitIds"].push(item);
        }
        return data;
    }

    clone(): UpdateInventoryItemDto {
        const json = this.toJSON();
        let result = new UpdateInventoryItemDto();
        result.init(json);
        return result;
    }
}

/** Dto of an inventory item to update sent from the client */
export interface IUpdateInventoryItemDto {
    /** Identifier of the related Inspection */
    inspectionId: number;
    /** Identifier of the related Asset */
    assetId: number;
    /** String describing the item type in inventory on the asset */
    itemType: string;
    /** String describing the type of the inventory item */
    type: string;
    /** The number of instances of the inventory item on the asset */
    quantity: number;
    /** Comments regarding the Inventory item */
    comments: string | undefined;
    /** List of circuit ids related to the inventory item */
    circuitIds: number[] | undefined;
}

export class UpdateOrthomosaicDto implements IUpdateOrthomosaicDto {
    /** Name of the Orthomosaic */
    name!: string;
    /** Url of the Orthomosaic */
    url!: string;
    /** Blob storage directory location at which the Orthomosaic resides */
    blobStorageLocation!: string;
    /** Specifies whether this Orthomosaic should be displayed by default on loading */
    displayOnLoad!: boolean;
    /** The minimum zoom level for this Orthomosaic. */
    minZoom!: number | undefined;
    /** The maximum zoom level for this Orthomosaic. */
    maxZoom!: number | undefined;
    /** The minimum latitude for this Orthomosaic. */
    minLatitude!: number | undefined;
    /** The maximum latitude for this Orthomosaic. */
    maxLatitude!: number | undefined;
    /** The minimum longitude for this Orthomosaic. */
    minLongitude!: number | undefined;
    /** The maximum longitude for this Orthomosaic. */
    maxLongitude!: number | undefined;

    constructor(data?: IUpdateOrthomosaicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.blobStorageLocation = _data["blobStorageLocation"];
            this.displayOnLoad = _data["displayOnLoad"];
            this.minZoom = _data["minZoom"];
            this.maxZoom = _data["maxZoom"];
            this.minLatitude = _data["minLatitude"];
            this.maxLatitude = _data["maxLatitude"];
            this.minLongitude = _data["minLongitude"];
            this.maxLongitude = _data["maxLongitude"];
        }
    }

    static fromJS(data: any): UpdateOrthomosaicDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrthomosaicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["blobStorageLocation"] = this.blobStorageLocation;
        data["displayOnLoad"] = this.displayOnLoad;
        data["minZoom"] = this.minZoom;
        data["maxZoom"] = this.maxZoom;
        data["minLatitude"] = this.minLatitude;
        data["maxLatitude"] = this.maxLatitude;
        data["minLongitude"] = this.minLongitude;
        data["maxLongitude"] = this.maxLongitude;
        return data;
    }

    clone(): UpdateOrthomosaicDto {
        const json = this.toJSON();
        let result = new UpdateOrthomosaicDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrthomosaicDto {
    /** Name of the Orthomosaic */
    name: string;
    /** Url of the Orthomosaic */
    url: string;
    /** Blob storage directory location at which the Orthomosaic resides */
    blobStorageLocation: string;
    /** Specifies whether this Orthomosaic should be displayed by default on loading */
    displayOnLoad: boolean;
    /** The minimum zoom level for this Orthomosaic. */
    minZoom: number | undefined;
    /** The maximum zoom level for this Orthomosaic. */
    maxZoom: number | undefined;
    /** The minimum latitude for this Orthomosaic. */
    minLatitude: number | undefined;
    /** The maximum latitude for this Orthomosaic. */
    maxLatitude: number | undefined;
    /** The minimum longitude for this Orthomosaic. */
    minLongitude: number | undefined;
    /** The maximum longitude for this Orthomosaic. */
    maxLongitude: number | undefined;
}

/** UpdateAssetDto represents data for updating a pole type asset. */
export class UpdatePoleDto implements IUpdatePoleDto {
    id!: number;
    /** The tenant this pole belongs to. This is required. */
    tenantId!: number;
    /** The facility ID for this pole. */
    facilityId!: string | undefined;
    /** Analysis Status Dto */
    analysisStatus!: AnalysisStatusDto | undefined;
    /** The collector id for this pole on the current inspection */
    collectorId!: string | undefined;
    /** The inspection id for this pole during the current update */
    inspectionId!: number;
    /** The human-readable address for this pole. */
    address!: string | undefined;
    /** The comments for this pole. */
    comments!: string | undefined;
    /** The brand date of this pole. */
    brandDate!: number | undefined;
    /** The pole height of this pole. */
    poleHeight!: number | undefined;
    /** The pole class of this pole. */
    poleClass!: string | undefined;
    /** The risk zone of this pole. */
    riskZone!: string | undefined;
    /** The construction type of this pole. */
    constructionType!: string | undefined;
    /** The ground resistance of this pole. */
    groundResistance!: number | undefined;
    /** Determines whether this pole is truck accessible. */
    truckAccessible!: boolean;
    /** The latitude coordinate for this pole. This is required. */
    latitude!: number | undefined;
    /** The longitude coordinate for this pole. This is required. */
    longitude!: number | undefined;
    /** List of circuits to set to the asset. */
    circuits!: CircuitDto[] | undefined;
    /** JSON string representing the custom properties for this pole. */
    customProperties!: string | undefined;

    constructor(data?: IUpdatePoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.facilityId = _data["facilityId"];
            this.analysisStatus = _data["analysisStatus"] ? AnalysisStatusDto.fromJS(_data["analysisStatus"]) : <any>undefined;
            this.collectorId = _data["collectorId"];
            this.inspectionId = _data["inspectionId"];
            this.address = _data["address"];
            this.comments = _data["comments"];
            this.brandDate = _data["brandDate"];
            this.poleHeight = _data["poleHeight"];
            this.poleClass = _data["poleClass"];
            this.riskZone = _data["riskZone"];
            this.constructionType = _data["constructionType"];
            this.groundResistance = _data["groundResistance"];
            this.truckAccessible = _data["truckAccessible"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
            this.customProperties = _data["customProperties"];
        }
    }

    static fromJS(data: any): UpdatePoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["facilityId"] = this.facilityId;
        data["analysisStatus"] = this.analysisStatus ? this.analysisStatus.toJSON() : <any>undefined;
        data["collectorId"] = this.collectorId;
        data["inspectionId"] = this.inspectionId;
        data["address"] = this.address;
        data["comments"] = this.comments;
        data["brandDate"] = this.brandDate;
        data["poleHeight"] = this.poleHeight;
        data["poleClass"] = this.poleClass;
        data["riskZone"] = this.riskZone;
        data["constructionType"] = this.constructionType;
        data["groundResistance"] = this.groundResistance;
        data["truckAccessible"] = this.truckAccessible;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        data["customProperties"] = this.customProperties;
        return data;
    }

    clone(): UpdatePoleDto {
        const json = this.toJSON();
        let result = new UpdatePoleDto();
        result.init(json);
        return result;
    }
}

/** UpdateAssetDto represents data for updating a pole type asset. */
export interface IUpdatePoleDto {
    id: number;
    /** The tenant this pole belongs to. This is required. */
    tenantId: number;
    /** The facility ID for this pole. */
    facilityId: string | undefined;
    /** Analysis Status Dto */
    analysisStatus: AnalysisStatusDto | undefined;
    /** The collector id for this pole on the current inspection */
    collectorId: string | undefined;
    /** The inspection id for this pole during the current update */
    inspectionId: number;
    /** The human-readable address for this pole. */
    address: string | undefined;
    /** The comments for this pole. */
    comments: string | undefined;
    /** The brand date of this pole. */
    brandDate: number | undefined;
    /** The pole height of this pole. */
    poleHeight: number | undefined;
    /** The pole class of this pole. */
    poleClass: string | undefined;
    /** The risk zone of this pole. */
    riskZone: string | undefined;
    /** The construction type of this pole. */
    constructionType: string | undefined;
    /** The ground resistance of this pole. */
    groundResistance: number | undefined;
    /** Determines whether this pole is truck accessible. */
    truckAccessible: boolean;
    /** The latitude coordinate for this pole. This is required. */
    latitude: number | undefined;
    /** The longitude coordinate for this pole. This is required. */
    longitude: number | undefined;
    /** List of circuits to set to the asset. */
    circuits: CircuitDto[] | undefined;
    /** JSON string representing the custom properties for this pole. */
    customProperties: string | undefined;
}

/** Update dto from workbench */
export class UpdatePoleWBDto implements IUpdatePoleWBDto {
    /** Tenant Inspection belongs to */
    tenantId!: number | undefined;
    /** The Facility Id for an Asset. */
    facilityId!: string | undefined;
    /** The Comments for an Asset */
    comments!: string | undefined;
    /** District */
    district!: string | undefined;
    /** State */
    state!: string | undefined;
    /** Assessment company */
    assessmentCompany!: string | undefined;
    /** Assessment Date */
    assessmentDate!: moment.Moment | undefined;
    /** Brand date */
    brandDate!: number | undefined;
    /** Pole height */
    poleHeight!: number | undefined;
    /** Pole class */
    poleClass!: string | undefined;
    /** Risk zone */
    riskZone!: string | undefined;
    /** Construction type */
    constructionType!: string | undefined;
    /** Truck accessible */
    truckAccessible!: boolean | undefined;
    /** Ground resistance */
    groundResistance!: number | undefined;
    /** Wind exposure */
    windExposure!: string | undefined;
    /** List of Circuits linked to this Asset */
    circuitIds!: number[] | undefined;
    /** Time at which the Asset was last updated */
    lastModificationTime!: moment.Moment | undefined;

    constructor(data?: IUpdatePoleWBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.facilityId = _data["facilityId"];
            this.comments = _data["comments"];
            this.district = _data["district"];
            this.state = _data["state"];
            this.assessmentCompany = _data["assessmentCompany"];
            this.assessmentDate = _data["assessmentDate"] ? moment(_data["assessmentDate"].toString()) : <any>undefined;
            this.brandDate = _data["brandDate"];
            this.poleHeight = _data["poleHeight"];
            this.poleClass = _data["poleClass"];
            this.riskZone = _data["riskZone"];
            this.constructionType = _data["constructionType"];
            this.truckAccessible = _data["truckAccessible"];
            this.groundResistance = _data["groundResistance"];
            this.windExposure = _data["windExposure"];
            if (Array.isArray(_data["circuitIds"])) {
                this.circuitIds = [] as any;
                for (let item of _data["circuitIds"])
                    this.circuitIds!.push(item);
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePoleWBDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePoleWBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["facilityId"] = this.facilityId;
        data["comments"] = this.comments;
        data["district"] = this.district;
        data["state"] = this.state;
        data["assessmentCompany"] = this.assessmentCompany;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : <any>undefined;
        data["brandDate"] = this.brandDate;
        data["poleHeight"] = this.poleHeight;
        data["poleClass"] = this.poleClass;
        data["riskZone"] = this.riskZone;
        data["constructionType"] = this.constructionType;
        data["truckAccessible"] = this.truckAccessible;
        data["groundResistance"] = this.groundResistance;
        data["windExposure"] = this.windExposure;
        if (Array.isArray(this.circuitIds)) {
            data["circuitIds"] = [];
            for (let item of this.circuitIds)
                data["circuitIds"].push(item);
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdatePoleWBDto {
        const json = this.toJSON();
        let result = new UpdatePoleWBDto();
        result.init(json);
        return result;
    }
}

/** Update dto from workbench */
export interface IUpdatePoleWBDto {
    /** Tenant Inspection belongs to */
    tenantId: number | undefined;
    /** The Facility Id for an Asset. */
    facilityId: string | undefined;
    /** The Comments for an Asset */
    comments: string | undefined;
    /** District */
    district: string | undefined;
    /** State */
    state: string | undefined;
    /** Assessment company */
    assessmentCompany: string | undefined;
    /** Assessment Date */
    assessmentDate: moment.Moment | undefined;
    /** Brand date */
    brandDate: number | undefined;
    /** Pole height */
    poleHeight: number | undefined;
    /** Pole class */
    poleClass: string | undefined;
    /** Risk zone */
    riskZone: string | undefined;
    /** Construction type */
    constructionType: string | undefined;
    /** Truck accessible */
    truckAccessible: boolean | undefined;
    /** Ground resistance */
    groundResistance: number | undefined;
    /** Wind exposure */
    windExposure: string | undefined;
    /** List of Circuits linked to this Asset */
    circuitIds: number[] | undefined;
    /** Time at which the Asset was last updated */
    lastModificationTime: moment.Moment | undefined;
}

/** Dto passed by client */
export class UpdateQCInspectionToAssetDto implements IUpdateQCInspectionToAssetDto {
    notes!: string | undefined;
    statusId!: number | undefined;

    constructor(data?: IUpdateQCInspectionToAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notes = _data["notes"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateQCInspectionToAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQCInspectionToAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notes"] = this.notes;
        data["statusId"] = this.statusId;
        return data;
    }

    clone(): UpdateQCInspectionToAssetDto {
        const json = this.toJSON();
        let result = new UpdateQCInspectionToAssetDto();
        result.init(json);
        return result;
    }
}

/** Dto passed by client */
export interface IUpdateQCInspectionToAssetDto {
    notes: string | undefined;
    statusId: number | undefined;
}

/** UpdateSpanDto represents data for updating a span type asset. */
export class UpdateSpanDto implements IUpdateSpanDto {
    id!: number;
    /** The tenant this span belongs to. This is required. */
    tenantId!: number | undefined;
    /** The facility ID for this span. */
    facilityId!: string | undefined;
    /** The construction type of the span */
    constructionType!: string | undefined;
    /** The voltage carried by the span */
    voltage!: string | undefined;
    /** Length of the span */
    spanLength!: number | undefined;
    /** The inspection id for this span during the current update */
    inspectionId!: number;
    /** A semicolon delimited string of coordinates for the polylines needed for the span */
    polyLineData!: string | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId!: number | undefined;
    /** Identifier for the ending point pole for the span */
    endAssetId!: number | undefined;
    /** JSon data of custom asset properties values */
    customProperties!: string | undefined;
    /** The list of custom asset properties and their values related to the span */
    customPropertyValues!: CustomAssetPropertyValueDto[] | undefined;
    /** List of circuits to set to the asset. */
    circuits!: CircuitDto[] | undefined;

    constructor(data?: IUpdateSpanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.facilityId = _data["facilityId"];
            this.constructionType = _data["constructionType"];
            this.voltage = _data["voltage"];
            this.spanLength = _data["spanLength"];
            this.inspectionId = _data["inspectionId"];
            this.polyLineData = _data["polyLineData"];
            this.startAssetId = _data["startAssetId"];
            this.endAssetId = _data["endAssetId"];
            this.customProperties = _data["customProperties"];
            if (Array.isArray(_data["customPropertyValues"])) {
                this.customPropertyValues = [] as any;
                for (let item of _data["customPropertyValues"])
                    this.customPropertyValues!.push(CustomAssetPropertyValueDto.fromJS(item));
            }
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSpanDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["facilityId"] = this.facilityId;
        data["constructionType"] = this.constructionType;
        data["voltage"] = this.voltage;
        data["spanLength"] = this.spanLength;
        data["inspectionId"] = this.inspectionId;
        data["polyLineData"] = this.polyLineData;
        data["startAssetId"] = this.startAssetId;
        data["endAssetId"] = this.endAssetId;
        data["customProperties"] = this.customProperties;
        if (Array.isArray(this.customPropertyValues)) {
            data["customPropertyValues"] = [];
            for (let item of this.customPropertyValues)
                data["customPropertyValues"].push(item.toJSON());
        }
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateSpanDto {
        const json = this.toJSON();
        let result = new UpdateSpanDto();
        result.init(json);
        return result;
    }
}

/** UpdateSpanDto represents data for updating a span type asset. */
export interface IUpdateSpanDto {
    id: number;
    /** The tenant this span belongs to. This is required. */
    tenantId: number | undefined;
    /** The facility ID for this span. */
    facilityId: string | undefined;
    /** The construction type of the span */
    constructionType: string | undefined;
    /** The voltage carried by the span */
    voltage: string | undefined;
    /** Length of the span */
    spanLength: number | undefined;
    /** The inspection id for this span during the current update */
    inspectionId: number;
    /** A semicolon delimited string of coordinates for the polylines needed for the span */
    polyLineData: string | undefined;
    /** Identifier for the starting point pole for the span */
    startAssetId: number | undefined;
    /** Identifier for the ending point pole for the span */
    endAssetId: number | undefined;
    /** JSon data of custom asset properties values */
    customProperties: string | undefined;
    /** The list of custom asset properties and their values related to the span */
    customPropertyValues: CustomAssetPropertyValueDto[] | undefined;
    /** List of circuits to set to the asset. */
    circuits: CircuitDto[] | undefined;
}

/** Dto to update a condition from workbench */
export class UpdateWBConditionDto implements IUpdateWBConditionDto {
    inspectionId!: number;
    assetId!: number;
    conditionName!: string;
    priority!: string;
    itemType!: string;
    type!: string;
    comments!: string | undefined;
    circuits!: CircuitDto[] | undefined;

    constructor(data?: IUpdateWBConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.assetId = _data["assetId"];
            this.conditionName = _data["conditionName"];
            this.priority = _data["priority"];
            this.itemType = _data["itemType"];
            this.type = _data["type"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateWBConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWBConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["assetId"] = this.assetId;
        data["conditionName"] = this.conditionName;
        data["priority"] = this.priority;
        data["itemType"] = this.itemType;
        data["type"] = this.type;
        data["comments"] = this.comments;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateWBConditionDto {
        const json = this.toJSON();
        let result = new UpdateWBConditionDto();
        result.init(json);
        return result;
    }
}

/** Dto to update a condition from workbench */
export interface IUpdateWBConditionDto {
    inspectionId: number;
    assetId: number;
    conditionName: string;
    priority: string;
    itemType: string;
    type: string;
    comments: string | undefined;
    circuits: CircuitDto[] | undefined;
}

/** The dto representing a command to upsert a condition quality assurance note */
export class UpsertConditionQualityAssuranceNoteDto implements IUpsertConditionQualityAssuranceNoteDto {
    /** The id of the associated condition */
    conditionId!: number;
    /** A flag indicating if the qa note is deleted */
    isDeleted!: boolean;
    /** The notes */
    notes!: string | undefined;

    constructor(data?: IUpsertConditionQualityAssuranceNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionId = _data["conditionId"];
            this.isDeleted = _data["isDeleted"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpsertConditionQualityAssuranceNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertConditionQualityAssuranceNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionId"] = this.conditionId;
        data["isDeleted"] = this.isDeleted;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpsertConditionQualityAssuranceNoteDto {
        const json = this.toJSON();
        let result = new UpsertConditionQualityAssuranceNoteDto();
        result.init(json);
        return result;
    }
}

/** The dto representing a command to upsert a condition quality assurance note */
export interface IUpsertConditionQualityAssuranceNoteDto {
    /** The id of the associated condition */
    conditionId: number;
    /** A flag indicating if the qa note is deleted */
    isDeleted: boolean;
    /** The notes */
    notes: string | undefined;
}

/** The dto representing a command to upsert an inventory item quality assurance note */
export class UpsertInventoryItemQualityAssuranceNoteDto implements IUpsertInventoryItemQualityAssuranceNoteDto {
    /** The id of the associated inventory item */
    inventoryItemId!: number;
    /** A flag indicating if the note is deleted */
    isDeleted!: boolean;
    /** The notes */
    notes!: string | undefined;

    constructor(data?: IUpsertInventoryItemQualityAssuranceNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryItemId = _data["inventoryItemId"];
            this.isDeleted = _data["isDeleted"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpsertInventoryItemQualityAssuranceNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertInventoryItemQualityAssuranceNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryItemId"] = this.inventoryItemId;
        data["isDeleted"] = this.isDeleted;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpsertInventoryItemQualityAssuranceNoteDto {
        const json = this.toJSON();
        let result = new UpsertInventoryItemQualityAssuranceNoteDto();
        result.init(json);
        return result;
    }
}

/** The dto representing a command to upsert an inventory item quality assurance note */
export interface IUpsertInventoryItemQualityAssuranceNoteDto {
    /** The id of the associated inventory item */
    inventoryItemId: number;
    /** A flag indicating if the note is deleted */
    isDeleted: boolean;
    /** The notes */
    notes: string | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    fullName!: string | undefined;
    lastLoginTime!: moment.Moment | undefined;
    creationTime!: moment.Moment;
    roleNames!: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserInspectionDataCollectionAssignmentDto implements IUserInspectionDataCollectionAssignmentDto {
    id!: number;
    /** Identifier of the Inspection the User is assigned to collect data under */
    inspectionId!: number;
    /** Identifier of the User that is assigned to collect data for the Inspection */
    userId!: number;
    /** The user that is assigned to collect data for the Inspection */
    user!: DisplayUserDto | undefined;

    constructor(data?: IUserInspectionDataCollectionAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? DisplayUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserInspectionDataCollectionAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInspectionDataCollectionAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserInspectionDataCollectionAssignmentDto {
        const json = this.toJSON();
        let result = new UserInspectionDataCollectionAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IUserInspectionDataCollectionAssignmentDto {
    id: number;
    /** Identifier of the Inspection the User is assigned to collect data under */
    inspectionId: number;
    /** Identifier of the User that is assigned to collect data for the Inspection */
    userId: number;
    /** The user that is assigned to collect data for the Inspection */
    user: DisplayUserDto | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

/** Dto containing metrics data about the user logins */
export class UserLoginMetricsDto implements IUserLoginMetricsDto {
    tenantName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    lastLogin!: moment.Moment | undefined;
    successfulLogins!: number;

    constructor(data?: IUserLoginMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.lastLogin = _data["lastLogin"] ? moment(_data["lastLogin"].toString()) : <any>undefined;
            this.successfulLogins = _data["successfulLogins"];
        }
    }

    static fromJS(data: any): UserLoginMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        data["successfulLogins"] = this.successfulLogins;
        return data;
    }

    clone(): UserLoginMetricsDto {
        const json = this.toJSON();
        let result = new UserLoginMetricsDto();
        result.init(json);
        return result;
    }
}

/** Dto containing metrics data about the user logins */
export interface IUserLoginMetricsDto {
    tenantName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    lastLogin: moment.Moment | undefined;
    successfulLogins: number;
}

/** UserNavigationHistoryItemDto represents data for a navigated asset by a user. */
export class UserNavigationHistoryItemDto implements IUserNavigationHistoryItemDto {
    id!: number;
    /** The id of the inspection this WorkbenchUserNavigationHistoryItem belongs to. */
    inspectionId!: number;
    /** The inspection this WorkbenchUserNavigationHistoryItem belongs to. */
    inspection!: InspectionDto | undefined;
    /** The id of the asset this WorkbenchUserNavigationHistoryItem belongs to. */
    assetId!: number;
    /** The asset this WorkbenchUserNavigationHistoryItem belongs to. */
    asset!: WBAssetDto | undefined;
    /** The id of the user created this WorkbenchUserNavigationHistoryItem. */
    creatorUserId!: number | undefined;
    /** The created time for this WorkbenchUserNavigationHistoryItem. */
    creationTime!: moment.Moment;

    constructor(data?: IUserNavigationHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? WBAssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserNavigationHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNavigationHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserNavigationHistoryItemDto {
        const json = this.toJSON();
        let result = new UserNavigationHistoryItemDto();
        result.init(json);
        return result;
    }
}

/** UserNavigationHistoryItemDto represents data for a navigated asset by a user. */
export interface IUserNavigationHistoryItemDto {
    id: number;
    /** The id of the inspection this WorkbenchUserNavigationHistoryItem belongs to. */
    inspectionId: number;
    /** The inspection this WorkbenchUserNavigationHistoryItem belongs to. */
    inspection: InspectionDto | undefined;
    /** The id of the asset this WorkbenchUserNavigationHistoryItem belongs to. */
    assetId: number;
    /** The asset this WorkbenchUserNavigationHistoryItem belongs to. */
    asset: WBAssetDto | undefined;
    /** The id of the user created this WorkbenchUserNavigationHistoryItem. */
    creatorUserId: number | undefined;
    /** The created time for this WorkbenchUserNavigationHistoryItem. */
    creationTime: moment.Moment;
}

export class UserNavigationHistoryItemDtoPagedResultDto implements IUserNavigationHistoryItemDtoPagedResultDto {
    items!: UserNavigationHistoryItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserNavigationHistoryItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNavigationHistoryItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserNavigationHistoryItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNavigationHistoryItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserNavigationHistoryItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserNavigationHistoryItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserNavigationHistoryItemDtoPagedResultDto {
    items: UserNavigationHistoryItemDto[] | undefined;
    totalCount: number;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message!: string | undefined;
    members!: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

/** Dto to model an asset from Workbench's perspective */
export class WBAssetDto implements IWBAssetDto {
    id!: number;
    /** The facility id */
    facilityId!: string | undefined;
    /** The id of the tenant */
    tenantId!: number;
    /** Comments */
    comments!: string | undefined;
    /** District */
    district!: string | undefined;
    /** State */
    state!: string | undefined;
    /** Assessment Company */
    assessmentCompany!: string | undefined;
    /** Assessment Date */
    assessmentDate!: moment.Moment | undefined;
    /** Brand date */
    brandDate!: number | undefined;
    /** Pole height */
    poleHeight!: number | undefined;
    /** Pole class */
    poleClass!: string | undefined;
    /** Risk zone */
    riskZone!: string | undefined;
    /** Construction Type */
    constructionType!: string | undefined;
    /** Truck Accessiblity */
    truckAccessible!: boolean;
    /** Ground Resistance */
    groundResistance!: number | undefined;
    /** Wind Exposure */
    windExposure!: string | undefined;
    /** Circuits */
    circuits!: CircuitDto[] | undefined;

    constructor(data?: IWBAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.facilityId = _data["facilityId"];
            this.tenantId = _data["tenantId"];
            this.comments = _data["comments"];
            this.district = _data["district"];
            this.state = _data["state"];
            this.assessmentCompany = _data["assessmentCompany"];
            this.assessmentDate = _data["assessmentDate"] ? moment(_data["assessmentDate"].toString()) : <any>undefined;
            this.brandDate = _data["brandDate"];
            this.poleHeight = _data["poleHeight"];
            this.poleClass = _data["poleClass"];
            this.riskZone = _data["riskZone"];
            this.constructionType = _data["constructionType"];
            this.truckAccessible = _data["truckAccessible"];
            this.groundResistance = _data["groundResistance"];
            this.windExposure = _data["windExposure"];
            if (Array.isArray(_data["circuits"])) {
                this.circuits = [] as any;
                for (let item of _data["circuits"])
                    this.circuits!.push(CircuitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WBAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WBAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facilityId"] = this.facilityId;
        data["tenantId"] = this.tenantId;
        data["comments"] = this.comments;
        data["district"] = this.district;
        data["state"] = this.state;
        data["assessmentCompany"] = this.assessmentCompany;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : <any>undefined;
        data["brandDate"] = this.brandDate;
        data["poleHeight"] = this.poleHeight;
        data["poleClass"] = this.poleClass;
        data["riskZone"] = this.riskZone;
        data["constructionType"] = this.constructionType;
        data["truckAccessible"] = this.truckAccessible;
        data["groundResistance"] = this.groundResistance;
        data["windExposure"] = this.windExposure;
        if (Array.isArray(this.circuits)) {
            data["circuits"] = [];
            for (let item of this.circuits)
                data["circuits"].push(item.toJSON());
        }
        return data;
    }

    clone(): WBAssetDto {
        const json = this.toJSON();
        let result = new WBAssetDto();
        result.init(json);
        return result;
    }
}

/** Dto to model an asset from Workbench's perspective */
export interface IWBAssetDto {
    id: number;
    /** The facility id */
    facilityId: string | undefined;
    /** The id of the tenant */
    tenantId: number;
    /** Comments */
    comments: string | undefined;
    /** District */
    district: string | undefined;
    /** State */
    state: string | undefined;
    /** Assessment Company */
    assessmentCompany: string | undefined;
    /** Assessment Date */
    assessmentDate: moment.Moment | undefined;
    /** Brand date */
    brandDate: number | undefined;
    /** Pole height */
    poleHeight: number | undefined;
    /** Pole class */
    poleClass: string | undefined;
    /** Risk zone */
    riskZone: string | undefined;
    /** Construction Type */
    constructionType: string | undefined;
    /** Truck Accessiblity */
    truckAccessible: boolean;
    /** Ground Resistance */
    groundResistance: number | undefined;
    /** Wind Exposure */
    windExposure: string | undefined;
    /** Circuits */
    circuits: CircuitDto[] | undefined;
}

/** Dto for a ConditionSuggestion to be used by a client */
export class WBConditionSuggestionDto implements IWBConditionSuggestionDto {
    /** Identifier of the parent Condition Type */
    conditionTypeId!: number;
    /** The parent Condition Type */
    conditionType!: ConditionTypeDto | undefined;
    /** Name of the Condition */
    conditionName!: string | undefined;
    /** Default Rwcid (Priority) of the Inspection Condition */
    defaultRwcid!: string | undefined;
    /** The inspection method for this Condition Suggestion */
    inspectionMethod!: string | undefined;

    constructor(data?: IWBConditionSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionTypeId = _data["conditionTypeId"];
            this.conditionType = _data["conditionType"] ? ConditionTypeDto.fromJS(_data["conditionType"]) : <any>undefined;
            this.conditionName = _data["conditionName"];
            this.defaultRwcid = _data["defaultRwcid"];
            this.inspectionMethod = _data["inspectionMethod"];
        }
    }

    static fromJS(data: any): WBConditionSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WBConditionSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionTypeId"] = this.conditionTypeId;
        data["conditionType"] = this.conditionType ? this.conditionType.toJSON() : <any>undefined;
        data["conditionName"] = this.conditionName;
        data["defaultRwcid"] = this.defaultRwcid;
        data["inspectionMethod"] = this.inspectionMethod;
        return data;
    }

    clone(): WBConditionSuggestionDto {
        const json = this.toJSON();
        let result = new WBConditionSuggestionDto();
        result.init(json);
        return result;
    }
}

/** Dto for a ConditionSuggestion to be used by a client */
export interface IWBConditionSuggestionDto {
    /** Identifier of the parent Condition Type */
    conditionTypeId: number;
    /** The parent Condition Type */
    conditionType: ConditionTypeDto | undefined;
    /** Name of the Condition */
    conditionName: string | undefined;
    /** Default Rwcid (Priority) of the Inspection Condition */
    defaultRwcid: string | undefined;
    /** The inspection method for this Condition Suggestion */
    inspectionMethod: string | undefined;
}

/** DTO for InspectionToAsset from workbench's perspective */
export class WBInspectionToAssetDto implements IWBInspectionToAssetDto {
    /** Identifier of the related Inspection */
    inspectionId!: number;
    /** The related inspection */
    inspection!: InspectionDto | undefined;
    /** Id of the asset */
    assetId!: number;
    /** The related Asset object */
    asset!: WBAssetDto | undefined;
    /** Latitude */
    latitude!: number | undefined;
    /** Longitude */
    longitude!: number | undefined;
    /** Flag denoting whether or not the Inspection/Asset pair has images */
    hasImages!: boolean;
    /** Flag denoting whether there are images tied to this Inspection/Asset pair that are missing URLs */
    hasImagesWithMissingUrls!: boolean;
    /** Flag denoting whether or not the Asset has been Inspected on its related Inspection */
    isInspected!: boolean;
    /** Identifier of the user who has inspected this asset on this inspection */
    inspectorUserEmail!: string | undefined;
    /** Identifier of the quality assurance status of the Asset on the given Inspection */
    qualityAssuranceStatusId!: number | undefined;
    /** Flag determining whether the Asset has been marked as having its QC Feedback reviewed */
    isQCFeedbackReviewed!: boolean;
    /** Email address of the AD user that marked the Asset as having reviewed its QC Feedback */
    qcFeedbackReviewedBy!: string | undefined;
    /** The time at which the Asset was mark has having its QC Feedback reviewed */
    qcFeedbackReviewTime!: moment.Moment | undefined;
    /** Email address of the AD user that marked the Asset as QC Reviewed */
    qcReviewedBy!: string | undefined;
    /** Time at which the Asset was marked as having been QC Reviewed */
    qcReviewTime!: moment.Moment | undefined;
    /** The notes pertaining to the QC of the Asset */
    qcReviewNotes!: string | undefined;
    /** Flag indicating whether or not the ITA or any of its nested conditions or inventory items has QC review notes */
    hasQCReviewNotes!: boolean;
    /** Identifier of the Analyzed Status */
    analysisStatusId!: number | undefined;
    /** Index for ordering assigned to the InspectionToAsset pair */
    index!: number;
    /** List of Conditions related to the Asset on its Inspection */
    conditions!: ConditionDto[] | undefined;
    /** List of inventory items related to the Asset on its Inspection */
    inventoryItems!: InventoryItemDto[] | undefined;
    /** List of images reltaed to the asset */
    images!: ImageDto[] | undefined;
    /** The time the inspection was completed */
    inspectionTime!: moment.Moment | undefined;

    constructor(data?: IWBInspectionToAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : <any>undefined;
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? WBAssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.hasImages = _data["hasImages"];
            this.hasImagesWithMissingUrls = _data["hasImagesWithMissingUrls"];
            this.isInspected = _data["isInspected"];
            this.inspectorUserEmail = _data["inspectorUserEmail"];
            this.qualityAssuranceStatusId = _data["qualityAssuranceStatusId"];
            this.isQCFeedbackReviewed = _data["isQCFeedbackReviewed"];
            this.qcFeedbackReviewedBy = _data["qcFeedbackReviewedBy"];
            this.qcFeedbackReviewTime = _data["qcFeedbackReviewTime"] ? moment(_data["qcFeedbackReviewTime"].toString()) : <any>undefined;
            this.qcReviewedBy = _data["qcReviewedBy"];
            this.qcReviewTime = _data["qcReviewTime"] ? moment(_data["qcReviewTime"].toString()) : <any>undefined;
            this.qcReviewNotes = _data["qcReviewNotes"];
            this.hasQCReviewNotes = _data["hasQCReviewNotes"];
            this.analysisStatusId = _data["analysisStatusId"];
            this.index = _data["index"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConditionDto.fromJS(item));
            }
            if (Array.isArray(_data["inventoryItems"])) {
                this.inventoryItems = [] as any;
                for (let item of _data["inventoryItems"])
                    this.inventoryItems!.push(InventoryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            this.inspectionTime = _data["inspectionTime"] ? moment(_data["inspectionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WBInspectionToAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WBInspectionToAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["hasImages"] = this.hasImages;
        data["hasImagesWithMissingUrls"] = this.hasImagesWithMissingUrls;
        data["isInspected"] = this.isInspected;
        data["inspectorUserEmail"] = this.inspectorUserEmail;
        data["qualityAssuranceStatusId"] = this.qualityAssuranceStatusId;
        data["isQCFeedbackReviewed"] = this.isQCFeedbackReviewed;
        data["qcFeedbackReviewedBy"] = this.qcFeedbackReviewedBy;
        data["qcFeedbackReviewTime"] = this.qcFeedbackReviewTime ? this.qcFeedbackReviewTime.toISOString() : <any>undefined;
        data["qcReviewedBy"] = this.qcReviewedBy;
        data["qcReviewTime"] = this.qcReviewTime ? this.qcReviewTime.toISOString() : <any>undefined;
        data["qcReviewNotes"] = this.qcReviewNotes;
        data["hasQCReviewNotes"] = this.hasQCReviewNotes;
        data["analysisStatusId"] = this.analysisStatusId;
        data["index"] = this.index;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        if (Array.isArray(this.inventoryItems)) {
            data["inventoryItems"] = [];
            for (let item of this.inventoryItems)
                data["inventoryItems"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["inspectionTime"] = this.inspectionTime ? this.inspectionTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): WBInspectionToAssetDto {
        const json = this.toJSON();
        let result = new WBInspectionToAssetDto();
        result.init(json);
        return result;
    }
}

/** DTO for InspectionToAsset from workbench's perspective */
export interface IWBInspectionToAssetDto {
    /** Identifier of the related Inspection */
    inspectionId: number;
    /** The related inspection */
    inspection: InspectionDto | undefined;
    /** Id of the asset */
    assetId: number;
    /** The related Asset object */
    asset: WBAssetDto | undefined;
    /** Latitude */
    latitude: number | undefined;
    /** Longitude */
    longitude: number | undefined;
    /** Flag denoting whether or not the Inspection/Asset pair has images */
    hasImages: boolean;
    /** Flag denoting whether there are images tied to this Inspection/Asset pair that are missing URLs */
    hasImagesWithMissingUrls: boolean;
    /** Flag denoting whether or not the Asset has been Inspected on its related Inspection */
    isInspected: boolean;
    /** Identifier of the user who has inspected this asset on this inspection */
    inspectorUserEmail: string | undefined;
    /** Identifier of the quality assurance status of the Asset on the given Inspection */
    qualityAssuranceStatusId: number | undefined;
    /** Flag determining whether the Asset has been marked as having its QC Feedback reviewed */
    isQCFeedbackReviewed: boolean;
    /** Email address of the AD user that marked the Asset as having reviewed its QC Feedback */
    qcFeedbackReviewedBy: string | undefined;
    /** The time at which the Asset was mark has having its QC Feedback reviewed */
    qcFeedbackReviewTime: moment.Moment | undefined;
    /** Email address of the AD user that marked the Asset as QC Reviewed */
    qcReviewedBy: string | undefined;
    /** Time at which the Asset was marked as having been QC Reviewed */
    qcReviewTime: moment.Moment | undefined;
    /** The notes pertaining to the QC of the Asset */
    qcReviewNotes: string | undefined;
    /** Flag indicating whether or not the ITA or any of its nested conditions or inventory items has QC review notes */
    hasQCReviewNotes: boolean;
    /** Identifier of the Analyzed Status */
    analysisStatusId: number | undefined;
    /** Index for ordering assigned to the InspectionToAsset pair */
    index: number;
    /** List of Conditions related to the Asset on its Inspection */
    conditions: ConditionDto[] | undefined;
    /** List of inventory items related to the Asset on its Inspection */
    inventoryItems: InventoryItemDto[] | undefined;
    /** List of images reltaed to the asset */
    images: ImageDto[] | undefined;
    /** The time the inspection was completed */
    inspectionTime: moment.Moment | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}